/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		getContact:{
			by:{
				type:"ContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContact:{
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContact:{
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContact:{
			data:{
				type:"ContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContact:{
			by:{
				type:"ContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCardMedia:{
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CardMediaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCardMedia:{
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CardMediaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCardMedia:{
			data:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactLocation:{
			by:{
				type:"ContactLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactLocation:{
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactLocation:{
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactLocation:{
			data:{
				type:"ContactLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactLocation:{
			by:{
				type:"ContactLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDirector:{
			by:{
				type:"DirectorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDirector:{
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDirector:{
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDirector:{
			data:{
				type:"DirectorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDirector:{
			by:{
				type:"DirectorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DirectorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFilm:{
			by:{
				type:"FilmUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFilm:{
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FilmOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFilm:{
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FilmOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFilm:{
			data:{
				type:"FilmCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFilm:{
			by:{
				type:"FilmUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FilmUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDirectorLocation:{
			by:{
				type:"DirectorLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDirectorLocation:{
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDirectorLocation:{
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDirectorLocation:{
			data:{
				type:"DirectorLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDirectorLocation:{
			by:{
				type:"DirectorLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DirectorLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactsPage:{
			by:{
				type:"ContactsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactsPage:{
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactsPage:{
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactsPage:{
			data:{
				type:"ContactsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactsPage:{
			by:{
				type:"ContactsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDirectorsPage:{
			by:{
				type:"DirectorsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDirectorsPage:{
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDirectorsPage:{
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDirectorsPage:{
			data:{
				type:"DirectorsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDirectorsPage:{
			by:{
				type:"DirectorsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DirectorsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFilmItem:{
			by:{
				type:"FilmItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFilmItem:{
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FilmItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFilmItem:{
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FilmItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFilmItem:{
			data:{
				type:"FilmItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFilmItem:{
			by:{
				type:"FilmItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FilmItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDirectorContentGroup:{
			by:{
				type:"DirectorContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDirectorContentGroup:{
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDirectorContentGroup:{
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDirectorContentGroup:{
			data:{
				type:"DirectorContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDirectorContentGroup:{
			by:{
				type:"DirectorContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DirectorContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographer:{
			data:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographerContentGroup:{
			by:{
				type:"PhotographerContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographerContentGroup:{
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographerContentGroup:{
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographerContentGroup:{
			data:{
				type:"PhotographerContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographerContentGroup:{
			by:{
				type:"PhotographerContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographerContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographerLocation:{
			by:{
				type:"PhotographerLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographerLocation:{
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographerLocation:{
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographerLocation:{
			data:{
				type:"PhotographerLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographerLocation:{
			by:{
				type:"PhotographerLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographerLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographersPage:{
			by:{
				type:"PhotographersPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographersPage:{
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographersPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographersPage:{
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographersPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographersPage:{
			data:{
				type:"PhotographersPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographersPage:{
			by:{
				type:"PhotographersPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographersPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getOurWorkPage:{
			by:{
				type:"OurWorkPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listOurWorkPage:{
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OurWorkPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateOurWorkPage:{
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OurWorkPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateOurWorkPage:{
			data:{
				type:"OurWorkPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateOurWorkPage:{
			by:{
				type:"OurWorkPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"OurWorkPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getOurWorkPageContentGroup:{
			by:{
				type:"OurWorkPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listOurWorkPageContentGroup:{
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OurWorkPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateOurWorkPageContentGroup:{
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OurWorkPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateOurWorkPageContentGroup:{
			data:{
				type:"OurWorkPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateOurWorkPageContentGroup:{
			by:{
				type:"OurWorkPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"OurWorkPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentGroup:{
			by:{
				type:"ContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentGroup:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentGroup:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentGroup:{
			data:{
				type:"ContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentGroup:{
			by:{
				type:"ContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePageContentGroup:{
			by:{
				type:"HomePageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePageContentGroup:{
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePageContentGroup:{
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePageContentGroup:{
			data:{
				type:"HomePageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePageContentGroup:{
			by:{
				type:"HomePageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTabletopPage:{
			by:{
				type:"TabletopPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTabletopPage:{
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TabletopPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTabletopPage:{
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TabletopPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTabletopPage:{
			data:{
				type:"TabletopPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTabletopPage:{
			by:{
				type:"TabletopPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TabletopPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTabletopPageContentGroup:{
			by:{
				type:"TabletopPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTabletopPageContentGroup:{
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TabletopPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTabletopPageContentGroup:{
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TabletopPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTabletopPageContentGroup:{
			data:{
				type:"TabletopPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTabletopPageContentGroup:{
			by:{
				type:"TabletopPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TabletopPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographersPageContentGroup:{
			by:{
				type:"PhotographersPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographersPageContentGroup:{
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographersPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographersPageContentGroup:{
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographersPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographersPageContentGroup:{
			data:{
				type:"PhotographersPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographersPageContentGroup:{
			by:{
				type:"PhotographersPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographersPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Contact:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactLocation:{
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	UUID: "String",
	ImageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UUIDCondition:{
		and:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StringCondition:{
		and:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contains:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		containsCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IntCondition:{
		and:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocation:{
		contact:{
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactByWordpressId:{
			by:{
				type:"ContactLocationContactByWordpressIdUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactByImage:{
			by:{
				type:"ContactLocationContactByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContact:{
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContactWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactLocation:{
			type:"ContactLocationWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContactWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContactWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContactWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		fax:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"ContactWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContactLocationWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContactLocationWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContactLocationWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactLocation:{
			type:"ContactLocationOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OrderDirection: "enum",
	ImageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		fax:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationContactByWordpressIdUniqueWhere:{
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationContactByImageUniqueWhere:{
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContactCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactLocation:{
			type:"ContactCreateContactLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactCreateContactLocationEntityRelationInput:{
		connect:{
			type:"ContactLocationUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactLocationWithoutContactCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"ContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationWithoutContactCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fax:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContactUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactLocation:{
			type:"ContactUpdateContactLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactUpdateContactLocationEntityRelationInput:{
		create:{
			type:"ContactLocationWithoutContactCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactLocationWithoutContactUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactUpsertContactLocationRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactLocationUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationWithoutContactUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fax:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactUpsertContactLocationRelationInput:{
		update:{
			type:"ContactLocationWithoutContactUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactLocationWithoutContactCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Content:{
		blocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocksByReferences:{
			by:{
				type:"ContentBlocksByReferencesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentBlock:{
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		references:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByLink:{
			by:{
				type:"ContentBlockReferencesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateReferences:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"CardMediaWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceTypeCondition:{
		and:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceType: "enum",
	LinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkTypeCondition:{
		and:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkType: "enum",
	LinkableWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"ContactsPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"DirectorsPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"PhotographersPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"OurWorkPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"TabletopPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"HomePageContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HomePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HomePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OneCondition:{
		and:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	One: "enum",
	SeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HomePageContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HomePageContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HomePageContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"ContentGroupTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		films:{
			type:"FilmItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupTypeCondition:{
		and:{
			type:"ContentGroupTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentGroupTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentGroupTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentGroupType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentGroupType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentGroupType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentGroupType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentGroupType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentGroupType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentGroupType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentGroupType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupType: "enum",
	GalleryWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"GalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"GalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"GalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"GalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"GalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"ContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		film:{
			type:"FilmWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FilmItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FilmItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FilmItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		vimeoId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FilmWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FilmWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FilmWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"RedirectWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"RedirectWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"RedirectWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"DirectorContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorLocation:{
			type:"DirectorLocationWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"DirectorWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"DirectorWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"DirectorWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"DirectorContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"DirectorContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"DirectorContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"DirectorLocationWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"DirectorLocationWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"DirectorLocationWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContactsPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContactsPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContactsPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"DirectorsPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"DirectorsPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"DirectorsPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographerContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographerLocation:{
			type:"PhotographerLocationWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PhotographerWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PhotographerWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PhotographerWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PhotographerContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PhotographerContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PhotographerContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PhotographerLocationWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PhotographerLocationWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PhotographerLocationWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographersPageContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PhotographersPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PhotographersPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PhotographersPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"PhotographersPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PhotographersPageContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PhotographersPageContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PhotographersPageContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"OurWorkPageContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"OurWorkPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"OurWorkPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"OurWorkPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"OurWorkPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"OurWorkPageContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"OurWorkPageContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"OurWorkPageContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		teamTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"TabletopPageContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TabletopPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TabletopPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TabletopPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"TabletopPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TabletopPageContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TabletopPageContentGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TabletopPageContentGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"CardMediaWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"CardMediaWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"CardMediaWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReference:{
		block:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		cardMedia:{
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Link:{
		internalLink:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Linkable:{
		homePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		redirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		director:{
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactsPage:{
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		directorsPage:{
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		photographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		photographersPage:{
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		ourWorkPage:{
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		tabletopPage:{
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HomePage:{
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroups:{
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		backgroundImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroupsByContentGroup:{
			by:{
				type:"HomePageContentGroupsByContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentGroups:{
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Seo:{
		ogImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HomePageContentGroup:{
		homePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroup:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentGroup:{
		gallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		films:{
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FilmItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFilms:{
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FilmItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Gallery:{
		items:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	GalleryItem:{
		list:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	GalleryItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItem:{
		contentGroups:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		film:{
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Film:{
		posterImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FilmItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"ContentGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		film:{
			type:"FilmOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		vimeoId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"ContactsPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"DirectorsPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"PhotographersPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"OurWorkPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"TabletopPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorLocation:{
			type:"DirectorLocationOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographerLocation:{
			type:"PhotographerLocationOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		teamTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupsByContentGroupUniqueWhere:{
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		films:{
			type:"FilmItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Redirect:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Director:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroups:{
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		directorLocation:{
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroupsByContentGroup:{
			by:{
				type:"DirectorContentGroupsByContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentGroups:{
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	DirectorContentGroup:{
		director:{
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroup:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	DirectorContentGroupOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocation:{
		director:{
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		directorByWordpressId:{
			by:{
				type:"DirectorLocationDirectorByWordpressIdUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		directorByImage:{
			by:{
				type:"DirectorLocationDirectorByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		directorByLink:{
			by:{
				type:"DirectorLocationDirectorByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		directorByContentGroups:{
			by:{
				type:"DirectorLocationDirectorByContentGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDirector:{
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	DirectorLocationDirectorByWordpressIdUniqueWhere:{
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationDirectorByImageUniqueWhere:{
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationDirectorByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"ContactsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"DirectorsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"PhotographersPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"OurWorkPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"TabletopPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"HomePageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundImage:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"DirectorContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographerContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographersPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"OurWorkPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"TabletopPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationDirectorByContentGroupsUniqueWhere:{
		contentGroups:{
			type:"DirectorContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupsByContentGroupUniqueWhere:{
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPage:{
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	DirectorsPage:{
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Photographer:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroups:{
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		photographerLocation:{
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroupsByContentGroup:{
			by:{
				type:"PhotographerContentGroupsByContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentGroups:{
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PhotographerContentGroup:{
		photographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroup:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PhotographerContentGroupOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocation:{
		photographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		photographerByWordpressId:{
			by:{
				type:"PhotographerLocationPhotographerByWordpressIdUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		photographerByImage:{
			by:{
				type:"PhotographerLocationPhotographerByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		photographerByContentGroups:{
			by:{
				type:"PhotographerLocationPhotographerByContentGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		photographerByLink:{
			by:{
				type:"PhotographerLocationPhotographerByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PhotographerLocationPhotographerByWordpressIdUniqueWhere:{
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationPhotographerByImageUniqueWhere:{
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationPhotographerByContentGroupsUniqueWhere:{
		contentGroups:{
			type:"PhotographerContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationPhotographerByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupsByContentGroupUniqueWhere:{
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPage:{
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroups:{
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographersPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroupsByContentGroup:{
			by:{
				type:"PhotographersPageContentGroupsByContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentGroups:{
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographersPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PhotographersPageContentGroup:{
		photographersPage:{
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroup:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PhotographersPageContentGroupOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"PhotographersPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupsByContentGroupUniqueWhere:{
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPage:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroups:{
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OurWorkPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroupsByContentGroup:{
			by:{
				type:"OurWorkPageContentGroupsByContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentGroups:{
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OurWorkPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	OurWorkPageContentGroup:{
		ourWorkPage:{
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroup:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	OurWorkPageContentGroupOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"OurWorkPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupsByContentGroupUniqueWhere:{
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPage:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroups:{
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TabletopPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroupsByContentGroup:{
			by:{
				type:"TabletopPageContentGroupsByContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentGroups:{
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TabletopPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TabletopPageContentGroup:{
		tabletopPage:{
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentGroup:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TabletopPageContentGroupOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"TabletopPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"ContentGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupsByContentGroupUniqueWhere:{
		contentGroup:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMedia:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentReferenceOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentBlockOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"CardMediaOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlocksByReferencesUniqueWhere:{
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentCreateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateBlocksEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateReferencesEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"ContentReferenceCreateCardMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkCreateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInternalLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableCreateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableCreateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableCreateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableCreatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableCreatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableCreateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableCreateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateHomePageEntityRelationInput:{
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HomePageCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"HomePageCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		backgroundImage:{
			type:"HomePageCreateBackgroundImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateContentGroupsEntityRelationInput:{
		connect:{
			type:"HomePageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageContentGroupWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupWithoutHomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"HomePageContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupCreateContentGroupEntityRelationInput:{
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"ContentGroupType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentGroupCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		films:{
			type:"ContentGroupCreateFilmsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupCreateGalleryEntityRelationInput:{
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryCreateItemsEntityRelationInput:{
		connect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupCreateFilmsEntityRelationInput:{
		connect:{
			type:"FilmItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FilmItemWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemWithoutContentGroupsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		film:{
			type:"FilmItemCreateFilmEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemCreateFilmEntityRelationInput:{
		connect:{
			type:"FilmUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FilmCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterImage:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vimeoId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterImage:{
			type:"FilmCreatePosterImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmCreatePosterImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateBackgroundImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateRedirectEntityRelationInput:{
		connect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateDirectorEntityRelationInput:{
		connect:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"DirectorCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"DirectorCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		directorLocation:{
			type:"DirectorCreateDirectorLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorCreateContentGroupsEntityRelationInput:{
		connect:{
			type:"DirectorContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorContentGroupWithoutDirectorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupWithoutDirectorCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"DirectorContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupCreateContentGroupEntityRelationInput:{
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorCreateDirectorLocationEntityRelationInput:{
		connect:{
			type:"DirectorLocationUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorLocationWithoutDirectorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationWithoutDirectorCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateContactsPageEntityRelationInput:{
		connect:{
			type:"ContactsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactsPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactsPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateDirectorsPageEntityRelationInput:{
		connect:{
			type:"DirectorsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorsPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"DirectorsPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreatePhotographerEntityRelationInput:{
		connect:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"PhotographerCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographerCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		photographerLocation:{
			type:"PhotographerCreatePhotographerLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerCreateContentGroupsEntityRelationInput:{
		connect:{
			type:"PhotographerContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerContentGroupWithoutPhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupWithoutPhotographerCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"PhotographerContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupCreateContentGroupEntityRelationInput:{
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerCreatePhotographerLocationEntityRelationInput:{
		connect:{
			type:"PhotographerLocationUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerLocationWithoutPhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationWithoutPhotographerCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreatePhotographersPageEntityRelationInput:{
		connect:{
			type:"PhotographersPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographersPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PhotographersPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographersPageCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageCreateContentGroupsEntityRelationInput:{
		connect:{
			type:"PhotographersPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographersPageContentGroupWithoutPhotographersPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupWithoutPhotographersPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"PhotographersPageContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupCreateContentGroupEntityRelationInput:{
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateOurWorkPageEntityRelationInput:{
		connect:{
			type:"OurWorkPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"OurWorkPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"OurWorkPageCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seo:{
			type:"OurWorkPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageCreateContentGroupsEntityRelationInput:{
		connect:{
			type:"OurWorkPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"OurWorkPageContentGroupWithoutOurWorkPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupWithoutOurWorkPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"OurWorkPageContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupCreateContentGroupEntityRelationInput:{
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateTabletopPageEntityRelationInput:{
		connect:{
			type:"TabletopPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TabletopPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		teamTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"TabletopPageCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TabletopPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"TabletopPageCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageCreateContentGroupsEntityRelationInput:{
		connect:{
			type:"TabletopPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TabletopPageContentGroupWithoutTabletopPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupWithoutTabletopPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"TabletopPageContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupCreateContentGroupEntityRelationInput:{
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateCardMediaEntityRelationInput:{
		connect:{
			type:"CardMediaUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CardMediaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"CardMediaCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateInput:{
		blocks:{
			type:"ContentUpdateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateBlocksEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentUpsertBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentBlockWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateReferencesEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockUpdateReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentReferenceWithoutBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutBlockUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"ContentReferenceUpdateCardMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInput:{
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkUpdateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInternalLinkEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkUpsertInternalLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableUpdateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableUpdateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableUpdateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableUpdatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableUpdatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableUpdateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableUpdateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateHomePageEntityRelationInput:{
		create:{
			type:"HomePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertHomePageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HomePageUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"HomePageUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		backgroundImage:{
			type:"HomePageUpdateBackgroundImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateOgImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoUpsertOgImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpsertOgImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateContentGroupsEntityRelationInput:{
		create:{
			type:"HomePageContentGroupWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageUpdateContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HomePageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HomePageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HomePageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateContentGroupsRelationInput:{
		by:{
			type:"HomePageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HomePageContentGroupWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupWithoutHomePageUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"HomePageContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupUpdateContentGroupEntityRelationInput:{
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageContentGroupUpsertContentGroupRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"ContentGroupType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentGroupUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		films:{
			type:"ContentGroupUpdateFilmsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupUpdateGalleryEntityRelationInput:{
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentGroupUpsertGalleryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateInput:{
		items:{
			type:"GalleryUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateItemsEntityRelationInput:{
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateItemsRelationInput:{
		by:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"GalleryItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpsertItemsRelationInput:{
		by:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupUpsertGalleryRelationInput:{
		update:{
			type:"GalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupUpdateFilmsEntityRelationInput:{
		create:{
			type:"FilmItemWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentGroupUpdateFilmsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentGroupUpsertFilmsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FilmItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FilmItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FilmItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupUpdateFilmsRelationInput:{
		by:{
			type:"FilmItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FilmItemWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemWithoutContentGroupsUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		film:{
			type:"FilmItemUpdateFilmEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemUpdateFilmEntityRelationInput:{
		create:{
			type:"FilmCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FilmUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FilmItemUpsertFilmRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FilmUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vimeoId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterImage:{
			type:"FilmUpdatePosterImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmUpdatePosterImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FilmUpsertPosterImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmUpsertPosterImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemUpsertFilmRelationInput:{
		update:{
			type:"FilmUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FilmCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupUpsertFilmsRelationInput:{
		by:{
			type:"FilmItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FilmItemWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FilmItemWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupUpsertContentGroupRelationInput:{
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertContentGroupsRelationInput:{
		by:{
			type:"HomePageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageContentGroupWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageContentGroupWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateBackgroundImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertBackgroundImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertBackgroundImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertHomePageRelationInput:{
		update:{
			type:"HomePageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateRedirectEntityRelationInput:{
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RedirectWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertRedirectRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWithoutLinkUpdateInput:{
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RedirectUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpsertTargetRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertRedirectRelationInput:{
		update:{
			type:"RedirectWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateDirectorEntityRelationInput:{
		create:{
			type:"DirectorWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DirectorWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertDirectorRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorWithoutLinkUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"DirectorUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"DirectorUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		directorLocation:{
			type:"DirectorUpdateDirectorLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DirectorUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUpdateContentGroupsEntityRelationInput:{
		create:{
			type:"DirectorContentGroupWithoutDirectorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DirectorUpdateContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DirectorUpsertContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DirectorContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"DirectorContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"DirectorContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUpdateContentGroupsRelationInput:{
		by:{
			type:"DirectorContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"DirectorContentGroupWithoutDirectorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupWithoutDirectorUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"DirectorContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupUpdateContentGroupEntityRelationInput:{
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DirectorContentGroupUpsertContentGroupRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupUpsertContentGroupRelationInput:{
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUpsertContentGroupsRelationInput:{
		by:{
			type:"DirectorContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DirectorContentGroupWithoutDirectorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorContentGroupWithoutDirectorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUpdateDirectorLocationEntityRelationInput:{
		create:{
			type:"DirectorLocationWithoutDirectorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DirectorLocationWithoutDirectorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DirectorUpsertDirectorLocationRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DirectorLocationUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationWithoutDirectorUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUpsertDirectorLocationRelationInput:{
		update:{
			type:"DirectorLocationWithoutDirectorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorLocationWithoutDirectorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertDirectorRelationInput:{
		update:{
			type:"DirectorWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateContactsPageEntityRelationInput:{
		create:{
			type:"ContactsPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactsPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertContactsPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactsPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactsPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertContactsPageRelationInput:{
		update:{
			type:"ContactsPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactsPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateDirectorsPageEntityRelationInput:{
		create:{
			type:"DirectorsPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DirectorsPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertDirectorsPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DirectorsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"DirectorsPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DirectorsPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertDirectorsPageRelationInput:{
		update:{
			type:"DirectorsPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorsPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdatePhotographerEntityRelationInput:{
		create:{
			type:"PhotographerWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographerWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertPhotographerRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerWithoutLinkUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"PhotographerUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographerUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		photographerLocation:{
			type:"PhotographerUpdatePhotographerLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographerUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpdateContentGroupsEntityRelationInput:{
		create:{
			type:"PhotographerContentGroupWithoutPhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographerUpdateContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographerUpsertContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PhotographerContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PhotographerContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PhotographerContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpdateContentGroupsRelationInput:{
		by:{
			type:"PhotographerContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PhotographerContentGroupWithoutPhotographerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupWithoutPhotographerUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"PhotographerContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupUpdateContentGroupEntityRelationInput:{
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographerContentGroupUpsertContentGroupRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupUpsertContentGroupRelationInput:{
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpsertContentGroupsRelationInput:{
		by:{
			type:"PhotographerContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographerContentGroupWithoutPhotographerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerContentGroupWithoutPhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpdatePhotographerLocationEntityRelationInput:{
		create:{
			type:"PhotographerLocationWithoutPhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographerLocationWithoutPhotographerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographerUpsertPhotographerLocationRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PhotographerLocationUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationWithoutPhotographerUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpsertPhotographerLocationRelationInput:{
		update:{
			type:"PhotographerLocationWithoutPhotographerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerLocationWithoutPhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertPhotographerRelationInput:{
		update:{
			type:"PhotographerWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdatePhotographersPageEntityRelationInput:{
		create:{
			type:"PhotographersPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographersPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertPhotographersPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PhotographersPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PhotographersPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographersPageUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographersPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageUpdateContentGroupsEntityRelationInput:{
		create:{
			type:"PhotographersPageContentGroupWithoutPhotographersPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographersPageUpdateContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographersPageUpsertContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PhotographersPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PhotographersPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PhotographersPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageUpdateContentGroupsRelationInput:{
		by:{
			type:"PhotographersPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PhotographersPageContentGroupWithoutPhotographersPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupWithoutPhotographersPageUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"PhotographersPageContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupUpdateContentGroupEntityRelationInput:{
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographersPageContentGroupUpsertContentGroupRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupUpsertContentGroupRelationInput:{
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageUpsertContentGroupsRelationInput:{
		by:{
			type:"PhotographersPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographersPageContentGroupWithoutPhotographersPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographersPageContentGroupWithoutPhotographersPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertPhotographersPageRelationInput:{
		update:{
			type:"PhotographersPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographersPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateOurWorkPageEntityRelationInput:{
		create:{
			type:"OurWorkPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"OurWorkPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertOurWorkPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"OurWorkPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"OurWorkPageUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seo:{
			type:"OurWorkPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageUpdateContentGroupsEntityRelationInput:{
		create:{
			type:"OurWorkPageContentGroupWithoutOurWorkPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"OurWorkPageUpdateContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"OurWorkPageUpsertContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"OurWorkPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"OurWorkPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"OurWorkPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageUpdateContentGroupsRelationInput:{
		by:{
			type:"OurWorkPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"OurWorkPageContentGroupWithoutOurWorkPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupWithoutOurWorkPageUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"OurWorkPageContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupUpdateContentGroupEntityRelationInput:{
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"OurWorkPageContentGroupUpsertContentGroupRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupUpsertContentGroupRelationInput:{
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageUpsertContentGroupsRelationInput:{
		by:{
			type:"OurWorkPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"OurWorkPageContentGroupWithoutOurWorkPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"OurWorkPageContentGroupWithoutOurWorkPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"OurWorkPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertOurWorkPageRelationInput:{
		update:{
			type:"OurWorkPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"OurWorkPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateTabletopPageEntityRelationInput:{
		create:{
			type:"TabletopPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TabletopPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertTabletopPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TabletopPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		teamTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"TabletopPageUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TabletopPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"TabletopPageUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TabletopPageUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TabletopPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUpdateContentGroupsEntityRelationInput:{
		create:{
			type:"TabletopPageContentGroupWithoutTabletopPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TabletopPageUpdateContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TabletopPageUpsertContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TabletopPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TabletopPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TabletopPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUpdateContentGroupsRelationInput:{
		by:{
			type:"TabletopPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TabletopPageContentGroupWithoutTabletopPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupWithoutTabletopPageUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"TabletopPageContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupUpdateContentGroupEntityRelationInput:{
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TabletopPageContentGroupUpsertContentGroupRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupUpsertContentGroupRelationInput:{
		update:{
			type:"ContentGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUpsertContentGroupsRelationInput:{
		by:{
			type:"TabletopPageContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TabletopPageContentGroupWithoutTabletopPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TabletopPageContentGroupWithoutTabletopPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertTabletopPageRelationInput:{
		update:{
			type:"TabletopPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TabletopPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpsertInternalLinkRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateCardMediaEntityRelationInput:{
		create:{
			type:"CardMediaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CardMediaUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertCardMediaRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CardMediaUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaUpdateInput:{
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"CardMediaUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CardMediaUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertCardMediaRelationInput:{
		update:{
			type:"CardMediaUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CardMediaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpsertBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutBlocksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateContentEntityRelationInput:{
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutBlocksUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertContentRelationInput:{
		update:{
			type:"ContentWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceCreateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"ContentReferenceCreateCardMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateBlockEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutReferencesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceUpdateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"ContentReferenceUpdateCardMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateBlockEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertBlockRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutReferencesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertBlockRelationInput:{
		update:{
			type:"ContentBlockWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeo:{
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FallbackSeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FallbackSeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FallbackSeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FallbackSeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FallbackSeoCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FallbackSeoUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FallbackSeoUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Footer:{
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		socialLinks:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		directorsButton:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactButton:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinks:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SocialLinkType: "enum",
	SocialLinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SocialLinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkLabel:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkTypeCondition:{
		and:{
			type:"SocialLinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"SocialLinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"SocialLinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"SocialLinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"SocialLinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkLabel:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsButton:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactButton:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsButton:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactButton:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsButton:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactButton:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"FooterCreateSocialLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		directorsText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsButton:{
			type:"FooterCreateDirectorsButtonEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactButton:{
			type:"FooterCreateContactButtonEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateSocialLinksEntityRelationInput:{
		connect:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateDirectorsButtonEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateContactButtonEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"FooterUpdateSocialLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		directorsText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsButton:{
			type:"FooterUpdateDirectorsButtonEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactButton:{
			type:"FooterUpdateContactButtonEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateSocialLinksEntityRelationInput:{
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterUpdateSocialLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertSocialLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateSocialLinksRelationInput:{
		by:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SocialLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUpdateInput:{
		type:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertSocialLinksRelationInput:{
		by:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateDirectorsButtonEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertDirectorsButtonRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertDirectorsButtonRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateContactButtonEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertContactButtonRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertContactButtonRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateListEntityRelationInput:{
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateListEntityRelationInput:{
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpsertListRelationInput:{
		update:{
			type:"GalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Header:{
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		links:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinks:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HeaderLink:{
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HeaderLinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HeaderCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLinksEntityRelationInput:{
		connect:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HeaderLinkCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HeaderUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLinksEntityRelationInput:{
		create:{
			type:"HeaderLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderUpdateLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLinksRelationInput:{
		by:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HeaderLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HeaderLinkUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLinkUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLinksRelationInput:{
		by:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HomePageCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"HomePageCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		backgroundImage:{
			type:"HomePageCreateBackgroundImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutHomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableCreateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableCreateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableCreateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableCreatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableCreatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableCreateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableCreateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HomePageUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"HomePageUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		backgroundImage:{
			type:"HomePageUpdateBackgroundImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutHomePageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableUpdateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableUpdateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableUpdateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableUpdatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableUpdatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableUpdateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableUpdateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"RedirectCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutRedirectCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableCreateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableCreateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableCreateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableCreatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableCreatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableCreateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableCreateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateInput:{
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"RedirectUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutRedirectUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RedirectUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutRedirectUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableUpdateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableUpdateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableUpdateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableUpdatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableUpdatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableUpdateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableUpdateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutRedirectUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fax:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"ContactLocationCreateContactEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationCreateContactEntityRelationInput:{
		connect:{
			type:"ContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactWithoutContactLocationCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactWithoutContactLocationCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContactCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fax:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"ContactLocationUpdateContactEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationUpdateContactEntityRelationInput:{
		create:{
			type:"ContactWithoutContactLocationCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactLocationUpdateContactRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactLocationUpsertContactRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationUpdateContactRelationInput:{
		by:{
			type:"ContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContactWithoutContactLocationUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactWithoutContactLocationUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContactUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactLocationUpsertContactRelationInput:{
		by:{
			type:"ContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactWithoutContactLocationUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactWithoutContactLocationCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"DirectorCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DirectorCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"DirectorCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		directorLocation:{
			type:"DirectorCreateDirectorLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutDirectorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutDirectorCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableCreateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableCreateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableCreatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableCreatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableCreateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableCreateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"DirectorUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DirectorUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"DirectorUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		directorLocation:{
			type:"DirectorUpdateDirectorLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutDirectorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutDirectorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DirectorUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutDirectorUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableUpdateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableUpdateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableUpdatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableUpdatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableUpdateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableUpdateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutDirectorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutDirectorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorLocationCreateDirectorEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationCreateDirectorEntityRelationInput:{
		connect:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorWithoutDirectorLocationCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorWithoutDirectorLocationCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"DirectorCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DirectorCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"DirectorCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorLocationUpdateDirectorEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationUpdateDirectorEntityRelationInput:{
		create:{
			type:"DirectorWithoutDirectorLocationCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DirectorLocationUpdateDirectorRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DirectorLocationUpsertDirectorRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationUpdateDirectorRelationInput:{
		by:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"DirectorWithoutDirectorLocationUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorWithoutDirectorLocationUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"DirectorUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DirectorUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"DirectorUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorLocationUpsertDirectorRelationInput:{
		by:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DirectorWithoutDirectorLocationUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorWithoutDirectorLocationCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactsPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContactsPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutContactsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutContactsPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableCreateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableCreateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableCreatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableCreatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableCreateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableCreateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactsPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContactsPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutContactsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutContactsPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactsPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutContactsPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableUpdateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableUpdateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableUpdatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableUpdatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableUpdateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableUpdateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactsPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutContactsPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutContactsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"DirectorsPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DirectorsPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutDirectorsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutDirectorsPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableCreateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableCreateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableCreatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableCreatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableCreateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableCreateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"DirectorsPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DirectorsPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutDirectorsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutDirectorsPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DirectorsPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutDirectorsPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableUpdateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableUpdateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableUpdatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableUpdatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableUpdateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableUpdateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorsPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutDirectorsPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutDirectorsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"FilmItemCreateContentGroupsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		film:{
			type:"FilmItemCreateFilmEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemCreateContentGroupsEntityRelationInput:{
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupWithoutFilmsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupWithoutFilmsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"ContentGroupType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentGroupCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"FilmItemUpdateContentGroupsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		film:{
			type:"FilmItemUpdateFilmEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemUpdateContentGroupsEntityRelationInput:{
		create:{
			type:"ContentGroupWithoutFilmsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentGroupWithoutFilmsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FilmItemUpsertContentGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentGroupWithoutFilmsUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"ContentGroupType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentGroupUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FilmItemUpsertContentGroupsRelationInput:{
		update:{
			type:"ContentGroupWithoutFilmsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentGroupWithoutFilmsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorContentGroupCreateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"DirectorContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupCreateDirectorEntityRelationInput:{
		connect:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorWithoutContentGroupsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"DirectorCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DirectorCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorLocation:{
			type:"DirectorCreateDirectorLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"DirectorContentGroupUpdateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"DirectorContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupUpdateDirectorEntityRelationInput:{
		create:{
			type:"DirectorWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DirectorWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DirectorContentGroupUpsertDirectorRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DirectorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorWithoutContentGroupsUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"DirectorUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DirectorUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorLocation:{
			type:"DirectorUpdateDirectorLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DirectorContentGroupUpsertDirectorRelationInput:{
		update:{
			type:"DirectorWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DirectorWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"PhotographerCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographerCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		link:{
			type:"PhotographerCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographerLocation:{
			type:"PhotographerCreatePhotographerLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPhotographerCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableCreateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableCreateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableCreateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableCreatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableCreateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableCreateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"PhotographerUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographerUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		link:{
			type:"PhotographerUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographerLocation:{
			type:"PhotographerUpdatePhotographerLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutPhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutPhotographerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographerUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPhotographerUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableUpdateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableUpdateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableUpdateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableUpdatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableUpdateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableUpdateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutPhotographerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerContentGroupCreatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"PhotographerContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupCreatePhotographerEntityRelationInput:{
		connect:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerWithoutContentGroupsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"PhotographerCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PhotographerCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographerLocation:{
			type:"PhotographerCreatePhotographerLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerContentGroupUpdatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"PhotographerContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupUpdatePhotographerEntityRelationInput:{
		create:{
			type:"PhotographerWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographerWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographerContentGroupUpsertPhotographerRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerWithoutContentGroupsUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"PhotographerUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PhotographerUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographerLocation:{
			type:"PhotographerUpdatePhotographerLocationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerContentGroupUpsertPhotographerRelationInput:{
		update:{
			type:"PhotographerWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerLocationCreatePhotographerEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationCreatePhotographerEntityRelationInput:{
		connect:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerWithoutPhotographerLocationCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerWithoutPhotographerLocationCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"PhotographerCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographerCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		link:{
			type:"PhotographerCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		city:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"PhotographerLocationUpdatePhotographerEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationUpdatePhotographerEntityRelationInput:{
		create:{
			type:"PhotographerWithoutPhotographerLocationCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographerLocationUpdatePhotographerRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographerLocationUpsertPhotographerRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationUpdatePhotographerRelationInput:{
		by:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PhotographerWithoutPhotographerLocationUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerWithoutPhotographerLocationUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"PhotographerUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographerUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		link:{
			type:"PhotographerUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		wordpressId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerLocationUpsertPhotographerRelationInput:{
		by:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographerWithoutPhotographerLocationUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerWithoutPhotographerLocationCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PhotographersPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PhotographersPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographersPageCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPhotographersPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPhotographersPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableCreateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableCreateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableCreateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableCreatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableCreateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableCreateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PhotographersPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PhotographersPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"PhotographersPageUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutPhotographersPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutPhotographersPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographersPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPhotographersPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableUpdateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableUpdateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableUpdateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableUpdatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableUpdateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableUpdateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutPhotographersPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPhotographersPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"OurWorkPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"OurWorkPageCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seo:{
			type:"OurWorkPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutOurWorkPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutOurWorkPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableCreateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableCreateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableCreateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableCreatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableCreatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableCreateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"OurWorkPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"OurWorkPageUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seo:{
			type:"OurWorkPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutOurWorkPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutOurWorkPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"OurWorkPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutOurWorkPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableUpdateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableUpdateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableUpdateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableUpdatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableUpdatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"LinkableUpdateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutOurWorkPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutOurWorkPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"OurWorkPageContentGroupCreateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"OurWorkPageContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupCreateOurWorkPageEntityRelationInput:{
		connect:{
			type:"OurWorkPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"OurWorkPageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageWithoutContentGroupsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"OurWorkPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"OurWorkPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"OurWorkPageContentGroupUpdateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"OurWorkPageContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupUpdateOurWorkPageEntityRelationInput:{
		create:{
			type:"OurWorkPageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"OurWorkPageWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"OurWorkPageContentGroupUpsertOurWorkPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"OurWorkPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageWithoutContentGroupsUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"OurWorkPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"OurWorkPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OurWorkPageContentGroupUpsertOurWorkPageRelationInput:{
		update:{
			type:"OurWorkPageWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"OurWorkPageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageContentGroupCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"HomePageContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupCreateHomePageEntityRelationInput:{
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutContentGroupsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HomePageCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundImage:{
			type:"HomePageCreateBackgroundImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageContentGroupUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"HomePageContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupUpdateHomePageEntityRelationInput:{
		create:{
			type:"HomePageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageContentGroupUpsertHomePageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutContentGroupsUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HomePageUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundImage:{
			type:"HomePageUpdateBackgroundImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageContentGroupUpsertHomePageRelationInput:{
		update:{
			type:"HomePageWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		teamTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TabletopPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"TabletopPageCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TabletopPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"TabletopPageCreateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutTabletopPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutTabletopPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableCreateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableCreateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableCreateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableCreatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableCreatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableCreateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		teamTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TabletopPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"TabletopPageUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TabletopPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroups:{
			type:"TabletopPageUpdateContentGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutTabletopPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutTabletopPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TabletopPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutTabletopPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		director:{
			type:"LinkableUpdateDirectorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactsPage:{
			type:"LinkableUpdateContactsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		directorsPage:{
			type:"LinkableUpdateDirectorsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"LinkableUpdatePhotographerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"LinkableUpdatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ourWorkPage:{
			type:"LinkableUpdateOurWorkPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutTabletopPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutTabletopPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"TabletopPageContentGroupCreateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"TabletopPageContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupCreateTabletopPageEntityRelationInput:{
		connect:{
			type:"TabletopPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TabletopPageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageWithoutContentGroupsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		teamTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TabletopPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"TabletopPageCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TabletopPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		tabletopPage:{
			type:"TabletopPageContentGroupUpdateTabletopPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"TabletopPageContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupUpdateTabletopPageEntityRelationInput:{
		create:{
			type:"TabletopPageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TabletopPageWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TabletopPageContentGroupUpsertTabletopPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TabletopPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageWithoutContentGroupsUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		teamTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TabletopPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"TabletopPageUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TabletopPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TabletopPageContentGroupUpsertTabletopPageRelationInput:{
		update:{
			type:"TabletopPageWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TabletopPageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"PhotographersPageContentGroupCreatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"PhotographersPageContentGroupCreateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupCreatePhotographersPageEntityRelationInput:{
		connect:{
			type:"PhotographersPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographersPageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageWithoutContentGroupsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PhotographersPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PhotographersPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographersPage:{
			type:"PhotographersPageContentGroupUpdatePhotographersPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentGroup:{
			type:"PhotographersPageContentGroupUpdateContentGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupUpdatePhotographersPageEntityRelationInput:{
		create:{
			type:"PhotographersPageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographersPageWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographersPageContentGroupUpsertPhotographersPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PhotographersPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageWithoutContentGroupsUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PhotographersPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PhotographersPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographersPageContentGroupUpsertPhotographersPageRelationInput:{
		update:{
			type:"PhotographersPageWithoutContentGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographersPageWithoutContentGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	QueryTransaction:{
		getContact:{
			by:{
				type:"ContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContact:{
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContact:{
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContact:{
			data:{
				type:"ContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContact:{
			by:{
				type:"ContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCardMedia:{
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CardMediaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCardMedia:{
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CardMediaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCardMedia:{
			data:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactLocation:{
			by:{
				type:"ContactLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactLocation:{
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactLocation:{
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactLocation:{
			data:{
				type:"ContactLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactLocation:{
			by:{
				type:"ContactLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDirector:{
			by:{
				type:"DirectorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDirector:{
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDirector:{
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDirector:{
			data:{
				type:"DirectorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDirector:{
			by:{
				type:"DirectorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DirectorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFilm:{
			by:{
				type:"FilmUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFilm:{
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FilmOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFilm:{
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FilmOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFilm:{
			data:{
				type:"FilmCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFilm:{
			by:{
				type:"FilmUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FilmUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDirectorLocation:{
			by:{
				type:"DirectorLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDirectorLocation:{
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDirectorLocation:{
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDirectorLocation:{
			data:{
				type:"DirectorLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDirectorLocation:{
			by:{
				type:"DirectorLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DirectorLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactsPage:{
			by:{
				type:"ContactsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactsPage:{
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactsPage:{
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactsPage:{
			data:{
				type:"ContactsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactsPage:{
			by:{
				type:"ContactsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDirectorsPage:{
			by:{
				type:"DirectorsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDirectorsPage:{
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDirectorsPage:{
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDirectorsPage:{
			data:{
				type:"DirectorsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDirectorsPage:{
			by:{
				type:"DirectorsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DirectorsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFilmItem:{
			by:{
				type:"FilmItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFilmItem:{
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FilmItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFilmItem:{
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FilmItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFilmItem:{
			data:{
				type:"FilmItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFilmItem:{
			by:{
				type:"FilmItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FilmItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDirectorContentGroup:{
			by:{
				type:"DirectorContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDirectorContentGroup:{
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDirectorContentGroup:{
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DirectorContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDirectorContentGroup:{
			data:{
				type:"DirectorContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDirectorContentGroup:{
			by:{
				type:"DirectorContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DirectorContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographer:{
			data:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographerContentGroup:{
			by:{
				type:"PhotographerContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographerContentGroup:{
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographerContentGroup:{
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographerContentGroup:{
			data:{
				type:"PhotographerContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographerContentGroup:{
			by:{
				type:"PhotographerContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographerContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographerLocation:{
			by:{
				type:"PhotographerLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographerLocation:{
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographerLocation:{
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerLocationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographerLocation:{
			data:{
				type:"PhotographerLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographerLocation:{
			by:{
				type:"PhotographerLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographerLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographersPage:{
			by:{
				type:"PhotographersPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographersPage:{
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographersPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographersPage:{
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographersPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographersPage:{
			data:{
				type:"PhotographersPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographersPage:{
			by:{
				type:"PhotographersPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographersPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getOurWorkPage:{
			by:{
				type:"OurWorkPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listOurWorkPage:{
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OurWorkPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateOurWorkPage:{
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OurWorkPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateOurWorkPage:{
			data:{
				type:"OurWorkPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateOurWorkPage:{
			by:{
				type:"OurWorkPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"OurWorkPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getOurWorkPageContentGroup:{
			by:{
				type:"OurWorkPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listOurWorkPageContentGroup:{
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OurWorkPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateOurWorkPageContentGroup:{
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OurWorkPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateOurWorkPageContentGroup:{
			data:{
				type:"OurWorkPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateOurWorkPageContentGroup:{
			by:{
				type:"OurWorkPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"OurWorkPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentGroup:{
			by:{
				type:"ContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentGroup:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentGroup:{
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentGroup:{
			data:{
				type:"ContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentGroup:{
			by:{
				type:"ContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePageContentGroup:{
			by:{
				type:"HomePageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePageContentGroup:{
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePageContentGroup:{
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePageContentGroup:{
			data:{
				type:"HomePageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePageContentGroup:{
			by:{
				type:"HomePageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTabletopPage:{
			by:{
				type:"TabletopPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTabletopPage:{
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TabletopPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTabletopPage:{
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TabletopPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTabletopPage:{
			data:{
				type:"TabletopPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTabletopPage:{
			by:{
				type:"TabletopPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TabletopPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTabletopPageContentGroup:{
			by:{
				type:"TabletopPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTabletopPageContentGroup:{
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TabletopPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTabletopPageContentGroup:{
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TabletopPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTabletopPageContentGroup:{
			data:{
				type:"TabletopPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTabletopPageContentGroup:{
			by:{
				type:"TabletopPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TabletopPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographersPageContentGroup:{
			by:{
				type:"PhotographersPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographersPageContentGroup:{
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographersPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographersPageContentGroup:{
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographersPageContentGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographersPageContentGroup:{
			data:{
				type:"PhotographersPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographersPageContentGroup:{
			by:{
				type:"PhotographersPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographersPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Mutation:{
		createContact:{
			data:{
				type:"ContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContact:{
			by:{
				type:"ContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContact:{
			by:{
				type:"ContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContact:{
			by:{
				type:"ContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCardMedia:{
			data:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactLocation:{
			data:{
				type:"ContactLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactLocation:{
			by:{
				type:"ContactLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactLocation:{
			by:{
				type:"ContactLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactLocation:{
			by:{
				type:"ContactLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDirector:{
			data:{
				type:"DirectorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDirector:{
			by:{
				type:"DirectorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDirector:{
			by:{
				type:"DirectorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DirectorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDirector:{
			by:{
				type:"DirectorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DirectorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DirectorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFilm:{
			data:{
				type:"FilmCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFilm:{
			by:{
				type:"FilmUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFilm:{
			by:{
				type:"FilmUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FilmUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFilm:{
			by:{
				type:"FilmUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FilmUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FilmCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDirectorLocation:{
			data:{
				type:"DirectorLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDirectorLocation:{
			by:{
				type:"DirectorLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDirectorLocation:{
			by:{
				type:"DirectorLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DirectorLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDirectorLocation:{
			by:{
				type:"DirectorLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DirectorLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DirectorLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactsPage:{
			data:{
				type:"ContactsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactsPage:{
			by:{
				type:"ContactsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactsPage:{
			by:{
				type:"ContactsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactsPage:{
			by:{
				type:"ContactsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDirectorsPage:{
			data:{
				type:"DirectorsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDirectorsPage:{
			by:{
				type:"DirectorsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDirectorsPage:{
			by:{
				type:"DirectorsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DirectorsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDirectorsPage:{
			by:{
				type:"DirectorsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DirectorsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DirectorsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFilmItem:{
			data:{
				type:"FilmItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFilmItem:{
			by:{
				type:"FilmItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFilmItem:{
			by:{
				type:"FilmItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FilmItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFilmItem:{
			by:{
				type:"FilmItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FilmItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FilmItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDirectorContentGroup:{
			data:{
				type:"DirectorContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDirectorContentGroup:{
			by:{
				type:"DirectorContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDirectorContentGroup:{
			by:{
				type:"DirectorContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DirectorContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDirectorContentGroup:{
			by:{
				type:"DirectorContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DirectorContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DirectorContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographer:{
			data:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographerContentGroup:{
			data:{
				type:"PhotographerContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographerContentGroup:{
			by:{
				type:"PhotographerContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographerContentGroup:{
			by:{
				type:"PhotographerContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographerContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographerContentGroup:{
			by:{
				type:"PhotographerContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographerContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographerContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographerLocation:{
			data:{
				type:"PhotographerLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographerLocation:{
			by:{
				type:"PhotographerLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographerLocation:{
			by:{
				type:"PhotographerLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographerLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographerLocation:{
			by:{
				type:"PhotographerLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographerLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographerLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographersPage:{
			data:{
				type:"PhotographersPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographersPage:{
			by:{
				type:"PhotographersPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographersPage:{
			by:{
				type:"PhotographersPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographersPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographersPage:{
			by:{
				type:"PhotographersPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographersPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographersPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createOurWorkPage:{
			data:{
				type:"OurWorkPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteOurWorkPage:{
			by:{
				type:"OurWorkPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateOurWorkPage:{
			by:{
				type:"OurWorkPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"OurWorkPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertOurWorkPage:{
			by:{
				type:"OurWorkPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"OurWorkPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"OurWorkPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createOurWorkPageContentGroup:{
			data:{
				type:"OurWorkPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteOurWorkPageContentGroup:{
			by:{
				type:"OurWorkPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateOurWorkPageContentGroup:{
			by:{
				type:"OurWorkPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"OurWorkPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertOurWorkPageContentGroup:{
			by:{
				type:"OurWorkPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"OurWorkPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"OurWorkPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentGroup:{
			data:{
				type:"ContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentGroup:{
			by:{
				type:"ContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentGroup:{
			by:{
				type:"ContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentGroup:{
			by:{
				type:"ContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePageContentGroup:{
			data:{
				type:"HomePageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePageContentGroup:{
			by:{
				type:"HomePageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePageContentGroup:{
			by:{
				type:"HomePageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePageContentGroup:{
			by:{
				type:"HomePageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTabletopPage:{
			data:{
				type:"TabletopPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTabletopPage:{
			by:{
				type:"TabletopPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTabletopPage:{
			by:{
				type:"TabletopPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TabletopPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTabletopPage:{
			by:{
				type:"TabletopPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TabletopPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TabletopPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTabletopPageContentGroup:{
			data:{
				type:"TabletopPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTabletopPageContentGroup:{
			by:{
				type:"TabletopPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTabletopPageContentGroup:{
			by:{
				type:"TabletopPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TabletopPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTabletopPageContentGroup:{
			by:{
				type:"TabletopPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TabletopPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TabletopPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographersPageContentGroup:{
			data:{
				type:"PhotographersPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographersPageContentGroup:{
			by:{
				type:"PhotographersPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographersPageContentGroup:{
			by:{
				type:"PhotographersPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographersPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographersPageContentGroup:{
			by:{
				type:"PhotographersPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographersPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographersPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		transaction:{
			options:{
				type:"MutationTransactionOptions",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateUploadUrl:{
			contentType:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			prefix:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateReadUrl:{
			objectKey:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	_MutationErrorType: "enum",
	MutationTransaction:{
		createContact:{
			data:{
				type:"ContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContact:{
			by:{
				type:"ContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContact:{
			by:{
				type:"ContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContact:{
			by:{
				type:"ContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCardMedia:{
			data:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactLocation:{
			data:{
				type:"ContactLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactLocation:{
			by:{
				type:"ContactLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactLocation:{
			by:{
				type:"ContactLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactLocation:{
			by:{
				type:"ContactLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDirector:{
			data:{
				type:"DirectorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDirector:{
			by:{
				type:"DirectorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDirector:{
			by:{
				type:"DirectorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DirectorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDirector:{
			by:{
				type:"DirectorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DirectorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DirectorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFilm:{
			data:{
				type:"FilmCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFilm:{
			by:{
				type:"FilmUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFilm:{
			by:{
				type:"FilmUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FilmUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFilm:{
			by:{
				type:"FilmUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FilmUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FilmCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDirectorLocation:{
			data:{
				type:"DirectorLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDirectorLocation:{
			by:{
				type:"DirectorLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDirectorLocation:{
			by:{
				type:"DirectorLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DirectorLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDirectorLocation:{
			by:{
				type:"DirectorLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DirectorLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DirectorLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactsPage:{
			data:{
				type:"ContactsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactsPage:{
			by:{
				type:"ContactsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactsPage:{
			by:{
				type:"ContactsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactsPage:{
			by:{
				type:"ContactsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDirectorsPage:{
			data:{
				type:"DirectorsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDirectorsPage:{
			by:{
				type:"DirectorsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDirectorsPage:{
			by:{
				type:"DirectorsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DirectorsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDirectorsPage:{
			by:{
				type:"DirectorsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DirectorsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DirectorsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFilmItem:{
			data:{
				type:"FilmItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFilmItem:{
			by:{
				type:"FilmItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFilmItem:{
			by:{
				type:"FilmItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FilmItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFilmItem:{
			by:{
				type:"FilmItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FilmItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FilmItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FilmItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDirectorContentGroup:{
			data:{
				type:"DirectorContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDirectorContentGroup:{
			by:{
				type:"DirectorContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDirectorContentGroup:{
			by:{
				type:"DirectorContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DirectorContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDirectorContentGroup:{
			by:{
				type:"DirectorContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DirectorContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DirectorContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DirectorContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographer:{
			data:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographerContentGroup:{
			data:{
				type:"PhotographerContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographerContentGroup:{
			by:{
				type:"PhotographerContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographerContentGroup:{
			by:{
				type:"PhotographerContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographerContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographerContentGroup:{
			by:{
				type:"PhotographerContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographerContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographerContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographerLocation:{
			data:{
				type:"PhotographerLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographerLocation:{
			by:{
				type:"PhotographerLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographerLocation:{
			by:{
				type:"PhotographerLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographerLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographerLocation:{
			by:{
				type:"PhotographerLocationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerLocationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographerLocationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographerLocationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographersPage:{
			data:{
				type:"PhotographersPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographersPage:{
			by:{
				type:"PhotographersPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographersPage:{
			by:{
				type:"PhotographersPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographersPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographersPage:{
			by:{
				type:"PhotographersPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographersPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographersPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createOurWorkPage:{
			data:{
				type:"OurWorkPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteOurWorkPage:{
			by:{
				type:"OurWorkPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateOurWorkPage:{
			by:{
				type:"OurWorkPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"OurWorkPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertOurWorkPage:{
			by:{
				type:"OurWorkPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"OurWorkPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"OurWorkPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createOurWorkPageContentGroup:{
			data:{
				type:"OurWorkPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteOurWorkPageContentGroup:{
			by:{
				type:"OurWorkPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateOurWorkPageContentGroup:{
			by:{
				type:"OurWorkPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"OurWorkPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertOurWorkPageContentGroup:{
			by:{
				type:"OurWorkPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OurWorkPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"OurWorkPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"OurWorkPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentGroup:{
			data:{
				type:"ContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentGroup:{
			by:{
				type:"ContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentGroup:{
			by:{
				type:"ContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentGroup:{
			by:{
				type:"ContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePageContentGroup:{
			data:{
				type:"HomePageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePageContentGroup:{
			by:{
				type:"HomePageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePageContentGroup:{
			by:{
				type:"HomePageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePageContentGroup:{
			by:{
				type:"HomePageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTabletopPage:{
			data:{
				type:"TabletopPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTabletopPage:{
			by:{
				type:"TabletopPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTabletopPage:{
			by:{
				type:"TabletopPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TabletopPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTabletopPage:{
			by:{
				type:"TabletopPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TabletopPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TabletopPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTabletopPageContentGroup:{
			data:{
				type:"TabletopPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTabletopPageContentGroup:{
			by:{
				type:"TabletopPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTabletopPageContentGroup:{
			by:{
				type:"TabletopPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TabletopPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTabletopPageContentGroup:{
			by:{
				type:"TabletopPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TabletopPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TabletopPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TabletopPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographersPageContentGroup:{
			data:{
				type:"PhotographersPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographersPageContentGroup:{
			by:{
				type:"PhotographersPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographersPageContentGroup:{
			by:{
				type:"PhotographersPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographersPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographersPageContentGroup:{
			by:{
				type:"PhotographersPageContentGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographersPageContentGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographersPageContentGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographersPageContentGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	MutationTransactionOptions:{
		deferForeignKeyConstraints:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Json: "String",
	_OnDeleteBehaviour: "enum",
	_RelationSide: "enum",
	_OrderByDirection: "enum"
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		getContact:"Contact",
		listContact:"Contact",
		paginateContact:"ContactConnection",
		validateCreateContact:"_ValidationResult",
		validateUpdateContact:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getCardMedia:"CardMedia",
		listCardMedia:"CardMedia",
		paginateCardMedia:"CardMediaConnection",
		validateCreateCardMedia:"_ValidationResult",
		validateUpdateCardMedia:"_ValidationResult",
		getFallbackSeo:"FallbackSeo",
		listFallbackSeo:"FallbackSeo",
		paginateFallbackSeo:"FallbackSeoConnection",
		validateCreateFallbackSeo:"_ValidationResult",
		validateUpdateFallbackSeo:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getSocialLink:"SocialLink",
		listSocialLink:"SocialLink",
		paginateSocialLink:"SocialLinkConnection",
		validateCreateSocialLink:"_ValidationResult",
		validateUpdateSocialLink:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHeaderLink:"HeaderLink",
		listHeaderLink:"HeaderLink",
		paginateHeaderLink:"HeaderLinkConnection",
		validateCreateHeaderLink:"_ValidationResult",
		validateUpdateHeaderLink:"_ValidationResult",
		getHomePage:"HomePage",
		listHomePage:"HomePage",
		paginateHomePage:"HomePageConnection",
		validateCreateHomePage:"_ValidationResult",
		validateUpdateHomePage:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getContactLocation:"ContactLocation",
		listContactLocation:"ContactLocation",
		paginateContactLocation:"ContactLocationConnection",
		validateCreateContactLocation:"_ValidationResult",
		validateUpdateContactLocation:"_ValidationResult",
		getDirector:"Director",
		listDirector:"Director",
		paginateDirector:"DirectorConnection",
		validateCreateDirector:"_ValidationResult",
		validateUpdateDirector:"_ValidationResult",
		getFilm:"Film",
		listFilm:"Film",
		paginateFilm:"FilmConnection",
		validateCreateFilm:"_ValidationResult",
		validateUpdateFilm:"_ValidationResult",
		getDirectorLocation:"DirectorLocation",
		listDirectorLocation:"DirectorLocation",
		paginateDirectorLocation:"DirectorLocationConnection",
		validateCreateDirectorLocation:"_ValidationResult",
		validateUpdateDirectorLocation:"_ValidationResult",
		getContactsPage:"ContactsPage",
		listContactsPage:"ContactsPage",
		paginateContactsPage:"ContactsPageConnection",
		validateCreateContactsPage:"_ValidationResult",
		validateUpdateContactsPage:"_ValidationResult",
		getDirectorsPage:"DirectorsPage",
		listDirectorsPage:"DirectorsPage",
		paginateDirectorsPage:"DirectorsPageConnection",
		validateCreateDirectorsPage:"_ValidationResult",
		validateUpdateDirectorsPage:"_ValidationResult",
		getFilmItem:"FilmItem",
		listFilmItem:"FilmItem",
		paginateFilmItem:"FilmItemConnection",
		validateCreateFilmItem:"_ValidationResult",
		validateUpdateFilmItem:"_ValidationResult",
		getDirectorContentGroup:"DirectorContentGroup",
		listDirectorContentGroup:"DirectorContentGroup",
		paginateDirectorContentGroup:"DirectorContentGroupConnection",
		validateCreateDirectorContentGroup:"_ValidationResult",
		validateUpdateDirectorContentGroup:"_ValidationResult",
		getPhotographer:"Photographer",
		listPhotographer:"Photographer",
		paginatePhotographer:"PhotographerConnection",
		validateCreatePhotographer:"_ValidationResult",
		validateUpdatePhotographer:"_ValidationResult",
		getPhotographerContentGroup:"PhotographerContentGroup",
		listPhotographerContentGroup:"PhotographerContentGroup",
		paginatePhotographerContentGroup:"PhotographerContentGroupConnection",
		validateCreatePhotographerContentGroup:"_ValidationResult",
		validateUpdatePhotographerContentGroup:"_ValidationResult",
		getPhotographerLocation:"PhotographerLocation",
		listPhotographerLocation:"PhotographerLocation",
		paginatePhotographerLocation:"PhotographerLocationConnection",
		validateCreatePhotographerLocation:"_ValidationResult",
		validateUpdatePhotographerLocation:"_ValidationResult",
		getPhotographersPage:"PhotographersPage",
		listPhotographersPage:"PhotographersPage",
		paginatePhotographersPage:"PhotographersPageConnection",
		validateCreatePhotographersPage:"_ValidationResult",
		validateUpdatePhotographersPage:"_ValidationResult",
		getOurWorkPage:"OurWorkPage",
		listOurWorkPage:"OurWorkPage",
		paginateOurWorkPage:"OurWorkPageConnection",
		validateCreateOurWorkPage:"_ValidationResult",
		validateUpdateOurWorkPage:"_ValidationResult",
		getOurWorkPageContentGroup:"OurWorkPageContentGroup",
		listOurWorkPageContentGroup:"OurWorkPageContentGroup",
		paginateOurWorkPageContentGroup:"OurWorkPageContentGroupConnection",
		validateCreateOurWorkPageContentGroup:"_ValidationResult",
		validateUpdateOurWorkPageContentGroup:"_ValidationResult",
		getContentGroup:"ContentGroup",
		listContentGroup:"ContentGroup",
		paginateContentGroup:"ContentGroupConnection",
		validateCreateContentGroup:"_ValidationResult",
		validateUpdateContentGroup:"_ValidationResult",
		getHomePageContentGroup:"HomePageContentGroup",
		listHomePageContentGroup:"HomePageContentGroup",
		paginateHomePageContentGroup:"HomePageContentGroupConnection",
		validateCreateHomePageContentGroup:"_ValidationResult",
		validateUpdateHomePageContentGroup:"_ValidationResult",
		getTabletopPage:"TabletopPage",
		listTabletopPage:"TabletopPage",
		paginateTabletopPage:"TabletopPageConnection",
		validateCreateTabletopPage:"_ValidationResult",
		validateUpdateTabletopPage:"_ValidationResult",
		getTabletopPageContentGroup:"TabletopPageContentGroup",
		listTabletopPageContentGroup:"TabletopPageContentGroup",
		paginateTabletopPageContentGroup:"TabletopPageContentGroupConnection",
		validateCreateTabletopPageContentGroup:"_ValidationResult",
		validateUpdateTabletopPageContentGroup:"_ValidationResult",
		getPhotographersPageContentGroup:"PhotographersPageContentGroup",
		listPhotographersPageContentGroup:"PhotographersPageContentGroup",
		paginatePhotographersPageContentGroup:"PhotographersPageContentGroupConnection",
		validateCreatePhotographersPageContentGroup:"_ValidationResult",
		validateUpdatePhotographersPageContentGroup:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info",
		schema:"_Schema",
		s3DummyQuery:"String"
	},
	Contact:{
		_meta:"ContactMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		position:"String",
		phone:"String",
		email:"String",
		image:"Image",
		contactLocation:"ContactLocation",
		wordpressId:"String"
	},
	ContactMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		position:"FieldMeta",
		phone:"FieldMeta",
		email:"FieldMeta",
		image:"FieldMeta",
		contactLocation:"FieldMeta",
		wordpressId:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		alt:"String"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		alt:"FieldMeta"
	},
	ContactLocation:{
		_meta:"ContactLocationMeta",
		id:"UUID",
		order:"Int",
		city:"String",
		state:"String",
		address:"String",
		email:"String",
		phone:"String",
		fax:"String",
		note:"String",
		contact:"Contact",
		contactByWordpressId:"Contact",
		contactByImage:"Contact",
		paginateContact:"ContactConnection"
	},
	ContactLocationMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		city:"FieldMeta",
		state:"FieldMeta",
		address:"FieldMeta",
		email:"FieldMeta",
		phone:"FieldMeta",
		fax:"FieldMeta",
		note:"FieldMeta",
		contact:"FieldMeta"
	},
	ContactConnection:{
		pageInfo:"PageInfo",
		edges:"ContactEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	ContactEdge:{
		node:"Contact"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	Content:{
		_meta:"ContentMeta",
		id:"UUID",
		blocks:"ContentBlock",
		blocksByReferences:"ContentBlock",
		paginateBlocks:"ContentBlockConnection"
	},
	ContentMeta:{
		id:"FieldMeta",
		blocks:"FieldMeta"
	},
	ContentBlock:{
		_meta:"ContentBlockMeta",
		id:"UUID",
		order:"Int",
		json:"String",
		content:"Content",
		references:"ContentReference",
		referencesByLink:"ContentReference",
		paginateReferences:"ContentReferenceConnection"
	},
	ContentBlockMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		json:"FieldMeta",
		content:"FieldMeta",
		references:"FieldMeta"
	},
	ContentReference:{
		_meta:"ContentReferenceMeta",
		id:"UUID",
		type:"ContentReferenceType",
		text:"String",
		block:"ContentBlock",
		link:"Link",
		image:"Image",
		cardMedia:"CardMedia"
	},
	ContentReferenceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		text:"FieldMeta",
		block:"FieldMeta",
		link:"FieldMeta",
		image:"FieldMeta",
		cardMedia:"FieldMeta"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkType",
		title:"String",
		externalLink:"String",
		internalLink:"Linkable"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		externalLink:"FieldMeta",
		internalLink:"FieldMeta"
	},
	Linkable:{
		_meta:"LinkableMeta",
		id:"UUID",
		url:"String",
		homePage:"HomePage",
		redirect:"Redirect",
		director:"Director",
		contactsPage:"ContactsPage",
		directorsPage:"DirectorsPage",
		photographer:"Photographer",
		photographersPage:"PhotographersPage",
		ourWorkPage:"OurWorkPage",
		tabletopPage:"TabletopPage"
	},
	LinkableMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		homePage:"FieldMeta",
		redirect:"FieldMeta",
		director:"FieldMeta",
		contactsPage:"FieldMeta",
		directorsPage:"FieldMeta",
		photographer:"FieldMeta",
		photographersPage:"FieldMeta",
		ourWorkPage:"FieldMeta",
		tabletopPage:"FieldMeta"
	},
	HomePage:{
		_meta:"HomePageMeta",
		id:"UUID",
		unique:"One",
		tagline:"String",
		logo:"Image",
		seo:"Seo",
		link:"Linkable",
		directorsText:"String",
		contentGroups:"HomePageContentGroup",
		backgroundImage:"Image",
		contentGroupsByContentGroup:"HomePageContentGroup",
		paginateContentGroups:"HomePageContentGroupConnection"
	},
	HomePageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		tagline:"FieldMeta",
		logo:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		directorsText:"FieldMeta",
		contentGroups:"FieldMeta",
		backgroundImage:"FieldMeta"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		ogImage:"Image"
	},
	SeoMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		ogImage:"FieldMeta"
	},
	HomePageContentGroup:{
		_meta:"HomePageContentGroupMeta",
		id:"UUID",
		order:"Int",
		homePage:"HomePage",
		contentGroup:"ContentGroup"
	},
	HomePageContentGroupMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		homePage:"FieldMeta",
		contentGroup:"FieldMeta"
	},
	ContentGroup:{
		_meta:"ContentGroupMeta",
		id:"UUID",
		title:"String",
		contentType:"ContentGroupType",
		gallery:"Gallery",
		films:"FilmItem",
		paginateFilms:"FilmItemConnection"
	},
	ContentGroupMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		contentType:"FieldMeta",
		gallery:"FieldMeta",
		films:"FieldMeta"
	},
	Gallery:{
		_meta:"GalleryMeta",
		id:"UUID",
		items:"GalleryItem",
		paginateItems:"GalleryItemConnection"
	},
	GalleryMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	GalleryItem:{
		_meta:"GalleryItemMeta",
		id:"UUID",
		order:"Int",
		list:"Gallery",
		image:"Image"
	},
	GalleryItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	GalleryItemConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryItemEdge"
	},
	GalleryItemEdge:{
		node:"GalleryItem"
	},
	FilmItem:{
		_meta:"FilmItemMeta",
		id:"UUID",
		order:"Int",
		contentGroups:"ContentGroup",
		film:"Film"
	},
	FilmItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		contentGroups:"FieldMeta",
		film:"FieldMeta"
	},
	Film:{
		_meta:"FilmMeta",
		id:"UUID",
		name:"String",
		author:"String",
		vimeoId:"String",
		posterImage:"Image",
		order:"Int",
		wordpressId:"String"
	},
	FilmMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		author:"FieldMeta",
		vimeoId:"FieldMeta",
		posterImage:"FieldMeta",
		order:"FieldMeta",
		wordpressId:"FieldMeta"
	},
	FilmItemConnection:{
		pageInfo:"PageInfo",
		edges:"FilmItemEdge"
	},
	FilmItemEdge:{
		node:"FilmItem"
	},
	HomePageContentGroupConnection:{
		pageInfo:"PageInfo",
		edges:"HomePageContentGroupEdge"
	},
	HomePageContentGroupEdge:{
		node:"HomePageContentGroup"
	},
	Redirect:{
		_meta:"RedirectMeta",
		id:"UUID",
		targetUrl:"String",
		link:"Linkable",
		target:"Linkable"
	},
	RedirectMeta:{
		id:"FieldMeta",
		targetUrl:"FieldMeta",
		link:"FieldMeta",
		target:"FieldMeta"
	},
	Director:{
		_meta:"DirectorMeta",
		id:"UUID",
		name:"String",
		leadParagraph:"String",
		image:"Image",
		link:"Linkable",
		order:"Int",
		contentGroups:"DirectorContentGroup",
		directorLocation:"DirectorLocation",
		wordpressId:"String",
		contentGroupsByContentGroup:"DirectorContentGroup",
		paginateContentGroups:"DirectorContentGroupConnection"
	},
	DirectorMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		leadParagraph:"FieldMeta",
		image:"FieldMeta",
		link:"FieldMeta",
		order:"FieldMeta",
		contentGroups:"FieldMeta",
		directorLocation:"FieldMeta",
		wordpressId:"FieldMeta"
	},
	DirectorContentGroup:{
		_meta:"DirectorContentGroupMeta",
		id:"UUID",
		order:"Int",
		director:"Director",
		contentGroup:"ContentGroup"
	},
	DirectorContentGroupMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		director:"FieldMeta",
		contentGroup:"FieldMeta"
	},
	DirectorLocation:{
		_meta:"DirectorLocationMeta",
		id:"UUID",
		order:"Int",
		city:"String",
		director:"Director",
		directorByWordpressId:"Director",
		directorByImage:"Director",
		directorByLink:"Director",
		directorByContentGroups:"Director",
		paginateDirector:"DirectorConnection"
	},
	DirectorLocationMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		city:"FieldMeta",
		director:"FieldMeta"
	},
	DirectorConnection:{
		pageInfo:"PageInfo",
		edges:"DirectorEdge"
	},
	DirectorEdge:{
		node:"Director"
	},
	DirectorContentGroupConnection:{
		pageInfo:"PageInfo",
		edges:"DirectorContentGroupEdge"
	},
	DirectorContentGroupEdge:{
		node:"DirectorContentGroup"
	},
	ContactsPage:{
		_meta:"ContactsPageMeta",
		id:"UUID",
		unique:"One",
		title:"String",
		seo:"Seo",
		link:"Linkable",
		leadParagraph:"String"
	},
	ContactsPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		title:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		leadParagraph:"FieldMeta"
	},
	DirectorsPage:{
		_meta:"DirectorsPageMeta",
		id:"UUID",
		unique:"One",
		title:"String",
		seo:"Seo",
		link:"Linkable",
		leadParagraph:"String"
	},
	DirectorsPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		title:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		leadParagraph:"FieldMeta"
	},
	Photographer:{
		_meta:"PhotographerMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		leadParagraph:"String",
		image:"Image",
		contentGroups:"PhotographerContentGroup",
		link:"Linkable",
		photographerLocation:"PhotographerLocation",
		wordpressId:"String",
		contentGroupsByContentGroup:"PhotographerContentGroup",
		paginateContentGroups:"PhotographerContentGroupConnection"
	},
	PhotographerMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		leadParagraph:"FieldMeta",
		image:"FieldMeta",
		contentGroups:"FieldMeta",
		link:"FieldMeta",
		photographerLocation:"FieldMeta",
		wordpressId:"FieldMeta"
	},
	PhotographerContentGroup:{
		_meta:"PhotographerContentGroupMeta",
		id:"UUID",
		order:"Int",
		photographer:"Photographer",
		contentGroup:"ContentGroup"
	},
	PhotographerContentGroupMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		photographer:"FieldMeta",
		contentGroup:"FieldMeta"
	},
	PhotographerLocation:{
		_meta:"PhotographerLocationMeta",
		id:"UUID",
		order:"Int",
		city:"String",
		photographer:"Photographer",
		photographerByWordpressId:"Photographer",
		photographerByImage:"Photographer",
		photographerByContentGroups:"Photographer",
		photographerByLink:"Photographer",
		paginatePhotographer:"PhotographerConnection"
	},
	PhotographerLocationMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		city:"FieldMeta",
		photographer:"FieldMeta"
	},
	PhotographerConnection:{
		pageInfo:"PageInfo",
		edges:"PhotographerEdge"
	},
	PhotographerEdge:{
		node:"Photographer"
	},
	PhotographerContentGroupConnection:{
		pageInfo:"PageInfo",
		edges:"PhotographerContentGroupEdge"
	},
	PhotographerContentGroupEdge:{
		node:"PhotographerContentGroup"
	},
	PhotographersPage:{
		_meta:"PhotographersPageMeta",
		id:"UUID",
		unique:"One",
		title:"String",
		leadParagraph:"String",
		seo:"Seo",
		link:"Linkable",
		contentGroups:"PhotographersPageContentGroup",
		contentGroupsByContentGroup:"PhotographersPageContentGroup",
		paginateContentGroups:"PhotographersPageContentGroupConnection"
	},
	PhotographersPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		title:"FieldMeta",
		leadParagraph:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		contentGroups:"FieldMeta"
	},
	PhotographersPageContentGroup:{
		_meta:"PhotographersPageContentGroupMeta",
		id:"UUID",
		order:"Int",
		photographersPage:"PhotographersPage",
		contentGroup:"ContentGroup"
	},
	PhotographersPageContentGroupMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		photographersPage:"FieldMeta",
		contentGroup:"FieldMeta"
	},
	PhotographersPageContentGroupConnection:{
		pageInfo:"PageInfo",
		edges:"PhotographersPageContentGroupEdge"
	},
	PhotographersPageContentGroupEdge:{
		node:"PhotographersPageContentGroup"
	},
	OurWorkPage:{
		_meta:"OurWorkPageMeta",
		id:"UUID",
		unique:"One",
		title:"String",
		leadParagraph:"String",
		link:"Linkable",
		contentGroups:"OurWorkPageContentGroup",
		seo:"Seo",
		contentGroupsByContentGroup:"OurWorkPageContentGroup",
		paginateContentGroups:"OurWorkPageContentGroupConnection"
	},
	OurWorkPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		title:"FieldMeta",
		leadParagraph:"FieldMeta",
		link:"FieldMeta",
		contentGroups:"FieldMeta",
		seo:"FieldMeta"
	},
	OurWorkPageContentGroup:{
		_meta:"OurWorkPageContentGroupMeta",
		id:"UUID",
		order:"Int",
		ourWorkPage:"OurWorkPage",
		contentGroup:"ContentGroup"
	},
	OurWorkPageContentGroupMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		ourWorkPage:"FieldMeta",
		contentGroup:"FieldMeta"
	},
	OurWorkPageContentGroupConnection:{
		pageInfo:"PageInfo",
		edges:"OurWorkPageContentGroupEdge"
	},
	OurWorkPageContentGroupEdge:{
		node:"OurWorkPageContentGroup"
	},
	TabletopPage:{
		_meta:"TabletopPageMeta",
		id:"UUID",
		unique:"One",
		title:"String",
		leadParagraph:"String",
		teamTitle:"String",
		link:"Linkable",
		logo:"Image",
		seo:"Seo",
		contentGroups:"TabletopPageContentGroup",
		contentGroupsByContentGroup:"TabletopPageContentGroup",
		paginateContentGroups:"TabletopPageContentGroupConnection"
	},
	TabletopPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		title:"FieldMeta",
		leadParagraph:"FieldMeta",
		teamTitle:"FieldMeta",
		link:"FieldMeta",
		logo:"FieldMeta",
		seo:"FieldMeta",
		contentGroups:"FieldMeta"
	},
	TabletopPageContentGroup:{
		_meta:"TabletopPageContentGroupMeta",
		id:"UUID",
		order:"Int",
		tabletopPage:"TabletopPage",
		contentGroup:"ContentGroup"
	},
	TabletopPageContentGroupMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		tabletopPage:"FieldMeta",
		contentGroup:"FieldMeta"
	},
	TabletopPageContentGroupConnection:{
		pageInfo:"PageInfo",
		edges:"TabletopPageContentGroupEdge"
	},
	TabletopPageContentGroupEdge:{
		node:"TabletopPageContentGroup"
	},
	CardMedia:{
		_meta:"CardMediaMeta",
		id:"UUID",
		text:"String",
		imageNote:"String",
		image:"Image"
	},
	CardMediaMeta:{
		id:"FieldMeta",
		text:"FieldMeta",
		imageNote:"FieldMeta",
		image:"FieldMeta"
	},
	ContentReferenceConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceEdge"
	},
	ContentReferenceEdge:{
		node:"ContentReference"
	},
	ContentBlockConnection:{
		pageInfo:"PageInfo",
		edges:"ContentBlockEdge"
	},
	ContentBlockEdge:{
		node:"ContentBlock"
	},
	ContentConnection:{
		pageInfo:"PageInfo",
		edges:"ContentEdge"
	},
	ContentEdge:{
		node:"Content"
	},
	CardMediaConnection:{
		pageInfo:"PageInfo",
		edges:"CardMediaEdge"
	},
	CardMediaEdge:{
		node:"CardMedia"
	},
	FallbackSeo:{
		_meta:"FallbackSeoMeta",
		id:"UUID",
		unique:"One",
		seo:"Seo"
	},
	FallbackSeoMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		seo:"FieldMeta"
	},
	FallbackSeoConnection:{
		pageInfo:"PageInfo",
		edges:"FallbackSeoEdge"
	},
	FallbackSeoEdge:{
		node:"FallbackSeo"
	},
	Footer:{
		_meta:"FooterMeta",
		id:"UUID",
		unique:"One",
		logo:"Image",
		socialLinks:"SocialLink",
		directorsText:"String",
		contactText:"String",
		directorsButton:"Link",
		contactButton:"Link",
		paginateSocialLinks:"SocialLinkConnection"
	},
	FooterMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		logo:"FieldMeta",
		socialLinks:"FieldMeta",
		directorsText:"FieldMeta",
		contactText:"FieldMeta",
		directorsButton:"FieldMeta",
		contactButton:"FieldMeta"
	},
	SocialLink:{
		_meta:"SocialLinkMeta",
		id:"UUID",
		type:"SocialLinkType",
		order:"Int",
		link:"String",
		linkLabel:"String"
	},
	SocialLinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta",
		linkLabel:"FieldMeta"
	},
	SocialLinkConnection:{
		pageInfo:"PageInfo",
		edges:"SocialLinkEdge"
	},
	SocialLinkEdge:{
		node:"SocialLink"
	},
	FooterConnection:{
		pageInfo:"PageInfo",
		edges:"FooterEdge"
	},
	FooterEdge:{
		node:"Footer"
	},
	GalleryConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryEdge"
	},
	GalleryEdge:{
		node:"Gallery"
	},
	Header:{
		_meta:"HeaderMeta",
		id:"UUID",
		unique:"One",
		logo:"Image",
		links:"HeaderLink",
		paginateLinks:"HeaderLinkConnection"
	},
	HeaderMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		logo:"FieldMeta",
		links:"FieldMeta"
	},
	HeaderLink:{
		_meta:"HeaderLinkMeta",
		id:"UUID",
		order:"Int",
		link:"Link"
	},
	HeaderLinkMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta"
	},
	HeaderLinkConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderLinkEdge"
	},
	HeaderLinkEdge:{
		node:"HeaderLink"
	},
	HeaderConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderEdge"
	},
	HeaderEdge:{
		node:"Header"
	},
	HomePageConnection:{
		pageInfo:"PageInfo",
		edges:"HomePageEdge"
	},
	HomePageEdge:{
		node:"HomePage"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	LinkableConnection:{
		pageInfo:"PageInfo",
		edges:"LinkableEdge"
	},
	LinkableEdge:{
		node:"Linkable"
	},
	RedirectConnection:{
		pageInfo:"PageInfo",
		edges:"RedirectEdge"
	},
	RedirectEdge:{
		node:"Redirect"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	ContactLocationConnection:{
		pageInfo:"PageInfo",
		edges:"ContactLocationEdge"
	},
	ContactLocationEdge:{
		node:"ContactLocation"
	},
	FilmConnection:{
		pageInfo:"PageInfo",
		edges:"FilmEdge"
	},
	FilmEdge:{
		node:"Film"
	},
	DirectorLocationConnection:{
		pageInfo:"PageInfo",
		edges:"DirectorLocationEdge"
	},
	DirectorLocationEdge:{
		node:"DirectorLocation"
	},
	ContactsPageConnection:{
		pageInfo:"PageInfo",
		edges:"ContactsPageEdge"
	},
	ContactsPageEdge:{
		node:"ContactsPage"
	},
	DirectorsPageConnection:{
		pageInfo:"PageInfo",
		edges:"DirectorsPageEdge"
	},
	DirectorsPageEdge:{
		node:"DirectorsPage"
	},
	PhotographerLocationConnection:{
		pageInfo:"PageInfo",
		edges:"PhotographerLocationEdge"
	},
	PhotographerLocationEdge:{
		node:"PhotographerLocation"
	},
	PhotographersPageConnection:{
		pageInfo:"PageInfo",
		edges:"PhotographersPageEdge"
	},
	PhotographersPageEdge:{
		node:"PhotographersPage"
	},
	OurWorkPageConnection:{
		pageInfo:"PageInfo",
		edges:"OurWorkPageEdge"
	},
	OurWorkPageEdge:{
		node:"OurWorkPage"
	},
	ContentGroupConnection:{
		pageInfo:"PageInfo",
		edges:"ContentGroupEdge"
	},
	ContentGroupEdge:{
		node:"ContentGroup"
	},
	TabletopPageConnection:{
		pageInfo:"PageInfo",
		edges:"TabletopPageEdge"
	},
	TabletopPageEdge:{
		node:"TabletopPage"
	},
	QueryTransaction:{
		getContact:"Contact",
		listContact:"Contact",
		paginateContact:"ContactConnection",
		validateCreateContact:"_ValidationResult",
		validateUpdateContact:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getCardMedia:"CardMedia",
		listCardMedia:"CardMedia",
		paginateCardMedia:"CardMediaConnection",
		validateCreateCardMedia:"_ValidationResult",
		validateUpdateCardMedia:"_ValidationResult",
		getFallbackSeo:"FallbackSeo",
		listFallbackSeo:"FallbackSeo",
		paginateFallbackSeo:"FallbackSeoConnection",
		validateCreateFallbackSeo:"_ValidationResult",
		validateUpdateFallbackSeo:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getSocialLink:"SocialLink",
		listSocialLink:"SocialLink",
		paginateSocialLink:"SocialLinkConnection",
		validateCreateSocialLink:"_ValidationResult",
		validateUpdateSocialLink:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHeaderLink:"HeaderLink",
		listHeaderLink:"HeaderLink",
		paginateHeaderLink:"HeaderLinkConnection",
		validateCreateHeaderLink:"_ValidationResult",
		validateUpdateHeaderLink:"_ValidationResult",
		getHomePage:"HomePage",
		listHomePage:"HomePage",
		paginateHomePage:"HomePageConnection",
		validateCreateHomePage:"_ValidationResult",
		validateUpdateHomePage:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getContactLocation:"ContactLocation",
		listContactLocation:"ContactLocation",
		paginateContactLocation:"ContactLocationConnection",
		validateCreateContactLocation:"_ValidationResult",
		validateUpdateContactLocation:"_ValidationResult",
		getDirector:"Director",
		listDirector:"Director",
		paginateDirector:"DirectorConnection",
		validateCreateDirector:"_ValidationResult",
		validateUpdateDirector:"_ValidationResult",
		getFilm:"Film",
		listFilm:"Film",
		paginateFilm:"FilmConnection",
		validateCreateFilm:"_ValidationResult",
		validateUpdateFilm:"_ValidationResult",
		getDirectorLocation:"DirectorLocation",
		listDirectorLocation:"DirectorLocation",
		paginateDirectorLocation:"DirectorLocationConnection",
		validateCreateDirectorLocation:"_ValidationResult",
		validateUpdateDirectorLocation:"_ValidationResult",
		getContactsPage:"ContactsPage",
		listContactsPage:"ContactsPage",
		paginateContactsPage:"ContactsPageConnection",
		validateCreateContactsPage:"_ValidationResult",
		validateUpdateContactsPage:"_ValidationResult",
		getDirectorsPage:"DirectorsPage",
		listDirectorsPage:"DirectorsPage",
		paginateDirectorsPage:"DirectorsPageConnection",
		validateCreateDirectorsPage:"_ValidationResult",
		validateUpdateDirectorsPage:"_ValidationResult",
		getFilmItem:"FilmItem",
		listFilmItem:"FilmItem",
		paginateFilmItem:"FilmItemConnection",
		validateCreateFilmItem:"_ValidationResult",
		validateUpdateFilmItem:"_ValidationResult",
		getDirectorContentGroup:"DirectorContentGroup",
		listDirectorContentGroup:"DirectorContentGroup",
		paginateDirectorContentGroup:"DirectorContentGroupConnection",
		validateCreateDirectorContentGroup:"_ValidationResult",
		validateUpdateDirectorContentGroup:"_ValidationResult",
		getPhotographer:"Photographer",
		listPhotographer:"Photographer",
		paginatePhotographer:"PhotographerConnection",
		validateCreatePhotographer:"_ValidationResult",
		validateUpdatePhotographer:"_ValidationResult",
		getPhotographerContentGroup:"PhotographerContentGroup",
		listPhotographerContentGroup:"PhotographerContentGroup",
		paginatePhotographerContentGroup:"PhotographerContentGroupConnection",
		validateCreatePhotographerContentGroup:"_ValidationResult",
		validateUpdatePhotographerContentGroup:"_ValidationResult",
		getPhotographerLocation:"PhotographerLocation",
		listPhotographerLocation:"PhotographerLocation",
		paginatePhotographerLocation:"PhotographerLocationConnection",
		validateCreatePhotographerLocation:"_ValidationResult",
		validateUpdatePhotographerLocation:"_ValidationResult",
		getPhotographersPage:"PhotographersPage",
		listPhotographersPage:"PhotographersPage",
		paginatePhotographersPage:"PhotographersPageConnection",
		validateCreatePhotographersPage:"_ValidationResult",
		validateUpdatePhotographersPage:"_ValidationResult",
		getOurWorkPage:"OurWorkPage",
		listOurWorkPage:"OurWorkPage",
		paginateOurWorkPage:"OurWorkPageConnection",
		validateCreateOurWorkPage:"_ValidationResult",
		validateUpdateOurWorkPage:"_ValidationResult",
		getOurWorkPageContentGroup:"OurWorkPageContentGroup",
		listOurWorkPageContentGroup:"OurWorkPageContentGroup",
		paginateOurWorkPageContentGroup:"OurWorkPageContentGroupConnection",
		validateCreateOurWorkPageContentGroup:"_ValidationResult",
		validateUpdateOurWorkPageContentGroup:"_ValidationResult",
		getContentGroup:"ContentGroup",
		listContentGroup:"ContentGroup",
		paginateContentGroup:"ContentGroupConnection",
		validateCreateContentGroup:"_ValidationResult",
		validateUpdateContentGroup:"_ValidationResult",
		getHomePageContentGroup:"HomePageContentGroup",
		listHomePageContentGroup:"HomePageContentGroup",
		paginateHomePageContentGroup:"HomePageContentGroupConnection",
		validateCreateHomePageContentGroup:"_ValidationResult",
		validateUpdateHomePageContentGroup:"_ValidationResult",
		getTabletopPage:"TabletopPage",
		listTabletopPage:"TabletopPage",
		paginateTabletopPage:"TabletopPageConnection",
		validateCreateTabletopPage:"_ValidationResult",
		validateUpdateTabletopPage:"_ValidationResult",
		getTabletopPageContentGroup:"TabletopPageContentGroup",
		listTabletopPageContentGroup:"TabletopPageContentGroup",
		paginateTabletopPageContentGroup:"TabletopPageContentGroupConnection",
		validateCreateTabletopPageContentGroup:"_ValidationResult",
		validateUpdateTabletopPageContentGroup:"_ValidationResult",
		getPhotographersPageContentGroup:"PhotographersPageContentGroup",
		listPhotographersPageContentGroup:"PhotographersPageContentGroup",
		paginatePhotographersPageContentGroup:"PhotographersPageContentGroupConnection",
		validateCreatePhotographersPageContentGroup:"_ValidationResult",
		validateUpdatePhotographersPageContentGroup:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		createContact:"ContactCreateResult",
		deleteContact:"ContactDeleteResult",
		updateContact:"ContactUpdateResult",
		upsertContact:"ContactUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createCardMedia:"CardMediaCreateResult",
		deleteCardMedia:"CardMediaDeleteResult",
		updateCardMedia:"CardMediaUpdateResult",
		upsertCardMedia:"CardMediaUpsertResult",
		createFallbackSeo:"FallbackSeoCreateResult",
		deleteFallbackSeo:"FallbackSeoDeleteResult",
		updateFallbackSeo:"FallbackSeoUpdateResult",
		upsertFallbackSeo:"FallbackSeoUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createSocialLink:"SocialLinkCreateResult",
		deleteSocialLink:"SocialLinkDeleteResult",
		updateSocialLink:"SocialLinkUpdateResult",
		upsertSocialLink:"SocialLinkUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHeaderLink:"HeaderLinkCreateResult",
		deleteHeaderLink:"HeaderLinkDeleteResult",
		updateHeaderLink:"HeaderLinkUpdateResult",
		upsertHeaderLink:"HeaderLinkUpsertResult",
		createHomePage:"HomePageCreateResult",
		deleteHomePage:"HomePageDeleteResult",
		updateHomePage:"HomePageUpdateResult",
		upsertHomePage:"HomePageUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createContactLocation:"ContactLocationCreateResult",
		deleteContactLocation:"ContactLocationDeleteResult",
		updateContactLocation:"ContactLocationUpdateResult",
		upsertContactLocation:"ContactLocationUpsertResult",
		createDirector:"DirectorCreateResult",
		deleteDirector:"DirectorDeleteResult",
		updateDirector:"DirectorUpdateResult",
		upsertDirector:"DirectorUpsertResult",
		createFilm:"FilmCreateResult",
		deleteFilm:"FilmDeleteResult",
		updateFilm:"FilmUpdateResult",
		upsertFilm:"FilmUpsertResult",
		createDirectorLocation:"DirectorLocationCreateResult",
		deleteDirectorLocation:"DirectorLocationDeleteResult",
		updateDirectorLocation:"DirectorLocationUpdateResult",
		upsertDirectorLocation:"DirectorLocationUpsertResult",
		createContactsPage:"ContactsPageCreateResult",
		deleteContactsPage:"ContactsPageDeleteResult",
		updateContactsPage:"ContactsPageUpdateResult",
		upsertContactsPage:"ContactsPageUpsertResult",
		createDirectorsPage:"DirectorsPageCreateResult",
		deleteDirectorsPage:"DirectorsPageDeleteResult",
		updateDirectorsPage:"DirectorsPageUpdateResult",
		upsertDirectorsPage:"DirectorsPageUpsertResult",
		createFilmItem:"FilmItemCreateResult",
		deleteFilmItem:"FilmItemDeleteResult",
		updateFilmItem:"FilmItemUpdateResult",
		upsertFilmItem:"FilmItemUpsertResult",
		createDirectorContentGroup:"DirectorContentGroupCreateResult",
		deleteDirectorContentGroup:"DirectorContentGroupDeleteResult",
		updateDirectorContentGroup:"DirectorContentGroupUpdateResult",
		upsertDirectorContentGroup:"DirectorContentGroupUpsertResult",
		createPhotographer:"PhotographerCreateResult",
		deletePhotographer:"PhotographerDeleteResult",
		updatePhotographer:"PhotographerUpdateResult",
		upsertPhotographer:"PhotographerUpsertResult",
		createPhotographerContentGroup:"PhotographerContentGroupCreateResult",
		deletePhotographerContentGroup:"PhotographerContentGroupDeleteResult",
		updatePhotographerContentGroup:"PhotographerContentGroupUpdateResult",
		upsertPhotographerContentGroup:"PhotographerContentGroupUpsertResult",
		createPhotographerLocation:"PhotographerLocationCreateResult",
		deletePhotographerLocation:"PhotographerLocationDeleteResult",
		updatePhotographerLocation:"PhotographerLocationUpdateResult",
		upsertPhotographerLocation:"PhotographerLocationUpsertResult",
		createPhotographersPage:"PhotographersPageCreateResult",
		deletePhotographersPage:"PhotographersPageDeleteResult",
		updatePhotographersPage:"PhotographersPageUpdateResult",
		upsertPhotographersPage:"PhotographersPageUpsertResult",
		createOurWorkPage:"OurWorkPageCreateResult",
		deleteOurWorkPage:"OurWorkPageDeleteResult",
		updateOurWorkPage:"OurWorkPageUpdateResult",
		upsertOurWorkPage:"OurWorkPageUpsertResult",
		createOurWorkPageContentGroup:"OurWorkPageContentGroupCreateResult",
		deleteOurWorkPageContentGroup:"OurWorkPageContentGroupDeleteResult",
		updateOurWorkPageContentGroup:"OurWorkPageContentGroupUpdateResult",
		upsertOurWorkPageContentGroup:"OurWorkPageContentGroupUpsertResult",
		createContentGroup:"ContentGroupCreateResult",
		deleteContentGroup:"ContentGroupDeleteResult",
		updateContentGroup:"ContentGroupUpdateResult",
		upsertContentGroup:"ContentGroupUpsertResult",
		createHomePageContentGroup:"HomePageContentGroupCreateResult",
		deleteHomePageContentGroup:"HomePageContentGroupDeleteResult",
		updateHomePageContentGroup:"HomePageContentGroupUpdateResult",
		upsertHomePageContentGroup:"HomePageContentGroupUpsertResult",
		createTabletopPage:"TabletopPageCreateResult",
		deleteTabletopPage:"TabletopPageDeleteResult",
		updateTabletopPage:"TabletopPageUpdateResult",
		upsertTabletopPage:"TabletopPageUpsertResult",
		createTabletopPageContentGroup:"TabletopPageContentGroupCreateResult",
		deleteTabletopPageContentGroup:"TabletopPageContentGroupDeleteResult",
		updateTabletopPageContentGroup:"TabletopPageContentGroupUpdateResult",
		upsertTabletopPageContentGroup:"TabletopPageContentGroupUpsertResult",
		createPhotographersPageContentGroup:"PhotographersPageContentGroupCreateResult",
		deletePhotographersPageContentGroup:"PhotographersPageContentGroupDeleteResult",
		updatePhotographersPageContentGroup:"PhotographersPageContentGroupUpdateResult",
		upsertPhotographersPageContentGroup:"PhotographersPageContentGroupUpsertResult",
		transaction:"MutationTransaction",
		query:"Query",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead"
	},
	ContactCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Contact",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on ContactCreateResult": "ContactCreateResult",
		"...on ContactDeleteResult": "ContactDeleteResult",
		"...on ContactUpdateResult": "ContactUpdateResult",
		"...on ContactUpsertResult": "ContactUpsertResult",
		"...on ContentCreateResult": "ContentCreateResult",
		"...on ContentDeleteResult": "ContentDeleteResult",
		"...on ContentUpdateResult": "ContentUpdateResult",
		"...on ContentUpsertResult": "ContentUpsertResult",
		"...on ContentBlockCreateResult": "ContentBlockCreateResult",
		"...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
		"...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
		"...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
		"...on ContentReferenceCreateResult": "ContentReferenceCreateResult",
		"...on ContentReferenceDeleteResult": "ContentReferenceDeleteResult",
		"...on ContentReferenceUpdateResult": "ContentReferenceUpdateResult",
		"...on ContentReferenceUpsertResult": "ContentReferenceUpsertResult",
		"...on CardMediaCreateResult": "CardMediaCreateResult",
		"...on CardMediaDeleteResult": "CardMediaDeleteResult",
		"...on CardMediaUpdateResult": "CardMediaUpdateResult",
		"...on CardMediaUpsertResult": "CardMediaUpsertResult",
		"...on FallbackSeoCreateResult": "FallbackSeoCreateResult",
		"...on FallbackSeoDeleteResult": "FallbackSeoDeleteResult",
		"...on FallbackSeoUpdateResult": "FallbackSeoUpdateResult",
		"...on FallbackSeoUpsertResult": "FallbackSeoUpsertResult",
		"...on FooterCreateResult": "FooterCreateResult",
		"...on FooterDeleteResult": "FooterDeleteResult",
		"...on FooterUpdateResult": "FooterUpdateResult",
		"...on FooterUpsertResult": "FooterUpsertResult",
		"...on SocialLinkCreateResult": "SocialLinkCreateResult",
		"...on SocialLinkDeleteResult": "SocialLinkDeleteResult",
		"...on SocialLinkUpdateResult": "SocialLinkUpdateResult",
		"...on SocialLinkUpsertResult": "SocialLinkUpsertResult",
		"...on GalleryCreateResult": "GalleryCreateResult",
		"...on GalleryDeleteResult": "GalleryDeleteResult",
		"...on GalleryUpdateResult": "GalleryUpdateResult",
		"...on GalleryUpsertResult": "GalleryUpsertResult",
		"...on GalleryItemCreateResult": "GalleryItemCreateResult",
		"...on GalleryItemDeleteResult": "GalleryItemDeleteResult",
		"...on GalleryItemUpdateResult": "GalleryItemUpdateResult",
		"...on GalleryItemUpsertResult": "GalleryItemUpsertResult",
		"...on HeaderCreateResult": "HeaderCreateResult",
		"...on HeaderDeleteResult": "HeaderDeleteResult",
		"...on HeaderUpdateResult": "HeaderUpdateResult",
		"...on HeaderUpsertResult": "HeaderUpsertResult",
		"...on HeaderLinkCreateResult": "HeaderLinkCreateResult",
		"...on HeaderLinkDeleteResult": "HeaderLinkDeleteResult",
		"...on HeaderLinkUpdateResult": "HeaderLinkUpdateResult",
		"...on HeaderLinkUpsertResult": "HeaderLinkUpsertResult",
		"...on HomePageCreateResult": "HomePageCreateResult",
		"...on HomePageDeleteResult": "HomePageDeleteResult",
		"...on HomePageUpdateResult": "HomePageUpdateResult",
		"...on HomePageUpsertResult": "HomePageUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on LinkableCreateResult": "LinkableCreateResult",
		"...on LinkableDeleteResult": "LinkableDeleteResult",
		"...on LinkableUpdateResult": "LinkableUpdateResult",
		"...on LinkableUpsertResult": "LinkableUpsertResult",
		"...on RedirectCreateResult": "RedirectCreateResult",
		"...on RedirectDeleteResult": "RedirectDeleteResult",
		"...on RedirectUpdateResult": "RedirectUpdateResult",
		"...on RedirectUpsertResult": "RedirectUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on ContactLocationCreateResult": "ContactLocationCreateResult",
		"...on ContactLocationDeleteResult": "ContactLocationDeleteResult",
		"...on ContactLocationUpdateResult": "ContactLocationUpdateResult",
		"...on ContactLocationUpsertResult": "ContactLocationUpsertResult",
		"...on DirectorCreateResult": "DirectorCreateResult",
		"...on DirectorDeleteResult": "DirectorDeleteResult",
		"...on DirectorUpdateResult": "DirectorUpdateResult",
		"...on DirectorUpsertResult": "DirectorUpsertResult",
		"...on FilmCreateResult": "FilmCreateResult",
		"...on FilmDeleteResult": "FilmDeleteResult",
		"...on FilmUpdateResult": "FilmUpdateResult",
		"...on FilmUpsertResult": "FilmUpsertResult",
		"...on DirectorLocationCreateResult": "DirectorLocationCreateResult",
		"...on DirectorLocationDeleteResult": "DirectorLocationDeleteResult",
		"...on DirectorLocationUpdateResult": "DirectorLocationUpdateResult",
		"...on DirectorLocationUpsertResult": "DirectorLocationUpsertResult",
		"...on ContactsPageCreateResult": "ContactsPageCreateResult",
		"...on ContactsPageDeleteResult": "ContactsPageDeleteResult",
		"...on ContactsPageUpdateResult": "ContactsPageUpdateResult",
		"...on ContactsPageUpsertResult": "ContactsPageUpsertResult",
		"...on DirectorsPageCreateResult": "DirectorsPageCreateResult",
		"...on DirectorsPageDeleteResult": "DirectorsPageDeleteResult",
		"...on DirectorsPageUpdateResult": "DirectorsPageUpdateResult",
		"...on DirectorsPageUpsertResult": "DirectorsPageUpsertResult",
		"...on FilmItemCreateResult": "FilmItemCreateResult",
		"...on FilmItemDeleteResult": "FilmItemDeleteResult",
		"...on FilmItemUpdateResult": "FilmItemUpdateResult",
		"...on FilmItemUpsertResult": "FilmItemUpsertResult",
		"...on DirectorContentGroupCreateResult": "DirectorContentGroupCreateResult",
		"...on DirectorContentGroupDeleteResult": "DirectorContentGroupDeleteResult",
		"...on DirectorContentGroupUpdateResult": "DirectorContentGroupUpdateResult",
		"...on DirectorContentGroupUpsertResult": "DirectorContentGroupUpsertResult",
		"...on PhotographerCreateResult": "PhotographerCreateResult",
		"...on PhotographerDeleteResult": "PhotographerDeleteResult",
		"...on PhotographerUpdateResult": "PhotographerUpdateResult",
		"...on PhotographerUpsertResult": "PhotographerUpsertResult",
		"...on PhotographerContentGroupCreateResult": "PhotographerContentGroupCreateResult",
		"...on PhotographerContentGroupDeleteResult": "PhotographerContentGroupDeleteResult",
		"...on PhotographerContentGroupUpdateResult": "PhotographerContentGroupUpdateResult",
		"...on PhotographerContentGroupUpsertResult": "PhotographerContentGroupUpsertResult",
		"...on PhotographerLocationCreateResult": "PhotographerLocationCreateResult",
		"...on PhotographerLocationDeleteResult": "PhotographerLocationDeleteResult",
		"...on PhotographerLocationUpdateResult": "PhotographerLocationUpdateResult",
		"...on PhotographerLocationUpsertResult": "PhotographerLocationUpsertResult",
		"...on PhotographersPageCreateResult": "PhotographersPageCreateResult",
		"...on PhotographersPageDeleteResult": "PhotographersPageDeleteResult",
		"...on PhotographersPageUpdateResult": "PhotographersPageUpdateResult",
		"...on PhotographersPageUpsertResult": "PhotographersPageUpsertResult",
		"...on OurWorkPageCreateResult": "OurWorkPageCreateResult",
		"...on OurWorkPageDeleteResult": "OurWorkPageDeleteResult",
		"...on OurWorkPageUpdateResult": "OurWorkPageUpdateResult",
		"...on OurWorkPageUpsertResult": "OurWorkPageUpsertResult",
		"...on OurWorkPageContentGroupCreateResult": "OurWorkPageContentGroupCreateResult",
		"...on OurWorkPageContentGroupDeleteResult": "OurWorkPageContentGroupDeleteResult",
		"...on OurWorkPageContentGroupUpdateResult": "OurWorkPageContentGroupUpdateResult",
		"...on OurWorkPageContentGroupUpsertResult": "OurWorkPageContentGroupUpsertResult",
		"...on ContentGroupCreateResult": "ContentGroupCreateResult",
		"...on ContentGroupDeleteResult": "ContentGroupDeleteResult",
		"...on ContentGroupUpdateResult": "ContentGroupUpdateResult",
		"...on ContentGroupUpsertResult": "ContentGroupUpsertResult",
		"...on HomePageContentGroupCreateResult": "HomePageContentGroupCreateResult",
		"...on HomePageContentGroupDeleteResult": "HomePageContentGroupDeleteResult",
		"...on HomePageContentGroupUpdateResult": "HomePageContentGroupUpdateResult",
		"...on HomePageContentGroupUpsertResult": "HomePageContentGroupUpsertResult",
		"...on TabletopPageCreateResult": "TabletopPageCreateResult",
		"...on TabletopPageDeleteResult": "TabletopPageDeleteResult",
		"...on TabletopPageUpdateResult": "TabletopPageUpdateResult",
		"...on TabletopPageUpsertResult": "TabletopPageUpsertResult",
		"...on TabletopPageContentGroupCreateResult": "TabletopPageContentGroupCreateResult",
		"...on TabletopPageContentGroupDeleteResult": "TabletopPageContentGroupDeleteResult",
		"...on TabletopPageContentGroupUpdateResult": "TabletopPageContentGroupUpdateResult",
		"...on TabletopPageContentGroupUpsertResult": "TabletopPageContentGroupUpsertResult",
		"...on PhotographersPageContentGroupCreateResult": "PhotographersPageContentGroupCreateResult",
		"...on PhotographersPageContentGroupDeleteResult": "PhotographersPageContentGroupDeleteResult",
		"...on PhotographersPageContentGroupUpdateResult": "PhotographersPageContentGroupUpdateResult",
		"...on PhotographersPageContentGroupUpsertResult": "PhotographersPageContentGroupUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	ContactDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Contact"
	},
	ContactUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Contact",
		validation:"_ValidationResult"
	},
	ContactUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Contact",
		validation:"_ValidationResult"
	},
	ContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content"
	},
	ContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentBlockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock"
	},
	ContentBlockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentReferenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference"
	},
	ContentReferenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	CardMediaCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardMedia",
		validation:"_ValidationResult"
	},
	CardMediaDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardMedia"
	},
	CardMediaUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardMedia",
		validation:"_ValidationResult"
	},
	CardMediaUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardMedia",
		validation:"_ValidationResult"
	},
	FallbackSeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo",
		validation:"_ValidationResult"
	},
	FallbackSeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo"
	},
	FallbackSeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo",
		validation:"_ValidationResult"
	},
	FallbackSeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo",
		validation:"_ValidationResult"
	},
	FooterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer"
	},
	FooterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	SocialLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SocialLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink"
	},
	SocialLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SocialLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	GalleryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery"
	},
	GalleryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem"
	},
	GalleryItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	HeaderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header"
	},
	HeaderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink",
		validation:"_ValidationResult"
	},
	HeaderLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink"
	},
	HeaderLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink",
		validation:"_ValidationResult"
	},
	HeaderLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink",
		validation:"_ValidationResult"
	},
	HomePageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage"
	},
	HomePageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable"
	},
	LinkableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	RedirectCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect"
	},
	RedirectUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	ContactLocationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactLocation",
		validation:"_ValidationResult"
	},
	ContactLocationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactLocation"
	},
	ContactLocationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactLocation",
		validation:"_ValidationResult"
	},
	ContactLocationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactLocation",
		validation:"_ValidationResult"
	},
	DirectorCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Director",
		validation:"_ValidationResult"
	},
	DirectorDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Director"
	},
	DirectorUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Director",
		validation:"_ValidationResult"
	},
	DirectorUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Director",
		validation:"_ValidationResult"
	},
	FilmCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Film",
		validation:"_ValidationResult"
	},
	FilmDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Film"
	},
	FilmUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Film",
		validation:"_ValidationResult"
	},
	FilmUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Film",
		validation:"_ValidationResult"
	},
	DirectorLocationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorLocation",
		validation:"_ValidationResult"
	},
	DirectorLocationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorLocation"
	},
	DirectorLocationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorLocation",
		validation:"_ValidationResult"
	},
	DirectorLocationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorLocation",
		validation:"_ValidationResult"
	},
	ContactsPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactsPage",
		validation:"_ValidationResult"
	},
	ContactsPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactsPage"
	},
	ContactsPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactsPage",
		validation:"_ValidationResult"
	},
	ContactsPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactsPage",
		validation:"_ValidationResult"
	},
	DirectorsPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorsPage",
		validation:"_ValidationResult"
	},
	DirectorsPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorsPage"
	},
	DirectorsPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorsPage",
		validation:"_ValidationResult"
	},
	DirectorsPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorsPage",
		validation:"_ValidationResult"
	},
	FilmItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilmItem",
		validation:"_ValidationResult"
	},
	FilmItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilmItem"
	},
	FilmItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilmItem",
		validation:"_ValidationResult"
	},
	FilmItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilmItem",
		validation:"_ValidationResult"
	},
	DirectorContentGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorContentGroup",
		validation:"_ValidationResult"
	},
	DirectorContentGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorContentGroup"
	},
	DirectorContentGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorContentGroup",
		validation:"_ValidationResult"
	},
	DirectorContentGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DirectorContentGroup",
		validation:"_ValidationResult"
	},
	PhotographerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Photographer",
		validation:"_ValidationResult"
	},
	PhotographerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Photographer"
	},
	PhotographerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Photographer",
		validation:"_ValidationResult"
	},
	PhotographerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Photographer",
		validation:"_ValidationResult"
	},
	PhotographerContentGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographerContentGroup",
		validation:"_ValidationResult"
	},
	PhotographerContentGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographerContentGroup"
	},
	PhotographerContentGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographerContentGroup",
		validation:"_ValidationResult"
	},
	PhotographerContentGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographerContentGroup",
		validation:"_ValidationResult"
	},
	PhotographerLocationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographerLocation",
		validation:"_ValidationResult"
	},
	PhotographerLocationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographerLocation"
	},
	PhotographerLocationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographerLocation",
		validation:"_ValidationResult"
	},
	PhotographerLocationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographerLocation",
		validation:"_ValidationResult"
	},
	PhotographersPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographersPage",
		validation:"_ValidationResult"
	},
	PhotographersPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographersPage"
	},
	PhotographersPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographersPage",
		validation:"_ValidationResult"
	},
	PhotographersPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographersPage",
		validation:"_ValidationResult"
	},
	OurWorkPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OurWorkPage",
		validation:"_ValidationResult"
	},
	OurWorkPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OurWorkPage"
	},
	OurWorkPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OurWorkPage",
		validation:"_ValidationResult"
	},
	OurWorkPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OurWorkPage",
		validation:"_ValidationResult"
	},
	OurWorkPageContentGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OurWorkPageContentGroup",
		validation:"_ValidationResult"
	},
	OurWorkPageContentGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OurWorkPageContentGroup"
	},
	OurWorkPageContentGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OurWorkPageContentGroup",
		validation:"_ValidationResult"
	},
	OurWorkPageContentGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OurWorkPageContentGroup",
		validation:"_ValidationResult"
	},
	ContentGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentGroup",
		validation:"_ValidationResult"
	},
	ContentGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentGroup"
	},
	ContentGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentGroup",
		validation:"_ValidationResult"
	},
	ContentGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentGroup",
		validation:"_ValidationResult"
	},
	HomePageContentGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageContentGroup",
		validation:"_ValidationResult"
	},
	HomePageContentGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageContentGroup"
	},
	HomePageContentGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageContentGroup",
		validation:"_ValidationResult"
	},
	HomePageContentGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageContentGroup",
		validation:"_ValidationResult"
	},
	TabletopPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TabletopPage",
		validation:"_ValidationResult"
	},
	TabletopPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TabletopPage"
	},
	TabletopPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TabletopPage",
		validation:"_ValidationResult"
	},
	TabletopPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TabletopPage",
		validation:"_ValidationResult"
	},
	TabletopPageContentGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TabletopPageContentGroup",
		validation:"_ValidationResult"
	},
	TabletopPageContentGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TabletopPageContentGroup"
	},
	TabletopPageContentGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TabletopPageContentGroup",
		validation:"_ValidationResult"
	},
	TabletopPageContentGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TabletopPageContentGroup",
		validation:"_ValidationResult"
	},
	PhotographersPageContentGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographersPageContentGroup",
		validation:"_ValidationResult"
	},
	PhotographersPageContentGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographersPageContentGroup"
	},
	PhotographersPageContentGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographersPageContentGroup",
		validation:"_ValidationResult"
	},
	PhotographersPageContentGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PhotographersPageContentGroup",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		createContact:"ContactCreateResult",
		deleteContact:"ContactDeleteResult",
		updateContact:"ContactUpdateResult",
		upsertContact:"ContactUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createCardMedia:"CardMediaCreateResult",
		deleteCardMedia:"CardMediaDeleteResult",
		updateCardMedia:"CardMediaUpdateResult",
		upsertCardMedia:"CardMediaUpsertResult",
		createFallbackSeo:"FallbackSeoCreateResult",
		deleteFallbackSeo:"FallbackSeoDeleteResult",
		updateFallbackSeo:"FallbackSeoUpdateResult",
		upsertFallbackSeo:"FallbackSeoUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createSocialLink:"SocialLinkCreateResult",
		deleteSocialLink:"SocialLinkDeleteResult",
		updateSocialLink:"SocialLinkUpdateResult",
		upsertSocialLink:"SocialLinkUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHeaderLink:"HeaderLinkCreateResult",
		deleteHeaderLink:"HeaderLinkDeleteResult",
		updateHeaderLink:"HeaderLinkUpdateResult",
		upsertHeaderLink:"HeaderLinkUpsertResult",
		createHomePage:"HomePageCreateResult",
		deleteHomePage:"HomePageDeleteResult",
		updateHomePage:"HomePageUpdateResult",
		upsertHomePage:"HomePageUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createContactLocation:"ContactLocationCreateResult",
		deleteContactLocation:"ContactLocationDeleteResult",
		updateContactLocation:"ContactLocationUpdateResult",
		upsertContactLocation:"ContactLocationUpsertResult",
		createDirector:"DirectorCreateResult",
		deleteDirector:"DirectorDeleteResult",
		updateDirector:"DirectorUpdateResult",
		upsertDirector:"DirectorUpsertResult",
		createFilm:"FilmCreateResult",
		deleteFilm:"FilmDeleteResult",
		updateFilm:"FilmUpdateResult",
		upsertFilm:"FilmUpsertResult",
		createDirectorLocation:"DirectorLocationCreateResult",
		deleteDirectorLocation:"DirectorLocationDeleteResult",
		updateDirectorLocation:"DirectorLocationUpdateResult",
		upsertDirectorLocation:"DirectorLocationUpsertResult",
		createContactsPage:"ContactsPageCreateResult",
		deleteContactsPage:"ContactsPageDeleteResult",
		updateContactsPage:"ContactsPageUpdateResult",
		upsertContactsPage:"ContactsPageUpsertResult",
		createDirectorsPage:"DirectorsPageCreateResult",
		deleteDirectorsPage:"DirectorsPageDeleteResult",
		updateDirectorsPage:"DirectorsPageUpdateResult",
		upsertDirectorsPage:"DirectorsPageUpsertResult",
		createFilmItem:"FilmItemCreateResult",
		deleteFilmItem:"FilmItemDeleteResult",
		updateFilmItem:"FilmItemUpdateResult",
		upsertFilmItem:"FilmItemUpsertResult",
		createDirectorContentGroup:"DirectorContentGroupCreateResult",
		deleteDirectorContentGroup:"DirectorContentGroupDeleteResult",
		updateDirectorContentGroup:"DirectorContentGroupUpdateResult",
		upsertDirectorContentGroup:"DirectorContentGroupUpsertResult",
		createPhotographer:"PhotographerCreateResult",
		deletePhotographer:"PhotographerDeleteResult",
		updatePhotographer:"PhotographerUpdateResult",
		upsertPhotographer:"PhotographerUpsertResult",
		createPhotographerContentGroup:"PhotographerContentGroupCreateResult",
		deletePhotographerContentGroup:"PhotographerContentGroupDeleteResult",
		updatePhotographerContentGroup:"PhotographerContentGroupUpdateResult",
		upsertPhotographerContentGroup:"PhotographerContentGroupUpsertResult",
		createPhotographerLocation:"PhotographerLocationCreateResult",
		deletePhotographerLocation:"PhotographerLocationDeleteResult",
		updatePhotographerLocation:"PhotographerLocationUpdateResult",
		upsertPhotographerLocation:"PhotographerLocationUpsertResult",
		createPhotographersPage:"PhotographersPageCreateResult",
		deletePhotographersPage:"PhotographersPageDeleteResult",
		updatePhotographersPage:"PhotographersPageUpdateResult",
		upsertPhotographersPage:"PhotographersPageUpsertResult",
		createOurWorkPage:"OurWorkPageCreateResult",
		deleteOurWorkPage:"OurWorkPageDeleteResult",
		updateOurWorkPage:"OurWorkPageUpdateResult",
		upsertOurWorkPage:"OurWorkPageUpsertResult",
		createOurWorkPageContentGroup:"OurWorkPageContentGroupCreateResult",
		deleteOurWorkPageContentGroup:"OurWorkPageContentGroupDeleteResult",
		updateOurWorkPageContentGroup:"OurWorkPageContentGroupUpdateResult",
		upsertOurWorkPageContentGroup:"OurWorkPageContentGroupUpsertResult",
		createContentGroup:"ContentGroupCreateResult",
		deleteContentGroup:"ContentGroupDeleteResult",
		updateContentGroup:"ContentGroupUpdateResult",
		upsertContentGroup:"ContentGroupUpsertResult",
		createHomePageContentGroup:"HomePageContentGroupCreateResult",
		deleteHomePageContentGroup:"HomePageContentGroupDeleteResult",
		updateHomePageContentGroup:"HomePageContentGroupUpdateResult",
		upsertHomePageContentGroup:"HomePageContentGroupUpsertResult",
		createTabletopPage:"TabletopPageCreateResult",
		deleteTabletopPage:"TabletopPageDeleteResult",
		updateTabletopPage:"TabletopPageUpdateResult",
		upsertTabletopPage:"TabletopPageUpsertResult",
		createTabletopPageContentGroup:"TabletopPageContentGroupCreateResult",
		deleteTabletopPageContentGroup:"TabletopPageContentGroupDeleteResult",
		updateTabletopPageContentGroup:"TabletopPageContentGroupUpdateResult",
		upsertTabletopPageContentGroup:"TabletopPageContentGroupUpsertResult",
		createPhotographersPageContentGroup:"PhotographersPageContentGroupCreateResult",
		deletePhotographersPageContentGroup:"PhotographersPageContentGroupDeleteResult",
		updatePhotographersPageContentGroup:"PhotographersPageContentGroupUpdateResult",
		upsertPhotographersPageContentGroup:"PhotographersPageContentGroupUpsertResult",
		query:"Query"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	_RuleMessage:{
		text:"String"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	}
}
type ZEUS_INTERFACES = GraphQLTypes["MutationResult"] | GraphQLTypes["_Field"]
type ZEUS_UNIONS = GraphQLTypes["_PathFragment"] | GraphQLTypes["_Argument"]

export type ValueTypes = {
    ["Query"]: AliasType<{
getContact?: [{	by:ValueTypes["ContactUniqueWhere"],	filter?:ValueTypes["ContactWhere"] | null},ValueTypes["Contact"]],
listContact?: [{	filter?:ValueTypes["ContactWhere"] | null,	orderBy?:ValueTypes["ContactOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Contact"]],
paginateContact?: [{	filter?:ValueTypes["ContactWhere"] | null,	orderBy?:ValueTypes["ContactOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactConnection"]],
validateCreateContact?: [{	data:ValueTypes["ContactCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContact?: [{	by:ValueTypes["ContactUniqueWhere"],	data:ValueTypes["ContactUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null},ValueTypes["CardMedia"]],
listCardMedia?: [{	filter?:ValueTypes["CardMediaWhere"] | null,	orderBy?:ValueTypes["CardMediaOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CardMedia"]],
paginateCardMedia?: [{	filter?:ValueTypes["CardMediaWhere"] | null,	orderBy?:ValueTypes["CardMediaOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CardMediaConnection"]],
validateCreateCardMedia?: [{	data:ValueTypes["CardMediaCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	data:ValueTypes["CardMediaUpdateInput"]},ValueTypes["_ValidationResult"]],
getFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeo"]],
listFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FallbackSeo"]],
paginateFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FallbackSeoConnection"]],
validateCreateFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
listSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLink"]],
paginateSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkConnection"]],
validateCreateSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
listGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLink"]],
listHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLink"]],
paginateHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLinkConnection"]],
validateCreateHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
listHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactLocation?: [{	by:ValueTypes["ContactLocationUniqueWhere"],	filter?:ValueTypes["ContactLocationWhere"] | null},ValueTypes["ContactLocation"]],
listContactLocation?: [{	filter?:ValueTypes["ContactLocationWhere"] | null,	orderBy?:ValueTypes["ContactLocationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactLocation"]],
paginateContactLocation?: [{	filter?:ValueTypes["ContactLocationWhere"] | null,	orderBy?:ValueTypes["ContactLocationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactLocationConnection"]],
validateCreateContactLocation?: [{	data:ValueTypes["ContactLocationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactLocation?: [{	by:ValueTypes["ContactLocationUniqueWhere"],	data:ValueTypes["ContactLocationUpdateInput"]},ValueTypes["_ValidationResult"]],
getDirector?: [{	by:ValueTypes["DirectorUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null},ValueTypes["Director"]],
listDirector?: [{	filter?:ValueTypes["DirectorWhere"] | null,	orderBy?:ValueTypes["DirectorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Director"]],
paginateDirector?: [{	filter?:ValueTypes["DirectorWhere"] | null,	orderBy?:ValueTypes["DirectorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DirectorConnection"]],
validateCreateDirector?: [{	data:ValueTypes["DirectorCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDirector?: [{	by:ValueTypes["DirectorUniqueWhere"],	data:ValueTypes["DirectorUpdateInput"]},ValueTypes["_ValidationResult"]],
getFilm?: [{	by:ValueTypes["FilmUniqueWhere"],	filter?:ValueTypes["FilmWhere"] | null},ValueTypes["Film"]],
listFilm?: [{	filter?:ValueTypes["FilmWhere"] | null,	orderBy?:ValueTypes["FilmOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Film"]],
paginateFilm?: [{	filter?:ValueTypes["FilmWhere"] | null,	orderBy?:ValueTypes["FilmOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilmConnection"]],
validateCreateFilm?: [{	data:ValueTypes["FilmCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFilm?: [{	by:ValueTypes["FilmUniqueWhere"],	data:ValueTypes["FilmUpdateInput"]},ValueTypes["_ValidationResult"]],
getDirectorLocation?: [{	by:ValueTypes["DirectorLocationUniqueWhere"],	filter?:ValueTypes["DirectorLocationWhere"] | null},ValueTypes["DirectorLocation"]],
listDirectorLocation?: [{	filter?:ValueTypes["DirectorLocationWhere"] | null,	orderBy?:ValueTypes["DirectorLocationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DirectorLocation"]],
paginateDirectorLocation?: [{	filter?:ValueTypes["DirectorLocationWhere"] | null,	orderBy?:ValueTypes["DirectorLocationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DirectorLocationConnection"]],
validateCreateDirectorLocation?: [{	data:ValueTypes["DirectorLocationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDirectorLocation?: [{	by:ValueTypes["DirectorLocationUniqueWhere"],	data:ValueTypes["DirectorLocationUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactsPage?: [{	by:ValueTypes["ContactsPageUniqueWhere"],	filter?:ValueTypes["ContactsPageWhere"] | null},ValueTypes["ContactsPage"]],
listContactsPage?: [{	filter?:ValueTypes["ContactsPageWhere"] | null,	orderBy?:ValueTypes["ContactsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactsPage"]],
paginateContactsPage?: [{	filter?:ValueTypes["ContactsPageWhere"] | null,	orderBy?:ValueTypes["ContactsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactsPageConnection"]],
validateCreateContactsPage?: [{	data:ValueTypes["ContactsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactsPage?: [{	by:ValueTypes["ContactsPageUniqueWhere"],	data:ValueTypes["ContactsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getDirectorsPage?: [{	by:ValueTypes["DirectorsPageUniqueWhere"],	filter?:ValueTypes["DirectorsPageWhere"] | null},ValueTypes["DirectorsPage"]],
listDirectorsPage?: [{	filter?:ValueTypes["DirectorsPageWhere"] | null,	orderBy?:ValueTypes["DirectorsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DirectorsPage"]],
paginateDirectorsPage?: [{	filter?:ValueTypes["DirectorsPageWhere"] | null,	orderBy?:ValueTypes["DirectorsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DirectorsPageConnection"]],
validateCreateDirectorsPage?: [{	data:ValueTypes["DirectorsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDirectorsPage?: [{	by:ValueTypes["DirectorsPageUniqueWhere"],	data:ValueTypes["DirectorsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getFilmItem?: [{	by:ValueTypes["FilmItemUniqueWhere"],	filter?:ValueTypes["FilmItemWhere"] | null},ValueTypes["FilmItem"]],
listFilmItem?: [{	filter?:ValueTypes["FilmItemWhere"] | null,	orderBy?:ValueTypes["FilmItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilmItem"]],
paginateFilmItem?: [{	filter?:ValueTypes["FilmItemWhere"] | null,	orderBy?:ValueTypes["FilmItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilmItemConnection"]],
validateCreateFilmItem?: [{	data:ValueTypes["FilmItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFilmItem?: [{	by:ValueTypes["FilmItemUniqueWhere"],	data:ValueTypes["FilmItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getDirectorContentGroup?: [{	by:ValueTypes["DirectorContentGroupUniqueWhere"],	filter?:ValueTypes["DirectorContentGroupWhere"] | null},ValueTypes["DirectorContentGroup"]],
listDirectorContentGroup?: [{	filter?:ValueTypes["DirectorContentGroupWhere"] | null,	orderBy?:ValueTypes["DirectorContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DirectorContentGroup"]],
paginateDirectorContentGroup?: [{	filter?:ValueTypes["DirectorContentGroupWhere"] | null,	orderBy?:ValueTypes["DirectorContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DirectorContentGroupConnection"]],
validateCreateDirectorContentGroup?: [{	data:ValueTypes["DirectorContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDirectorContentGroup?: [{	by:ValueTypes["DirectorContentGroupUniqueWhere"],	data:ValueTypes["DirectorContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["Photographer"]],
listPhotographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Photographer"]],
paginatePhotographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerConnection"]],
validateCreatePhotographer?: [{	data:ValueTypes["PhotographerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	data:ValueTypes["PhotographerUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographerContentGroup?: [{	by:ValueTypes["PhotographerContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographerContentGroupWhere"] | null},ValueTypes["PhotographerContentGroup"]],
listPhotographerContentGroup?: [{	filter?:ValueTypes["PhotographerContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographerContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PhotographerContentGroup"]],
paginatePhotographerContentGroup?: [{	filter?:ValueTypes["PhotographerContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographerContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerContentGroupConnection"]],
validateCreatePhotographerContentGroup?: [{	data:ValueTypes["PhotographerContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographerContentGroup?: [{	by:ValueTypes["PhotographerContentGroupUniqueWhere"],	data:ValueTypes["PhotographerContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographerLocation?: [{	by:ValueTypes["PhotographerLocationUniqueWhere"],	filter?:ValueTypes["PhotographerLocationWhere"] | null},ValueTypes["PhotographerLocation"]],
listPhotographerLocation?: [{	filter?:ValueTypes["PhotographerLocationWhere"] | null,	orderBy?:ValueTypes["PhotographerLocationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PhotographerLocation"]],
paginatePhotographerLocation?: [{	filter?:ValueTypes["PhotographerLocationWhere"] | null,	orderBy?:ValueTypes["PhotographerLocationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerLocationConnection"]],
validateCreatePhotographerLocation?: [{	data:ValueTypes["PhotographerLocationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographerLocation?: [{	by:ValueTypes["PhotographerLocationUniqueWhere"],	data:ValueTypes["PhotographerLocationUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographersPage?: [{	by:ValueTypes["PhotographersPageUniqueWhere"],	filter?:ValueTypes["PhotographersPageWhere"] | null},ValueTypes["PhotographersPage"]],
listPhotographersPage?: [{	filter?:ValueTypes["PhotographersPageWhere"] | null,	orderBy?:ValueTypes["PhotographersPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PhotographersPage"]],
paginatePhotographersPage?: [{	filter?:ValueTypes["PhotographersPageWhere"] | null,	orderBy?:ValueTypes["PhotographersPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographersPageConnection"]],
validateCreatePhotographersPage?: [{	data:ValueTypes["PhotographersPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographersPage?: [{	by:ValueTypes["PhotographersPageUniqueWhere"],	data:ValueTypes["PhotographersPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getOurWorkPage?: [{	by:ValueTypes["OurWorkPageUniqueWhere"],	filter?:ValueTypes["OurWorkPageWhere"] | null},ValueTypes["OurWorkPage"]],
listOurWorkPage?: [{	filter?:ValueTypes["OurWorkPageWhere"] | null,	orderBy?:ValueTypes["OurWorkPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["OurWorkPage"]],
paginateOurWorkPage?: [{	filter?:ValueTypes["OurWorkPageWhere"] | null,	orderBy?:ValueTypes["OurWorkPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["OurWorkPageConnection"]],
validateCreateOurWorkPage?: [{	data:ValueTypes["OurWorkPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOurWorkPage?: [{	by:ValueTypes["OurWorkPageUniqueWhere"],	data:ValueTypes["OurWorkPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getOurWorkPageContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupUniqueWhere"],	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null},ValueTypes["OurWorkPageContentGroup"]],
listOurWorkPageContentGroup?: [{	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null,	orderBy?:ValueTypes["OurWorkPageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["OurWorkPageContentGroup"]],
paginateOurWorkPageContentGroup?: [{	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null,	orderBy?:ValueTypes["OurWorkPageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["OurWorkPageContentGroupConnection"]],
validateCreateOurWorkPageContentGroup?: [{	data:ValueTypes["OurWorkPageContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOurWorkPageContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupUniqueWhere"],	data:ValueTypes["OurWorkPageContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentGroup?: [{	by:ValueTypes["ContentGroupUniqueWhere"],	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroup"]],
listContentGroup?: [{	filter?:ValueTypes["ContentGroupWhere"] | null,	orderBy?:ValueTypes["ContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentGroup"]],
paginateContentGroup?: [{	filter?:ValueTypes["ContentGroupWhere"] | null,	orderBy?:ValueTypes["ContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentGroupConnection"]],
validateCreateContentGroup?: [{	data:ValueTypes["ContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentGroup?: [{	by:ValueTypes["ContentGroupUniqueWhere"],	data:ValueTypes["ContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePageContentGroup?: [{	by:ValueTypes["HomePageContentGroupUniqueWhere"],	filter?:ValueTypes["HomePageContentGroupWhere"] | null},ValueTypes["HomePageContentGroup"]],
listHomePageContentGroup?: [{	filter?:ValueTypes["HomePageContentGroupWhere"] | null,	orderBy?:ValueTypes["HomePageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePageContentGroup"]],
paginateHomePageContentGroup?: [{	filter?:ValueTypes["HomePageContentGroupWhere"] | null,	orderBy?:ValueTypes["HomePageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageContentGroupConnection"]],
validateCreateHomePageContentGroup?: [{	data:ValueTypes["HomePageContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePageContentGroup?: [{	by:ValueTypes["HomePageContentGroupUniqueWhere"],	data:ValueTypes["HomePageContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getTabletopPage?: [{	by:ValueTypes["TabletopPageUniqueWhere"],	filter?:ValueTypes["TabletopPageWhere"] | null},ValueTypes["TabletopPage"]],
listTabletopPage?: [{	filter?:ValueTypes["TabletopPageWhere"] | null,	orderBy?:ValueTypes["TabletopPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TabletopPage"]],
paginateTabletopPage?: [{	filter?:ValueTypes["TabletopPageWhere"] | null,	orderBy?:ValueTypes["TabletopPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TabletopPageConnection"]],
validateCreateTabletopPage?: [{	data:ValueTypes["TabletopPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTabletopPage?: [{	by:ValueTypes["TabletopPageUniqueWhere"],	data:ValueTypes["TabletopPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getTabletopPageContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupUniqueWhere"],	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null},ValueTypes["TabletopPageContentGroup"]],
listTabletopPageContentGroup?: [{	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null,	orderBy?:ValueTypes["TabletopPageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TabletopPageContentGroup"]],
paginateTabletopPageContentGroup?: [{	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null,	orderBy?:ValueTypes["TabletopPageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TabletopPageContentGroupConnection"]],
validateCreateTabletopPageContentGroup?: [{	data:ValueTypes["TabletopPageContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTabletopPageContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupUniqueWhere"],	data:ValueTypes["TabletopPageContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographersPageContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null},ValueTypes["PhotographersPageContentGroup"]],
listPhotographersPageContentGroup?: [{	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographersPageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PhotographersPageContentGroup"]],
paginatePhotographersPageContentGroup?: [{	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographersPageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographersPageContentGroupConnection"]],
validateCreatePhotographersPageContentGroup?: [{	data:ValueTypes["PhotographersPageContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographersPageContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupUniqueWhere"],	data:ValueTypes["PhotographersPageContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:true,
		__typename?: true
}>;
	["Contact"]: AliasType<{
	_meta?:ValueTypes["ContactMeta"],
	id?:true,
	order?:true,
	name?:true,
	position?:true,
	phone?:true,
	email?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
contactLocation?: [{	filter?:ValueTypes["ContactLocationWhere"] | null},ValueTypes["ContactLocation"]],
	wordpressId?:true,
		__typename?: true
}>;
	["ContactMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	position?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	contactLocation?:ValueTypes["FieldMeta"],
	wordpressId?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FieldMeta"]: AliasType<{
	readable?:true,
	updatable?:true,
		__typename?: true
}>;
	["UUID"]:string;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:true,
	url?:true,
	width?:true,
	height?:true,
	size?:true,
	type?:true,
	alt?:true,
		__typename?: true
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	alt?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageWhere"] | undefined | null)[],
	not?:ValueTypes["ImageWhere"] | null
};
	["UUIDCondition"]: {
	and?:ValueTypes["UUIDCondition"][],
	or?:ValueTypes["UUIDCondition"][],
	not?:ValueTypes["UUIDCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["UUID"] | null,
	notEq?:ValueTypes["UUID"] | null,
	in?:ValueTypes["UUID"][],
	notIn?:ValueTypes["UUID"][],
	lt?:ValueTypes["UUID"] | null,
	lte?:ValueTypes["UUID"] | null,
	gt?:ValueTypes["UUID"] | null,
	gte?:ValueTypes["UUID"] | null
};
	["StringCondition"]: {
	and?:ValueTypes["StringCondition"][],
	or?:ValueTypes["StringCondition"][],
	not?:ValueTypes["StringCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:string | null,
	notEq?:string | null,
	in?:string[],
	notIn?:string[],
	lt?:string | null,
	lte?:string | null,
	gt?:string | null,
	gte?:string | null,
	contains?:string | null,
	startsWith?:string | null,
	endsWith?:string | null,
	containsCI?:string | null,
	startsWithCI?:string | null,
	endsWithCI?:string | null
};
	["IntCondition"]: {
	and?:ValueTypes["IntCondition"][],
	or?:ValueTypes["IntCondition"][],
	not?:ValueTypes["IntCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["ContactLocation"]: AliasType<{
	_meta?:ValueTypes["ContactLocationMeta"],
	id?:true,
	order?:true,
	city?:true,
	state?:true,
	address?:true,
	email?:true,
	phone?:true,
	fax?:true,
	note?:true,
contact?: [{	filter?:ValueTypes["ContactWhere"] | null,	orderBy?:ValueTypes["ContactOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Contact"]],
contactByWordpressId?: [{	by:ValueTypes["ContactLocationContactByWordpressIdUniqueWhere"],	filter?:ValueTypes["ContactWhere"] | null},ValueTypes["Contact"]],
contactByImage?: [{	by:ValueTypes["ContactLocationContactByImageUniqueWhere"],	filter?:ValueTypes["ContactWhere"] | null},ValueTypes["Contact"]],
paginateContact?: [{	filter?:ValueTypes["ContactWhere"] | null,	orderBy?:ValueTypes["ContactOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactConnection"]],
		__typename?: true
}>;
	["ContactLocationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	city?:ValueTypes["FieldMeta"],
	state?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	fax?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	contact?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContactWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	position?:ValueTypes["StringCondition"] | null,
	phone?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	contactLocation?:ValueTypes["ContactLocationWhere"] | null,
	wordpressId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ContactWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactWhere"] | undefined | null)[],
	not?:ValueTypes["ContactWhere"] | null
};
	["ContactLocationWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	city?:ValueTypes["StringCondition"] | null,
	state?:ValueTypes["StringCondition"] | null,
	address?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	phone?:ValueTypes["StringCondition"] | null,
	fax?:ValueTypes["StringCondition"] | null,
	note?:ValueTypes["StringCondition"] | null,
	contact?:ValueTypes["ContactWhere"] | null,
	and?:(ValueTypes["ContactLocationWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactLocationWhere"] | undefined | null)[],
	not?:ValueTypes["ContactLocationWhere"] | null
};
	["ContactOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	position?:ValueTypes["OrderDirection"] | null,
	phone?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	contactLocation?:ValueTypes["ContactLocationOrderBy"] | null,
	wordpressId?:ValueTypes["OrderDirection"] | null
};
	["OrderDirection"]:OrderDirection;
	["ImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	alt?:ValueTypes["OrderDirection"] | null
};
	["ContactLocationOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	city?:ValueTypes["OrderDirection"] | null,
	state?:ValueTypes["OrderDirection"] | null,
	address?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	phone?:ValueTypes["OrderDirection"] | null,
	fax?:ValueTypes["OrderDirection"] | null,
	note?:ValueTypes["OrderDirection"] | null
};
	["ContactLocationContactByWordpressIdUniqueWhere"]: {
	wordpressId?:string | null
};
	["ContactLocationContactByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["ImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContactConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactEdge"],
		__typename?: true
}>;
	["PageInfo"]: AliasType<{
	totalCount?:true,
		__typename?: true
}>;
	["ContactEdge"]: AliasType<{
	node?:ValueTypes["Contact"],
		__typename?: true
}>;
	["ContactUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	wordpressId?:string | null,
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["_ValidationResult"]: AliasType<{
	valid?:true,
	errors?:ValueTypes["_ValidationError"],
		__typename?: true
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: true
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: true
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:true,
		__typename?: true
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:true,
	alias?:true,
		__typename?: true
}>;
	["_ValidationMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["ContactCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	position?:string | null,
	phone?:string | null,
	email?:string | null,
	image?:ValueTypes["ContactCreateImageEntityRelationInput"] | null,
	contactLocation?:ValueTypes["ContactCreateContactLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactCreateContactLocationEntityRelationInput"]: {
	connect?:ValueTypes["ContactLocationUniqueWhere"] | null,
	create?:ValueTypes["ContactLocationWithoutContactCreateInput"] | null
};
	["ContactLocationUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	contact?:ValueTypes["ContactUniqueWhere"] | null
};
	["ContactLocationWithoutContactCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	city?:string | null,
	state?:string | null,
	address?:string | null,
	email?:string | null,
	phone?:string | null,
	fax?:string | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	position?:string | null,
	phone?:string | null,
	email?:string | null,
	image?:ValueTypes["ContactUpdateImageEntityRelationInput"] | null,
	contactLocation?:ValueTypes["ContactUpdateContactLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ContactUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContactUpdateContactLocationEntityRelationInput"]: {
	create?:ValueTypes["ContactLocationWithoutContactCreateInput"] | null,
	update?:ValueTypes["ContactLocationWithoutContactUpdateInput"] | null,
	upsert?:ValueTypes["ContactUpsertContactLocationRelationInput"] | null,
	connect?:ValueTypes["ContactLocationUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactLocationWithoutContactUpdateInput"]: {
	order?:number | null,
	city?:string | null,
	state?:string | null,
	address?:string | null,
	email?:string | null,
	phone?:string | null,
	fax?:string | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactUpsertContactLocationRelationInput"]: {
	update?:ValueTypes["ContactLocationWithoutContactUpdateInput"] | null,
	create?:ValueTypes["ContactLocationWithoutContactCreateInput"] | null
};
	["Content"]: AliasType<{
	_meta?:ValueTypes["ContentMeta"],
	id?:true,
blocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
blocksByReferences?: [{	by:ValueTypes["ContentBlocksByReferencesUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
paginateBlocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
		__typename?: true
}>;
	["ContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:true,
	order?:true,
	json?:true,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
references?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
referencesByLink?: [{	by:ValueTypes["ContentBlockReferencesByLinkUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
paginateReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: true
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	blocks?:ValueTypes["ContentBlockWhere"] | null,
	and?:(ValueTypes["ContentWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentWhere"] | undefined | null)[],
	not?:ValueTypes["ContentWhere"] | null
};
	["ContentBlockWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	json?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	references?:ValueTypes["ContentReferenceWhere"] | null,
	and?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	not?:ValueTypes["ContentBlockWhere"] | null
};
	["ContentReferenceWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ContentReferenceTypeCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	block?:ValueTypes["ContentBlockWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	cardMedia?:ValueTypes["CardMediaWhere"] | null,
	and?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	not?:ValueTypes["ContentReferenceWhere"] | null
};
	["ContentReferenceTypeCondition"]: {
	and?:ValueTypes["ContentReferenceTypeCondition"][],
	or?:ValueTypes["ContentReferenceTypeCondition"][],
	not?:ValueTypes["ContentReferenceTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentReferenceType"] | null,
	notEq?:ValueTypes["ContentReferenceType"] | null,
	in?:ValueTypes["ContentReferenceType"][],
	notIn?:ValueTypes["ContentReferenceType"][],
	lt?:ValueTypes["ContentReferenceType"] | null,
	lte?:ValueTypes["ContentReferenceType"] | null,
	gt?:ValueTypes["ContentReferenceType"] | null,
	gte?:ValueTypes["ContentReferenceType"] | null
};
	["ContentReferenceType"]:ContentReferenceType;
	["LinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["LinkTypeCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	externalLink?:ValueTypes["StringCondition"] | null,
	internalLink?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["LinkWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkWhere"] | undefined | null)[],
	not?:ValueTypes["LinkWhere"] | null
};
	["LinkTypeCondition"]: {
	and?:ValueTypes["LinkTypeCondition"][],
	or?:ValueTypes["LinkTypeCondition"][],
	not?:ValueTypes["LinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["LinkType"] | null,
	notEq?:ValueTypes["LinkType"] | null,
	in?:ValueTypes["LinkType"][],
	notIn?:ValueTypes["LinkType"][],
	lt?:ValueTypes["LinkType"] | null,
	lte?:ValueTypes["LinkType"] | null,
	gt?:ValueTypes["LinkType"] | null,
	gte?:ValueTypes["LinkType"] | null
};
	["LinkType"]:LinkType;
	["LinkableWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	homePage?:ValueTypes["HomePageWhere"] | null,
	redirect?:ValueTypes["RedirectWhere"] | null,
	director?:ValueTypes["DirectorWhere"] | null,
	contactsPage?:ValueTypes["ContactsPageWhere"] | null,
	directorsPage?:ValueTypes["DirectorsPageWhere"] | null,
	photographer?:ValueTypes["PhotographerWhere"] | null,
	photographersPage?:ValueTypes["PhotographersPageWhere"] | null,
	ourWorkPage?:ValueTypes["OurWorkPageWhere"] | null,
	tabletopPage?:ValueTypes["TabletopPageWhere"] | null,
	and?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	not?:ValueTypes["LinkableWhere"] | null
};
	["HomePageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	tagline?:ValueTypes["StringCondition"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	directorsText?:ValueTypes["StringCondition"] | null,
	contentGroups?:ValueTypes["HomePageContentGroupWhere"] | null,
	backgroundImage?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["HomePageWhere"] | undefined | null)[],
	or?:(ValueTypes["HomePageWhere"] | undefined | null)[],
	not?:ValueTypes["HomePageWhere"] | null
};
	["OneCondition"]: {
	and?:ValueTypes["OneCondition"][],
	or?:ValueTypes["OneCondition"][],
	not?:ValueTypes["OneCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["One"] | null,
	notEq?:ValueTypes["One"] | null,
	in?:ValueTypes["One"][],
	notIn?:ValueTypes["One"][],
	lt?:ValueTypes["One"] | null,
	lte?:ValueTypes["One"] | null,
	gt?:ValueTypes["One"] | null,
	gte?:ValueTypes["One"] | null
};
	["One"]:One;
	["SeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	ogTitle?:ValueTypes["StringCondition"] | null,
	ogDescription?:ValueTypes["StringCondition"] | null,
	ogImage?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["SeoWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoWhere"] | undefined | null)[],
	not?:ValueTypes["SeoWhere"] | null
};
	["HomePageContentGroupWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	homePage?:ValueTypes["HomePageWhere"] | null,
	contentGroup?:ValueTypes["ContentGroupWhere"] | null,
	and?:(ValueTypes["HomePageContentGroupWhere"] | undefined | null)[],
	or?:(ValueTypes["HomePageContentGroupWhere"] | undefined | null)[],
	not?:ValueTypes["HomePageContentGroupWhere"] | null
};
	["ContentGroupWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	contentType?:ValueTypes["ContentGroupTypeCondition"] | null,
	gallery?:ValueTypes["GalleryWhere"] | null,
	films?:ValueTypes["FilmItemWhere"] | null,
	and?:(ValueTypes["ContentGroupWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentGroupWhere"] | undefined | null)[],
	not?:ValueTypes["ContentGroupWhere"] | null
};
	["ContentGroupTypeCondition"]: {
	and?:ValueTypes["ContentGroupTypeCondition"][],
	or?:ValueTypes["ContentGroupTypeCondition"][],
	not?:ValueTypes["ContentGroupTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentGroupType"] | null,
	notEq?:ValueTypes["ContentGroupType"] | null,
	in?:ValueTypes["ContentGroupType"][],
	notIn?:ValueTypes["ContentGroupType"][],
	lt?:ValueTypes["ContentGroupType"] | null,
	lte?:ValueTypes["ContentGroupType"] | null,
	gt?:ValueTypes["ContentGroupType"] | null,
	gte?:ValueTypes["ContentGroupType"] | null
};
	["ContentGroupType"]:ContentGroupType;
	["GalleryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["GalleryItemWhere"] | null,
	and?:(ValueTypes["GalleryWhere"] | undefined | null)[],
	or?:(ValueTypes["GalleryWhere"] | undefined | null)[],
	not?:ValueTypes["GalleryWhere"] | null
};
	["GalleryItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["GalleryWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["GalleryItemWhere"] | undefined | null)[],
	or?:(ValueTypes["GalleryItemWhere"] | undefined | null)[],
	not?:ValueTypes["GalleryItemWhere"] | null
};
	["FilmItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	contentGroups?:ValueTypes["ContentGroupWhere"] | null,
	film?:ValueTypes["FilmWhere"] | null,
	and?:(ValueTypes["FilmItemWhere"] | undefined | null)[],
	or?:(ValueTypes["FilmItemWhere"] | undefined | null)[],
	not?:ValueTypes["FilmItemWhere"] | null
};
	["FilmWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	author?:ValueTypes["StringCondition"] | null,
	vimeoId?:ValueTypes["StringCondition"] | null,
	posterImage?:ValueTypes["ImageWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	wordpressId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["FilmWhere"] | undefined | null)[],
	or?:(ValueTypes["FilmWhere"] | undefined | null)[],
	not?:ValueTypes["FilmWhere"] | null
};
	["RedirectWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	targetUrl?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	target?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	or?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	not?:ValueTypes["RedirectWhere"] | null
};
	["DirectorWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	contentGroups?:ValueTypes["DirectorContentGroupWhere"] | null,
	directorLocation?:ValueTypes["DirectorLocationWhere"] | null,
	wordpressId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["DirectorWhere"] | undefined | null)[],
	or?:(ValueTypes["DirectorWhere"] | undefined | null)[],
	not?:ValueTypes["DirectorWhere"] | null
};
	["DirectorContentGroupWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	director?:ValueTypes["DirectorWhere"] | null,
	contentGroup?:ValueTypes["ContentGroupWhere"] | null,
	and?:(ValueTypes["DirectorContentGroupWhere"] | undefined | null)[],
	or?:(ValueTypes["DirectorContentGroupWhere"] | undefined | null)[],
	not?:ValueTypes["DirectorContentGroupWhere"] | null
};
	["DirectorLocationWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	city?:ValueTypes["StringCondition"] | null,
	director?:ValueTypes["DirectorWhere"] | null,
	and?:(ValueTypes["DirectorLocationWhere"] | undefined | null)[],
	or?:(ValueTypes["DirectorLocationWhere"] | undefined | null)[],
	not?:ValueTypes["DirectorLocationWhere"] | null
};
	["ContactsPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ContactsPageWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactsPageWhere"] | undefined | null)[],
	not?:ValueTypes["ContactsPageWhere"] | null
};
	["DirectorsPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["DirectorsPageWhere"] | undefined | null)[],
	or?:(ValueTypes["DirectorsPageWhere"] | undefined | null)[],
	not?:ValueTypes["DirectorsPageWhere"] | null
};
	["PhotographerWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	contentGroups?:ValueTypes["PhotographerContentGroupWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	photographerLocation?:ValueTypes["PhotographerLocationWhere"] | null,
	wordpressId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["PhotographerWhere"] | undefined | null)[],
	or?:(ValueTypes["PhotographerWhere"] | undefined | null)[],
	not?:ValueTypes["PhotographerWhere"] | null
};
	["PhotographerContentGroupWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	photographer?:ValueTypes["PhotographerWhere"] | null,
	contentGroup?:ValueTypes["ContentGroupWhere"] | null,
	and?:(ValueTypes["PhotographerContentGroupWhere"] | undefined | null)[],
	or?:(ValueTypes["PhotographerContentGroupWhere"] | undefined | null)[],
	not?:ValueTypes["PhotographerContentGroupWhere"] | null
};
	["PhotographerLocationWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	city?:ValueTypes["StringCondition"] | null,
	photographer?:ValueTypes["PhotographerWhere"] | null,
	and?:(ValueTypes["PhotographerLocationWhere"] | undefined | null)[],
	or?:(ValueTypes["PhotographerLocationWhere"] | undefined | null)[],
	not?:ValueTypes["PhotographerLocationWhere"] | null
};
	["PhotographersPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	contentGroups?:ValueTypes["PhotographersPageContentGroupWhere"] | null,
	and?:(ValueTypes["PhotographersPageWhere"] | undefined | null)[],
	or?:(ValueTypes["PhotographersPageWhere"] | undefined | null)[],
	not?:ValueTypes["PhotographersPageWhere"] | null
};
	["PhotographersPageContentGroupWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	photographersPage?:ValueTypes["PhotographersPageWhere"] | null,
	contentGroup?:ValueTypes["ContentGroupWhere"] | null,
	and?:(ValueTypes["PhotographersPageContentGroupWhere"] | undefined | null)[],
	or?:(ValueTypes["PhotographersPageContentGroupWhere"] | undefined | null)[],
	not?:ValueTypes["PhotographersPageContentGroupWhere"] | null
};
	["OurWorkPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	contentGroups?:ValueTypes["OurWorkPageContentGroupWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["OurWorkPageWhere"] | undefined | null)[],
	or?:(ValueTypes["OurWorkPageWhere"] | undefined | null)[],
	not?:ValueTypes["OurWorkPageWhere"] | null
};
	["OurWorkPageContentGroupWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	ourWorkPage?:ValueTypes["OurWorkPageWhere"] | null,
	contentGroup?:ValueTypes["ContentGroupWhere"] | null,
	and?:(ValueTypes["OurWorkPageContentGroupWhere"] | undefined | null)[],
	or?:(ValueTypes["OurWorkPageContentGroupWhere"] | undefined | null)[],
	not?:ValueTypes["OurWorkPageContentGroupWhere"] | null
};
	["TabletopPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	teamTitle?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	contentGroups?:ValueTypes["TabletopPageContentGroupWhere"] | null,
	and?:(ValueTypes["TabletopPageWhere"] | undefined | null)[],
	or?:(ValueTypes["TabletopPageWhere"] | undefined | null)[],
	not?:ValueTypes["TabletopPageWhere"] | null
};
	["TabletopPageContentGroupWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	tabletopPage?:ValueTypes["TabletopPageWhere"] | null,
	contentGroup?:ValueTypes["ContentGroupWhere"] | null,
	and?:(ValueTypes["TabletopPageContentGroupWhere"] | undefined | null)[],
	or?:(ValueTypes["TabletopPageContentGroupWhere"] | undefined | null)[],
	not?:ValueTypes["TabletopPageContentGroupWhere"] | null
};
	["CardMediaWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	imageNote?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["CardMediaWhere"] | undefined | null)[],
	or?:(ValueTypes["CardMediaWhere"] | undefined | null)[],
	not?:ValueTypes["CardMediaWhere"] | null
};
	["ContentReference"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceMeta"],
	id?:true,
	type?:true,
	text?:true,
block?: [{	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
cardMedia?: [{	filter?:ValueTypes["CardMediaWhere"] | null},ValueTypes["CardMedia"]],
		__typename?: true
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	block?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	cardMedia?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:true,
	type?:true,
	title?:true,
	externalLink?:true,
internalLink?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: true
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	internalLink?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:true,
	url?:true,
homePage?: [{	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
redirect?: [{	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
director?: [{	filter?:ValueTypes["DirectorWhere"] | null},ValueTypes["Director"]],
contactsPage?: [{	filter?:ValueTypes["ContactsPageWhere"] | null},ValueTypes["ContactsPage"]],
directorsPage?: [{	filter?:ValueTypes["DirectorsPageWhere"] | null},ValueTypes["DirectorsPage"]],
photographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["Photographer"]],
photographersPage?: [{	filter?:ValueTypes["PhotographersPageWhere"] | null},ValueTypes["PhotographersPage"]],
ourWorkPage?: [{	filter?:ValueTypes["OurWorkPageWhere"] | null},ValueTypes["OurWorkPage"]],
tabletopPage?: [{	filter?:ValueTypes["TabletopPageWhere"] | null},ValueTypes["TabletopPage"]],
		__typename?: true
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	homePage?:ValueTypes["FieldMeta"],
	redirect?:ValueTypes["FieldMeta"],
	director?:ValueTypes["FieldMeta"],
	contactsPage?:ValueTypes["FieldMeta"],
	directorsPage?:ValueTypes["FieldMeta"],
	photographer?:ValueTypes["FieldMeta"],
	photographersPage?:ValueTypes["FieldMeta"],
	ourWorkPage?:ValueTypes["FieldMeta"],
	tabletopPage?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HomePage"]: AliasType<{
	_meta?:ValueTypes["HomePageMeta"],
	id?:true,
	unique?:true,
	tagline?:true,
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	directorsText?:true,
contentGroups?: [{	filter?:ValueTypes["HomePageContentGroupWhere"] | null,	orderBy?:ValueTypes["HomePageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePageContentGroup"]],
backgroundImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
contentGroupsByContentGroup?: [{	by:ValueTypes["HomePageContentGroupsByContentGroupUniqueWhere"],	filter?:ValueTypes["HomePageContentGroupWhere"] | null},ValueTypes["HomePageContentGroup"]],
paginateContentGroups?: [{	filter?:ValueTypes["HomePageContentGroupWhere"] | null,	orderBy?:ValueTypes["HomePageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageContentGroupConnection"]],
		__typename?: true
}>;
	["HomePageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	tagline?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	directorsText?:ValueTypes["FieldMeta"],
	contentGroups?:ValueTypes["FieldMeta"],
	backgroundImage?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:true,
	title?:true,
	description?:true,
	ogTitle?:true,
	ogDescription?:true,
ogImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HomePageContentGroup"]: AliasType<{
	_meta?:ValueTypes["HomePageContentGroupMeta"],
	id?:true,
	order?:true,
homePage?: [{	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
contentGroup?: [{	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroup"]],
		__typename?: true
}>;
	["HomePageContentGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	homePage?:ValueTypes["FieldMeta"],
	contentGroup?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentGroup"]: AliasType<{
	_meta?:ValueTypes["ContentGroupMeta"],
	id?:true,
	title?:true,
	contentType?:true,
gallery?: [{	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
films?: [{	filter?:ValueTypes["FilmItemWhere"] | null,	orderBy?:ValueTypes["FilmItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilmItem"]],
paginateFilms?: [{	filter?:ValueTypes["FilmItemWhere"] | null,	orderBy?:ValueTypes["FilmItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilmItemConnection"]],
		__typename?: true
}>;
	["ContentGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	contentType?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	films?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Gallery"]: AliasType<{
	_meta?:ValueTypes["GalleryMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateItems?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
		__typename?: true
}>;
	["GalleryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["GalleryItem"]: AliasType<{
	_meta?:ValueTypes["GalleryItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["GalleryItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["GalleryItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["GalleryOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["GalleryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["GalleryItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryItemEdge"],
		__typename?: true
}>;
	["GalleryItemEdge"]: AliasType<{
	node?:ValueTypes["GalleryItem"],
		__typename?: true
}>;
	["FilmItem"]: AliasType<{
	_meta?:ValueTypes["FilmItemMeta"],
	id?:true,
	order?:true,
contentGroups?: [{	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroup"]],
film?: [{	filter?:ValueTypes["FilmWhere"] | null},ValueTypes["Film"]],
		__typename?: true
}>;
	["FilmItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	contentGroups?:ValueTypes["FieldMeta"],
	film?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Film"]: AliasType<{
	_meta?:ValueTypes["FilmMeta"],
	id?:true,
	name?:true,
	author?:true,
	vimeoId?:true,
posterImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	order?:true,
	wordpressId?:true,
		__typename?: true
}>;
	["FilmMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	author?:ValueTypes["FieldMeta"],
	vimeoId?:ValueTypes["FieldMeta"],
	posterImage?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	wordpressId?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FilmItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	contentGroups?:ValueTypes["ContentGroupOrderBy"] | null,
	film?:ValueTypes["FilmOrderBy"] | null
};
	["ContentGroupOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	contentType?:ValueTypes["OrderDirection"] | null,
	gallery?:ValueTypes["GalleryOrderBy"] | null
};
	["FilmOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	author?:ValueTypes["OrderDirection"] | null,
	vimeoId?:ValueTypes["OrderDirection"] | null,
	posterImage?:ValueTypes["ImageOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	wordpressId?:ValueTypes["OrderDirection"] | null
};
	["FilmItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FilmItemEdge"],
		__typename?: true
}>;
	["FilmItemEdge"]: AliasType<{
	node?:ValueTypes["FilmItem"],
		__typename?: true
}>;
	["HomePageContentGroupOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	homePage?:ValueTypes["HomePageOrderBy"] | null,
	contentGroup?:ValueTypes["ContentGroupOrderBy"] | null
};
	["HomePageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	tagline?:ValueTypes["OrderDirection"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	directorsText?:ValueTypes["OrderDirection"] | null,
	backgroundImage?:ValueTypes["ImageOrderBy"] | null
};
	["SeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	ogTitle?:ValueTypes["OrderDirection"] | null,
	ogDescription?:ValueTypes["OrderDirection"] | null,
	ogImage?:ValueTypes["ImageOrderBy"] | null
};
	["LinkableOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	homePage?:ValueTypes["HomePageOrderBy"] | null,
	redirect?:ValueTypes["RedirectOrderBy"] | null,
	director?:ValueTypes["DirectorOrderBy"] | null,
	contactsPage?:ValueTypes["ContactsPageOrderBy"] | null,
	directorsPage?:ValueTypes["DirectorsPageOrderBy"] | null,
	photographer?:ValueTypes["PhotographerOrderBy"] | null,
	photographersPage?:ValueTypes["PhotographersPageOrderBy"] | null,
	ourWorkPage?:ValueTypes["OurWorkPageOrderBy"] | null,
	tabletopPage?:ValueTypes["TabletopPageOrderBy"] | null
};
	["RedirectOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	targetUrl?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	target?:ValueTypes["LinkableOrderBy"] | null
};
	["DirectorOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	directorLocation?:ValueTypes["DirectorLocationOrderBy"] | null,
	wordpressId?:ValueTypes["OrderDirection"] | null
};
	["DirectorLocationOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	city?:ValueTypes["OrderDirection"] | null
};
	["ContactsPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null
};
	["DirectorsPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null
};
	["PhotographerOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	photographerLocation?:ValueTypes["PhotographerLocationOrderBy"] | null,
	wordpressId?:ValueTypes["OrderDirection"] | null
};
	["PhotographerLocationOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	city?:ValueTypes["OrderDirection"] | null
};
	["PhotographersPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null
};
	["OurWorkPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["TabletopPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	teamTitle?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["HomePageContentGroupsByContentGroupUniqueWhere"]: {
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["ContentGroupUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	gallery?:ValueTypes["GalleryUniqueWhere"] | null,
	films?:ValueTypes["FilmItemUniqueWhere"] | null
};
	["GalleryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["GalleryItemUniqueWhere"] | null
};
	["GalleryItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["FilmItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["HomePageContentGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageContentGroupEdge"],
		__typename?: true
}>;
	["HomePageContentGroupEdge"]: AliasType<{
	node?:ValueTypes["HomePageContentGroup"],
		__typename?: true
}>;
	["Redirect"]: AliasType<{
	_meta?:ValueTypes["RedirectMeta"],
	id?:true,
	targetUrl?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
target?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: true
}>;
	["RedirectMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	targetUrl?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Director"]: AliasType<{
	_meta?:ValueTypes["DirectorMeta"],
	id?:true,
	name?:true,
	leadParagraph?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	order?:true,
contentGroups?: [{	filter?:ValueTypes["DirectorContentGroupWhere"] | null,	orderBy?:ValueTypes["DirectorContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DirectorContentGroup"]],
directorLocation?: [{	filter?:ValueTypes["DirectorLocationWhere"] | null},ValueTypes["DirectorLocation"]],
	wordpressId?:true,
contentGroupsByContentGroup?: [{	by:ValueTypes["DirectorContentGroupsByContentGroupUniqueWhere"],	filter?:ValueTypes["DirectorContentGroupWhere"] | null},ValueTypes["DirectorContentGroup"]],
paginateContentGroups?: [{	filter?:ValueTypes["DirectorContentGroupWhere"] | null,	orderBy?:ValueTypes["DirectorContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DirectorContentGroupConnection"]],
		__typename?: true
}>;
	["DirectorMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	contentGroups?:ValueTypes["FieldMeta"],
	directorLocation?:ValueTypes["FieldMeta"],
	wordpressId?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["DirectorContentGroup"]: AliasType<{
	_meta?:ValueTypes["DirectorContentGroupMeta"],
	id?:true,
	order?:true,
director?: [{	filter?:ValueTypes["DirectorWhere"] | null},ValueTypes["Director"]],
contentGroup?: [{	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroup"]],
		__typename?: true
}>;
	["DirectorContentGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	director?:ValueTypes["FieldMeta"],
	contentGroup?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["DirectorContentGroupOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	director?:ValueTypes["DirectorOrderBy"] | null,
	contentGroup?:ValueTypes["ContentGroupOrderBy"] | null
};
	["DirectorLocation"]: AliasType<{
	_meta?:ValueTypes["DirectorLocationMeta"],
	id?:true,
	order?:true,
	city?:true,
director?: [{	filter?:ValueTypes["DirectorWhere"] | null,	orderBy?:ValueTypes["DirectorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Director"]],
directorByWordpressId?: [{	by:ValueTypes["DirectorLocationDirectorByWordpressIdUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null},ValueTypes["Director"]],
directorByImage?: [{	by:ValueTypes["DirectorLocationDirectorByImageUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null},ValueTypes["Director"]],
directorByLink?: [{	by:ValueTypes["DirectorLocationDirectorByLinkUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null},ValueTypes["Director"]],
directorByContentGroups?: [{	by:ValueTypes["DirectorLocationDirectorByContentGroupsUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null},ValueTypes["Director"]],
paginateDirector?: [{	filter?:ValueTypes["DirectorWhere"] | null,	orderBy?:ValueTypes["DirectorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DirectorConnection"]],
		__typename?: true
}>;
	["DirectorLocationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	city?:ValueTypes["FieldMeta"],
	director?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["DirectorLocationDirectorByWordpressIdUniqueWhere"]: {
	wordpressId?:string | null
};
	["DirectorLocationDirectorByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["DirectorLocationDirectorByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LinkableUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["HomePageUniqueWhere"] | null,
	redirect?:ValueTypes["RedirectUniqueWhere"] | null,
	director?:ValueTypes["DirectorUniqueWhere"] | null,
	contactsPage?:ValueTypes["ContactsPageUniqueWhere"] | null,
	directorsPage?:ValueTypes["DirectorsPageUniqueWhere"] | null,
	photographer?:ValueTypes["PhotographerUniqueWhere"] | null,
	photographersPage?:ValueTypes["PhotographersPageUniqueWhere"] | null,
	ourWorkPage?:ValueTypes["OurWorkPageUniqueWhere"] | null,
	tabletopPage?:ValueTypes["TabletopPageUniqueWhere"] | null
};
	["HomePageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["ImageUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	contentGroups?:ValueTypes["HomePageContentGroupUniqueWhere"] | null,
	backgroundImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["SeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["HomePageContentGroupUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["RedirectUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["DirectorUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	wordpressId?:string | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	contentGroups?:ValueTypes["DirectorContentGroupUniqueWhere"] | null
};
	["DirectorContentGroupUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["ContactsPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["DirectorsPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["PhotographerUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	wordpressId?:string | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	contentGroups?:ValueTypes["PhotographerContentGroupUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["PhotographerContentGroupUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["PhotographersPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	contentGroups?:ValueTypes["PhotographersPageContentGroupUniqueWhere"] | null
};
	["PhotographersPageContentGroupUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["OurWorkPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	contentGroups?:ValueTypes["OurWorkPageContentGroupUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["OurWorkPageContentGroupUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["TabletopPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	logo?:ValueTypes["ImageUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	contentGroups?:ValueTypes["TabletopPageContentGroupUniqueWhere"] | null
};
	["TabletopPageContentGroupUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["DirectorLocationDirectorByContentGroupsUniqueWhere"]: {
	contentGroups?:ValueTypes["DirectorContentGroupUniqueWhere"] | null
};
	["DirectorConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DirectorEdge"],
		__typename?: true
}>;
	["DirectorEdge"]: AliasType<{
	node?:ValueTypes["Director"],
		__typename?: true
}>;
	["DirectorContentGroupsByContentGroupUniqueWhere"]: {
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["DirectorContentGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DirectorContentGroupEdge"],
		__typename?: true
}>;
	["DirectorContentGroupEdge"]: AliasType<{
	node?:ValueTypes["DirectorContentGroup"],
		__typename?: true
}>;
	["ContactsPage"]: AliasType<{
	_meta?:ValueTypes["ContactsPageMeta"],
	id?:true,
	unique?:true,
	title?:true,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	leadParagraph?:true,
		__typename?: true
}>;
	["ContactsPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["DirectorsPage"]: AliasType<{
	_meta?:ValueTypes["DirectorsPageMeta"],
	id?:true,
	unique?:true,
	title?:true,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	leadParagraph?:true,
		__typename?: true
}>;
	["DirectorsPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Photographer"]: AliasType<{
	_meta?:ValueTypes["PhotographerMeta"],
	id?:true,
	order?:true,
	name?:true,
	leadParagraph?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
contentGroups?: [{	filter?:ValueTypes["PhotographerContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographerContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PhotographerContentGroup"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
photographerLocation?: [{	filter?:ValueTypes["PhotographerLocationWhere"] | null},ValueTypes["PhotographerLocation"]],
	wordpressId?:true,
contentGroupsByContentGroup?: [{	by:ValueTypes["PhotographerContentGroupsByContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographerContentGroupWhere"] | null},ValueTypes["PhotographerContentGroup"]],
paginateContentGroups?: [{	filter?:ValueTypes["PhotographerContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographerContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerContentGroupConnection"]],
		__typename?: true
}>;
	["PhotographerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	contentGroups?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	photographerLocation?:ValueTypes["FieldMeta"],
	wordpressId?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PhotographerContentGroup"]: AliasType<{
	_meta?:ValueTypes["PhotographerContentGroupMeta"],
	id?:true,
	order?:true,
photographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["Photographer"]],
contentGroup?: [{	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroup"]],
		__typename?: true
}>;
	["PhotographerContentGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	photographer?:ValueTypes["FieldMeta"],
	contentGroup?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PhotographerContentGroupOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	photographer?:ValueTypes["PhotographerOrderBy"] | null,
	contentGroup?:ValueTypes["ContentGroupOrderBy"] | null
};
	["PhotographerLocation"]: AliasType<{
	_meta?:ValueTypes["PhotographerLocationMeta"],
	id?:true,
	order?:true,
	city?:true,
photographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Photographer"]],
photographerByWordpressId?: [{	by:ValueTypes["PhotographerLocationPhotographerByWordpressIdUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["Photographer"]],
photographerByImage?: [{	by:ValueTypes["PhotographerLocationPhotographerByImageUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["Photographer"]],
photographerByContentGroups?: [{	by:ValueTypes["PhotographerLocationPhotographerByContentGroupsUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["Photographer"]],
photographerByLink?: [{	by:ValueTypes["PhotographerLocationPhotographerByLinkUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["Photographer"]],
paginatePhotographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerConnection"]],
		__typename?: true
}>;
	["PhotographerLocationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	city?:ValueTypes["FieldMeta"],
	photographer?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PhotographerLocationPhotographerByWordpressIdUniqueWhere"]: {
	wordpressId?:string | null
};
	["PhotographerLocationPhotographerByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["PhotographerLocationPhotographerByContentGroupsUniqueWhere"]: {
	contentGroups?:ValueTypes["PhotographerContentGroupUniqueWhere"] | null
};
	["PhotographerLocationPhotographerByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["PhotographerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PhotographerEdge"],
		__typename?: true
}>;
	["PhotographerEdge"]: AliasType<{
	node?:ValueTypes["Photographer"],
		__typename?: true
}>;
	["PhotographerContentGroupsByContentGroupUniqueWhere"]: {
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["PhotographerContentGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PhotographerContentGroupEdge"],
		__typename?: true
}>;
	["PhotographerContentGroupEdge"]: AliasType<{
	node?:ValueTypes["PhotographerContentGroup"],
		__typename?: true
}>;
	["PhotographersPage"]: AliasType<{
	_meta?:ValueTypes["PhotographersPageMeta"],
	id?:true,
	unique?:true,
	title?:true,
	leadParagraph?:true,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
contentGroups?: [{	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographersPageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PhotographersPageContentGroup"]],
contentGroupsByContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupsByContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null},ValueTypes["PhotographersPageContentGroup"]],
paginateContentGroups?: [{	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographersPageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographersPageContentGroupConnection"]],
		__typename?: true
}>;
	["PhotographersPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	contentGroups?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PhotographersPageContentGroup"]: AliasType<{
	_meta?:ValueTypes["PhotographersPageContentGroupMeta"],
	id?:true,
	order?:true,
photographersPage?: [{	filter?:ValueTypes["PhotographersPageWhere"] | null},ValueTypes["PhotographersPage"]],
contentGroup?: [{	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroup"]],
		__typename?: true
}>;
	["PhotographersPageContentGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	photographersPage?:ValueTypes["FieldMeta"],
	contentGroup?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PhotographersPageContentGroupOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	photographersPage?:ValueTypes["PhotographersPageOrderBy"] | null,
	contentGroup?:ValueTypes["ContentGroupOrderBy"] | null
};
	["PhotographersPageContentGroupsByContentGroupUniqueWhere"]: {
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["PhotographersPageContentGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PhotographersPageContentGroupEdge"],
		__typename?: true
}>;
	["PhotographersPageContentGroupEdge"]: AliasType<{
	node?:ValueTypes["PhotographersPageContentGroup"],
		__typename?: true
}>;
	["OurWorkPage"]: AliasType<{
	_meta?:ValueTypes["OurWorkPageMeta"],
	id?:true,
	unique?:true,
	title?:true,
	leadParagraph?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
contentGroups?: [{	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null,	orderBy?:ValueTypes["OurWorkPageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["OurWorkPageContentGroup"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
contentGroupsByContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupsByContentGroupUniqueWhere"],	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null},ValueTypes["OurWorkPageContentGroup"]],
paginateContentGroups?: [{	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null,	orderBy?:ValueTypes["OurWorkPageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["OurWorkPageContentGroupConnection"]],
		__typename?: true
}>;
	["OurWorkPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	contentGroups?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["OurWorkPageContentGroup"]: AliasType<{
	_meta?:ValueTypes["OurWorkPageContentGroupMeta"],
	id?:true,
	order?:true,
ourWorkPage?: [{	filter?:ValueTypes["OurWorkPageWhere"] | null},ValueTypes["OurWorkPage"]],
contentGroup?: [{	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroup"]],
		__typename?: true
}>;
	["OurWorkPageContentGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	ourWorkPage?:ValueTypes["FieldMeta"],
	contentGroup?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["OurWorkPageContentGroupOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	ourWorkPage?:ValueTypes["OurWorkPageOrderBy"] | null,
	contentGroup?:ValueTypes["ContentGroupOrderBy"] | null
};
	["OurWorkPageContentGroupsByContentGroupUniqueWhere"]: {
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["OurWorkPageContentGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OurWorkPageContentGroupEdge"],
		__typename?: true
}>;
	["OurWorkPageContentGroupEdge"]: AliasType<{
	node?:ValueTypes["OurWorkPageContentGroup"],
		__typename?: true
}>;
	["TabletopPage"]: AliasType<{
	_meta?:ValueTypes["TabletopPageMeta"],
	id?:true,
	unique?:true,
	title?:true,
	leadParagraph?:true,
	teamTitle?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
contentGroups?: [{	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null,	orderBy?:ValueTypes["TabletopPageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TabletopPageContentGroup"]],
contentGroupsByContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupsByContentGroupUniqueWhere"],	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null},ValueTypes["TabletopPageContentGroup"]],
paginateContentGroups?: [{	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null,	orderBy?:ValueTypes["TabletopPageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TabletopPageContentGroupConnection"]],
		__typename?: true
}>;
	["TabletopPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	teamTitle?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	contentGroups?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TabletopPageContentGroup"]: AliasType<{
	_meta?:ValueTypes["TabletopPageContentGroupMeta"],
	id?:true,
	order?:true,
tabletopPage?: [{	filter?:ValueTypes["TabletopPageWhere"] | null},ValueTypes["TabletopPage"]],
contentGroup?: [{	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroup"]],
		__typename?: true
}>;
	["TabletopPageContentGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	tabletopPage?:ValueTypes["FieldMeta"],
	contentGroup?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TabletopPageContentGroupOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	tabletopPage?:ValueTypes["TabletopPageOrderBy"] | null,
	contentGroup?:ValueTypes["ContentGroupOrderBy"] | null
};
	["TabletopPageContentGroupsByContentGroupUniqueWhere"]: {
	contentGroup?:ValueTypes["ContentGroupUniqueWhere"] | null
};
	["TabletopPageContentGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TabletopPageContentGroupEdge"],
		__typename?: true
}>;
	["TabletopPageContentGroupEdge"]: AliasType<{
	node?:ValueTypes["TabletopPageContentGroup"],
		__typename?: true
}>;
	["CardMedia"]: AliasType<{
	_meta?:ValueTypes["CardMediaMeta"],
	id?:true,
	text?:true,
	imageNote?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["CardMediaMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	imageNote?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentReferenceOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	block?:ValueTypes["ContentBlockOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	cardMedia?:ValueTypes["CardMediaOrderBy"] | null
};
	["ContentBlockOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	json?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null
};
	["ContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["LinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	externalLink?:ValueTypes["OrderDirection"] | null,
	internalLink?:ValueTypes["LinkableOrderBy"] | null
};
	["CardMediaOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	imageNote?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["LinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceEdge"],
		__typename?: true
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["ContentReference"],
		__typename?: true
}>;
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentReferenceUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: true
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["ContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentBlockUniqueWhere"] | null
};
	["ContentBlockUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentEdge"],
		__typename?: true
}>;
	["ContentEdge"]: AliasType<{
	node?:ValueTypes["Content"],
		__typename?: true
}>;
	["ContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentCreateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	alias?:string | null
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	text?:string | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	cardMedia?:ValueTypes["ContentReferenceCreateCardMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkCreateInternalLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableCreateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableCreateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableCreateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableCreatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableCreatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableCreateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableCreateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateHomePageEntityRelationInput"]: {
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	create?:ValueTypes["HomePageWithoutLinkCreateInput"] | null
};
	["HomePageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	tagline?:string | null,
	logo?:ValueTypes["HomePageCreateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageCreateSeoEntityRelationInput"] | null,
	directorsText?:string | null,
	contentGroups?:ValueTypes["HomePageCreateContentGroupsEntityRelationInput"][],
	backgroundImage?:ValueTypes["HomePageCreateBackgroundImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HomePageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["SeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HomePageCreateContentGroupsEntityRelationInput"]: {
	connect?:ValueTypes["HomePageContentGroupUniqueWhere"] | null,
	create?:ValueTypes["HomePageContentGroupWithoutHomePageCreateInput"] | null,
	alias?:string | null
};
	["HomePageContentGroupWithoutHomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentGroup?:ValueTypes["HomePageContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageContentGroupCreateContentGroupEntityRelationInput"]: {
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["ContentGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	contentType?:ValueTypes["ContentGroupType"] | null,
	gallery?:ValueTypes["ContentGroupCreateGalleryEntityRelationInput"] | null,
	films?:ValueTypes["ContentGroupCreateFilmsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentGroupCreateGalleryEntityRelationInput"]: {
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	create?:ValueTypes["GalleryCreateInput"] | null
};
	["GalleryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["GalleryCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GalleryCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["GalleryItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["GalleryItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentGroupCreateFilmsEntityRelationInput"]: {
	connect?:ValueTypes["FilmItemUniqueWhere"] | null,
	create?:ValueTypes["FilmItemWithoutContentGroupsCreateInput"] | null,
	alias?:string | null
};
	["FilmItemWithoutContentGroupsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	film?:ValueTypes["FilmItemCreateFilmEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilmItemCreateFilmEntityRelationInput"]: {
	connect?:ValueTypes["FilmUniqueWhere"] | null,
	create?:ValueTypes["FilmCreateInput"] | null
};
	["FilmUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	wordpressId?:string | null,
	posterImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["FilmCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	author?:string | null,
	vimeoId?:string | null,
	posterImage?:ValueTypes["FilmCreatePosterImageEntityRelationInput"] | null,
	order?:number | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["FilmCreatePosterImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HomePageCreateBackgroundImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["LinkableCreateRedirectEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null
};
	["RedirectWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	targetUrl?:string | null,
	target?:ValueTypes["RedirectCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableCreateDirectorEntityRelationInput"]: {
	connect?:ValueTypes["DirectorUniqueWhere"] | null,
	create?:ValueTypes["DirectorWithoutLinkCreateInput"] | null
};
	["DirectorWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["DirectorCreateImageEntityRelationInput"] | null,
	order?:number | null,
	contentGroups?:ValueTypes["DirectorCreateContentGroupsEntityRelationInput"][],
	directorLocation?:ValueTypes["DirectorCreateDirectorLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["DirectorCreateContentGroupsEntityRelationInput"]: {
	connect?:ValueTypes["DirectorContentGroupUniqueWhere"] | null,
	create?:ValueTypes["DirectorContentGroupWithoutDirectorCreateInput"] | null,
	alias?:string | null
};
	["DirectorContentGroupWithoutDirectorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentGroup?:ValueTypes["DirectorContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DirectorContentGroupCreateContentGroupEntityRelationInput"]: {
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["DirectorCreateDirectorLocationEntityRelationInput"]: {
	connect?:ValueTypes["DirectorLocationUniqueWhere"] | null,
	create?:ValueTypes["DirectorLocationWithoutDirectorCreateInput"] | null
};
	["DirectorLocationUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	director?:ValueTypes["DirectorUniqueWhere"] | null
};
	["DirectorLocationWithoutDirectorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	city?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateContactsPageEntityRelationInput"]: {
	connect?:ValueTypes["ContactsPageUniqueWhere"] | null,
	create?:ValueTypes["ContactsPageWithoutLinkCreateInput"] | null
};
	["ContactsPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["ContactsPageCreateSeoEntityRelationInput"] | null,
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactsPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableCreateDirectorsPageEntityRelationInput"]: {
	connect?:ValueTypes["DirectorsPageUniqueWhere"] | null,
	create?:ValueTypes["DirectorsPageWithoutLinkCreateInput"] | null
};
	["DirectorsPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["DirectorsPageCreateSeoEntityRelationInput"] | null,
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorsPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableCreatePhotographerEntityRelationInput"]: {
	connect?:ValueTypes["PhotographerUniqueWhere"] | null,
	create?:ValueTypes["PhotographerWithoutLinkCreateInput"] | null
};
	["PhotographerWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["PhotographerCreateImageEntityRelationInput"] | null,
	contentGroups?:ValueTypes["PhotographerCreateContentGroupsEntityRelationInput"][],
	photographerLocation?:ValueTypes["PhotographerCreatePhotographerLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["PhotographerCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["PhotographerCreateContentGroupsEntityRelationInput"]: {
	connect?:ValueTypes["PhotographerContentGroupUniqueWhere"] | null,
	create?:ValueTypes["PhotographerContentGroupWithoutPhotographerCreateInput"] | null,
	alias?:string | null
};
	["PhotographerContentGroupWithoutPhotographerCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentGroup?:ValueTypes["PhotographerContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographerContentGroupCreateContentGroupEntityRelationInput"]: {
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["PhotographerCreatePhotographerLocationEntityRelationInput"]: {
	connect?:ValueTypes["PhotographerLocationUniqueWhere"] | null,
	create?:ValueTypes["PhotographerLocationWithoutPhotographerCreateInput"] | null
};
	["PhotographerLocationUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	photographer?:ValueTypes["PhotographerUniqueWhere"] | null
};
	["PhotographerLocationWithoutPhotographerCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	city?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreatePhotographersPageEntityRelationInput"]: {
	connect?:ValueTypes["PhotographersPageUniqueWhere"] | null,
	create?:ValueTypes["PhotographersPageWithoutLinkCreateInput"] | null
};
	["PhotographersPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["PhotographersPageCreateSeoEntityRelationInput"] | null,
	contentGroups?:ValueTypes["PhotographersPageCreateContentGroupsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PhotographersPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["PhotographersPageCreateContentGroupsEntityRelationInput"]: {
	connect?:ValueTypes["PhotographersPageContentGroupUniqueWhere"] | null,
	create?:ValueTypes["PhotographersPageContentGroupWithoutPhotographersPageCreateInput"] | null,
	alias?:string | null
};
	["PhotographersPageContentGroupWithoutPhotographersPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentGroup?:ValueTypes["PhotographersPageContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographersPageContentGroupCreateContentGroupEntityRelationInput"]: {
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["LinkableCreateOurWorkPageEntityRelationInput"]: {
	connect?:ValueTypes["OurWorkPageUniqueWhere"] | null,
	create?:ValueTypes["OurWorkPageWithoutLinkCreateInput"] | null
};
	["OurWorkPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	contentGroups?:ValueTypes["OurWorkPageCreateContentGroupsEntityRelationInput"][],
	seo?:ValueTypes["OurWorkPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageCreateContentGroupsEntityRelationInput"]: {
	connect?:ValueTypes["OurWorkPageContentGroupUniqueWhere"] | null,
	create?:ValueTypes["OurWorkPageContentGroupWithoutOurWorkPageCreateInput"] | null,
	alias?:string | null
};
	["OurWorkPageContentGroupWithoutOurWorkPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentGroup?:ValueTypes["OurWorkPageContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageContentGroupCreateContentGroupEntityRelationInput"]: {
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["OurWorkPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableCreateTabletopPageEntityRelationInput"]: {
	connect?:ValueTypes["TabletopPageUniqueWhere"] | null,
	create?:ValueTypes["TabletopPageWithoutLinkCreateInput"] | null
};
	["TabletopPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	teamTitle?:string | null,
	logo?:ValueTypes["TabletopPageCreateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["TabletopPageCreateSeoEntityRelationInput"] | null,
	contentGroups?:ValueTypes["TabletopPageCreateContentGroupsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TabletopPageCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["TabletopPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["TabletopPageCreateContentGroupsEntityRelationInput"]: {
	connect?:ValueTypes["TabletopPageContentGroupUniqueWhere"] | null,
	create?:ValueTypes["TabletopPageContentGroupWithoutTabletopPageCreateInput"] | null,
	alias?:string | null
};
	["TabletopPageContentGroupWithoutTabletopPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentGroup?:ValueTypes["TabletopPageContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TabletopPageContentGroupCreateContentGroupEntityRelationInput"]: {
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceCreateCardMediaEntityRelationInput"]: {
	connect?:ValueTypes["CardMediaUniqueWhere"] | null,
	create?:ValueTypes["CardMediaCreateInput"] | null
};
	["CardMediaUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["CardMediaCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	imageNote?:string | null,
	image?:ValueTypes["CardMediaCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CardMediaCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentUpdateInput"]: {
	blocks?:ValueTypes["ContentUpdateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateBlocksRelationInput"] | null,
	upsert?:ValueTypes["ContentUpsertBlocksRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:ValueTypes["ContentBlockUniqueWhere"] | null,
	alias?:string | null
};
	["ContentUpdateBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	data?:ValueTypes["ContentBlockWithoutContentUpdateInput"] | null
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	update?:ValueTypes["ContentBlockUpdateReferencesRelationInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertReferencesRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	data?:ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | null
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	text?:string | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	cardMedia?:ValueTypes["ContentReferenceUpdateCardMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkUpdateInput"]: {
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkUpdateInternalLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["LinkUpsertInternalLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableUpdateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableUpdateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableUpdateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableUpdatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableUpdatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableUpdateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableUpdateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
	create?:ValueTypes["HomePageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["HomePageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertHomePageRelationInput"] | null,
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	tagline?:string | null,
	logo?:ValueTypes["HomePageUpdateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageUpdateSeoEntityRelationInput"] | null,
	directorsText?:string | null,
	contentGroups?:ValueTypes["HomePageUpdateContentGroupsEntityRelationInput"][],
	backgroundImage?:ValueTypes["HomePageUpdateBackgroundImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HomePageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertOgImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HomePageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["HomePageUpdateContentGroupsEntityRelationInput"]: {
	create?:ValueTypes["HomePageContentGroupWithoutHomePageCreateInput"] | null,
	update?:ValueTypes["HomePageUpdateContentGroupsRelationInput"] | null,
	upsert?:ValueTypes["HomePageUpsertContentGroupsRelationInput"] | null,
	connect?:ValueTypes["HomePageContentGroupUniqueWhere"] | null,
	disconnect?:ValueTypes["HomePageContentGroupUniqueWhere"] | null,
	delete?:ValueTypes["HomePageContentGroupUniqueWhere"] | null,
	alias?:string | null
};
	["HomePageUpdateContentGroupsRelationInput"]: {
	by?:ValueTypes["HomePageContentGroupUniqueWhere"] | null,
	data?:ValueTypes["HomePageContentGroupWithoutHomePageUpdateInput"] | null
};
	["HomePageContentGroupWithoutHomePageUpdateInput"]: {
	order?:number | null,
	contentGroup?:ValueTypes["HomePageContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageContentGroupUpdateContentGroupEntityRelationInput"]: {
	create?:ValueTypes["ContentGroupCreateInput"] | null,
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	upsert?:ValueTypes["HomePageContentGroupUpsertContentGroupRelationInput"] | null,
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentGroupUpdateInput"]: {
	title?:string | null,
	contentType?:ValueTypes["ContentGroupType"] | null,
	gallery?:ValueTypes["ContentGroupUpdateGalleryEntityRelationInput"] | null,
	films?:ValueTypes["ContentGroupUpdateFilmsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentGroupUpdateGalleryEntityRelationInput"]: {
	create?:ValueTypes["GalleryCreateInput"] | null,
	update?:ValueTypes["GalleryUpdateInput"] | null,
	upsert?:ValueTypes["ContentGroupUpsertGalleryRelationInput"] | null,
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryUpdateInput"]: {
	items?:ValueTypes["GalleryUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GalleryUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null,
	update?:ValueTypes["GalleryUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["GalleryUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	disconnect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	delete?:ValueTypes["GalleryItemUniqueWhere"] | null,
	alias?:string | null
};
	["GalleryUpdateItemsRelationInput"]: {
	by?:ValueTypes["GalleryItemUniqueWhere"] | null,
	data?:ValueTypes["GalleryItemWithoutListUpdateInput"] | null
};
	["GalleryItemWithoutListUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["GalleryItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["GalleryItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["GalleryUpsertItemsRelationInput"]: {
	by?:ValueTypes["GalleryItemUniqueWhere"] | null,
	update?:ValueTypes["GalleryItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null
};
	["ContentGroupUpsertGalleryRelationInput"]: {
	update?:ValueTypes["GalleryUpdateInput"] | null,
	create?:ValueTypes["GalleryCreateInput"] | null
};
	["ContentGroupUpdateFilmsEntityRelationInput"]: {
	create?:ValueTypes["FilmItemWithoutContentGroupsCreateInput"] | null,
	update?:ValueTypes["ContentGroupUpdateFilmsRelationInput"] | null,
	upsert?:ValueTypes["ContentGroupUpsertFilmsRelationInput"] | null,
	connect?:ValueTypes["FilmItemUniqueWhere"] | null,
	disconnect?:ValueTypes["FilmItemUniqueWhere"] | null,
	delete?:ValueTypes["FilmItemUniqueWhere"] | null,
	alias?:string | null
};
	["ContentGroupUpdateFilmsRelationInput"]: {
	by?:ValueTypes["FilmItemUniqueWhere"] | null,
	data?:ValueTypes["FilmItemWithoutContentGroupsUpdateInput"] | null
};
	["FilmItemWithoutContentGroupsUpdateInput"]: {
	order?:number | null,
	film?:ValueTypes["FilmItemUpdateFilmEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilmItemUpdateFilmEntityRelationInput"]: {
	create?:ValueTypes["FilmCreateInput"] | null,
	update?:ValueTypes["FilmUpdateInput"] | null,
	upsert?:ValueTypes["FilmItemUpsertFilmRelationInput"] | null,
	connect?:ValueTypes["FilmUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FilmUpdateInput"]: {
	name?:string | null,
	author?:string | null,
	vimeoId?:string | null,
	posterImage?:ValueTypes["FilmUpdatePosterImageEntityRelationInput"] | null,
	order?:number | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["FilmUpdatePosterImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["FilmUpsertPosterImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FilmUpsertPosterImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FilmItemUpsertFilmRelationInput"]: {
	update?:ValueTypes["FilmUpdateInput"] | null,
	create?:ValueTypes["FilmCreateInput"] | null
};
	["ContentGroupUpsertFilmsRelationInput"]: {
	by?:ValueTypes["FilmItemUniqueWhere"] | null,
	update?:ValueTypes["FilmItemWithoutContentGroupsUpdateInput"] | null,
	create?:ValueTypes["FilmItemWithoutContentGroupsCreateInput"] | null
};
	["HomePageContentGroupUpsertContentGroupRelationInput"]: {
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["HomePageUpsertContentGroupsRelationInput"]: {
	by?:ValueTypes["HomePageContentGroupUniqueWhere"] | null,
	update?:ValueTypes["HomePageContentGroupWithoutHomePageUpdateInput"] | null,
	create?:ValueTypes["HomePageContentGroupWithoutHomePageCreateInput"] | null
};
	["HomePageUpdateBackgroundImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertBackgroundImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageUpsertBackgroundImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["LinkableUpsertHomePageRelationInput"]: {
	update?:ValueTypes["HomePageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["HomePageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null,
	update?:ValueTypes["RedirectWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertRedirectRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RedirectWithoutLinkUpdateInput"]: {
	targetUrl?:string | null,
	target?:ValueTypes["RedirectUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RedirectUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableUpsertRedirectRelationInput"]: {
	update?:ValueTypes["RedirectWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null
};
	["LinkableUpdateDirectorEntityRelationInput"]: {
	create?:ValueTypes["DirectorWithoutLinkCreateInput"] | null,
	update?:ValueTypes["DirectorWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertDirectorRelationInput"] | null,
	connect?:ValueTypes["DirectorUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DirectorWithoutLinkUpdateInput"]: {
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["DirectorUpdateImageEntityRelationInput"] | null,
	order?:number | null,
	contentGroups?:ValueTypes["DirectorUpdateContentGroupsEntityRelationInput"][],
	directorLocation?:ValueTypes["DirectorUpdateDirectorLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["DirectorUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DirectorUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["DirectorUpdateContentGroupsEntityRelationInput"]: {
	create?:ValueTypes["DirectorContentGroupWithoutDirectorCreateInput"] | null,
	update?:ValueTypes["DirectorUpdateContentGroupsRelationInput"] | null,
	upsert?:ValueTypes["DirectorUpsertContentGroupsRelationInput"] | null,
	connect?:ValueTypes["DirectorContentGroupUniqueWhere"] | null,
	disconnect?:ValueTypes["DirectorContentGroupUniqueWhere"] | null,
	delete?:ValueTypes["DirectorContentGroupUniqueWhere"] | null,
	alias?:string | null
};
	["DirectorUpdateContentGroupsRelationInput"]: {
	by?:ValueTypes["DirectorContentGroupUniqueWhere"] | null,
	data?:ValueTypes["DirectorContentGroupWithoutDirectorUpdateInput"] | null
};
	["DirectorContentGroupWithoutDirectorUpdateInput"]: {
	order?:number | null,
	contentGroup?:ValueTypes["DirectorContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DirectorContentGroupUpdateContentGroupEntityRelationInput"]: {
	create?:ValueTypes["ContentGroupCreateInput"] | null,
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	upsert?:ValueTypes["DirectorContentGroupUpsertContentGroupRelationInput"] | null,
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DirectorContentGroupUpsertContentGroupRelationInput"]: {
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["DirectorUpsertContentGroupsRelationInput"]: {
	by?:ValueTypes["DirectorContentGroupUniqueWhere"] | null,
	update?:ValueTypes["DirectorContentGroupWithoutDirectorUpdateInput"] | null,
	create?:ValueTypes["DirectorContentGroupWithoutDirectorCreateInput"] | null
};
	["DirectorUpdateDirectorLocationEntityRelationInput"]: {
	create?:ValueTypes["DirectorLocationWithoutDirectorCreateInput"] | null,
	update?:ValueTypes["DirectorLocationWithoutDirectorUpdateInput"] | null,
	upsert?:ValueTypes["DirectorUpsertDirectorLocationRelationInput"] | null,
	connect?:ValueTypes["DirectorLocationUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DirectorLocationWithoutDirectorUpdateInput"]: {
	order?:number | null,
	city?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorUpsertDirectorLocationRelationInput"]: {
	update?:ValueTypes["DirectorLocationWithoutDirectorUpdateInput"] | null,
	create?:ValueTypes["DirectorLocationWithoutDirectorCreateInput"] | null
};
	["LinkableUpsertDirectorRelationInput"]: {
	update?:ValueTypes["DirectorWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["DirectorWithoutLinkCreateInput"] | null
};
	["LinkableUpdateContactsPageEntityRelationInput"]: {
	create?:ValueTypes["ContactsPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["ContactsPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertContactsPageRelationInput"] | null,
	connect?:ValueTypes["ContactsPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactsPageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["ContactsPageUpdateSeoEntityRelationInput"] | null,
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactsPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ContactsPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactsPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertContactsPageRelationInput"]: {
	update?:ValueTypes["ContactsPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["ContactsPageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateDirectorsPageEntityRelationInput"]: {
	create?:ValueTypes["DirectorsPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["DirectorsPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertDirectorsPageRelationInput"] | null,
	connect?:ValueTypes["DirectorsPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DirectorsPageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["DirectorsPageUpdateSeoEntityRelationInput"] | null,
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorsPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["DirectorsPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DirectorsPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertDirectorsPageRelationInput"]: {
	update?:ValueTypes["DirectorsPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["DirectorsPageWithoutLinkCreateInput"] | null
};
	["LinkableUpdatePhotographerEntityRelationInput"]: {
	create?:ValueTypes["PhotographerWithoutLinkCreateInput"] | null,
	update?:ValueTypes["PhotographerWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertPhotographerRelationInput"] | null,
	connect?:ValueTypes["PhotographerUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PhotographerWithoutLinkUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["PhotographerUpdateImageEntityRelationInput"] | null,
	contentGroups?:ValueTypes["PhotographerUpdateContentGroupsEntityRelationInput"][],
	photographerLocation?:ValueTypes["PhotographerUpdatePhotographerLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["PhotographerUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["PhotographerUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PhotographerUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["PhotographerUpdateContentGroupsEntityRelationInput"]: {
	create?:ValueTypes["PhotographerContentGroupWithoutPhotographerCreateInput"] | null,
	update?:ValueTypes["PhotographerUpdateContentGroupsRelationInput"] | null,
	upsert?:ValueTypes["PhotographerUpsertContentGroupsRelationInput"] | null,
	connect?:ValueTypes["PhotographerContentGroupUniqueWhere"] | null,
	disconnect?:ValueTypes["PhotographerContentGroupUniqueWhere"] | null,
	delete?:ValueTypes["PhotographerContentGroupUniqueWhere"] | null,
	alias?:string | null
};
	["PhotographerUpdateContentGroupsRelationInput"]: {
	by?:ValueTypes["PhotographerContentGroupUniqueWhere"] | null,
	data?:ValueTypes["PhotographerContentGroupWithoutPhotographerUpdateInput"] | null
};
	["PhotographerContentGroupWithoutPhotographerUpdateInput"]: {
	order?:number | null,
	contentGroup?:ValueTypes["PhotographerContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographerContentGroupUpdateContentGroupEntityRelationInput"]: {
	create?:ValueTypes["ContentGroupCreateInput"] | null,
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	upsert?:ValueTypes["PhotographerContentGroupUpsertContentGroupRelationInput"] | null,
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PhotographerContentGroupUpsertContentGroupRelationInput"]: {
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["PhotographerUpsertContentGroupsRelationInput"]: {
	by?:ValueTypes["PhotographerContentGroupUniqueWhere"] | null,
	update?:ValueTypes["PhotographerContentGroupWithoutPhotographerUpdateInput"] | null,
	create?:ValueTypes["PhotographerContentGroupWithoutPhotographerCreateInput"] | null
};
	["PhotographerUpdatePhotographerLocationEntityRelationInput"]: {
	create?:ValueTypes["PhotographerLocationWithoutPhotographerCreateInput"] | null,
	update?:ValueTypes["PhotographerLocationWithoutPhotographerUpdateInput"] | null,
	upsert?:ValueTypes["PhotographerUpsertPhotographerLocationRelationInput"] | null,
	connect?:ValueTypes["PhotographerLocationUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PhotographerLocationWithoutPhotographerUpdateInput"]: {
	order?:number | null,
	city?:string | null,
	_dummy_field_?:boolean | null
};
	["PhotographerUpsertPhotographerLocationRelationInput"]: {
	update?:ValueTypes["PhotographerLocationWithoutPhotographerUpdateInput"] | null,
	create?:ValueTypes["PhotographerLocationWithoutPhotographerCreateInput"] | null
};
	["LinkableUpsertPhotographerRelationInput"]: {
	update?:ValueTypes["PhotographerWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["PhotographerWithoutLinkCreateInput"] | null
};
	["LinkableUpdatePhotographersPageEntityRelationInput"]: {
	create?:ValueTypes["PhotographersPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["PhotographersPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertPhotographersPageRelationInput"] | null,
	connect?:ValueTypes["PhotographersPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PhotographersPageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["PhotographersPageUpdateSeoEntityRelationInput"] | null,
	contentGroups?:ValueTypes["PhotographersPageUpdateContentGroupsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PhotographersPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["PhotographersPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PhotographersPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["PhotographersPageUpdateContentGroupsEntityRelationInput"]: {
	create?:ValueTypes["PhotographersPageContentGroupWithoutPhotographersPageCreateInput"] | null,
	update?:ValueTypes["PhotographersPageUpdateContentGroupsRelationInput"] | null,
	upsert?:ValueTypes["PhotographersPageUpsertContentGroupsRelationInput"] | null,
	connect?:ValueTypes["PhotographersPageContentGroupUniqueWhere"] | null,
	disconnect?:ValueTypes["PhotographersPageContentGroupUniqueWhere"] | null,
	delete?:ValueTypes["PhotographersPageContentGroupUniqueWhere"] | null,
	alias?:string | null
};
	["PhotographersPageUpdateContentGroupsRelationInput"]: {
	by?:ValueTypes["PhotographersPageContentGroupUniqueWhere"] | null,
	data?:ValueTypes["PhotographersPageContentGroupWithoutPhotographersPageUpdateInput"] | null
};
	["PhotographersPageContentGroupWithoutPhotographersPageUpdateInput"]: {
	order?:number | null,
	contentGroup?:ValueTypes["PhotographersPageContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographersPageContentGroupUpdateContentGroupEntityRelationInput"]: {
	create?:ValueTypes["ContentGroupCreateInput"] | null,
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	upsert?:ValueTypes["PhotographersPageContentGroupUpsertContentGroupRelationInput"] | null,
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PhotographersPageContentGroupUpsertContentGroupRelationInput"]: {
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["PhotographersPageUpsertContentGroupsRelationInput"]: {
	by?:ValueTypes["PhotographersPageContentGroupUniqueWhere"] | null,
	update?:ValueTypes["PhotographersPageContentGroupWithoutPhotographersPageUpdateInput"] | null,
	create?:ValueTypes["PhotographersPageContentGroupWithoutPhotographersPageCreateInput"] | null
};
	["LinkableUpsertPhotographersPageRelationInput"]: {
	update?:ValueTypes["PhotographersPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["PhotographersPageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateOurWorkPageEntityRelationInput"]: {
	create?:ValueTypes["OurWorkPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["OurWorkPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertOurWorkPageRelationInput"] | null,
	connect?:ValueTypes["OurWorkPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["OurWorkPageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	contentGroups?:ValueTypes["OurWorkPageUpdateContentGroupsEntityRelationInput"][],
	seo?:ValueTypes["OurWorkPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageUpdateContentGroupsEntityRelationInput"]: {
	create?:ValueTypes["OurWorkPageContentGroupWithoutOurWorkPageCreateInput"] | null,
	update?:ValueTypes["OurWorkPageUpdateContentGroupsRelationInput"] | null,
	upsert?:ValueTypes["OurWorkPageUpsertContentGroupsRelationInput"] | null,
	connect?:ValueTypes["OurWorkPageContentGroupUniqueWhere"] | null,
	disconnect?:ValueTypes["OurWorkPageContentGroupUniqueWhere"] | null,
	delete?:ValueTypes["OurWorkPageContentGroupUniqueWhere"] | null,
	alias?:string | null
};
	["OurWorkPageUpdateContentGroupsRelationInput"]: {
	by?:ValueTypes["OurWorkPageContentGroupUniqueWhere"] | null,
	data?:ValueTypes["OurWorkPageContentGroupWithoutOurWorkPageUpdateInput"] | null
};
	["OurWorkPageContentGroupWithoutOurWorkPageUpdateInput"]: {
	order?:number | null,
	contentGroup?:ValueTypes["OurWorkPageContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageContentGroupUpdateContentGroupEntityRelationInput"]: {
	create?:ValueTypes["ContentGroupCreateInput"] | null,
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	upsert?:ValueTypes["OurWorkPageContentGroupUpsertContentGroupRelationInput"] | null,
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["OurWorkPageContentGroupUpsertContentGroupRelationInput"]: {
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["OurWorkPageUpsertContentGroupsRelationInput"]: {
	by?:ValueTypes["OurWorkPageContentGroupUniqueWhere"] | null,
	update?:ValueTypes["OurWorkPageContentGroupWithoutOurWorkPageUpdateInput"] | null,
	create?:ValueTypes["OurWorkPageContentGroupWithoutOurWorkPageCreateInput"] | null
};
	["OurWorkPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["OurWorkPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["OurWorkPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertOurWorkPageRelationInput"]: {
	update?:ValueTypes["OurWorkPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["OurWorkPageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateTabletopPageEntityRelationInput"]: {
	create?:ValueTypes["TabletopPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["TabletopPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertTabletopPageRelationInput"] | null,
	connect?:ValueTypes["TabletopPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TabletopPageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	teamTitle?:string | null,
	logo?:ValueTypes["TabletopPageUpdateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["TabletopPageUpdateSeoEntityRelationInput"] | null,
	contentGroups?:ValueTypes["TabletopPageUpdateContentGroupsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TabletopPageUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["TabletopPageUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TabletopPageUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["TabletopPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["TabletopPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TabletopPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["TabletopPageUpdateContentGroupsEntityRelationInput"]: {
	create?:ValueTypes["TabletopPageContentGroupWithoutTabletopPageCreateInput"] | null,
	update?:ValueTypes["TabletopPageUpdateContentGroupsRelationInput"] | null,
	upsert?:ValueTypes["TabletopPageUpsertContentGroupsRelationInput"] | null,
	connect?:ValueTypes["TabletopPageContentGroupUniqueWhere"] | null,
	disconnect?:ValueTypes["TabletopPageContentGroupUniqueWhere"] | null,
	delete?:ValueTypes["TabletopPageContentGroupUniqueWhere"] | null,
	alias?:string | null
};
	["TabletopPageUpdateContentGroupsRelationInput"]: {
	by?:ValueTypes["TabletopPageContentGroupUniqueWhere"] | null,
	data?:ValueTypes["TabletopPageContentGroupWithoutTabletopPageUpdateInput"] | null
};
	["TabletopPageContentGroupWithoutTabletopPageUpdateInput"]: {
	order?:number | null,
	contentGroup?:ValueTypes["TabletopPageContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TabletopPageContentGroupUpdateContentGroupEntityRelationInput"]: {
	create?:ValueTypes["ContentGroupCreateInput"] | null,
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	upsert?:ValueTypes["TabletopPageContentGroupUpsertContentGroupRelationInput"] | null,
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TabletopPageContentGroupUpsertContentGroupRelationInput"]: {
	update?:ValueTypes["ContentGroupUpdateInput"] | null,
	create?:ValueTypes["ContentGroupCreateInput"] | null
};
	["TabletopPageUpsertContentGroupsRelationInput"]: {
	by?:ValueTypes["TabletopPageContentGroupUniqueWhere"] | null,
	update?:ValueTypes["TabletopPageContentGroupWithoutTabletopPageUpdateInput"] | null,
	create?:ValueTypes["TabletopPageContentGroupWithoutTabletopPageCreateInput"] | null
};
	["LinkableUpsertTabletopPageRelationInput"]: {
	update?:ValueTypes["TabletopPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["TabletopPageWithoutLinkCreateInput"] | null
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceUpdateCardMediaEntityRelationInput"]: {
	create?:ValueTypes["CardMediaCreateInput"] | null,
	update?:ValueTypes["CardMediaUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertCardMediaRelationInput"] | null,
	connect?:ValueTypes["CardMediaUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CardMediaUpdateInput"]: {
	text?:string | null,
	imageNote?:string | null,
	image?:ValueTypes["CardMediaUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CardMediaUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["CardMediaUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CardMediaUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceUpsertCardMediaRelationInput"]: {
	update?:ValueTypes["CardMediaUpdateInput"] | null,
	create?:ValueTypes["CardMediaCreateInput"] | null
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	update?:ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null
};
	["ContentUpsertBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	update?:ValueTypes["ContentBlockWithoutContentUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null
};
	["ContentBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null
};
	["ContentWithoutBlocksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null,
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ContentBlockUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null
};
	["ContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	text?:string | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	cardMedia?:ValueTypes["ContentReferenceCreateCardMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	text?:string | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	cardMedia?:ValueTypes["ContentReferenceUpdateCardMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null,
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertBlockRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null
};
	["CardMediaConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CardMediaEdge"],
		__typename?: true
}>;
	["CardMediaEdge"]: AliasType<{
	node?:ValueTypes["CardMedia"],
		__typename?: true
}>;
	["FallbackSeo"]: AliasType<{
	_meta?:ValueTypes["FallbackSeoMeta"],
	id?:true,
	unique?:true,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: true
}>;
	["FallbackSeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FallbackSeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["FallbackSeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["FallbackSeoWhere"] | undefined | null)[],
	or?:(ValueTypes["FallbackSeoWhere"] | undefined | null)[],
	not?:ValueTypes["FallbackSeoWhere"] | null
};
	["FallbackSeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["FallbackSeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FallbackSeoEdge"],
		__typename?: true
}>;
	["FallbackSeoEdge"]: AliasType<{
	node?:ValueTypes["FallbackSeo"],
		__typename?: true
}>;
	["FallbackSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["FallbackSeoCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FallbackSeoCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["FallbackSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["FallbackSeoUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FallbackSeoUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["FallbackSeoUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FallbackSeoUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["Footer"]: AliasType<{
	_meta?:ValueTypes["FooterMeta"],
	id?:true,
	unique?:true,
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
socialLinks?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLink"]],
	directorsText?:true,
	contactText?:true,
directorsButton?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
contactButton?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
paginateSocialLinks?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkConnection"]],
		__typename?: true
}>;
	["FooterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	socialLinks?:ValueTypes["FieldMeta"],
	directorsText?:ValueTypes["FieldMeta"],
	contactText?:ValueTypes["FieldMeta"],
	directorsButton?:ValueTypes["FieldMeta"],
	contactButton?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SocialLink"]: AliasType<{
	_meta?:ValueTypes["SocialLinkMeta"],
	id?:true,
	type?:true,
	order?:true,
	link?:true,
	linkLabel?:true,
		__typename?: true
}>;
	["SocialLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	linkLabel?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SocialLinkType"]:SocialLinkType;
	["SocialLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["SocialLinkTypeCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["StringCondition"] | null,
	linkLabel?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["SocialLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialLinkWhere"] | undefined | null)[],
	not?:ValueTypes["SocialLinkWhere"] | null
};
	["SocialLinkTypeCondition"]: {
	and?:ValueTypes["SocialLinkTypeCondition"][],
	or?:ValueTypes["SocialLinkTypeCondition"][],
	not?:ValueTypes["SocialLinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["SocialLinkType"] | null,
	notEq?:ValueTypes["SocialLinkType"] | null,
	in?:ValueTypes["SocialLinkType"][],
	notIn?:ValueTypes["SocialLinkType"][],
	lt?:ValueTypes["SocialLinkType"] | null,
	lte?:ValueTypes["SocialLinkType"] | null,
	gt?:ValueTypes["SocialLinkType"] | null,
	gte?:ValueTypes["SocialLinkType"] | null
};
	["SocialLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	linkLabel?:ValueTypes["OrderDirection"] | null
};
	["SocialLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialLinkEdge"],
		__typename?: true
}>;
	["SocialLinkEdge"]: AliasType<{
	node?:ValueTypes["SocialLink"],
		__typename?: true
}>;
	["FooterUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["ImageUniqueWhere"] | null,
	directorsButton?:ValueTypes["LinkUniqueWhere"] | null,
	contactButton?:ValueTypes["LinkUniqueWhere"] | null
};
	["FooterWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	socialLinks?:ValueTypes["SocialLinkWhere"] | null,
	directorsText?:ValueTypes["StringCondition"] | null,
	contactText?:ValueTypes["StringCondition"] | null,
	directorsButton?:ValueTypes["LinkWhere"] | null,
	contactButton?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["FooterWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterWhere"] | undefined | null)[],
	not?:ValueTypes["FooterWhere"] | null
};
	["FooterOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null,
	directorsText?:ValueTypes["OrderDirection"] | null,
	contactText?:ValueTypes["OrderDirection"] | null,
	directorsButton?:ValueTypes["LinkOrderBy"] | null,
	contactButton?:ValueTypes["LinkOrderBy"] | null
};
	["FooterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterEdge"],
		__typename?: true
}>;
	["FooterEdge"]: AliasType<{
	node?:ValueTypes["Footer"],
		__typename?: true
}>;
	["FooterCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["FooterCreateLogoEntityRelationInput"] | null,
	socialLinks?:ValueTypes["FooterCreateSocialLinksEntityRelationInput"][],
	directorsText?:string | null,
	contactText?:string | null,
	directorsButton?:ValueTypes["FooterCreateDirectorsButtonEntityRelationInput"] | null,
	contactButton?:ValueTypes["FooterCreateContactButtonEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterCreateSocialLinksEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkCreateInput"] | null,
	alias?:string | null
};
	["SocialLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SocialLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["SocialLinkType"] | null,
	order?:number | null,
	link?:string | null,
	linkLabel?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterCreateDirectorsButtonEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterCreateContactButtonEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["FooterUpdateLogoEntityRelationInput"] | null,
	socialLinks?:ValueTypes["FooterUpdateSocialLinksEntityRelationInput"][],
	directorsText?:string | null,
	contactText?:string | null,
	directorsButton?:ValueTypes["FooterUpdateDirectorsButtonEntityRelationInput"] | null,
	contactButton?:ValueTypes["FooterUpdateContactButtonEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterUpdateSocialLinksEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkCreateInput"] | null,
	update?:ValueTypes["FooterUpdateSocialLinksRelationInput"] | null,
	upsert?:ValueTypes["FooterUpsertSocialLinksRelationInput"] | null,
	connect?:ValueTypes["SocialLinkUniqueWhere"] | null,
	disconnect?:ValueTypes["SocialLinkUniqueWhere"] | null,
	delete?:ValueTypes["SocialLinkUniqueWhere"] | null,
	alias?:string | null
};
	["FooterUpdateSocialLinksRelationInput"]: {
	by?:ValueTypes["SocialLinkUniqueWhere"] | null,
	data?:ValueTypes["SocialLinkUpdateInput"] | null
};
	["SocialLinkUpdateInput"]: {
	type?:ValueTypes["SocialLinkType"] | null,
	order?:number | null,
	link?:string | null,
	linkLabel?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterUpsertSocialLinksRelationInput"]: {
	by?:ValueTypes["SocialLinkUniqueWhere"] | null,
	update?:ValueTypes["SocialLinkUpdateInput"] | null,
	create?:ValueTypes["SocialLinkCreateInput"] | null
};
	["FooterUpdateDirectorsButtonEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertDirectorsButtonRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertDirectorsButtonRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterUpdateContactButtonEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertContactButtonRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertContactButtonRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["GalleryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryEdge"],
		__typename?: true
}>;
	["GalleryEdge"]: AliasType<{
	node?:ValueTypes["Gallery"],
		__typename?: true
}>;
	["GalleryItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["GalleryItemCreateListEntityRelationInput"] | null,
	image?:ValueTypes["GalleryItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null
};
	["GalleryWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["GalleryItemUpdateListEntityRelationInput"] | null,
	image?:ValueTypes["GalleryItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null,
	update?:ValueTypes["GalleryWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["GalleryItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["GalleryItemUpsertListRelationInput"]: {
	update?:ValueTypes["GalleryWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null
};
	["Header"]: AliasType<{
	_meta?:ValueTypes["HeaderMeta"],
	id?:true,
	unique?:true,
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
links?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLink"]],
paginateLinks?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLinkConnection"]],
		__typename?: true
}>;
	["HeaderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HeaderLink"]: AliasType<{
	_meta?:ValueTypes["HeaderLinkMeta"],
	id?:true,
	order?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["HeaderLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HeaderLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["HeaderLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderLinkWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderLinkWhere"] | null
};
	["HeaderLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["HeaderLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderLinkEdge"],
		__typename?: true
}>;
	["HeaderLinkEdge"]: AliasType<{
	node?:ValueTypes["HeaderLink"],
		__typename?: true
}>;
	["HeaderUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["ImageUniqueWhere"] | null
};
	["HeaderWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	links?:ValueTypes["HeaderLinkWhere"] | null,
	and?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderWhere"] | null
};
	["HeaderOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null
};
	["HeaderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderEdge"],
		__typename?: true
}>;
	["HeaderEdge"]: AliasType<{
	node?:ValueTypes["Header"],
		__typename?: true
}>;
	["HeaderCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["HeaderCreateLogoEntityRelationInput"] | null,
	links?:ValueTypes["HeaderCreateLinksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HeaderCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderCreateLinksEntityRelationInput"]: {
	connect?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	create?:ValueTypes["HeaderLinkCreateInput"] | null,
	alias?:string | null
};
	["HeaderLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["HeaderLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["HeaderLinkCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLinkCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["HeaderUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["HeaderUpdateLogoEntityRelationInput"] | null,
	links?:ValueTypes["HeaderUpdateLinksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HeaderUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderUpdateLinksEntityRelationInput"]: {
	create?:ValueTypes["HeaderLinkCreateInput"] | null,
	update?:ValueTypes["HeaderUpdateLinksRelationInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLinksRelationInput"] | null,
	connect?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	disconnect?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	delete?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	alias?:string | null
};
	["HeaderUpdateLinksRelationInput"]: {
	by?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	data?:ValueTypes["HeaderLinkUpdateInput"] | null
};
	["HeaderLinkUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["HeaderLinkUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLinkUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["HeaderLinkUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderLinkUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["HeaderUpsertLinksRelationInput"]: {
	by?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	update?:ValueTypes["HeaderLinkUpdateInput"] | null,
	create?:ValueTypes["HeaderLinkCreateInput"] | null
};
	["HomePageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageEdge"],
		__typename?: true
}>;
	["HomePageEdge"]: AliasType<{
	node?:ValueTypes["HomePage"],
		__typename?: true
}>;
	["HomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	tagline?:string | null,
	logo?:ValueTypes["HomePageCreateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["HomePageCreateLinkEntityRelationInput"] | null,
	directorsText?:string | null,
	contentGroups?:ValueTypes["HomePageCreateContentGroupsEntityRelationInput"][],
	backgroundImage?:ValueTypes["HomePageCreateBackgroundImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null
};
	["LinkableWithoutHomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableCreateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableCreateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableCreateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableCreatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableCreatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableCreateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableCreateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	tagline?:string | null,
	logo?:ValueTypes["HomePageUpdateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["HomePageUpdateLinkEntityRelationInput"] | null,
	directorsText?:string | null,
	contentGroups?:ValueTypes["HomePageUpdateContentGroupsEntityRelationInput"][],
	backgroundImage?:ValueTypes["HomePageUpdateBackgroundImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutHomePageUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutHomePageUpdateInput"]: {
	url?:string | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableUpdateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableUpdateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableUpdateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableUpdatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableUpdatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableUpdateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableUpdateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutHomePageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null
};
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: true
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: true
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: true
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["RedirectConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RedirectEdge"],
		__typename?: true
}>;
	["RedirectEdge"]: AliasType<{
	node?:ValueTypes["Redirect"],
		__typename?: true
}>;
	["RedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	targetUrl?:string | null,
	link?:ValueTypes["RedirectCreateLinkEntityRelationInput"] | null,
	target?:ValueTypes["RedirectCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null
};
	["LinkableWithoutRedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	director?:ValueTypes["LinkableCreateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableCreateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableCreateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableCreatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableCreatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableCreateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableCreateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateInput"]: {
	targetUrl?:string | null,
	link?:ValueTypes["RedirectUpdateLinkEntityRelationInput"] | null,
	target?:ValueTypes["RedirectUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutRedirectUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutRedirectUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	director?:ValueTypes["LinkableUpdateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableUpdateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableUpdateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableUpdatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableUpdatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableUpdateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableUpdateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutRedirectUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null
};
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: true
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["ContactLocationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactLocationEdge"],
		__typename?: true
}>;
	["ContactLocationEdge"]: AliasType<{
	node?:ValueTypes["ContactLocation"],
		__typename?: true
}>;
	["ContactLocationCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	city?:string | null,
	state?:string | null,
	address?:string | null,
	email?:string | null,
	phone?:string | null,
	fax?:string | null,
	note?:string | null,
	contact?:ValueTypes["ContactLocationCreateContactEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContactLocationCreateContactEntityRelationInput"]: {
	connect?:ValueTypes["ContactUniqueWhere"] | null,
	create?:ValueTypes["ContactWithoutContactLocationCreateInput"] | null,
	alias?:string | null
};
	["ContactWithoutContactLocationCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	position?:string | null,
	phone?:string | null,
	email?:string | null,
	image?:ValueTypes["ContactCreateImageEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactLocationUpdateInput"]: {
	order?:number | null,
	city?:string | null,
	state?:string | null,
	address?:string | null,
	email?:string | null,
	phone?:string | null,
	fax?:string | null,
	note?:string | null,
	contact?:ValueTypes["ContactLocationUpdateContactEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContactLocationUpdateContactEntityRelationInput"]: {
	create?:ValueTypes["ContactWithoutContactLocationCreateInput"] | null,
	update?:ValueTypes["ContactLocationUpdateContactRelationInput"] | null,
	upsert?:ValueTypes["ContactLocationUpsertContactRelationInput"] | null,
	connect?:ValueTypes["ContactUniqueWhere"] | null,
	disconnect?:ValueTypes["ContactUniqueWhere"] | null,
	delete?:ValueTypes["ContactUniqueWhere"] | null,
	alias?:string | null
};
	["ContactLocationUpdateContactRelationInput"]: {
	by?:ValueTypes["ContactUniqueWhere"] | null,
	data?:ValueTypes["ContactWithoutContactLocationUpdateInput"] | null
};
	["ContactWithoutContactLocationUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	position?:string | null,
	phone?:string | null,
	email?:string | null,
	image?:ValueTypes["ContactUpdateImageEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactLocationUpsertContactRelationInput"]: {
	by?:ValueTypes["ContactUniqueWhere"] | null,
	update?:ValueTypes["ContactWithoutContactLocationUpdateInput"] | null,
	create?:ValueTypes["ContactWithoutContactLocationCreateInput"] | null
};
	["DirectorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["DirectorCreateImageEntityRelationInput"] | null,
	link?:ValueTypes["DirectorCreateLinkEntityRelationInput"] | null,
	order?:number | null,
	contentGroups?:ValueTypes["DirectorCreateContentGroupsEntityRelationInput"][],
	directorLocation?:ValueTypes["DirectorCreateDirectorLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutDirectorCreateInput"] | null
};
	["LinkableWithoutDirectorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableCreateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableCreateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableCreatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableCreatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableCreateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableCreateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DirectorUpdateInput"]: {
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["DirectorUpdateImageEntityRelationInput"] | null,
	link?:ValueTypes["DirectorUpdateLinkEntityRelationInput"] | null,
	order?:number | null,
	contentGroups?:ValueTypes["DirectorUpdateContentGroupsEntityRelationInput"][],
	directorLocation?:ValueTypes["DirectorUpdateDirectorLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutDirectorCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutDirectorUpdateInput"] | null,
	upsert?:ValueTypes["DirectorUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutDirectorUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableUpdateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableUpdateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableUpdatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableUpdatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableUpdateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableUpdateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DirectorUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutDirectorUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutDirectorCreateInput"] | null
};
	["FilmConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FilmEdge"],
		__typename?: true
}>;
	["FilmEdge"]: AliasType<{
	node?:ValueTypes["Film"],
		__typename?: true
}>;
	["DirectorLocationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DirectorLocationEdge"],
		__typename?: true
}>;
	["DirectorLocationEdge"]: AliasType<{
	node?:ValueTypes["DirectorLocation"],
		__typename?: true
}>;
	["DirectorLocationCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	city?:string | null,
	director?:ValueTypes["DirectorLocationCreateDirectorEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["DirectorLocationCreateDirectorEntityRelationInput"]: {
	connect?:ValueTypes["DirectorUniqueWhere"] | null,
	create?:ValueTypes["DirectorWithoutDirectorLocationCreateInput"] | null,
	alias?:string | null
};
	["DirectorWithoutDirectorLocationCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["DirectorCreateImageEntityRelationInput"] | null,
	link?:ValueTypes["DirectorCreateLinkEntityRelationInput"] | null,
	order?:number | null,
	contentGroups?:ValueTypes["DirectorCreateContentGroupsEntityRelationInput"][],
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorLocationUpdateInput"]: {
	order?:number | null,
	city?:string | null,
	director?:ValueTypes["DirectorLocationUpdateDirectorEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["DirectorLocationUpdateDirectorEntityRelationInput"]: {
	create?:ValueTypes["DirectorWithoutDirectorLocationCreateInput"] | null,
	update?:ValueTypes["DirectorLocationUpdateDirectorRelationInput"] | null,
	upsert?:ValueTypes["DirectorLocationUpsertDirectorRelationInput"] | null,
	connect?:ValueTypes["DirectorUniqueWhere"] | null,
	disconnect?:ValueTypes["DirectorUniqueWhere"] | null,
	delete?:ValueTypes["DirectorUniqueWhere"] | null,
	alias?:string | null
};
	["DirectorLocationUpdateDirectorRelationInput"]: {
	by?:ValueTypes["DirectorUniqueWhere"] | null,
	data?:ValueTypes["DirectorWithoutDirectorLocationUpdateInput"] | null
};
	["DirectorWithoutDirectorLocationUpdateInput"]: {
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["DirectorUpdateImageEntityRelationInput"] | null,
	link?:ValueTypes["DirectorUpdateLinkEntityRelationInput"] | null,
	order?:number | null,
	contentGroups?:ValueTypes["DirectorUpdateContentGroupsEntityRelationInput"][],
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorLocationUpsertDirectorRelationInput"]: {
	by?:ValueTypes["DirectorUniqueWhere"] | null,
	update?:ValueTypes["DirectorWithoutDirectorLocationUpdateInput"] | null,
	create?:ValueTypes["DirectorWithoutDirectorLocationCreateInput"] | null
};
	["ContactsPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactsPageEdge"],
		__typename?: true
}>;
	["ContactsPageEdge"]: AliasType<{
	node?:ValueTypes["ContactsPage"],
		__typename?: true
}>;
	["ContactsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["ContactsPageCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ContactsPageCreateLinkEntityRelationInput"] | null,
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactsPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutContactsPageCreateInput"] | null
};
	["LinkableWithoutContactsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableCreateDirectorEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableCreateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableCreatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableCreatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableCreateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableCreateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactsPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["ContactsPageUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ContactsPageUpdateLinkEntityRelationInput"] | null,
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactsPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutContactsPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutContactsPageUpdateInput"] | null,
	upsert?:ValueTypes["ContactsPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutContactsPageUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableUpdateDirectorEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableUpdateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableUpdatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableUpdatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableUpdateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableUpdateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactsPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutContactsPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutContactsPageCreateInput"] | null
};
	["DirectorsPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DirectorsPageEdge"],
		__typename?: true
}>;
	["DirectorsPageEdge"]: AliasType<{
	node?:ValueTypes["DirectorsPage"],
		__typename?: true
}>;
	["DirectorsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["DirectorsPageCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["DirectorsPageCreateLinkEntityRelationInput"] | null,
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorsPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutDirectorsPageCreateInput"] | null
};
	["LinkableWithoutDirectorsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableCreateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableCreateContactsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableCreatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableCreatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableCreateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableCreateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DirectorsPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["DirectorsPageUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["DirectorsPageUpdateLinkEntityRelationInput"] | null,
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorsPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutDirectorsPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutDirectorsPageUpdateInput"] | null,
	upsert?:ValueTypes["DirectorsPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutDirectorsPageUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableUpdateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableUpdateContactsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableUpdatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableUpdatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableUpdateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableUpdateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DirectorsPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutDirectorsPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutDirectorsPageCreateInput"] | null
};
	["FilmItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentGroups?:ValueTypes["FilmItemCreateContentGroupsEntityRelationInput"] | null,
	film?:ValueTypes["FilmItemCreateFilmEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilmItemCreateContentGroupsEntityRelationInput"]: {
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	create?:ValueTypes["ContentGroupWithoutFilmsCreateInput"] | null
};
	["ContentGroupWithoutFilmsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	contentType?:ValueTypes["ContentGroupType"] | null,
	gallery?:ValueTypes["ContentGroupCreateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilmItemUpdateInput"]: {
	order?:number | null,
	contentGroups?:ValueTypes["FilmItemUpdateContentGroupsEntityRelationInput"] | null,
	film?:ValueTypes["FilmItemUpdateFilmEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilmItemUpdateContentGroupsEntityRelationInput"]: {
	create?:ValueTypes["ContentGroupWithoutFilmsCreateInput"] | null,
	update?:ValueTypes["ContentGroupWithoutFilmsUpdateInput"] | null,
	upsert?:ValueTypes["FilmItemUpsertContentGroupsRelationInput"] | null,
	connect?:ValueTypes["ContentGroupUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentGroupWithoutFilmsUpdateInput"]: {
	title?:string | null,
	contentType?:ValueTypes["ContentGroupType"] | null,
	gallery?:ValueTypes["ContentGroupUpdateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilmItemUpsertContentGroupsRelationInput"]: {
	update?:ValueTypes["ContentGroupWithoutFilmsUpdateInput"] | null,
	create?:ValueTypes["ContentGroupWithoutFilmsCreateInput"] | null
};
	["DirectorContentGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	director?:ValueTypes["DirectorContentGroupCreateDirectorEntityRelationInput"] | null,
	contentGroup?:ValueTypes["DirectorContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DirectorContentGroupCreateDirectorEntityRelationInput"]: {
	connect?:ValueTypes["DirectorUniqueWhere"] | null,
	create?:ValueTypes["DirectorWithoutContentGroupsCreateInput"] | null
};
	["DirectorWithoutContentGroupsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["DirectorCreateImageEntityRelationInput"] | null,
	link?:ValueTypes["DirectorCreateLinkEntityRelationInput"] | null,
	order?:number | null,
	directorLocation?:ValueTypes["DirectorCreateDirectorLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorContentGroupUpdateInput"]: {
	order?:number | null,
	director?:ValueTypes["DirectorContentGroupUpdateDirectorEntityRelationInput"] | null,
	contentGroup?:ValueTypes["DirectorContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DirectorContentGroupUpdateDirectorEntityRelationInput"]: {
	create?:ValueTypes["DirectorWithoutContentGroupsCreateInput"] | null,
	update?:ValueTypes["DirectorWithoutContentGroupsUpdateInput"] | null,
	upsert?:ValueTypes["DirectorContentGroupUpsertDirectorRelationInput"] | null,
	connect?:ValueTypes["DirectorUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DirectorWithoutContentGroupsUpdateInput"]: {
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["DirectorUpdateImageEntityRelationInput"] | null,
	link?:ValueTypes["DirectorUpdateLinkEntityRelationInput"] | null,
	order?:number | null,
	directorLocation?:ValueTypes["DirectorUpdateDirectorLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["DirectorContentGroupUpsertDirectorRelationInput"]: {
	update?:ValueTypes["DirectorWithoutContentGroupsUpdateInput"] | null,
	create?:ValueTypes["DirectorWithoutContentGroupsCreateInput"] | null
};
	["PhotographerCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["PhotographerCreateImageEntityRelationInput"] | null,
	contentGroups?:ValueTypes["PhotographerCreateContentGroupsEntityRelationInput"][],
	link?:ValueTypes["PhotographerCreateLinkEntityRelationInput"] | null,
	photographerLocation?:ValueTypes["PhotographerCreatePhotographerLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["PhotographerCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutPhotographerCreateInput"] | null
};
	["LinkableWithoutPhotographerCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableCreateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableCreateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableCreateDirectorsPageEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableCreatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableCreateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableCreateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographerUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["PhotographerUpdateImageEntityRelationInput"] | null,
	contentGroups?:ValueTypes["PhotographerUpdateContentGroupsEntityRelationInput"][],
	link?:ValueTypes["PhotographerUpdateLinkEntityRelationInput"] | null,
	photographerLocation?:ValueTypes["PhotographerUpdatePhotographerLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["PhotographerUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutPhotographerCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutPhotographerUpdateInput"] | null,
	upsert?:ValueTypes["PhotographerUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutPhotographerUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableUpdateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableUpdateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableUpdateDirectorsPageEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableUpdatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableUpdateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableUpdateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographerUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutPhotographerUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutPhotographerCreateInput"] | null
};
	["PhotographerContentGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	photographer?:ValueTypes["PhotographerContentGroupCreatePhotographerEntityRelationInput"] | null,
	contentGroup?:ValueTypes["PhotographerContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographerContentGroupCreatePhotographerEntityRelationInput"]: {
	connect?:ValueTypes["PhotographerUniqueWhere"] | null,
	create?:ValueTypes["PhotographerWithoutContentGroupsCreateInput"] | null
};
	["PhotographerWithoutContentGroupsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["PhotographerCreateImageEntityRelationInput"] | null,
	link?:ValueTypes["PhotographerCreateLinkEntityRelationInput"] | null,
	photographerLocation?:ValueTypes["PhotographerCreatePhotographerLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["PhotographerContentGroupUpdateInput"]: {
	order?:number | null,
	photographer?:ValueTypes["PhotographerContentGroupUpdatePhotographerEntityRelationInput"] | null,
	contentGroup?:ValueTypes["PhotographerContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographerContentGroupUpdatePhotographerEntityRelationInput"]: {
	create?:ValueTypes["PhotographerWithoutContentGroupsCreateInput"] | null,
	update?:ValueTypes["PhotographerWithoutContentGroupsUpdateInput"] | null,
	upsert?:ValueTypes["PhotographerContentGroupUpsertPhotographerRelationInput"] | null,
	connect?:ValueTypes["PhotographerUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PhotographerWithoutContentGroupsUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["PhotographerUpdateImageEntityRelationInput"] | null,
	link?:ValueTypes["PhotographerUpdateLinkEntityRelationInput"] | null,
	photographerLocation?:ValueTypes["PhotographerUpdatePhotographerLocationEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["PhotographerContentGroupUpsertPhotographerRelationInput"]: {
	update?:ValueTypes["PhotographerWithoutContentGroupsUpdateInput"] | null,
	create?:ValueTypes["PhotographerWithoutContentGroupsCreateInput"] | null
};
	["PhotographerLocationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PhotographerLocationEdge"],
		__typename?: true
}>;
	["PhotographerLocationEdge"]: AliasType<{
	node?:ValueTypes["PhotographerLocation"],
		__typename?: true
}>;
	["PhotographerLocationCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	city?:string | null,
	photographer?:ValueTypes["PhotographerLocationCreatePhotographerEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PhotographerLocationCreatePhotographerEntityRelationInput"]: {
	connect?:ValueTypes["PhotographerUniqueWhere"] | null,
	create?:ValueTypes["PhotographerWithoutPhotographerLocationCreateInput"] | null,
	alias?:string | null
};
	["PhotographerWithoutPhotographerLocationCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["PhotographerCreateImageEntityRelationInput"] | null,
	contentGroups?:ValueTypes["PhotographerCreateContentGroupsEntityRelationInput"][],
	link?:ValueTypes["PhotographerCreateLinkEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["PhotographerLocationUpdateInput"]: {
	order?:number | null,
	city?:string | null,
	photographer?:ValueTypes["PhotographerLocationUpdatePhotographerEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PhotographerLocationUpdatePhotographerEntityRelationInput"]: {
	create?:ValueTypes["PhotographerWithoutPhotographerLocationCreateInput"] | null,
	update?:ValueTypes["PhotographerLocationUpdatePhotographerRelationInput"] | null,
	upsert?:ValueTypes["PhotographerLocationUpsertPhotographerRelationInput"] | null,
	connect?:ValueTypes["PhotographerUniqueWhere"] | null,
	disconnect?:ValueTypes["PhotographerUniqueWhere"] | null,
	delete?:ValueTypes["PhotographerUniqueWhere"] | null,
	alias?:string | null
};
	["PhotographerLocationUpdatePhotographerRelationInput"]: {
	by?:ValueTypes["PhotographerUniqueWhere"] | null,
	data?:ValueTypes["PhotographerWithoutPhotographerLocationUpdateInput"] | null
};
	["PhotographerWithoutPhotographerLocationUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["PhotographerUpdateImageEntityRelationInput"] | null,
	contentGroups?:ValueTypes["PhotographerUpdateContentGroupsEntityRelationInput"][],
	link?:ValueTypes["PhotographerUpdateLinkEntityRelationInput"] | null,
	wordpressId?:string | null,
	_dummy_field_?:boolean | null
};
	["PhotographerLocationUpsertPhotographerRelationInput"]: {
	by?:ValueTypes["PhotographerUniqueWhere"] | null,
	update?:ValueTypes["PhotographerWithoutPhotographerLocationUpdateInput"] | null,
	create?:ValueTypes["PhotographerWithoutPhotographerLocationCreateInput"] | null
};
	["PhotographersPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PhotographersPageEdge"],
		__typename?: true
}>;
	["PhotographersPageEdge"]: AliasType<{
	node?:ValueTypes["PhotographersPage"],
		__typename?: true
}>;
	["PhotographersPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["PhotographersPageCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["PhotographersPageCreateLinkEntityRelationInput"] | null,
	contentGroups?:ValueTypes["PhotographersPageCreateContentGroupsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PhotographersPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutPhotographersPageCreateInput"] | null
};
	["LinkableWithoutPhotographersPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableCreateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableCreateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableCreateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableCreatePhotographerEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableCreateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableCreateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographersPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["PhotographersPageUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["PhotographersPageUpdateLinkEntityRelationInput"] | null,
	contentGroups?:ValueTypes["PhotographersPageUpdateContentGroupsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PhotographersPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutPhotographersPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutPhotographersPageUpdateInput"] | null,
	upsert?:ValueTypes["PhotographersPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutPhotographersPageUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableUpdateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableUpdateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableUpdateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableUpdatePhotographerEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableUpdateOurWorkPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableUpdateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographersPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutPhotographersPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutPhotographersPageCreateInput"] | null
};
	["OurWorkPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OurWorkPageEdge"],
		__typename?: true
}>;
	["OurWorkPageEdge"]: AliasType<{
	node?:ValueTypes["OurWorkPage"],
		__typename?: true
}>;
	["OurWorkPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	link?:ValueTypes["OurWorkPageCreateLinkEntityRelationInput"] | null,
	contentGroups?:ValueTypes["OurWorkPageCreateContentGroupsEntityRelationInput"][],
	seo?:ValueTypes["OurWorkPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutOurWorkPageCreateInput"] | null
};
	["LinkableWithoutOurWorkPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableCreateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableCreateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableCreateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableCreatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableCreatePhotographersPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableCreateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	link?:ValueTypes["OurWorkPageUpdateLinkEntityRelationInput"] | null,
	contentGroups?:ValueTypes["OurWorkPageUpdateContentGroupsEntityRelationInput"][],
	seo?:ValueTypes["OurWorkPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutOurWorkPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutOurWorkPageUpdateInput"] | null,
	upsert?:ValueTypes["OurWorkPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutOurWorkPageUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableUpdateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableUpdateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableUpdateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableUpdatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableUpdatePhotographersPageEntityRelationInput"] | null,
	tabletopPage?:ValueTypes["LinkableUpdateTabletopPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutOurWorkPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutOurWorkPageCreateInput"] | null
};
	["OurWorkPageContentGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	ourWorkPage?:ValueTypes["OurWorkPageContentGroupCreateOurWorkPageEntityRelationInput"] | null,
	contentGroup?:ValueTypes["OurWorkPageContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageContentGroupCreateOurWorkPageEntityRelationInput"]: {
	connect?:ValueTypes["OurWorkPageUniqueWhere"] | null,
	create?:ValueTypes["OurWorkPageWithoutContentGroupsCreateInput"] | null
};
	["OurWorkPageWithoutContentGroupsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	link?:ValueTypes["OurWorkPageCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["OurWorkPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageContentGroupUpdateInput"]: {
	order?:number | null,
	ourWorkPage?:ValueTypes["OurWorkPageContentGroupUpdateOurWorkPageEntityRelationInput"] | null,
	contentGroup?:ValueTypes["OurWorkPageContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageContentGroupUpdateOurWorkPageEntityRelationInput"]: {
	create?:ValueTypes["OurWorkPageWithoutContentGroupsCreateInput"] | null,
	update?:ValueTypes["OurWorkPageWithoutContentGroupsUpdateInput"] | null,
	upsert?:ValueTypes["OurWorkPageContentGroupUpsertOurWorkPageRelationInput"] | null,
	connect?:ValueTypes["OurWorkPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["OurWorkPageWithoutContentGroupsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	link?:ValueTypes["OurWorkPageUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["OurWorkPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OurWorkPageContentGroupUpsertOurWorkPageRelationInput"]: {
	update?:ValueTypes["OurWorkPageWithoutContentGroupsUpdateInput"] | null,
	create?:ValueTypes["OurWorkPageWithoutContentGroupsCreateInput"] | null
};
	["ContentGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentGroupEdge"],
		__typename?: true
}>;
	["ContentGroupEdge"]: AliasType<{
	node?:ValueTypes["ContentGroup"],
		__typename?: true
}>;
	["HomePageContentGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	homePage?:ValueTypes["HomePageContentGroupCreateHomePageEntityRelationInput"] | null,
	contentGroup?:ValueTypes["HomePageContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageContentGroupCreateHomePageEntityRelationInput"]: {
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	create?:ValueTypes["HomePageWithoutContentGroupsCreateInput"] | null
};
	["HomePageWithoutContentGroupsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	tagline?:string | null,
	logo?:ValueTypes["HomePageCreateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["HomePageCreateLinkEntityRelationInput"] | null,
	directorsText?:string | null,
	backgroundImage?:ValueTypes["HomePageCreateBackgroundImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageContentGroupUpdateInput"]: {
	order?:number | null,
	homePage?:ValueTypes["HomePageContentGroupUpdateHomePageEntityRelationInput"] | null,
	contentGroup?:ValueTypes["HomePageContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageContentGroupUpdateHomePageEntityRelationInput"]: {
	create?:ValueTypes["HomePageWithoutContentGroupsCreateInput"] | null,
	update?:ValueTypes["HomePageWithoutContentGroupsUpdateInput"] | null,
	upsert?:ValueTypes["HomePageContentGroupUpsertHomePageRelationInput"] | null,
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageWithoutContentGroupsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	tagline?:string | null,
	logo?:ValueTypes["HomePageUpdateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["HomePageUpdateLinkEntityRelationInput"] | null,
	directorsText?:string | null,
	backgroundImage?:ValueTypes["HomePageUpdateBackgroundImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageContentGroupUpsertHomePageRelationInput"]: {
	update?:ValueTypes["HomePageWithoutContentGroupsUpdateInput"] | null,
	create?:ValueTypes["HomePageWithoutContentGroupsCreateInput"] | null
};
	["TabletopPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TabletopPageEdge"],
		__typename?: true
}>;
	["TabletopPageEdge"]: AliasType<{
	node?:ValueTypes["TabletopPage"],
		__typename?: true
}>;
	["TabletopPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	teamTitle?:string | null,
	link?:ValueTypes["TabletopPageCreateLinkEntityRelationInput"] | null,
	logo?:ValueTypes["TabletopPageCreateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["TabletopPageCreateSeoEntityRelationInput"] | null,
	contentGroups?:ValueTypes["TabletopPageCreateContentGroupsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TabletopPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutTabletopPageCreateInput"] | null
};
	["LinkableWithoutTabletopPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableCreateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableCreateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableCreateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableCreatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableCreatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableCreateOurWorkPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TabletopPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	teamTitle?:string | null,
	link?:ValueTypes["TabletopPageUpdateLinkEntityRelationInput"] | null,
	logo?:ValueTypes["TabletopPageUpdateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["TabletopPageUpdateSeoEntityRelationInput"] | null,
	contentGroups?:ValueTypes["TabletopPageUpdateContentGroupsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TabletopPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutTabletopPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutTabletopPageUpdateInput"] | null,
	upsert?:ValueTypes["TabletopPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutTabletopPageUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	director?:ValueTypes["LinkableUpdateDirectorEntityRelationInput"] | null,
	contactsPage?:ValueTypes["LinkableUpdateContactsPageEntityRelationInput"] | null,
	directorsPage?:ValueTypes["LinkableUpdateDirectorsPageEntityRelationInput"] | null,
	photographer?:ValueTypes["LinkableUpdatePhotographerEntityRelationInput"] | null,
	photographersPage?:ValueTypes["LinkableUpdatePhotographersPageEntityRelationInput"] | null,
	ourWorkPage?:ValueTypes["LinkableUpdateOurWorkPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TabletopPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutTabletopPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutTabletopPageCreateInput"] | null
};
	["TabletopPageContentGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	tabletopPage?:ValueTypes["TabletopPageContentGroupCreateTabletopPageEntityRelationInput"] | null,
	contentGroup?:ValueTypes["TabletopPageContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TabletopPageContentGroupCreateTabletopPageEntityRelationInput"]: {
	connect?:ValueTypes["TabletopPageUniqueWhere"] | null,
	create?:ValueTypes["TabletopPageWithoutContentGroupsCreateInput"] | null
};
	["TabletopPageWithoutContentGroupsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	teamTitle?:string | null,
	link?:ValueTypes["TabletopPageCreateLinkEntityRelationInput"] | null,
	logo?:ValueTypes["TabletopPageCreateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["TabletopPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TabletopPageContentGroupUpdateInput"]: {
	order?:number | null,
	tabletopPage?:ValueTypes["TabletopPageContentGroupUpdateTabletopPageEntityRelationInput"] | null,
	contentGroup?:ValueTypes["TabletopPageContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TabletopPageContentGroupUpdateTabletopPageEntityRelationInput"]: {
	create?:ValueTypes["TabletopPageWithoutContentGroupsCreateInput"] | null,
	update?:ValueTypes["TabletopPageWithoutContentGroupsUpdateInput"] | null,
	upsert?:ValueTypes["TabletopPageContentGroupUpsertTabletopPageRelationInput"] | null,
	connect?:ValueTypes["TabletopPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TabletopPageWithoutContentGroupsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	teamTitle?:string | null,
	link?:ValueTypes["TabletopPageUpdateLinkEntityRelationInput"] | null,
	logo?:ValueTypes["TabletopPageUpdateLogoEntityRelationInput"] | null,
	seo?:ValueTypes["TabletopPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TabletopPageContentGroupUpsertTabletopPageRelationInput"]: {
	update?:ValueTypes["TabletopPageWithoutContentGroupsUpdateInput"] | null,
	create?:ValueTypes["TabletopPageWithoutContentGroupsCreateInput"] | null
};
	["PhotographersPageContentGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	photographersPage?:ValueTypes["PhotographersPageContentGroupCreatePhotographersPageEntityRelationInput"] | null,
	contentGroup?:ValueTypes["PhotographersPageContentGroupCreateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographersPageContentGroupCreatePhotographersPageEntityRelationInput"]: {
	connect?:ValueTypes["PhotographersPageUniqueWhere"] | null,
	create?:ValueTypes["PhotographersPageWithoutContentGroupsCreateInput"] | null
};
	["PhotographersPageWithoutContentGroupsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["PhotographersPageCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["PhotographersPageCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographersPageContentGroupUpdateInput"]: {
	order?:number | null,
	photographersPage?:ValueTypes["PhotographersPageContentGroupUpdatePhotographersPageEntityRelationInput"] | null,
	contentGroup?:ValueTypes["PhotographersPageContentGroupUpdateContentGroupEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographersPageContentGroupUpdatePhotographersPageEntityRelationInput"]: {
	create?:ValueTypes["PhotographersPageWithoutContentGroupsCreateInput"] | null,
	update?:ValueTypes["PhotographersPageWithoutContentGroupsUpdateInput"] | null,
	upsert?:ValueTypes["PhotographersPageContentGroupUpsertPhotographersPageRelationInput"] | null,
	connect?:ValueTypes["PhotographersPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PhotographersPageWithoutContentGroupsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["PhotographersPageUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["PhotographersPageUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographersPageContentGroupUpsertPhotographersPageRelationInput"]: {
	update?:ValueTypes["PhotographersPageWithoutContentGroupsUpdateInput"] | null,
	create?:ValueTypes["PhotographersPageWithoutContentGroupsCreateInput"] | null
};
	["QueryTransaction"]: AliasType<{
getContact?: [{	by:ValueTypes["ContactUniqueWhere"],	filter?:ValueTypes["ContactWhere"] | null},ValueTypes["Contact"]],
listContact?: [{	filter?:ValueTypes["ContactWhere"] | null,	orderBy?:ValueTypes["ContactOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Contact"]],
paginateContact?: [{	filter?:ValueTypes["ContactWhere"] | null,	orderBy?:ValueTypes["ContactOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactConnection"]],
validateCreateContact?: [{	data:ValueTypes["ContactCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContact?: [{	by:ValueTypes["ContactUniqueWhere"],	data:ValueTypes["ContactUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null},ValueTypes["CardMedia"]],
listCardMedia?: [{	filter?:ValueTypes["CardMediaWhere"] | null,	orderBy?:ValueTypes["CardMediaOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CardMedia"]],
paginateCardMedia?: [{	filter?:ValueTypes["CardMediaWhere"] | null,	orderBy?:ValueTypes["CardMediaOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CardMediaConnection"]],
validateCreateCardMedia?: [{	data:ValueTypes["CardMediaCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	data:ValueTypes["CardMediaUpdateInput"]},ValueTypes["_ValidationResult"]],
getFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeo"]],
listFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FallbackSeo"]],
paginateFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FallbackSeoConnection"]],
validateCreateFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
listSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLink"]],
paginateSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkConnection"]],
validateCreateSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
listGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLink"]],
listHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLink"]],
paginateHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLinkConnection"]],
validateCreateHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
listHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactLocation?: [{	by:ValueTypes["ContactLocationUniqueWhere"],	filter?:ValueTypes["ContactLocationWhere"] | null},ValueTypes["ContactLocation"]],
listContactLocation?: [{	filter?:ValueTypes["ContactLocationWhere"] | null,	orderBy?:ValueTypes["ContactLocationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactLocation"]],
paginateContactLocation?: [{	filter?:ValueTypes["ContactLocationWhere"] | null,	orderBy?:ValueTypes["ContactLocationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactLocationConnection"]],
validateCreateContactLocation?: [{	data:ValueTypes["ContactLocationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactLocation?: [{	by:ValueTypes["ContactLocationUniqueWhere"],	data:ValueTypes["ContactLocationUpdateInput"]},ValueTypes["_ValidationResult"]],
getDirector?: [{	by:ValueTypes["DirectorUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null},ValueTypes["Director"]],
listDirector?: [{	filter?:ValueTypes["DirectorWhere"] | null,	orderBy?:ValueTypes["DirectorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Director"]],
paginateDirector?: [{	filter?:ValueTypes["DirectorWhere"] | null,	orderBy?:ValueTypes["DirectorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DirectorConnection"]],
validateCreateDirector?: [{	data:ValueTypes["DirectorCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDirector?: [{	by:ValueTypes["DirectorUniqueWhere"],	data:ValueTypes["DirectorUpdateInput"]},ValueTypes["_ValidationResult"]],
getFilm?: [{	by:ValueTypes["FilmUniqueWhere"],	filter?:ValueTypes["FilmWhere"] | null},ValueTypes["Film"]],
listFilm?: [{	filter?:ValueTypes["FilmWhere"] | null,	orderBy?:ValueTypes["FilmOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Film"]],
paginateFilm?: [{	filter?:ValueTypes["FilmWhere"] | null,	orderBy?:ValueTypes["FilmOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilmConnection"]],
validateCreateFilm?: [{	data:ValueTypes["FilmCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFilm?: [{	by:ValueTypes["FilmUniqueWhere"],	data:ValueTypes["FilmUpdateInput"]},ValueTypes["_ValidationResult"]],
getDirectorLocation?: [{	by:ValueTypes["DirectorLocationUniqueWhere"],	filter?:ValueTypes["DirectorLocationWhere"] | null},ValueTypes["DirectorLocation"]],
listDirectorLocation?: [{	filter?:ValueTypes["DirectorLocationWhere"] | null,	orderBy?:ValueTypes["DirectorLocationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DirectorLocation"]],
paginateDirectorLocation?: [{	filter?:ValueTypes["DirectorLocationWhere"] | null,	orderBy?:ValueTypes["DirectorLocationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DirectorLocationConnection"]],
validateCreateDirectorLocation?: [{	data:ValueTypes["DirectorLocationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDirectorLocation?: [{	by:ValueTypes["DirectorLocationUniqueWhere"],	data:ValueTypes["DirectorLocationUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactsPage?: [{	by:ValueTypes["ContactsPageUniqueWhere"],	filter?:ValueTypes["ContactsPageWhere"] | null},ValueTypes["ContactsPage"]],
listContactsPage?: [{	filter?:ValueTypes["ContactsPageWhere"] | null,	orderBy?:ValueTypes["ContactsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactsPage"]],
paginateContactsPage?: [{	filter?:ValueTypes["ContactsPageWhere"] | null,	orderBy?:ValueTypes["ContactsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactsPageConnection"]],
validateCreateContactsPage?: [{	data:ValueTypes["ContactsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactsPage?: [{	by:ValueTypes["ContactsPageUniqueWhere"],	data:ValueTypes["ContactsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getDirectorsPage?: [{	by:ValueTypes["DirectorsPageUniqueWhere"],	filter?:ValueTypes["DirectorsPageWhere"] | null},ValueTypes["DirectorsPage"]],
listDirectorsPage?: [{	filter?:ValueTypes["DirectorsPageWhere"] | null,	orderBy?:ValueTypes["DirectorsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DirectorsPage"]],
paginateDirectorsPage?: [{	filter?:ValueTypes["DirectorsPageWhere"] | null,	orderBy?:ValueTypes["DirectorsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DirectorsPageConnection"]],
validateCreateDirectorsPage?: [{	data:ValueTypes["DirectorsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDirectorsPage?: [{	by:ValueTypes["DirectorsPageUniqueWhere"],	data:ValueTypes["DirectorsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getFilmItem?: [{	by:ValueTypes["FilmItemUniqueWhere"],	filter?:ValueTypes["FilmItemWhere"] | null},ValueTypes["FilmItem"]],
listFilmItem?: [{	filter?:ValueTypes["FilmItemWhere"] | null,	orderBy?:ValueTypes["FilmItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilmItem"]],
paginateFilmItem?: [{	filter?:ValueTypes["FilmItemWhere"] | null,	orderBy?:ValueTypes["FilmItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilmItemConnection"]],
validateCreateFilmItem?: [{	data:ValueTypes["FilmItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFilmItem?: [{	by:ValueTypes["FilmItemUniqueWhere"],	data:ValueTypes["FilmItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getDirectorContentGroup?: [{	by:ValueTypes["DirectorContentGroupUniqueWhere"],	filter?:ValueTypes["DirectorContentGroupWhere"] | null},ValueTypes["DirectorContentGroup"]],
listDirectorContentGroup?: [{	filter?:ValueTypes["DirectorContentGroupWhere"] | null,	orderBy?:ValueTypes["DirectorContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DirectorContentGroup"]],
paginateDirectorContentGroup?: [{	filter?:ValueTypes["DirectorContentGroupWhere"] | null,	orderBy?:ValueTypes["DirectorContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DirectorContentGroupConnection"]],
validateCreateDirectorContentGroup?: [{	data:ValueTypes["DirectorContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDirectorContentGroup?: [{	by:ValueTypes["DirectorContentGroupUniqueWhere"],	data:ValueTypes["DirectorContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["Photographer"]],
listPhotographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Photographer"]],
paginatePhotographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerConnection"]],
validateCreatePhotographer?: [{	data:ValueTypes["PhotographerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	data:ValueTypes["PhotographerUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographerContentGroup?: [{	by:ValueTypes["PhotographerContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographerContentGroupWhere"] | null},ValueTypes["PhotographerContentGroup"]],
listPhotographerContentGroup?: [{	filter?:ValueTypes["PhotographerContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographerContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PhotographerContentGroup"]],
paginatePhotographerContentGroup?: [{	filter?:ValueTypes["PhotographerContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographerContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerContentGroupConnection"]],
validateCreatePhotographerContentGroup?: [{	data:ValueTypes["PhotographerContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographerContentGroup?: [{	by:ValueTypes["PhotographerContentGroupUniqueWhere"],	data:ValueTypes["PhotographerContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographerLocation?: [{	by:ValueTypes["PhotographerLocationUniqueWhere"],	filter?:ValueTypes["PhotographerLocationWhere"] | null},ValueTypes["PhotographerLocation"]],
listPhotographerLocation?: [{	filter?:ValueTypes["PhotographerLocationWhere"] | null,	orderBy?:ValueTypes["PhotographerLocationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PhotographerLocation"]],
paginatePhotographerLocation?: [{	filter?:ValueTypes["PhotographerLocationWhere"] | null,	orderBy?:ValueTypes["PhotographerLocationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerLocationConnection"]],
validateCreatePhotographerLocation?: [{	data:ValueTypes["PhotographerLocationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographerLocation?: [{	by:ValueTypes["PhotographerLocationUniqueWhere"],	data:ValueTypes["PhotographerLocationUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographersPage?: [{	by:ValueTypes["PhotographersPageUniqueWhere"],	filter?:ValueTypes["PhotographersPageWhere"] | null},ValueTypes["PhotographersPage"]],
listPhotographersPage?: [{	filter?:ValueTypes["PhotographersPageWhere"] | null,	orderBy?:ValueTypes["PhotographersPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PhotographersPage"]],
paginatePhotographersPage?: [{	filter?:ValueTypes["PhotographersPageWhere"] | null,	orderBy?:ValueTypes["PhotographersPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographersPageConnection"]],
validateCreatePhotographersPage?: [{	data:ValueTypes["PhotographersPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographersPage?: [{	by:ValueTypes["PhotographersPageUniqueWhere"],	data:ValueTypes["PhotographersPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getOurWorkPage?: [{	by:ValueTypes["OurWorkPageUniqueWhere"],	filter?:ValueTypes["OurWorkPageWhere"] | null},ValueTypes["OurWorkPage"]],
listOurWorkPage?: [{	filter?:ValueTypes["OurWorkPageWhere"] | null,	orderBy?:ValueTypes["OurWorkPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["OurWorkPage"]],
paginateOurWorkPage?: [{	filter?:ValueTypes["OurWorkPageWhere"] | null,	orderBy?:ValueTypes["OurWorkPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["OurWorkPageConnection"]],
validateCreateOurWorkPage?: [{	data:ValueTypes["OurWorkPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOurWorkPage?: [{	by:ValueTypes["OurWorkPageUniqueWhere"],	data:ValueTypes["OurWorkPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getOurWorkPageContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupUniqueWhere"],	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null},ValueTypes["OurWorkPageContentGroup"]],
listOurWorkPageContentGroup?: [{	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null,	orderBy?:ValueTypes["OurWorkPageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["OurWorkPageContentGroup"]],
paginateOurWorkPageContentGroup?: [{	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null,	orderBy?:ValueTypes["OurWorkPageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["OurWorkPageContentGroupConnection"]],
validateCreateOurWorkPageContentGroup?: [{	data:ValueTypes["OurWorkPageContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOurWorkPageContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupUniqueWhere"],	data:ValueTypes["OurWorkPageContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentGroup?: [{	by:ValueTypes["ContentGroupUniqueWhere"],	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroup"]],
listContentGroup?: [{	filter?:ValueTypes["ContentGroupWhere"] | null,	orderBy?:ValueTypes["ContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentGroup"]],
paginateContentGroup?: [{	filter?:ValueTypes["ContentGroupWhere"] | null,	orderBy?:ValueTypes["ContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentGroupConnection"]],
validateCreateContentGroup?: [{	data:ValueTypes["ContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentGroup?: [{	by:ValueTypes["ContentGroupUniqueWhere"],	data:ValueTypes["ContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePageContentGroup?: [{	by:ValueTypes["HomePageContentGroupUniqueWhere"],	filter?:ValueTypes["HomePageContentGroupWhere"] | null},ValueTypes["HomePageContentGroup"]],
listHomePageContentGroup?: [{	filter?:ValueTypes["HomePageContentGroupWhere"] | null,	orderBy?:ValueTypes["HomePageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePageContentGroup"]],
paginateHomePageContentGroup?: [{	filter?:ValueTypes["HomePageContentGroupWhere"] | null,	orderBy?:ValueTypes["HomePageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageContentGroupConnection"]],
validateCreateHomePageContentGroup?: [{	data:ValueTypes["HomePageContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePageContentGroup?: [{	by:ValueTypes["HomePageContentGroupUniqueWhere"],	data:ValueTypes["HomePageContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getTabletopPage?: [{	by:ValueTypes["TabletopPageUniqueWhere"],	filter?:ValueTypes["TabletopPageWhere"] | null},ValueTypes["TabletopPage"]],
listTabletopPage?: [{	filter?:ValueTypes["TabletopPageWhere"] | null,	orderBy?:ValueTypes["TabletopPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TabletopPage"]],
paginateTabletopPage?: [{	filter?:ValueTypes["TabletopPageWhere"] | null,	orderBy?:ValueTypes["TabletopPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TabletopPageConnection"]],
validateCreateTabletopPage?: [{	data:ValueTypes["TabletopPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTabletopPage?: [{	by:ValueTypes["TabletopPageUniqueWhere"],	data:ValueTypes["TabletopPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getTabletopPageContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupUniqueWhere"],	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null},ValueTypes["TabletopPageContentGroup"]],
listTabletopPageContentGroup?: [{	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null,	orderBy?:ValueTypes["TabletopPageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TabletopPageContentGroup"]],
paginateTabletopPageContentGroup?: [{	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null,	orderBy?:ValueTypes["TabletopPageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TabletopPageContentGroupConnection"]],
validateCreateTabletopPageContentGroup?: [{	data:ValueTypes["TabletopPageContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTabletopPageContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupUniqueWhere"],	data:ValueTypes["TabletopPageContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographersPageContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null},ValueTypes["PhotographersPageContentGroup"]],
listPhotographersPageContentGroup?: [{	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographersPageContentGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PhotographersPageContentGroup"]],
paginatePhotographersPageContentGroup?: [{	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null,	orderBy?:ValueTypes["PhotographersPageContentGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographersPageContentGroupConnection"]],
validateCreatePhotographersPageContentGroup?: [{	data:ValueTypes["PhotographersPageContentGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographersPageContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupUniqueWhere"],	data:ValueTypes["PhotographersPageContentGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
		__typename?: true
}>;
	["Info"]: AliasType<{
	description?:true,
		__typename?: true
}>;
	["Mutation"]: AliasType<{
createContact?: [{	data:ValueTypes["ContactCreateInput"]},ValueTypes["ContactCreateResult"]],
deleteContact?: [{	by:ValueTypes["ContactUniqueWhere"],	filter?:ValueTypes["ContactWhere"] | null},ValueTypes["ContactDeleteResult"]],
updateContact?: [{	by:ValueTypes["ContactUniqueWhere"],	filter?:ValueTypes["ContactWhere"] | null,	data:ValueTypes["ContactUpdateInput"]},ValueTypes["ContactUpdateResult"]],
upsertContact?: [{	by:ValueTypes["ContactUniqueWhere"],	filter?:ValueTypes["ContactWhere"] | null,	update:ValueTypes["ContactUpdateInput"],	create:ValueTypes["ContactCreateInput"]},ValueTypes["ContactUpsertResult"]],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createCardMedia?: [{	data:ValueTypes["CardMediaCreateInput"]},ValueTypes["CardMediaCreateResult"]],
deleteCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null},ValueTypes["CardMediaDeleteResult"]],
updateCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null,	data:ValueTypes["CardMediaUpdateInput"]},ValueTypes["CardMediaUpdateResult"]],
upsertCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null,	update:ValueTypes["CardMediaUpdateInput"],	create:ValueTypes["CardMediaCreateInput"]},ValueTypes["CardMediaUpsertResult"]],
createFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoCreateResult"]],
deleteFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeoDeleteResult"]],
updateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["FallbackSeoUpdateResult"]],
upsertFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	update:ValueTypes["FallbackSeoUpdateInput"],	create:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkCreateResult"]],
deleteSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLinkDeleteResult"]],
updateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["SocialLinkUpdateResult"]],
upsertSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	update:ValueTypes["SocialLinkUpdateInput"],	create:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkUpsertResult"]],
createGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	update:ValueTypes["GalleryUpdateInput"],	create:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryUpsertResult"]],
createGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	update:ValueTypes["GalleryItemUpdateInput"],	create:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkCreateResult"]],
deleteHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLinkDeleteResult"]],
updateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["HeaderLinkUpdateResult"]],
upsertHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	update:ValueTypes["HeaderLinkUpdateInput"],	create:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkUpsertResult"]],
createHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	update:ValueTypes["HomePageUpdateInput"],	create:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createContactLocation?: [{	data:ValueTypes["ContactLocationCreateInput"]},ValueTypes["ContactLocationCreateResult"]],
deleteContactLocation?: [{	by:ValueTypes["ContactLocationUniqueWhere"],	filter?:ValueTypes["ContactLocationWhere"] | null},ValueTypes["ContactLocationDeleteResult"]],
updateContactLocation?: [{	by:ValueTypes["ContactLocationUniqueWhere"],	filter?:ValueTypes["ContactLocationWhere"] | null,	data:ValueTypes["ContactLocationUpdateInput"]},ValueTypes["ContactLocationUpdateResult"]],
upsertContactLocation?: [{	by:ValueTypes["ContactLocationUniqueWhere"],	filter?:ValueTypes["ContactLocationWhere"] | null,	update:ValueTypes["ContactLocationUpdateInput"],	create:ValueTypes["ContactLocationCreateInput"]},ValueTypes["ContactLocationUpsertResult"]],
createDirector?: [{	data:ValueTypes["DirectorCreateInput"]},ValueTypes["DirectorCreateResult"]],
deleteDirector?: [{	by:ValueTypes["DirectorUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null},ValueTypes["DirectorDeleteResult"]],
updateDirector?: [{	by:ValueTypes["DirectorUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null,	data:ValueTypes["DirectorUpdateInput"]},ValueTypes["DirectorUpdateResult"]],
upsertDirector?: [{	by:ValueTypes["DirectorUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null,	update:ValueTypes["DirectorUpdateInput"],	create:ValueTypes["DirectorCreateInput"]},ValueTypes["DirectorUpsertResult"]],
createFilm?: [{	data:ValueTypes["FilmCreateInput"]},ValueTypes["FilmCreateResult"]],
deleteFilm?: [{	by:ValueTypes["FilmUniqueWhere"],	filter?:ValueTypes["FilmWhere"] | null},ValueTypes["FilmDeleteResult"]],
updateFilm?: [{	by:ValueTypes["FilmUniqueWhere"],	filter?:ValueTypes["FilmWhere"] | null,	data:ValueTypes["FilmUpdateInput"]},ValueTypes["FilmUpdateResult"]],
upsertFilm?: [{	by:ValueTypes["FilmUniqueWhere"],	filter?:ValueTypes["FilmWhere"] | null,	update:ValueTypes["FilmUpdateInput"],	create:ValueTypes["FilmCreateInput"]},ValueTypes["FilmUpsertResult"]],
createDirectorLocation?: [{	data:ValueTypes["DirectorLocationCreateInput"]},ValueTypes["DirectorLocationCreateResult"]],
deleteDirectorLocation?: [{	by:ValueTypes["DirectorLocationUniqueWhere"],	filter?:ValueTypes["DirectorLocationWhere"] | null},ValueTypes["DirectorLocationDeleteResult"]],
updateDirectorLocation?: [{	by:ValueTypes["DirectorLocationUniqueWhere"],	filter?:ValueTypes["DirectorLocationWhere"] | null,	data:ValueTypes["DirectorLocationUpdateInput"]},ValueTypes["DirectorLocationUpdateResult"]],
upsertDirectorLocation?: [{	by:ValueTypes["DirectorLocationUniqueWhere"],	filter?:ValueTypes["DirectorLocationWhere"] | null,	update:ValueTypes["DirectorLocationUpdateInput"],	create:ValueTypes["DirectorLocationCreateInput"]},ValueTypes["DirectorLocationUpsertResult"]],
createContactsPage?: [{	data:ValueTypes["ContactsPageCreateInput"]},ValueTypes["ContactsPageCreateResult"]],
deleteContactsPage?: [{	by:ValueTypes["ContactsPageUniqueWhere"],	filter?:ValueTypes["ContactsPageWhere"] | null},ValueTypes["ContactsPageDeleteResult"]],
updateContactsPage?: [{	by:ValueTypes["ContactsPageUniqueWhere"],	filter?:ValueTypes["ContactsPageWhere"] | null,	data:ValueTypes["ContactsPageUpdateInput"]},ValueTypes["ContactsPageUpdateResult"]],
upsertContactsPage?: [{	by:ValueTypes["ContactsPageUniqueWhere"],	filter?:ValueTypes["ContactsPageWhere"] | null,	update:ValueTypes["ContactsPageUpdateInput"],	create:ValueTypes["ContactsPageCreateInput"]},ValueTypes["ContactsPageUpsertResult"]],
createDirectorsPage?: [{	data:ValueTypes["DirectorsPageCreateInput"]},ValueTypes["DirectorsPageCreateResult"]],
deleteDirectorsPage?: [{	by:ValueTypes["DirectorsPageUniqueWhere"],	filter?:ValueTypes["DirectorsPageWhere"] | null},ValueTypes["DirectorsPageDeleteResult"]],
updateDirectorsPage?: [{	by:ValueTypes["DirectorsPageUniqueWhere"],	filter?:ValueTypes["DirectorsPageWhere"] | null,	data:ValueTypes["DirectorsPageUpdateInput"]},ValueTypes["DirectorsPageUpdateResult"]],
upsertDirectorsPage?: [{	by:ValueTypes["DirectorsPageUniqueWhere"],	filter?:ValueTypes["DirectorsPageWhere"] | null,	update:ValueTypes["DirectorsPageUpdateInput"],	create:ValueTypes["DirectorsPageCreateInput"]},ValueTypes["DirectorsPageUpsertResult"]],
createFilmItem?: [{	data:ValueTypes["FilmItemCreateInput"]},ValueTypes["FilmItemCreateResult"]],
deleteFilmItem?: [{	by:ValueTypes["FilmItemUniqueWhere"],	filter?:ValueTypes["FilmItemWhere"] | null},ValueTypes["FilmItemDeleteResult"]],
updateFilmItem?: [{	by:ValueTypes["FilmItemUniqueWhere"],	filter?:ValueTypes["FilmItemWhere"] | null,	data:ValueTypes["FilmItemUpdateInput"]},ValueTypes["FilmItemUpdateResult"]],
upsertFilmItem?: [{	by:ValueTypes["FilmItemUniqueWhere"],	filter?:ValueTypes["FilmItemWhere"] | null,	update:ValueTypes["FilmItemUpdateInput"],	create:ValueTypes["FilmItemCreateInput"]},ValueTypes["FilmItemUpsertResult"]],
createDirectorContentGroup?: [{	data:ValueTypes["DirectorContentGroupCreateInput"]},ValueTypes["DirectorContentGroupCreateResult"]],
deleteDirectorContentGroup?: [{	by:ValueTypes["DirectorContentGroupUniqueWhere"],	filter?:ValueTypes["DirectorContentGroupWhere"] | null},ValueTypes["DirectorContentGroupDeleteResult"]],
updateDirectorContentGroup?: [{	by:ValueTypes["DirectorContentGroupUniqueWhere"],	filter?:ValueTypes["DirectorContentGroupWhere"] | null,	data:ValueTypes["DirectorContentGroupUpdateInput"]},ValueTypes["DirectorContentGroupUpdateResult"]],
upsertDirectorContentGroup?: [{	by:ValueTypes["DirectorContentGroupUniqueWhere"],	filter?:ValueTypes["DirectorContentGroupWhere"] | null,	update:ValueTypes["DirectorContentGroupUpdateInput"],	create:ValueTypes["DirectorContentGroupCreateInput"]},ValueTypes["DirectorContentGroupUpsertResult"]],
createPhotographer?: [{	data:ValueTypes["PhotographerCreateInput"]},ValueTypes["PhotographerCreateResult"]],
deletePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["PhotographerDeleteResult"]],
updatePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null,	data:ValueTypes["PhotographerUpdateInput"]},ValueTypes["PhotographerUpdateResult"]],
upsertPhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null,	update:ValueTypes["PhotographerUpdateInput"],	create:ValueTypes["PhotographerCreateInput"]},ValueTypes["PhotographerUpsertResult"]],
createPhotographerContentGroup?: [{	data:ValueTypes["PhotographerContentGroupCreateInput"]},ValueTypes["PhotographerContentGroupCreateResult"]],
deletePhotographerContentGroup?: [{	by:ValueTypes["PhotographerContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographerContentGroupWhere"] | null},ValueTypes["PhotographerContentGroupDeleteResult"]],
updatePhotographerContentGroup?: [{	by:ValueTypes["PhotographerContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographerContentGroupWhere"] | null,	data:ValueTypes["PhotographerContentGroupUpdateInput"]},ValueTypes["PhotographerContentGroupUpdateResult"]],
upsertPhotographerContentGroup?: [{	by:ValueTypes["PhotographerContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographerContentGroupWhere"] | null,	update:ValueTypes["PhotographerContentGroupUpdateInput"],	create:ValueTypes["PhotographerContentGroupCreateInput"]},ValueTypes["PhotographerContentGroupUpsertResult"]],
createPhotographerLocation?: [{	data:ValueTypes["PhotographerLocationCreateInput"]},ValueTypes["PhotographerLocationCreateResult"]],
deletePhotographerLocation?: [{	by:ValueTypes["PhotographerLocationUniqueWhere"],	filter?:ValueTypes["PhotographerLocationWhere"] | null},ValueTypes["PhotographerLocationDeleteResult"]],
updatePhotographerLocation?: [{	by:ValueTypes["PhotographerLocationUniqueWhere"],	filter?:ValueTypes["PhotographerLocationWhere"] | null,	data:ValueTypes["PhotographerLocationUpdateInput"]},ValueTypes["PhotographerLocationUpdateResult"]],
upsertPhotographerLocation?: [{	by:ValueTypes["PhotographerLocationUniqueWhere"],	filter?:ValueTypes["PhotographerLocationWhere"] | null,	update:ValueTypes["PhotographerLocationUpdateInput"],	create:ValueTypes["PhotographerLocationCreateInput"]},ValueTypes["PhotographerLocationUpsertResult"]],
createPhotographersPage?: [{	data:ValueTypes["PhotographersPageCreateInput"]},ValueTypes["PhotographersPageCreateResult"]],
deletePhotographersPage?: [{	by:ValueTypes["PhotographersPageUniqueWhere"],	filter?:ValueTypes["PhotographersPageWhere"] | null},ValueTypes["PhotographersPageDeleteResult"]],
updatePhotographersPage?: [{	by:ValueTypes["PhotographersPageUniqueWhere"],	filter?:ValueTypes["PhotographersPageWhere"] | null,	data:ValueTypes["PhotographersPageUpdateInput"]},ValueTypes["PhotographersPageUpdateResult"]],
upsertPhotographersPage?: [{	by:ValueTypes["PhotographersPageUniqueWhere"],	filter?:ValueTypes["PhotographersPageWhere"] | null,	update:ValueTypes["PhotographersPageUpdateInput"],	create:ValueTypes["PhotographersPageCreateInput"]},ValueTypes["PhotographersPageUpsertResult"]],
createOurWorkPage?: [{	data:ValueTypes["OurWorkPageCreateInput"]},ValueTypes["OurWorkPageCreateResult"]],
deleteOurWorkPage?: [{	by:ValueTypes["OurWorkPageUniqueWhere"],	filter?:ValueTypes["OurWorkPageWhere"] | null},ValueTypes["OurWorkPageDeleteResult"]],
updateOurWorkPage?: [{	by:ValueTypes["OurWorkPageUniqueWhere"],	filter?:ValueTypes["OurWorkPageWhere"] | null,	data:ValueTypes["OurWorkPageUpdateInput"]},ValueTypes["OurWorkPageUpdateResult"]],
upsertOurWorkPage?: [{	by:ValueTypes["OurWorkPageUniqueWhere"],	filter?:ValueTypes["OurWorkPageWhere"] | null,	update:ValueTypes["OurWorkPageUpdateInput"],	create:ValueTypes["OurWorkPageCreateInput"]},ValueTypes["OurWorkPageUpsertResult"]],
createOurWorkPageContentGroup?: [{	data:ValueTypes["OurWorkPageContentGroupCreateInput"]},ValueTypes["OurWorkPageContentGroupCreateResult"]],
deleteOurWorkPageContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupUniqueWhere"],	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null},ValueTypes["OurWorkPageContentGroupDeleteResult"]],
updateOurWorkPageContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupUniqueWhere"],	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null,	data:ValueTypes["OurWorkPageContentGroupUpdateInput"]},ValueTypes["OurWorkPageContentGroupUpdateResult"]],
upsertOurWorkPageContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupUniqueWhere"],	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null,	update:ValueTypes["OurWorkPageContentGroupUpdateInput"],	create:ValueTypes["OurWorkPageContentGroupCreateInput"]},ValueTypes["OurWorkPageContentGroupUpsertResult"]],
createContentGroup?: [{	data:ValueTypes["ContentGroupCreateInput"]},ValueTypes["ContentGroupCreateResult"]],
deleteContentGroup?: [{	by:ValueTypes["ContentGroupUniqueWhere"],	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroupDeleteResult"]],
updateContentGroup?: [{	by:ValueTypes["ContentGroupUniqueWhere"],	filter?:ValueTypes["ContentGroupWhere"] | null,	data:ValueTypes["ContentGroupUpdateInput"]},ValueTypes["ContentGroupUpdateResult"]],
upsertContentGroup?: [{	by:ValueTypes["ContentGroupUniqueWhere"],	filter?:ValueTypes["ContentGroupWhere"] | null,	update:ValueTypes["ContentGroupUpdateInput"],	create:ValueTypes["ContentGroupCreateInput"]},ValueTypes["ContentGroupUpsertResult"]],
createHomePageContentGroup?: [{	data:ValueTypes["HomePageContentGroupCreateInput"]},ValueTypes["HomePageContentGroupCreateResult"]],
deleteHomePageContentGroup?: [{	by:ValueTypes["HomePageContentGroupUniqueWhere"],	filter?:ValueTypes["HomePageContentGroupWhere"] | null},ValueTypes["HomePageContentGroupDeleteResult"]],
updateHomePageContentGroup?: [{	by:ValueTypes["HomePageContentGroupUniqueWhere"],	filter?:ValueTypes["HomePageContentGroupWhere"] | null,	data:ValueTypes["HomePageContentGroupUpdateInput"]},ValueTypes["HomePageContentGroupUpdateResult"]],
upsertHomePageContentGroup?: [{	by:ValueTypes["HomePageContentGroupUniqueWhere"],	filter?:ValueTypes["HomePageContentGroupWhere"] | null,	update:ValueTypes["HomePageContentGroupUpdateInput"],	create:ValueTypes["HomePageContentGroupCreateInput"]},ValueTypes["HomePageContentGroupUpsertResult"]],
createTabletopPage?: [{	data:ValueTypes["TabletopPageCreateInput"]},ValueTypes["TabletopPageCreateResult"]],
deleteTabletopPage?: [{	by:ValueTypes["TabletopPageUniqueWhere"],	filter?:ValueTypes["TabletopPageWhere"] | null},ValueTypes["TabletopPageDeleteResult"]],
updateTabletopPage?: [{	by:ValueTypes["TabletopPageUniqueWhere"],	filter?:ValueTypes["TabletopPageWhere"] | null,	data:ValueTypes["TabletopPageUpdateInput"]},ValueTypes["TabletopPageUpdateResult"]],
upsertTabletopPage?: [{	by:ValueTypes["TabletopPageUniqueWhere"],	filter?:ValueTypes["TabletopPageWhere"] | null,	update:ValueTypes["TabletopPageUpdateInput"],	create:ValueTypes["TabletopPageCreateInput"]},ValueTypes["TabletopPageUpsertResult"]],
createTabletopPageContentGroup?: [{	data:ValueTypes["TabletopPageContentGroupCreateInput"]},ValueTypes["TabletopPageContentGroupCreateResult"]],
deleteTabletopPageContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupUniqueWhere"],	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null},ValueTypes["TabletopPageContentGroupDeleteResult"]],
updateTabletopPageContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupUniqueWhere"],	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null,	data:ValueTypes["TabletopPageContentGroupUpdateInput"]},ValueTypes["TabletopPageContentGroupUpdateResult"]],
upsertTabletopPageContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupUniqueWhere"],	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null,	update:ValueTypes["TabletopPageContentGroupUpdateInput"],	create:ValueTypes["TabletopPageContentGroupCreateInput"]},ValueTypes["TabletopPageContentGroupUpsertResult"]],
createPhotographersPageContentGroup?: [{	data:ValueTypes["PhotographersPageContentGroupCreateInput"]},ValueTypes["PhotographersPageContentGroupCreateResult"]],
deletePhotographersPageContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null},ValueTypes["PhotographersPageContentGroupDeleteResult"]],
updatePhotographersPageContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null,	data:ValueTypes["PhotographersPageContentGroupUpdateInput"]},ValueTypes["PhotographersPageContentGroupUpdateResult"]],
upsertPhotographersPageContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null,	update:ValueTypes["PhotographersPageContentGroupUpdateInput"],	create:ValueTypes["PhotographersPageContentGroupCreateInput"]},ValueTypes["PhotographersPageContentGroupUpsertResult"]],
transaction?: [{	options?:ValueTypes["MutationTransactionOptions"] | null},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
generateUploadUrl?: [{	contentType:string,	expiration?:number | null,	prefix?:string | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey:string,	expiration?:number | null},ValueTypes["S3SignedRead"]],
		__typename?: true
}>;
	["ContactCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Contact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationResult"]:AliasType<{
		ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"];
		['...on ContactCreateResult']?: Omit<ValueTypes["ContactCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactDeleteResult']?: Omit<ValueTypes["ContactDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactUpdateResult']?: Omit<ValueTypes["ContactUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactUpsertResult']?: Omit<ValueTypes["ContactUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentCreateResult']?: Omit<ValueTypes["ContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ValueTypes["ContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ValueTypes["ContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ValueTypes["ContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ValueTypes["ContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ValueTypes["ContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ValueTypes["ContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ValueTypes["ContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardMediaCreateResult']?: Omit<ValueTypes["CardMediaCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardMediaDeleteResult']?: Omit<ValueTypes["CardMediaDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardMediaUpdateResult']?: Omit<ValueTypes["CardMediaUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardMediaUpsertResult']?: Omit<ValueTypes["CardMediaUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoCreateResult']?: Omit<ValueTypes["FallbackSeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoDeleteResult']?: Omit<ValueTypes["FallbackSeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoUpdateResult']?: Omit<ValueTypes["FallbackSeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoUpsertResult']?: Omit<ValueTypes["FallbackSeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ValueTypes["FooterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ValueTypes["FooterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ValueTypes["FooterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ValueTypes["FooterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkCreateResult']?: Omit<ValueTypes["SocialLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkDeleteResult']?: Omit<ValueTypes["SocialLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkUpdateResult']?: Omit<ValueTypes["SocialLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkUpsertResult']?: Omit<ValueTypes["SocialLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryCreateResult']?: Omit<ValueTypes["GalleryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryDeleteResult']?: Omit<ValueTypes["GalleryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpdateResult']?: Omit<ValueTypes["GalleryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpsertResult']?: Omit<ValueTypes["GalleryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemCreateResult']?: Omit<ValueTypes["GalleryItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemDeleteResult']?: Omit<ValueTypes["GalleryItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpdateResult']?: Omit<ValueTypes["GalleryItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpsertResult']?: Omit<ValueTypes["GalleryItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderCreateResult']?: Omit<ValueTypes["HeaderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderDeleteResult']?: Omit<ValueTypes["HeaderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpdateResult']?: Omit<ValueTypes["HeaderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpsertResult']?: Omit<ValueTypes["HeaderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkCreateResult']?: Omit<ValueTypes["HeaderLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkDeleteResult']?: Omit<ValueTypes["HeaderLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkUpdateResult']?: Omit<ValueTypes["HeaderLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkUpsertResult']?: Omit<ValueTypes["HeaderLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageCreateResult']?: Omit<ValueTypes["HomePageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageDeleteResult']?: Omit<ValueTypes["HomePageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpdateResult']?: Omit<ValueTypes["HomePageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpsertResult']?: Omit<ValueTypes["HomePageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectCreateResult']?: Omit<ValueTypes["RedirectCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectDeleteResult']?: Omit<ValueTypes["RedirectDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpdateResult']?: Omit<ValueTypes["RedirectUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpsertResult']?: Omit<ValueTypes["RedirectUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactLocationCreateResult']?: Omit<ValueTypes["ContactLocationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactLocationDeleteResult']?: Omit<ValueTypes["ContactLocationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactLocationUpdateResult']?: Omit<ValueTypes["ContactLocationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactLocationUpsertResult']?: Omit<ValueTypes["ContactLocationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorCreateResult']?: Omit<ValueTypes["DirectorCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorDeleteResult']?: Omit<ValueTypes["DirectorDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorUpdateResult']?: Omit<ValueTypes["DirectorUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorUpsertResult']?: Omit<ValueTypes["DirectorUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilmCreateResult']?: Omit<ValueTypes["FilmCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilmDeleteResult']?: Omit<ValueTypes["FilmDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilmUpdateResult']?: Omit<ValueTypes["FilmUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilmUpsertResult']?: Omit<ValueTypes["FilmUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorLocationCreateResult']?: Omit<ValueTypes["DirectorLocationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorLocationDeleteResult']?: Omit<ValueTypes["DirectorLocationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorLocationUpdateResult']?: Omit<ValueTypes["DirectorLocationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorLocationUpsertResult']?: Omit<ValueTypes["DirectorLocationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactsPageCreateResult']?: Omit<ValueTypes["ContactsPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactsPageDeleteResult']?: Omit<ValueTypes["ContactsPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactsPageUpdateResult']?: Omit<ValueTypes["ContactsPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactsPageUpsertResult']?: Omit<ValueTypes["ContactsPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorsPageCreateResult']?: Omit<ValueTypes["DirectorsPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorsPageDeleteResult']?: Omit<ValueTypes["DirectorsPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorsPageUpdateResult']?: Omit<ValueTypes["DirectorsPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorsPageUpsertResult']?: Omit<ValueTypes["DirectorsPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilmItemCreateResult']?: Omit<ValueTypes["FilmItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilmItemDeleteResult']?: Omit<ValueTypes["FilmItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilmItemUpdateResult']?: Omit<ValueTypes["FilmItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilmItemUpsertResult']?: Omit<ValueTypes["FilmItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorContentGroupCreateResult']?: Omit<ValueTypes["DirectorContentGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorContentGroupDeleteResult']?: Omit<ValueTypes["DirectorContentGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorContentGroupUpdateResult']?: Omit<ValueTypes["DirectorContentGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DirectorContentGroupUpsertResult']?: Omit<ValueTypes["DirectorContentGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerCreateResult']?: Omit<ValueTypes["PhotographerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerDeleteResult']?: Omit<ValueTypes["PhotographerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerUpdateResult']?: Omit<ValueTypes["PhotographerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerUpsertResult']?: Omit<ValueTypes["PhotographerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerContentGroupCreateResult']?: Omit<ValueTypes["PhotographerContentGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerContentGroupDeleteResult']?: Omit<ValueTypes["PhotographerContentGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerContentGroupUpdateResult']?: Omit<ValueTypes["PhotographerContentGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerContentGroupUpsertResult']?: Omit<ValueTypes["PhotographerContentGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerLocationCreateResult']?: Omit<ValueTypes["PhotographerLocationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerLocationDeleteResult']?: Omit<ValueTypes["PhotographerLocationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerLocationUpdateResult']?: Omit<ValueTypes["PhotographerLocationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerLocationUpsertResult']?: Omit<ValueTypes["PhotographerLocationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographersPageCreateResult']?: Omit<ValueTypes["PhotographersPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographersPageDeleteResult']?: Omit<ValueTypes["PhotographersPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographersPageUpdateResult']?: Omit<ValueTypes["PhotographersPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographersPageUpsertResult']?: Omit<ValueTypes["PhotographersPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OurWorkPageCreateResult']?: Omit<ValueTypes["OurWorkPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OurWorkPageDeleteResult']?: Omit<ValueTypes["OurWorkPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OurWorkPageUpdateResult']?: Omit<ValueTypes["OurWorkPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OurWorkPageUpsertResult']?: Omit<ValueTypes["OurWorkPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OurWorkPageContentGroupCreateResult']?: Omit<ValueTypes["OurWorkPageContentGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OurWorkPageContentGroupDeleteResult']?: Omit<ValueTypes["OurWorkPageContentGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OurWorkPageContentGroupUpdateResult']?: Omit<ValueTypes["OurWorkPageContentGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OurWorkPageContentGroupUpsertResult']?: Omit<ValueTypes["OurWorkPageContentGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentGroupCreateResult']?: Omit<ValueTypes["ContentGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentGroupDeleteResult']?: Omit<ValueTypes["ContentGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentGroupUpdateResult']?: Omit<ValueTypes["ContentGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentGroupUpsertResult']?: Omit<ValueTypes["ContentGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageContentGroupCreateResult']?: Omit<ValueTypes["HomePageContentGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageContentGroupDeleteResult']?: Omit<ValueTypes["HomePageContentGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageContentGroupUpdateResult']?: Omit<ValueTypes["HomePageContentGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageContentGroupUpsertResult']?: Omit<ValueTypes["HomePageContentGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TabletopPageCreateResult']?: Omit<ValueTypes["TabletopPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TabletopPageDeleteResult']?: Omit<ValueTypes["TabletopPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TabletopPageUpdateResult']?: Omit<ValueTypes["TabletopPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TabletopPageUpsertResult']?: Omit<ValueTypes["TabletopPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TabletopPageContentGroupCreateResult']?: Omit<ValueTypes["TabletopPageContentGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TabletopPageContentGroupDeleteResult']?: Omit<ValueTypes["TabletopPageContentGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TabletopPageContentGroupUpdateResult']?: Omit<ValueTypes["TabletopPageContentGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TabletopPageContentGroupUpsertResult']?: Omit<ValueTypes["TabletopPageContentGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographersPageContentGroupCreateResult']?: Omit<ValueTypes["PhotographersPageContentGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographersPageContentGroupDeleteResult']?: Omit<ValueTypes["PhotographersPageContentGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographersPageContentGroupUpdateResult']?: Omit<ValueTypes["PhotographersPageContentGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographersPageContentGroupUpsertResult']?: Omit<ValueTypes["PhotographersPageContentGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: true
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:true,
	message?:true,
		__typename?: true
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["ContactDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Contact"],
		__typename?: true
}>;
	["ContactUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Contact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Contact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
		__typename?: true
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
		__typename?: true
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CardMediaCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardMedia"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CardMediaDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardMedia"],
		__typename?: true
}>;
	["CardMediaUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardMedia"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CardMediaUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardMedia"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FallbackSeoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FallbackSeoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
		__typename?: true
}>;
	["FallbackSeoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FallbackSeoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
		__typename?: true
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
		__typename?: true
}>;
	["SocialLinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
		__typename?: true
}>;
	["GalleryUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
		__typename?: true
}>;
	["GalleryItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
		__typename?: true
}>;
	["HeaderUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
		__typename?: true
}>;
	["HeaderLinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
		__typename?: true
}>;
	["HomePageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
		__typename?: true
}>;
	["RedirectUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactLocationCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactLocation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactLocationDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactLocation"],
		__typename?: true
}>;
	["ContactLocationUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactLocation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactLocationUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactLocation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Director"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Director"],
		__typename?: true
}>;
	["DirectorUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Director"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Director"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FilmCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Film"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FilmDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Film"],
		__typename?: true
}>;
	["FilmUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Film"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FilmUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Film"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorLocationCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorLocation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorLocationDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorLocation"],
		__typename?: true
}>;
	["DirectorLocationUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorLocation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorLocationUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorLocation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactsPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactsPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactsPage"],
		__typename?: true
}>;
	["ContactsPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactsPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorsPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorsPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorsPage"],
		__typename?: true
}>;
	["DirectorsPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorsPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FilmItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilmItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FilmItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilmItem"],
		__typename?: true
}>;
	["FilmItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilmItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FilmItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilmItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorContentGroupCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorContentGroupDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorContentGroup"],
		__typename?: true
}>;
	["DirectorContentGroupUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DirectorContentGroupUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DirectorContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Photographer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Photographer"],
		__typename?: true
}>;
	["PhotographerUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Photographer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Photographer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerContentGroupCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographerContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerContentGroupDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographerContentGroup"],
		__typename?: true
}>;
	["PhotographerContentGroupUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographerContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerContentGroupUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographerContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerLocationCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographerLocation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerLocationDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographerLocation"],
		__typename?: true
}>;
	["PhotographerLocationUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographerLocation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerLocationUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographerLocation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographersPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographersPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographersPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographersPage"],
		__typename?: true
}>;
	["PhotographersPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographersPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographersPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographersPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["OurWorkPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OurWorkPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["OurWorkPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OurWorkPage"],
		__typename?: true
}>;
	["OurWorkPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OurWorkPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["OurWorkPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OurWorkPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["OurWorkPageContentGroupCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OurWorkPageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["OurWorkPageContentGroupDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OurWorkPageContentGroup"],
		__typename?: true
}>;
	["OurWorkPageContentGroupUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OurWorkPageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["OurWorkPageContentGroupUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OurWorkPageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentGroupCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentGroupDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentGroup"],
		__typename?: true
}>;
	["ContentGroupUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentGroupUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageContentGroupCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageContentGroupDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageContentGroup"],
		__typename?: true
}>;
	["HomePageContentGroupUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageContentGroupUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TabletopPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TabletopPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TabletopPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TabletopPage"],
		__typename?: true
}>;
	["TabletopPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TabletopPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TabletopPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TabletopPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TabletopPageContentGroupCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TabletopPageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TabletopPageContentGroupDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TabletopPageContentGroup"],
		__typename?: true
}>;
	["TabletopPageContentGroupUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TabletopPageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TabletopPageContentGroupUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TabletopPageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographersPageContentGroupCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographersPageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographersPageContentGroupDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographersPageContentGroup"],
		__typename?: true
}>;
	["PhotographersPageContentGroupUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographersPageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographersPageContentGroupUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PhotographersPageContentGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationTransaction"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
createContact?: [{	data:ValueTypes["ContactCreateInput"]},ValueTypes["ContactCreateResult"]],
deleteContact?: [{	by:ValueTypes["ContactUniqueWhere"],	filter?:ValueTypes["ContactWhere"] | null},ValueTypes["ContactDeleteResult"]],
updateContact?: [{	by:ValueTypes["ContactUniqueWhere"],	filter?:ValueTypes["ContactWhere"] | null,	data:ValueTypes["ContactUpdateInput"]},ValueTypes["ContactUpdateResult"]],
upsertContact?: [{	by:ValueTypes["ContactUniqueWhere"],	filter?:ValueTypes["ContactWhere"] | null,	update:ValueTypes["ContactUpdateInput"],	create:ValueTypes["ContactCreateInput"]},ValueTypes["ContactUpsertResult"]],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createCardMedia?: [{	data:ValueTypes["CardMediaCreateInput"]},ValueTypes["CardMediaCreateResult"]],
deleteCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null},ValueTypes["CardMediaDeleteResult"]],
updateCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null,	data:ValueTypes["CardMediaUpdateInput"]},ValueTypes["CardMediaUpdateResult"]],
upsertCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null,	update:ValueTypes["CardMediaUpdateInput"],	create:ValueTypes["CardMediaCreateInput"]},ValueTypes["CardMediaUpsertResult"]],
createFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoCreateResult"]],
deleteFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeoDeleteResult"]],
updateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["FallbackSeoUpdateResult"]],
upsertFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	update:ValueTypes["FallbackSeoUpdateInput"],	create:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkCreateResult"]],
deleteSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLinkDeleteResult"]],
updateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["SocialLinkUpdateResult"]],
upsertSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	update:ValueTypes["SocialLinkUpdateInput"],	create:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkUpsertResult"]],
createGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	update:ValueTypes["GalleryUpdateInput"],	create:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryUpsertResult"]],
createGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	update:ValueTypes["GalleryItemUpdateInput"],	create:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkCreateResult"]],
deleteHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLinkDeleteResult"]],
updateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["HeaderLinkUpdateResult"]],
upsertHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	update:ValueTypes["HeaderLinkUpdateInput"],	create:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkUpsertResult"]],
createHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	update:ValueTypes["HomePageUpdateInput"],	create:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createContactLocation?: [{	data:ValueTypes["ContactLocationCreateInput"]},ValueTypes["ContactLocationCreateResult"]],
deleteContactLocation?: [{	by:ValueTypes["ContactLocationUniqueWhere"],	filter?:ValueTypes["ContactLocationWhere"] | null},ValueTypes["ContactLocationDeleteResult"]],
updateContactLocation?: [{	by:ValueTypes["ContactLocationUniqueWhere"],	filter?:ValueTypes["ContactLocationWhere"] | null,	data:ValueTypes["ContactLocationUpdateInput"]},ValueTypes["ContactLocationUpdateResult"]],
upsertContactLocation?: [{	by:ValueTypes["ContactLocationUniqueWhere"],	filter?:ValueTypes["ContactLocationWhere"] | null,	update:ValueTypes["ContactLocationUpdateInput"],	create:ValueTypes["ContactLocationCreateInput"]},ValueTypes["ContactLocationUpsertResult"]],
createDirector?: [{	data:ValueTypes["DirectorCreateInput"]},ValueTypes["DirectorCreateResult"]],
deleteDirector?: [{	by:ValueTypes["DirectorUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null},ValueTypes["DirectorDeleteResult"]],
updateDirector?: [{	by:ValueTypes["DirectorUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null,	data:ValueTypes["DirectorUpdateInput"]},ValueTypes["DirectorUpdateResult"]],
upsertDirector?: [{	by:ValueTypes["DirectorUniqueWhere"],	filter?:ValueTypes["DirectorWhere"] | null,	update:ValueTypes["DirectorUpdateInput"],	create:ValueTypes["DirectorCreateInput"]},ValueTypes["DirectorUpsertResult"]],
createFilm?: [{	data:ValueTypes["FilmCreateInput"]},ValueTypes["FilmCreateResult"]],
deleteFilm?: [{	by:ValueTypes["FilmUniqueWhere"],	filter?:ValueTypes["FilmWhere"] | null},ValueTypes["FilmDeleteResult"]],
updateFilm?: [{	by:ValueTypes["FilmUniqueWhere"],	filter?:ValueTypes["FilmWhere"] | null,	data:ValueTypes["FilmUpdateInput"]},ValueTypes["FilmUpdateResult"]],
upsertFilm?: [{	by:ValueTypes["FilmUniqueWhere"],	filter?:ValueTypes["FilmWhere"] | null,	update:ValueTypes["FilmUpdateInput"],	create:ValueTypes["FilmCreateInput"]},ValueTypes["FilmUpsertResult"]],
createDirectorLocation?: [{	data:ValueTypes["DirectorLocationCreateInput"]},ValueTypes["DirectorLocationCreateResult"]],
deleteDirectorLocation?: [{	by:ValueTypes["DirectorLocationUniqueWhere"],	filter?:ValueTypes["DirectorLocationWhere"] | null},ValueTypes["DirectorLocationDeleteResult"]],
updateDirectorLocation?: [{	by:ValueTypes["DirectorLocationUniqueWhere"],	filter?:ValueTypes["DirectorLocationWhere"] | null,	data:ValueTypes["DirectorLocationUpdateInput"]},ValueTypes["DirectorLocationUpdateResult"]],
upsertDirectorLocation?: [{	by:ValueTypes["DirectorLocationUniqueWhere"],	filter?:ValueTypes["DirectorLocationWhere"] | null,	update:ValueTypes["DirectorLocationUpdateInput"],	create:ValueTypes["DirectorLocationCreateInput"]},ValueTypes["DirectorLocationUpsertResult"]],
createContactsPage?: [{	data:ValueTypes["ContactsPageCreateInput"]},ValueTypes["ContactsPageCreateResult"]],
deleteContactsPage?: [{	by:ValueTypes["ContactsPageUniqueWhere"],	filter?:ValueTypes["ContactsPageWhere"] | null},ValueTypes["ContactsPageDeleteResult"]],
updateContactsPage?: [{	by:ValueTypes["ContactsPageUniqueWhere"],	filter?:ValueTypes["ContactsPageWhere"] | null,	data:ValueTypes["ContactsPageUpdateInput"]},ValueTypes["ContactsPageUpdateResult"]],
upsertContactsPage?: [{	by:ValueTypes["ContactsPageUniqueWhere"],	filter?:ValueTypes["ContactsPageWhere"] | null,	update:ValueTypes["ContactsPageUpdateInput"],	create:ValueTypes["ContactsPageCreateInput"]},ValueTypes["ContactsPageUpsertResult"]],
createDirectorsPage?: [{	data:ValueTypes["DirectorsPageCreateInput"]},ValueTypes["DirectorsPageCreateResult"]],
deleteDirectorsPage?: [{	by:ValueTypes["DirectorsPageUniqueWhere"],	filter?:ValueTypes["DirectorsPageWhere"] | null},ValueTypes["DirectorsPageDeleteResult"]],
updateDirectorsPage?: [{	by:ValueTypes["DirectorsPageUniqueWhere"],	filter?:ValueTypes["DirectorsPageWhere"] | null,	data:ValueTypes["DirectorsPageUpdateInput"]},ValueTypes["DirectorsPageUpdateResult"]],
upsertDirectorsPage?: [{	by:ValueTypes["DirectorsPageUniqueWhere"],	filter?:ValueTypes["DirectorsPageWhere"] | null,	update:ValueTypes["DirectorsPageUpdateInput"],	create:ValueTypes["DirectorsPageCreateInput"]},ValueTypes["DirectorsPageUpsertResult"]],
createFilmItem?: [{	data:ValueTypes["FilmItemCreateInput"]},ValueTypes["FilmItemCreateResult"]],
deleteFilmItem?: [{	by:ValueTypes["FilmItemUniqueWhere"],	filter?:ValueTypes["FilmItemWhere"] | null},ValueTypes["FilmItemDeleteResult"]],
updateFilmItem?: [{	by:ValueTypes["FilmItemUniqueWhere"],	filter?:ValueTypes["FilmItemWhere"] | null,	data:ValueTypes["FilmItemUpdateInput"]},ValueTypes["FilmItemUpdateResult"]],
upsertFilmItem?: [{	by:ValueTypes["FilmItemUniqueWhere"],	filter?:ValueTypes["FilmItemWhere"] | null,	update:ValueTypes["FilmItemUpdateInput"],	create:ValueTypes["FilmItemCreateInput"]},ValueTypes["FilmItemUpsertResult"]],
createDirectorContentGroup?: [{	data:ValueTypes["DirectorContentGroupCreateInput"]},ValueTypes["DirectorContentGroupCreateResult"]],
deleteDirectorContentGroup?: [{	by:ValueTypes["DirectorContentGroupUniqueWhere"],	filter?:ValueTypes["DirectorContentGroupWhere"] | null},ValueTypes["DirectorContentGroupDeleteResult"]],
updateDirectorContentGroup?: [{	by:ValueTypes["DirectorContentGroupUniqueWhere"],	filter?:ValueTypes["DirectorContentGroupWhere"] | null,	data:ValueTypes["DirectorContentGroupUpdateInput"]},ValueTypes["DirectorContentGroupUpdateResult"]],
upsertDirectorContentGroup?: [{	by:ValueTypes["DirectorContentGroupUniqueWhere"],	filter?:ValueTypes["DirectorContentGroupWhere"] | null,	update:ValueTypes["DirectorContentGroupUpdateInput"],	create:ValueTypes["DirectorContentGroupCreateInput"]},ValueTypes["DirectorContentGroupUpsertResult"]],
createPhotographer?: [{	data:ValueTypes["PhotographerCreateInput"]},ValueTypes["PhotographerCreateResult"]],
deletePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["PhotographerDeleteResult"]],
updatePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null,	data:ValueTypes["PhotographerUpdateInput"]},ValueTypes["PhotographerUpdateResult"]],
upsertPhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null,	update:ValueTypes["PhotographerUpdateInput"],	create:ValueTypes["PhotographerCreateInput"]},ValueTypes["PhotographerUpsertResult"]],
createPhotographerContentGroup?: [{	data:ValueTypes["PhotographerContentGroupCreateInput"]},ValueTypes["PhotographerContentGroupCreateResult"]],
deletePhotographerContentGroup?: [{	by:ValueTypes["PhotographerContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographerContentGroupWhere"] | null},ValueTypes["PhotographerContentGroupDeleteResult"]],
updatePhotographerContentGroup?: [{	by:ValueTypes["PhotographerContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographerContentGroupWhere"] | null,	data:ValueTypes["PhotographerContentGroupUpdateInput"]},ValueTypes["PhotographerContentGroupUpdateResult"]],
upsertPhotographerContentGroup?: [{	by:ValueTypes["PhotographerContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographerContentGroupWhere"] | null,	update:ValueTypes["PhotographerContentGroupUpdateInput"],	create:ValueTypes["PhotographerContentGroupCreateInput"]},ValueTypes["PhotographerContentGroupUpsertResult"]],
createPhotographerLocation?: [{	data:ValueTypes["PhotographerLocationCreateInput"]},ValueTypes["PhotographerLocationCreateResult"]],
deletePhotographerLocation?: [{	by:ValueTypes["PhotographerLocationUniqueWhere"],	filter?:ValueTypes["PhotographerLocationWhere"] | null},ValueTypes["PhotographerLocationDeleteResult"]],
updatePhotographerLocation?: [{	by:ValueTypes["PhotographerLocationUniqueWhere"],	filter?:ValueTypes["PhotographerLocationWhere"] | null,	data:ValueTypes["PhotographerLocationUpdateInput"]},ValueTypes["PhotographerLocationUpdateResult"]],
upsertPhotographerLocation?: [{	by:ValueTypes["PhotographerLocationUniqueWhere"],	filter?:ValueTypes["PhotographerLocationWhere"] | null,	update:ValueTypes["PhotographerLocationUpdateInput"],	create:ValueTypes["PhotographerLocationCreateInput"]},ValueTypes["PhotographerLocationUpsertResult"]],
createPhotographersPage?: [{	data:ValueTypes["PhotographersPageCreateInput"]},ValueTypes["PhotographersPageCreateResult"]],
deletePhotographersPage?: [{	by:ValueTypes["PhotographersPageUniqueWhere"],	filter?:ValueTypes["PhotographersPageWhere"] | null},ValueTypes["PhotographersPageDeleteResult"]],
updatePhotographersPage?: [{	by:ValueTypes["PhotographersPageUniqueWhere"],	filter?:ValueTypes["PhotographersPageWhere"] | null,	data:ValueTypes["PhotographersPageUpdateInput"]},ValueTypes["PhotographersPageUpdateResult"]],
upsertPhotographersPage?: [{	by:ValueTypes["PhotographersPageUniqueWhere"],	filter?:ValueTypes["PhotographersPageWhere"] | null,	update:ValueTypes["PhotographersPageUpdateInput"],	create:ValueTypes["PhotographersPageCreateInput"]},ValueTypes["PhotographersPageUpsertResult"]],
createOurWorkPage?: [{	data:ValueTypes["OurWorkPageCreateInput"]},ValueTypes["OurWorkPageCreateResult"]],
deleteOurWorkPage?: [{	by:ValueTypes["OurWorkPageUniqueWhere"],	filter?:ValueTypes["OurWorkPageWhere"] | null},ValueTypes["OurWorkPageDeleteResult"]],
updateOurWorkPage?: [{	by:ValueTypes["OurWorkPageUniqueWhere"],	filter?:ValueTypes["OurWorkPageWhere"] | null,	data:ValueTypes["OurWorkPageUpdateInput"]},ValueTypes["OurWorkPageUpdateResult"]],
upsertOurWorkPage?: [{	by:ValueTypes["OurWorkPageUniqueWhere"],	filter?:ValueTypes["OurWorkPageWhere"] | null,	update:ValueTypes["OurWorkPageUpdateInput"],	create:ValueTypes["OurWorkPageCreateInput"]},ValueTypes["OurWorkPageUpsertResult"]],
createOurWorkPageContentGroup?: [{	data:ValueTypes["OurWorkPageContentGroupCreateInput"]},ValueTypes["OurWorkPageContentGroupCreateResult"]],
deleteOurWorkPageContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupUniqueWhere"],	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null},ValueTypes["OurWorkPageContentGroupDeleteResult"]],
updateOurWorkPageContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupUniqueWhere"],	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null,	data:ValueTypes["OurWorkPageContentGroupUpdateInput"]},ValueTypes["OurWorkPageContentGroupUpdateResult"]],
upsertOurWorkPageContentGroup?: [{	by:ValueTypes["OurWorkPageContentGroupUniqueWhere"],	filter?:ValueTypes["OurWorkPageContentGroupWhere"] | null,	update:ValueTypes["OurWorkPageContentGroupUpdateInput"],	create:ValueTypes["OurWorkPageContentGroupCreateInput"]},ValueTypes["OurWorkPageContentGroupUpsertResult"]],
createContentGroup?: [{	data:ValueTypes["ContentGroupCreateInput"]},ValueTypes["ContentGroupCreateResult"]],
deleteContentGroup?: [{	by:ValueTypes["ContentGroupUniqueWhere"],	filter?:ValueTypes["ContentGroupWhere"] | null},ValueTypes["ContentGroupDeleteResult"]],
updateContentGroup?: [{	by:ValueTypes["ContentGroupUniqueWhere"],	filter?:ValueTypes["ContentGroupWhere"] | null,	data:ValueTypes["ContentGroupUpdateInput"]},ValueTypes["ContentGroupUpdateResult"]],
upsertContentGroup?: [{	by:ValueTypes["ContentGroupUniqueWhere"],	filter?:ValueTypes["ContentGroupWhere"] | null,	update:ValueTypes["ContentGroupUpdateInput"],	create:ValueTypes["ContentGroupCreateInput"]},ValueTypes["ContentGroupUpsertResult"]],
createHomePageContentGroup?: [{	data:ValueTypes["HomePageContentGroupCreateInput"]},ValueTypes["HomePageContentGroupCreateResult"]],
deleteHomePageContentGroup?: [{	by:ValueTypes["HomePageContentGroupUniqueWhere"],	filter?:ValueTypes["HomePageContentGroupWhere"] | null},ValueTypes["HomePageContentGroupDeleteResult"]],
updateHomePageContentGroup?: [{	by:ValueTypes["HomePageContentGroupUniqueWhere"],	filter?:ValueTypes["HomePageContentGroupWhere"] | null,	data:ValueTypes["HomePageContentGroupUpdateInput"]},ValueTypes["HomePageContentGroupUpdateResult"]],
upsertHomePageContentGroup?: [{	by:ValueTypes["HomePageContentGroupUniqueWhere"],	filter?:ValueTypes["HomePageContentGroupWhere"] | null,	update:ValueTypes["HomePageContentGroupUpdateInput"],	create:ValueTypes["HomePageContentGroupCreateInput"]},ValueTypes["HomePageContentGroupUpsertResult"]],
createTabletopPage?: [{	data:ValueTypes["TabletopPageCreateInput"]},ValueTypes["TabletopPageCreateResult"]],
deleteTabletopPage?: [{	by:ValueTypes["TabletopPageUniqueWhere"],	filter?:ValueTypes["TabletopPageWhere"] | null},ValueTypes["TabletopPageDeleteResult"]],
updateTabletopPage?: [{	by:ValueTypes["TabletopPageUniqueWhere"],	filter?:ValueTypes["TabletopPageWhere"] | null,	data:ValueTypes["TabletopPageUpdateInput"]},ValueTypes["TabletopPageUpdateResult"]],
upsertTabletopPage?: [{	by:ValueTypes["TabletopPageUniqueWhere"],	filter?:ValueTypes["TabletopPageWhere"] | null,	update:ValueTypes["TabletopPageUpdateInput"],	create:ValueTypes["TabletopPageCreateInput"]},ValueTypes["TabletopPageUpsertResult"]],
createTabletopPageContentGroup?: [{	data:ValueTypes["TabletopPageContentGroupCreateInput"]},ValueTypes["TabletopPageContentGroupCreateResult"]],
deleteTabletopPageContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupUniqueWhere"],	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null},ValueTypes["TabletopPageContentGroupDeleteResult"]],
updateTabletopPageContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupUniqueWhere"],	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null,	data:ValueTypes["TabletopPageContentGroupUpdateInput"]},ValueTypes["TabletopPageContentGroupUpdateResult"]],
upsertTabletopPageContentGroup?: [{	by:ValueTypes["TabletopPageContentGroupUniqueWhere"],	filter?:ValueTypes["TabletopPageContentGroupWhere"] | null,	update:ValueTypes["TabletopPageContentGroupUpdateInput"],	create:ValueTypes["TabletopPageContentGroupCreateInput"]},ValueTypes["TabletopPageContentGroupUpsertResult"]],
createPhotographersPageContentGroup?: [{	data:ValueTypes["PhotographersPageContentGroupCreateInput"]},ValueTypes["PhotographersPageContentGroupCreateResult"]],
deletePhotographersPageContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null},ValueTypes["PhotographersPageContentGroupDeleteResult"]],
updatePhotographersPageContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null,	data:ValueTypes["PhotographersPageContentGroupUpdateInput"]},ValueTypes["PhotographersPageContentGroupUpdateResult"]],
upsertPhotographersPageContentGroup?: [{	by:ValueTypes["PhotographersPageContentGroupUniqueWhere"],	filter?:ValueTypes["PhotographersPageContentGroupWhere"] | null,	update:ValueTypes["PhotographersPageContentGroupUpdateInput"],	create:ValueTypes["PhotographersPageContentGroupCreateInput"]},ValueTypes["PhotographersPageContentGroupUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: true
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?:boolean | null
};
	/** Json custom scalar type */
["Json"]:unknown;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: true
}>;
	["_Entity"]: AliasType<{
	name?:true,
	customPrimaryAllowed?:true,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: true
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:true,
		__typename?: true
}>;
	["_Field"]:AliasType<{
		name?:true,
	type?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: true
}>;
	["_Column"]: AliasType<{
	name?:true,
	type?:true,
	enumName?:true,
	defaultValue?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_RelationSide"]:_RelationSide;
	["_OrderByDirection"]:_OrderByDirection;
	["_OrderBy"]: AliasType<{
	path?:true,
	direction?:true,
		__typename?: true
}>;
	["_Relation"]: AliasType<{
	name?:true,
	type?:true,
	side?:true,
	targetEntity?:true,
	ownedBy?:true,
	inversedBy?:true,
	nullable?:true,
	onDelete?:true,
	orphanRemoval?:true,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:true,
		__typename?: true
}>;
	["_Validator"]: AliasType<{
	operation?:true,
	arguments?:ValueTypes["_Argument"],
		__typename?: true
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: true
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:true,
		__typename?: true
}>;
	["_PathArgument"]: AliasType<{
	path?:true,
		__typename?: true
}>;
	["_LiteralArgument"]: AliasType<{
	value?:true,
		__typename?: true
}>;
	["_RuleMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["_Enum"]: AliasType<{
	name?:true,
	values?:true,
		__typename?: true
}>;
	["S3SignedUpload"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
	publicUrl?:true,
		__typename?: true
}>;
	["S3Header"]: AliasType<{
	key?:true,
	value?:true,
		__typename?: true
}>;
	["S3SignedRead"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
		__typename?: true
}>
  }

export type ModelTypes = {
    ["Query"]: {
		getContact?:ModelTypes["Contact"],
	listContact:ModelTypes["Contact"][],
	paginateContact:ModelTypes["ContactConnection"],
	validateCreateContact:ModelTypes["_ValidationResult"],
	validateUpdateContact:ModelTypes["_ValidationResult"],
	getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getCardMedia?:ModelTypes["CardMedia"],
	listCardMedia:ModelTypes["CardMedia"][],
	paginateCardMedia:ModelTypes["CardMediaConnection"],
	validateCreateCardMedia:ModelTypes["_ValidationResult"],
	validateUpdateCardMedia:ModelTypes["_ValidationResult"],
	getFallbackSeo?:ModelTypes["FallbackSeo"],
	listFallbackSeo:ModelTypes["FallbackSeo"][],
	paginateFallbackSeo:ModelTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo:ModelTypes["_ValidationResult"],
	validateUpdateFallbackSeo:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getSocialLink?:ModelTypes["SocialLink"],
	listSocialLink:ModelTypes["SocialLink"][],
	paginateSocialLink:ModelTypes["SocialLinkConnection"],
	validateCreateSocialLink:ModelTypes["_ValidationResult"],
	validateUpdateSocialLink:ModelTypes["_ValidationResult"],
	getGallery?:ModelTypes["Gallery"],
	listGallery:ModelTypes["Gallery"][],
	paginateGallery:ModelTypes["GalleryConnection"],
	validateCreateGallery:ModelTypes["_ValidationResult"],
	validateUpdateGallery:ModelTypes["_ValidationResult"],
	getGalleryItem?:ModelTypes["GalleryItem"],
	listGalleryItem:ModelTypes["GalleryItem"][],
	paginateGalleryItem:ModelTypes["GalleryItemConnection"],
	validateCreateGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateGalleryItem:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getHeaderLink?:ModelTypes["HeaderLink"],
	listHeaderLink:ModelTypes["HeaderLink"][],
	paginateHeaderLink:ModelTypes["HeaderLinkConnection"],
	validateCreateHeaderLink:ModelTypes["_ValidationResult"],
	validateUpdateHeaderLink:ModelTypes["_ValidationResult"],
	getHomePage?:ModelTypes["HomePage"],
	listHomePage:ModelTypes["HomePage"][],
	paginateHomePage:ModelTypes["HomePageConnection"],
	validateCreateHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHomePage:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getContactLocation?:ModelTypes["ContactLocation"],
	listContactLocation:ModelTypes["ContactLocation"][],
	paginateContactLocation:ModelTypes["ContactLocationConnection"],
	validateCreateContactLocation:ModelTypes["_ValidationResult"],
	validateUpdateContactLocation:ModelTypes["_ValidationResult"],
	getDirector?:ModelTypes["Director"],
	listDirector:ModelTypes["Director"][],
	paginateDirector:ModelTypes["DirectorConnection"],
	validateCreateDirector:ModelTypes["_ValidationResult"],
	validateUpdateDirector:ModelTypes["_ValidationResult"],
	getFilm?:ModelTypes["Film"],
	listFilm:ModelTypes["Film"][],
	paginateFilm:ModelTypes["FilmConnection"],
	validateCreateFilm:ModelTypes["_ValidationResult"],
	validateUpdateFilm:ModelTypes["_ValidationResult"],
	getDirectorLocation?:ModelTypes["DirectorLocation"],
	listDirectorLocation:ModelTypes["DirectorLocation"][],
	paginateDirectorLocation:ModelTypes["DirectorLocationConnection"],
	validateCreateDirectorLocation:ModelTypes["_ValidationResult"],
	validateUpdateDirectorLocation:ModelTypes["_ValidationResult"],
	getContactsPage?:ModelTypes["ContactsPage"],
	listContactsPage:ModelTypes["ContactsPage"][],
	paginateContactsPage:ModelTypes["ContactsPageConnection"],
	validateCreateContactsPage:ModelTypes["_ValidationResult"],
	validateUpdateContactsPage:ModelTypes["_ValidationResult"],
	getDirectorsPage?:ModelTypes["DirectorsPage"],
	listDirectorsPage:ModelTypes["DirectorsPage"][],
	paginateDirectorsPage:ModelTypes["DirectorsPageConnection"],
	validateCreateDirectorsPage:ModelTypes["_ValidationResult"],
	validateUpdateDirectorsPage:ModelTypes["_ValidationResult"],
	getFilmItem?:ModelTypes["FilmItem"],
	listFilmItem:ModelTypes["FilmItem"][],
	paginateFilmItem:ModelTypes["FilmItemConnection"],
	validateCreateFilmItem:ModelTypes["_ValidationResult"],
	validateUpdateFilmItem:ModelTypes["_ValidationResult"],
	getDirectorContentGroup?:ModelTypes["DirectorContentGroup"],
	listDirectorContentGroup:ModelTypes["DirectorContentGroup"][],
	paginateDirectorContentGroup:ModelTypes["DirectorContentGroupConnection"],
	validateCreateDirectorContentGroup:ModelTypes["_ValidationResult"],
	validateUpdateDirectorContentGroup:ModelTypes["_ValidationResult"],
	getPhotographer?:ModelTypes["Photographer"],
	listPhotographer:ModelTypes["Photographer"][],
	paginatePhotographer:ModelTypes["PhotographerConnection"],
	validateCreatePhotographer:ModelTypes["_ValidationResult"],
	validateUpdatePhotographer:ModelTypes["_ValidationResult"],
	getPhotographerContentGroup?:ModelTypes["PhotographerContentGroup"],
	listPhotographerContentGroup:ModelTypes["PhotographerContentGroup"][],
	paginatePhotographerContentGroup:ModelTypes["PhotographerContentGroupConnection"],
	validateCreatePhotographerContentGroup:ModelTypes["_ValidationResult"],
	validateUpdatePhotographerContentGroup:ModelTypes["_ValidationResult"],
	getPhotographerLocation?:ModelTypes["PhotographerLocation"],
	listPhotographerLocation:ModelTypes["PhotographerLocation"][],
	paginatePhotographerLocation:ModelTypes["PhotographerLocationConnection"],
	validateCreatePhotographerLocation:ModelTypes["_ValidationResult"],
	validateUpdatePhotographerLocation:ModelTypes["_ValidationResult"],
	getPhotographersPage?:ModelTypes["PhotographersPage"],
	listPhotographersPage:ModelTypes["PhotographersPage"][],
	paginatePhotographersPage:ModelTypes["PhotographersPageConnection"],
	validateCreatePhotographersPage:ModelTypes["_ValidationResult"],
	validateUpdatePhotographersPage:ModelTypes["_ValidationResult"],
	getOurWorkPage?:ModelTypes["OurWorkPage"],
	listOurWorkPage:ModelTypes["OurWorkPage"][],
	paginateOurWorkPage:ModelTypes["OurWorkPageConnection"],
	validateCreateOurWorkPage:ModelTypes["_ValidationResult"],
	validateUpdateOurWorkPage:ModelTypes["_ValidationResult"],
	getOurWorkPageContentGroup?:ModelTypes["OurWorkPageContentGroup"],
	listOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroup"][],
	paginateOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroupConnection"],
	validateCreateOurWorkPageContentGroup:ModelTypes["_ValidationResult"],
	validateUpdateOurWorkPageContentGroup:ModelTypes["_ValidationResult"],
	getContentGroup?:ModelTypes["ContentGroup"],
	listContentGroup:ModelTypes["ContentGroup"][],
	paginateContentGroup:ModelTypes["ContentGroupConnection"],
	validateCreateContentGroup:ModelTypes["_ValidationResult"],
	validateUpdateContentGroup:ModelTypes["_ValidationResult"],
	getHomePageContentGroup?:ModelTypes["HomePageContentGroup"],
	listHomePageContentGroup:ModelTypes["HomePageContentGroup"][],
	paginateHomePageContentGroup:ModelTypes["HomePageContentGroupConnection"],
	validateCreateHomePageContentGroup:ModelTypes["_ValidationResult"],
	validateUpdateHomePageContentGroup:ModelTypes["_ValidationResult"],
	getTabletopPage?:ModelTypes["TabletopPage"],
	listTabletopPage:ModelTypes["TabletopPage"][],
	paginateTabletopPage:ModelTypes["TabletopPageConnection"],
	validateCreateTabletopPage:ModelTypes["_ValidationResult"],
	validateUpdateTabletopPage:ModelTypes["_ValidationResult"],
	getTabletopPageContentGroup?:ModelTypes["TabletopPageContentGroup"],
	listTabletopPageContentGroup:ModelTypes["TabletopPageContentGroup"][],
	paginateTabletopPageContentGroup:ModelTypes["TabletopPageContentGroupConnection"],
	validateCreateTabletopPageContentGroup:ModelTypes["_ValidationResult"],
	validateUpdateTabletopPageContentGroup:ModelTypes["_ValidationResult"],
	getPhotographersPageContentGroup?:ModelTypes["PhotographersPageContentGroup"],
	listPhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroup"][],
	paginatePhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroupConnection"],
	validateCreatePhotographersPageContentGroup:ModelTypes["_ValidationResult"],
	validateUpdatePhotographersPageContentGroup:ModelTypes["_ValidationResult"],
	transaction?:ModelTypes["QueryTransaction"],
	_info?:ModelTypes["Info"],
	schema?:ModelTypes["_Schema"],
	s3DummyQuery?:string
};
	["Contact"]: {
		_meta?:ModelTypes["ContactMeta"],
	id:ModelTypes["UUID"],
	order:number,
	name?:string,
	position?:string,
	phone?:string,
	email?:string,
	image?:ModelTypes["Image"],
	contactLocation?:ModelTypes["ContactLocation"],
	wordpressId?:string
};
	["ContactMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	position?:ModelTypes["FieldMeta"],
	phone?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	contactLocation?:ModelTypes["FieldMeta"],
	wordpressId?:ModelTypes["FieldMeta"]
};
	["FieldMeta"]: {
		readable?:boolean,
	updatable?:boolean
};
	["UUID"]:string;
	["Image"]: {
		_meta?:ModelTypes["ImageMeta"],
	id:ModelTypes["UUID"],
	url:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	alt?:string
};
	["ImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	alt?:ModelTypes["FieldMeta"]
};
	["ImageWhere"]: GraphQLTypes["ImageWhere"];
	["UUIDCondition"]: GraphQLTypes["UUIDCondition"];
	["StringCondition"]: GraphQLTypes["StringCondition"];
	["IntCondition"]: GraphQLTypes["IntCondition"];
	["ContactLocation"]: {
		_meta?:ModelTypes["ContactLocationMeta"],
	id:ModelTypes["UUID"],
	order:number,
	city?:string,
	state?:string,
	address?:string,
	email?:string,
	phone?:string,
	fax?:string,
	note?:string,
	contact:ModelTypes["Contact"][],
	contactByWordpressId?:ModelTypes["Contact"],
	contactByImage?:ModelTypes["Contact"],
	paginateContact:ModelTypes["ContactConnection"]
};
	["ContactLocationMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	city?:ModelTypes["FieldMeta"],
	state?:ModelTypes["FieldMeta"],
	address?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	phone?:ModelTypes["FieldMeta"],
	fax?:ModelTypes["FieldMeta"],
	note?:ModelTypes["FieldMeta"],
	contact?:ModelTypes["FieldMeta"]
};
	["ContactWhere"]: GraphQLTypes["ContactWhere"];
	["ContactLocationWhere"]: GraphQLTypes["ContactLocationWhere"];
	["ContactOrderBy"]: GraphQLTypes["ContactOrderBy"];
	["OrderDirection"]: GraphQLTypes["OrderDirection"];
	["ImageOrderBy"]: GraphQLTypes["ImageOrderBy"];
	["ContactLocationOrderBy"]: GraphQLTypes["ContactLocationOrderBy"];
	["ContactLocationContactByWordpressIdUniqueWhere"]: GraphQLTypes["ContactLocationContactByWordpressIdUniqueWhere"];
	["ContactLocationContactByImageUniqueWhere"]: GraphQLTypes["ContactLocationContactByImageUniqueWhere"];
	["ImageUniqueWhere"]: GraphQLTypes["ImageUniqueWhere"];
	["ContactConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactEdge"][]
};
	["PageInfo"]: {
		totalCount:number
};
	["ContactEdge"]: {
		node:ModelTypes["Contact"]
};
	["ContactUniqueWhere"]: GraphQLTypes["ContactUniqueWhere"];
	["_ValidationResult"]: {
		valid:boolean,
	errors:ModelTypes["_ValidationError"][]
};
	["_ValidationError"]: {
		path:ModelTypes["_PathFragment"][],
	message:ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field:string
};
	["_IndexPathFragment"]: {
		index:number,
	alias?:string
};
	["_ValidationMessage"]: {
		text:string
};
	["ContactCreateInput"]: GraphQLTypes["ContactCreateInput"];
	["ContactCreateImageEntityRelationInput"]: GraphQLTypes["ContactCreateImageEntityRelationInput"];
	["ImageCreateInput"]: GraphQLTypes["ImageCreateInput"];
	["ContactCreateContactLocationEntityRelationInput"]: GraphQLTypes["ContactCreateContactLocationEntityRelationInput"];
	["ContactLocationUniqueWhere"]: GraphQLTypes["ContactLocationUniqueWhere"];
	["ContactLocationWithoutContactCreateInput"]: GraphQLTypes["ContactLocationWithoutContactCreateInput"];
	["ContactUpdateInput"]: GraphQLTypes["ContactUpdateInput"];
	["ContactUpdateImageEntityRelationInput"]: GraphQLTypes["ContactUpdateImageEntityRelationInput"];
	["ImageUpdateInput"]: GraphQLTypes["ImageUpdateInput"];
	["ContactUpsertImageRelationInput"]: GraphQLTypes["ContactUpsertImageRelationInput"];
	["ContactUpdateContactLocationEntityRelationInput"]: GraphQLTypes["ContactUpdateContactLocationEntityRelationInput"];
	["ContactLocationWithoutContactUpdateInput"]: GraphQLTypes["ContactLocationWithoutContactUpdateInput"];
	["ContactUpsertContactLocationRelationInput"]: GraphQLTypes["ContactUpsertContactLocationRelationInput"];
	["Content"]: {
		_meta?:ModelTypes["ContentMeta"],
	id:ModelTypes["UUID"],
	blocks:ModelTypes["ContentBlock"][],
	blocksByReferences?:ModelTypes["ContentBlock"],
	paginateBlocks:ModelTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	blocks?:ModelTypes["FieldMeta"]
};
	["ContentBlock"]: {
		_meta?:ModelTypes["ContentBlockMeta"],
	id:ModelTypes["UUID"],
	order:number,
	json:string,
	content?:ModelTypes["Content"],
	references:ModelTypes["ContentReference"][],
	referencesByLink?:ModelTypes["ContentReference"],
	paginateReferences:ModelTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	json?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	references?:ModelTypes["FieldMeta"]
};
	["ContentWhere"]: GraphQLTypes["ContentWhere"];
	["ContentBlockWhere"]: GraphQLTypes["ContentBlockWhere"];
	["ContentReferenceWhere"]: GraphQLTypes["ContentReferenceWhere"];
	["ContentReferenceTypeCondition"]: GraphQLTypes["ContentReferenceTypeCondition"];
	["ContentReferenceType"]: GraphQLTypes["ContentReferenceType"];
	["LinkWhere"]: GraphQLTypes["LinkWhere"];
	["LinkTypeCondition"]: GraphQLTypes["LinkTypeCondition"];
	["LinkType"]: GraphQLTypes["LinkType"];
	["LinkableWhere"]: GraphQLTypes["LinkableWhere"];
	["HomePageWhere"]: GraphQLTypes["HomePageWhere"];
	["OneCondition"]: GraphQLTypes["OneCondition"];
	["One"]: GraphQLTypes["One"];
	["SeoWhere"]: GraphQLTypes["SeoWhere"];
	["HomePageContentGroupWhere"]: GraphQLTypes["HomePageContentGroupWhere"];
	["ContentGroupWhere"]: GraphQLTypes["ContentGroupWhere"];
	["ContentGroupTypeCondition"]: GraphQLTypes["ContentGroupTypeCondition"];
	["ContentGroupType"]: GraphQLTypes["ContentGroupType"];
	["GalleryWhere"]: GraphQLTypes["GalleryWhere"];
	["GalleryItemWhere"]: GraphQLTypes["GalleryItemWhere"];
	["FilmItemWhere"]: GraphQLTypes["FilmItemWhere"];
	["FilmWhere"]: GraphQLTypes["FilmWhere"];
	["RedirectWhere"]: GraphQLTypes["RedirectWhere"];
	["DirectorWhere"]: GraphQLTypes["DirectorWhere"];
	["DirectorContentGroupWhere"]: GraphQLTypes["DirectorContentGroupWhere"];
	["DirectorLocationWhere"]: GraphQLTypes["DirectorLocationWhere"];
	["ContactsPageWhere"]: GraphQLTypes["ContactsPageWhere"];
	["DirectorsPageWhere"]: GraphQLTypes["DirectorsPageWhere"];
	["PhotographerWhere"]: GraphQLTypes["PhotographerWhere"];
	["PhotographerContentGroupWhere"]: GraphQLTypes["PhotographerContentGroupWhere"];
	["PhotographerLocationWhere"]: GraphQLTypes["PhotographerLocationWhere"];
	["PhotographersPageWhere"]: GraphQLTypes["PhotographersPageWhere"];
	["PhotographersPageContentGroupWhere"]: GraphQLTypes["PhotographersPageContentGroupWhere"];
	["OurWorkPageWhere"]: GraphQLTypes["OurWorkPageWhere"];
	["OurWorkPageContentGroupWhere"]: GraphQLTypes["OurWorkPageContentGroupWhere"];
	["TabletopPageWhere"]: GraphQLTypes["TabletopPageWhere"];
	["TabletopPageContentGroupWhere"]: GraphQLTypes["TabletopPageContentGroupWhere"];
	["CardMediaWhere"]: GraphQLTypes["CardMediaWhere"];
	["ContentReference"]: {
		_meta?:ModelTypes["ContentReferenceMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["ContentReferenceType"],
	text?:string,
	block?:ModelTypes["ContentBlock"],
	link?:ModelTypes["Link"],
	image?:ModelTypes["Image"],
	cardMedia?:ModelTypes["CardMedia"]
};
	["ContentReferenceMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	block?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	cardMedia?:ModelTypes["FieldMeta"]
};
	["Link"]: {
		_meta?:ModelTypes["LinkMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["LinkType"],
	title?:string,
	externalLink?:string,
	internalLink?:ModelTypes["Linkable"]
};
	["LinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	externalLink?:ModelTypes["FieldMeta"],
	internalLink?:ModelTypes["FieldMeta"]
};
	["Linkable"]: {
		_meta?:ModelTypes["LinkableMeta"],
	id:ModelTypes["UUID"],
	url:string,
	homePage?:ModelTypes["HomePage"],
	redirect?:ModelTypes["Redirect"],
	director?:ModelTypes["Director"],
	contactsPage?:ModelTypes["ContactsPage"],
	directorsPage?:ModelTypes["DirectorsPage"],
	photographer?:ModelTypes["Photographer"],
	photographersPage?:ModelTypes["PhotographersPage"],
	ourWorkPage?:ModelTypes["OurWorkPage"],
	tabletopPage?:ModelTypes["TabletopPage"]
};
	["LinkableMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	homePage?:ModelTypes["FieldMeta"],
	redirect?:ModelTypes["FieldMeta"],
	director?:ModelTypes["FieldMeta"],
	contactsPage?:ModelTypes["FieldMeta"],
	directorsPage?:ModelTypes["FieldMeta"],
	photographer?:ModelTypes["FieldMeta"],
	photographersPage?:ModelTypes["FieldMeta"],
	ourWorkPage?:ModelTypes["FieldMeta"],
	tabletopPage?:ModelTypes["FieldMeta"]
};
	["HomePage"]: {
		_meta?:ModelTypes["HomePageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	tagline?:string,
	logo?:ModelTypes["Image"],
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	directorsText?:string,
	contentGroups:ModelTypes["HomePageContentGroup"][],
	backgroundImage?:ModelTypes["Image"],
	contentGroupsByContentGroup?:ModelTypes["HomePageContentGroup"],
	paginateContentGroups:ModelTypes["HomePageContentGroupConnection"]
};
	["HomePageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	tagline?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	directorsText?:ModelTypes["FieldMeta"],
	contentGroups?:ModelTypes["FieldMeta"],
	backgroundImage?:ModelTypes["FieldMeta"]
};
	["Seo"]: {
		_meta?:ModelTypes["SeoMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	description?:string,
	ogTitle?:string,
	ogDescription?:string,
	ogImage?:ModelTypes["Image"]
};
	["SeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	ogTitle?:ModelTypes["FieldMeta"],
	ogDescription?:ModelTypes["FieldMeta"],
	ogImage?:ModelTypes["FieldMeta"]
};
	["HomePageContentGroup"]: {
		_meta?:ModelTypes["HomePageContentGroupMeta"],
	id:ModelTypes["UUID"],
	order:number,
	homePage?:ModelTypes["HomePage"],
	contentGroup?:ModelTypes["ContentGroup"]
};
	["HomePageContentGroupMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	homePage?:ModelTypes["FieldMeta"],
	contentGroup?:ModelTypes["FieldMeta"]
};
	["ContentGroup"]: {
		_meta?:ModelTypes["ContentGroupMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	contentType?:ModelTypes["ContentGroupType"],
	gallery?:ModelTypes["Gallery"],
	films:ModelTypes["FilmItem"][],
	paginateFilms:ModelTypes["FilmItemConnection"]
};
	["ContentGroupMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	contentType?:ModelTypes["FieldMeta"],
	gallery?:ModelTypes["FieldMeta"],
	films?:ModelTypes["FieldMeta"]
};
	["Gallery"]: {
		_meta?:ModelTypes["GalleryMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["GalleryItem"][],
	paginateItems:ModelTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["GalleryItem"]: {
		_meta?:ModelTypes["GalleryItemMeta"],
	id:ModelTypes["UUID"],
	order?:number,
	list?:ModelTypes["Gallery"],
	image?:ModelTypes["Image"]
};
	["GalleryItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["GalleryItemOrderBy"]: GraphQLTypes["GalleryItemOrderBy"];
	["GalleryOrderBy"]: GraphQLTypes["GalleryOrderBy"];
	["GalleryItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GalleryItemEdge"][]
};
	["GalleryItemEdge"]: {
		node:ModelTypes["GalleryItem"]
};
	["FilmItem"]: {
		_meta?:ModelTypes["FilmItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	contentGroups?:ModelTypes["ContentGroup"],
	film?:ModelTypes["Film"]
};
	["FilmItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	contentGroups?:ModelTypes["FieldMeta"],
	film?:ModelTypes["FieldMeta"]
};
	["Film"]: {
		_meta?:ModelTypes["FilmMeta"],
	id:ModelTypes["UUID"],
	name?:string,
	author?:string,
	vimeoId?:string,
	posterImage?:ModelTypes["Image"],
	order:number,
	wordpressId?:string
};
	["FilmMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	author?:ModelTypes["FieldMeta"],
	vimeoId?:ModelTypes["FieldMeta"],
	posterImage?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	wordpressId?:ModelTypes["FieldMeta"]
};
	["FilmItemOrderBy"]: GraphQLTypes["FilmItemOrderBy"];
	["ContentGroupOrderBy"]: GraphQLTypes["ContentGroupOrderBy"];
	["FilmOrderBy"]: GraphQLTypes["FilmOrderBy"];
	["FilmItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FilmItemEdge"][]
};
	["FilmItemEdge"]: {
		node:ModelTypes["FilmItem"]
};
	["HomePageContentGroupOrderBy"]: GraphQLTypes["HomePageContentGroupOrderBy"];
	["HomePageOrderBy"]: GraphQLTypes["HomePageOrderBy"];
	["SeoOrderBy"]: GraphQLTypes["SeoOrderBy"];
	["LinkableOrderBy"]: GraphQLTypes["LinkableOrderBy"];
	["RedirectOrderBy"]: GraphQLTypes["RedirectOrderBy"];
	["DirectorOrderBy"]: GraphQLTypes["DirectorOrderBy"];
	["DirectorLocationOrderBy"]: GraphQLTypes["DirectorLocationOrderBy"];
	["ContactsPageOrderBy"]: GraphQLTypes["ContactsPageOrderBy"];
	["DirectorsPageOrderBy"]: GraphQLTypes["DirectorsPageOrderBy"];
	["PhotographerOrderBy"]: GraphQLTypes["PhotographerOrderBy"];
	["PhotographerLocationOrderBy"]: GraphQLTypes["PhotographerLocationOrderBy"];
	["PhotographersPageOrderBy"]: GraphQLTypes["PhotographersPageOrderBy"];
	["OurWorkPageOrderBy"]: GraphQLTypes["OurWorkPageOrderBy"];
	["TabletopPageOrderBy"]: GraphQLTypes["TabletopPageOrderBy"];
	["HomePageContentGroupsByContentGroupUniqueWhere"]: GraphQLTypes["HomePageContentGroupsByContentGroupUniqueWhere"];
	["ContentGroupUniqueWhere"]: GraphQLTypes["ContentGroupUniqueWhere"];
	["GalleryUniqueWhere"]: GraphQLTypes["GalleryUniqueWhere"];
	["GalleryItemUniqueWhere"]: GraphQLTypes["GalleryItemUniqueWhere"];
	["FilmItemUniqueWhere"]: GraphQLTypes["FilmItemUniqueWhere"];
	["HomePageContentGroupConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HomePageContentGroupEdge"][]
};
	["HomePageContentGroupEdge"]: {
		node:ModelTypes["HomePageContentGroup"]
};
	["Redirect"]: {
		_meta?:ModelTypes["RedirectMeta"],
	id:ModelTypes["UUID"],
	targetUrl?:string,
	link?:ModelTypes["Linkable"],
	target?:ModelTypes["Linkable"]
};
	["RedirectMeta"]: {
		id?:ModelTypes["FieldMeta"],
	targetUrl?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"]
};
	["Director"]: {
		_meta?:ModelTypes["DirectorMeta"],
	id:ModelTypes["UUID"],
	name?:string,
	leadParagraph?:string,
	image?:ModelTypes["Image"],
	link?:ModelTypes["Linkable"],
	order:number,
	contentGroups:ModelTypes["DirectorContentGroup"][],
	directorLocation?:ModelTypes["DirectorLocation"],
	wordpressId?:string,
	contentGroupsByContentGroup?:ModelTypes["DirectorContentGroup"],
	paginateContentGroups:ModelTypes["DirectorContentGroupConnection"]
};
	["DirectorMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	contentGroups?:ModelTypes["FieldMeta"],
	directorLocation?:ModelTypes["FieldMeta"],
	wordpressId?:ModelTypes["FieldMeta"]
};
	["DirectorContentGroup"]: {
		_meta?:ModelTypes["DirectorContentGroupMeta"],
	id:ModelTypes["UUID"],
	order:number,
	director?:ModelTypes["Director"],
	contentGroup?:ModelTypes["ContentGroup"]
};
	["DirectorContentGroupMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	director?:ModelTypes["FieldMeta"],
	contentGroup?:ModelTypes["FieldMeta"]
};
	["DirectorContentGroupOrderBy"]: GraphQLTypes["DirectorContentGroupOrderBy"];
	["DirectorLocation"]: {
		_meta?:ModelTypes["DirectorLocationMeta"],
	id:ModelTypes["UUID"],
	order:number,
	city?:string,
	director:ModelTypes["Director"][],
	directorByWordpressId?:ModelTypes["Director"],
	directorByImage?:ModelTypes["Director"],
	directorByLink?:ModelTypes["Director"],
	directorByContentGroups?:ModelTypes["Director"],
	paginateDirector:ModelTypes["DirectorConnection"]
};
	["DirectorLocationMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	city?:ModelTypes["FieldMeta"],
	director?:ModelTypes["FieldMeta"]
};
	["DirectorLocationDirectorByWordpressIdUniqueWhere"]: GraphQLTypes["DirectorLocationDirectorByWordpressIdUniqueWhere"];
	["DirectorLocationDirectorByImageUniqueWhere"]: GraphQLTypes["DirectorLocationDirectorByImageUniqueWhere"];
	["DirectorLocationDirectorByLinkUniqueWhere"]: GraphQLTypes["DirectorLocationDirectorByLinkUniqueWhere"];
	["LinkableUniqueWhere"]: GraphQLTypes["LinkableUniqueWhere"];
	["HomePageUniqueWhere"]: GraphQLTypes["HomePageUniqueWhere"];
	["SeoUniqueWhere"]: GraphQLTypes["SeoUniqueWhere"];
	["HomePageContentGroupUniqueWhere"]: GraphQLTypes["HomePageContentGroupUniqueWhere"];
	["RedirectUniqueWhere"]: GraphQLTypes["RedirectUniqueWhere"];
	["DirectorUniqueWhere"]: GraphQLTypes["DirectorUniqueWhere"];
	["DirectorContentGroupUniqueWhere"]: GraphQLTypes["DirectorContentGroupUniqueWhere"];
	["ContactsPageUniqueWhere"]: GraphQLTypes["ContactsPageUniqueWhere"];
	["DirectorsPageUniqueWhere"]: GraphQLTypes["DirectorsPageUniqueWhere"];
	["PhotographerUniqueWhere"]: GraphQLTypes["PhotographerUniqueWhere"];
	["PhotographerContentGroupUniqueWhere"]: GraphQLTypes["PhotographerContentGroupUniqueWhere"];
	["PhotographersPageUniqueWhere"]: GraphQLTypes["PhotographersPageUniqueWhere"];
	["PhotographersPageContentGroupUniqueWhere"]: GraphQLTypes["PhotographersPageContentGroupUniqueWhere"];
	["OurWorkPageUniqueWhere"]: GraphQLTypes["OurWorkPageUniqueWhere"];
	["OurWorkPageContentGroupUniqueWhere"]: GraphQLTypes["OurWorkPageContentGroupUniqueWhere"];
	["TabletopPageUniqueWhere"]: GraphQLTypes["TabletopPageUniqueWhere"];
	["TabletopPageContentGroupUniqueWhere"]: GraphQLTypes["TabletopPageContentGroupUniqueWhere"];
	["DirectorLocationDirectorByContentGroupsUniqueWhere"]: GraphQLTypes["DirectorLocationDirectorByContentGroupsUniqueWhere"];
	["DirectorConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DirectorEdge"][]
};
	["DirectorEdge"]: {
		node:ModelTypes["Director"]
};
	["DirectorContentGroupsByContentGroupUniqueWhere"]: GraphQLTypes["DirectorContentGroupsByContentGroupUniqueWhere"];
	["DirectorContentGroupConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DirectorContentGroupEdge"][]
};
	["DirectorContentGroupEdge"]: {
		node:ModelTypes["DirectorContentGroup"]
};
	["ContactsPage"]: {
		_meta?:ModelTypes["ContactsPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	leadParagraph?:string
};
	["ContactsPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"]
};
	["DirectorsPage"]: {
		_meta?:ModelTypes["DirectorsPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	leadParagraph?:string
};
	["DirectorsPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"]
};
	["Photographer"]: {
		_meta?:ModelTypes["PhotographerMeta"],
	id:ModelTypes["UUID"],
	order:number,
	name?:string,
	leadParagraph?:string,
	image?:ModelTypes["Image"],
	contentGroups:ModelTypes["PhotographerContentGroup"][],
	link?:ModelTypes["Linkable"],
	photographerLocation?:ModelTypes["PhotographerLocation"],
	wordpressId?:string,
	contentGroupsByContentGroup?:ModelTypes["PhotographerContentGroup"],
	paginateContentGroups:ModelTypes["PhotographerContentGroupConnection"]
};
	["PhotographerMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	contentGroups?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	photographerLocation?:ModelTypes["FieldMeta"],
	wordpressId?:ModelTypes["FieldMeta"]
};
	["PhotographerContentGroup"]: {
		_meta?:ModelTypes["PhotographerContentGroupMeta"],
	id:ModelTypes["UUID"],
	order:number,
	photographer?:ModelTypes["Photographer"],
	contentGroup?:ModelTypes["ContentGroup"]
};
	["PhotographerContentGroupMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	photographer?:ModelTypes["FieldMeta"],
	contentGroup?:ModelTypes["FieldMeta"]
};
	["PhotographerContentGroupOrderBy"]: GraphQLTypes["PhotographerContentGroupOrderBy"];
	["PhotographerLocation"]: {
		_meta?:ModelTypes["PhotographerLocationMeta"],
	id:ModelTypes["UUID"],
	order:number,
	city?:string,
	photographer:ModelTypes["Photographer"][],
	photographerByWordpressId?:ModelTypes["Photographer"],
	photographerByImage?:ModelTypes["Photographer"],
	photographerByContentGroups?:ModelTypes["Photographer"],
	photographerByLink?:ModelTypes["Photographer"],
	paginatePhotographer:ModelTypes["PhotographerConnection"]
};
	["PhotographerLocationMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	city?:ModelTypes["FieldMeta"],
	photographer?:ModelTypes["FieldMeta"]
};
	["PhotographerLocationPhotographerByWordpressIdUniqueWhere"]: GraphQLTypes["PhotographerLocationPhotographerByWordpressIdUniqueWhere"];
	["PhotographerLocationPhotographerByImageUniqueWhere"]: GraphQLTypes["PhotographerLocationPhotographerByImageUniqueWhere"];
	["PhotographerLocationPhotographerByContentGroupsUniqueWhere"]: GraphQLTypes["PhotographerLocationPhotographerByContentGroupsUniqueWhere"];
	["PhotographerLocationPhotographerByLinkUniqueWhere"]: GraphQLTypes["PhotographerLocationPhotographerByLinkUniqueWhere"];
	["PhotographerConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PhotographerEdge"][]
};
	["PhotographerEdge"]: {
		node:ModelTypes["Photographer"]
};
	["PhotographerContentGroupsByContentGroupUniqueWhere"]: GraphQLTypes["PhotographerContentGroupsByContentGroupUniqueWhere"];
	["PhotographerContentGroupConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PhotographerContentGroupEdge"][]
};
	["PhotographerContentGroupEdge"]: {
		node:ModelTypes["PhotographerContentGroup"]
};
	["PhotographersPage"]: {
		_meta?:ModelTypes["PhotographersPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	leadParagraph?:string,
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	contentGroups:ModelTypes["PhotographersPageContentGroup"][],
	contentGroupsByContentGroup?:ModelTypes["PhotographersPageContentGroup"],
	paginateContentGroups:ModelTypes["PhotographersPageContentGroupConnection"]
};
	["PhotographersPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	contentGroups?:ModelTypes["FieldMeta"]
};
	["PhotographersPageContentGroup"]: {
		_meta?:ModelTypes["PhotographersPageContentGroupMeta"],
	id:ModelTypes["UUID"],
	order:number,
	photographersPage?:ModelTypes["PhotographersPage"],
	contentGroup?:ModelTypes["ContentGroup"]
};
	["PhotographersPageContentGroupMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	photographersPage?:ModelTypes["FieldMeta"],
	contentGroup?:ModelTypes["FieldMeta"]
};
	["PhotographersPageContentGroupOrderBy"]: GraphQLTypes["PhotographersPageContentGroupOrderBy"];
	["PhotographersPageContentGroupsByContentGroupUniqueWhere"]: GraphQLTypes["PhotographersPageContentGroupsByContentGroupUniqueWhere"];
	["PhotographersPageContentGroupConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PhotographersPageContentGroupEdge"][]
};
	["PhotographersPageContentGroupEdge"]: {
		node:ModelTypes["PhotographersPageContentGroup"]
};
	["OurWorkPage"]: {
		_meta?:ModelTypes["OurWorkPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	leadParagraph?:string,
	link?:ModelTypes["Linkable"],
	contentGroups:ModelTypes["OurWorkPageContentGroup"][],
	seo?:ModelTypes["Seo"],
	contentGroupsByContentGroup?:ModelTypes["OurWorkPageContentGroup"],
	paginateContentGroups:ModelTypes["OurWorkPageContentGroupConnection"]
};
	["OurWorkPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	contentGroups?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["OurWorkPageContentGroup"]: {
		_meta?:ModelTypes["OurWorkPageContentGroupMeta"],
	id:ModelTypes["UUID"],
	order:number,
	ourWorkPage?:ModelTypes["OurWorkPage"],
	contentGroup?:ModelTypes["ContentGroup"]
};
	["OurWorkPageContentGroupMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	ourWorkPage?:ModelTypes["FieldMeta"],
	contentGroup?:ModelTypes["FieldMeta"]
};
	["OurWorkPageContentGroupOrderBy"]: GraphQLTypes["OurWorkPageContentGroupOrderBy"];
	["OurWorkPageContentGroupsByContentGroupUniqueWhere"]: GraphQLTypes["OurWorkPageContentGroupsByContentGroupUniqueWhere"];
	["OurWorkPageContentGroupConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["OurWorkPageContentGroupEdge"][]
};
	["OurWorkPageContentGroupEdge"]: {
		node:ModelTypes["OurWorkPageContentGroup"]
};
	["TabletopPage"]: {
		_meta?:ModelTypes["TabletopPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	leadParagraph?:string,
	teamTitle?:string,
	link?:ModelTypes["Linkable"],
	logo?:ModelTypes["Image"],
	seo?:ModelTypes["Seo"],
	contentGroups:ModelTypes["TabletopPageContentGroup"][],
	contentGroupsByContentGroup?:ModelTypes["TabletopPageContentGroup"],
	paginateContentGroups:ModelTypes["TabletopPageContentGroupConnection"]
};
	["TabletopPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	teamTitle?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	contentGroups?:ModelTypes["FieldMeta"]
};
	["TabletopPageContentGroup"]: {
		_meta?:ModelTypes["TabletopPageContentGroupMeta"],
	id:ModelTypes["UUID"],
	order:number,
	tabletopPage?:ModelTypes["TabletopPage"],
	contentGroup?:ModelTypes["ContentGroup"]
};
	["TabletopPageContentGroupMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	tabletopPage?:ModelTypes["FieldMeta"],
	contentGroup?:ModelTypes["FieldMeta"]
};
	["TabletopPageContentGroupOrderBy"]: GraphQLTypes["TabletopPageContentGroupOrderBy"];
	["TabletopPageContentGroupsByContentGroupUniqueWhere"]: GraphQLTypes["TabletopPageContentGroupsByContentGroupUniqueWhere"];
	["TabletopPageContentGroupConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TabletopPageContentGroupEdge"][]
};
	["TabletopPageContentGroupEdge"]: {
		node:ModelTypes["TabletopPageContentGroup"]
};
	["CardMedia"]: {
		_meta?:ModelTypes["CardMediaMeta"],
	id:ModelTypes["UUID"],
	text?:string,
	imageNote?:string,
	image?:ModelTypes["Image"]
};
	["CardMediaMeta"]: {
		id?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	imageNote?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["ContentReferenceOrderBy"]: GraphQLTypes["ContentReferenceOrderBy"];
	["ContentBlockOrderBy"]: GraphQLTypes["ContentBlockOrderBy"];
	["ContentOrderBy"]: GraphQLTypes["ContentOrderBy"];
	["LinkOrderBy"]: GraphQLTypes["LinkOrderBy"];
	["CardMediaOrderBy"]: GraphQLTypes["CardMediaOrderBy"];
	["ContentBlockReferencesByLinkUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByLinkUniqueWhere"];
	["LinkUniqueWhere"]: GraphQLTypes["LinkUniqueWhere"];
	["ContentReferenceConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentReferenceEdge"][]
};
	["ContentReferenceEdge"]: {
		node:ModelTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: GraphQLTypes["ContentBlocksByReferencesUniqueWhere"];
	["ContentReferenceUniqueWhere"]: GraphQLTypes["ContentReferenceUniqueWhere"];
	["ContentBlockConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentBlockEdge"][]
};
	["ContentBlockEdge"]: {
		node:ModelTypes["ContentBlock"]
};
	["ContentUniqueWhere"]: GraphQLTypes["ContentUniqueWhere"];
	["ContentBlockUniqueWhere"]: GraphQLTypes["ContentBlockUniqueWhere"];
	["ContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentEdge"][]
};
	["ContentEdge"]: {
		node:ModelTypes["Content"]
};
	["ContentCreateInput"]: GraphQLTypes["ContentCreateInput"];
	["ContentCreateBlocksEntityRelationInput"]: GraphQLTypes["ContentCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutContentCreateInput"]: GraphQLTypes["ContentBlockWithoutContentCreateInput"];
	["ContentBlockCreateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"];
	["ContentReferenceWithoutBlockCreateInput"]: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"];
	["ContentReferenceCreateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"];
	["LinkCreateInput"]: GraphQLTypes["LinkCreateInput"];
	["LinkCreateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"];
	["LinkableCreateInput"]: GraphQLTypes["LinkableCreateInput"];
	["LinkableCreateHomePageEntityRelationInput"]: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"];
	["HomePageWithoutLinkCreateInput"]: GraphQLTypes["HomePageWithoutLinkCreateInput"];
	["HomePageCreateLogoEntityRelationInput"]: GraphQLTypes["HomePageCreateLogoEntityRelationInput"];
	["HomePageCreateSeoEntityRelationInput"]: GraphQLTypes["HomePageCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: GraphQLTypes["SeoCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: GraphQLTypes["SeoCreateOgImageEntityRelationInput"];
	["HomePageCreateContentGroupsEntityRelationInput"]: GraphQLTypes["HomePageCreateContentGroupsEntityRelationInput"];
	["HomePageContentGroupWithoutHomePageCreateInput"]: GraphQLTypes["HomePageContentGroupWithoutHomePageCreateInput"];
	["HomePageContentGroupCreateContentGroupEntityRelationInput"]: GraphQLTypes["HomePageContentGroupCreateContentGroupEntityRelationInput"];
	["ContentGroupCreateInput"]: GraphQLTypes["ContentGroupCreateInput"];
	["ContentGroupCreateGalleryEntityRelationInput"]: GraphQLTypes["ContentGroupCreateGalleryEntityRelationInput"];
	["GalleryCreateInput"]: GraphQLTypes["GalleryCreateInput"];
	["GalleryCreateItemsEntityRelationInput"]: GraphQLTypes["GalleryCreateItemsEntityRelationInput"];
	["GalleryItemWithoutListCreateInput"]: GraphQLTypes["GalleryItemWithoutListCreateInput"];
	["GalleryItemCreateImageEntityRelationInput"]: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"];
	["ContentGroupCreateFilmsEntityRelationInput"]: GraphQLTypes["ContentGroupCreateFilmsEntityRelationInput"];
	["FilmItemWithoutContentGroupsCreateInput"]: GraphQLTypes["FilmItemWithoutContentGroupsCreateInput"];
	["FilmItemCreateFilmEntityRelationInput"]: GraphQLTypes["FilmItemCreateFilmEntityRelationInput"];
	["FilmUniqueWhere"]: GraphQLTypes["FilmUniqueWhere"];
	["FilmCreateInput"]: GraphQLTypes["FilmCreateInput"];
	["FilmCreatePosterImageEntityRelationInput"]: GraphQLTypes["FilmCreatePosterImageEntityRelationInput"];
	["HomePageCreateBackgroundImageEntityRelationInput"]: GraphQLTypes["HomePageCreateBackgroundImageEntityRelationInput"];
	["LinkableCreateRedirectEntityRelationInput"]: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"];
	["RedirectWithoutLinkCreateInput"]: GraphQLTypes["RedirectWithoutLinkCreateInput"];
	["RedirectCreateTargetEntityRelationInput"]: GraphQLTypes["RedirectCreateTargetEntityRelationInput"];
	["LinkableCreateDirectorEntityRelationInput"]: GraphQLTypes["LinkableCreateDirectorEntityRelationInput"];
	["DirectorWithoutLinkCreateInput"]: GraphQLTypes["DirectorWithoutLinkCreateInput"];
	["DirectorCreateImageEntityRelationInput"]: GraphQLTypes["DirectorCreateImageEntityRelationInput"];
	["DirectorCreateContentGroupsEntityRelationInput"]: GraphQLTypes["DirectorCreateContentGroupsEntityRelationInput"];
	["DirectorContentGroupWithoutDirectorCreateInput"]: GraphQLTypes["DirectorContentGroupWithoutDirectorCreateInput"];
	["DirectorContentGroupCreateContentGroupEntityRelationInput"]: GraphQLTypes["DirectorContentGroupCreateContentGroupEntityRelationInput"];
	["DirectorCreateDirectorLocationEntityRelationInput"]: GraphQLTypes["DirectorCreateDirectorLocationEntityRelationInput"];
	["DirectorLocationUniqueWhere"]: GraphQLTypes["DirectorLocationUniqueWhere"];
	["DirectorLocationWithoutDirectorCreateInput"]: GraphQLTypes["DirectorLocationWithoutDirectorCreateInput"];
	["LinkableCreateContactsPageEntityRelationInput"]: GraphQLTypes["LinkableCreateContactsPageEntityRelationInput"];
	["ContactsPageWithoutLinkCreateInput"]: GraphQLTypes["ContactsPageWithoutLinkCreateInput"];
	["ContactsPageCreateSeoEntityRelationInput"]: GraphQLTypes["ContactsPageCreateSeoEntityRelationInput"];
	["LinkableCreateDirectorsPageEntityRelationInput"]: GraphQLTypes["LinkableCreateDirectorsPageEntityRelationInput"];
	["DirectorsPageWithoutLinkCreateInput"]: GraphQLTypes["DirectorsPageWithoutLinkCreateInput"];
	["DirectorsPageCreateSeoEntityRelationInput"]: GraphQLTypes["DirectorsPageCreateSeoEntityRelationInput"];
	["LinkableCreatePhotographerEntityRelationInput"]: GraphQLTypes["LinkableCreatePhotographerEntityRelationInput"];
	["PhotographerWithoutLinkCreateInput"]: GraphQLTypes["PhotographerWithoutLinkCreateInput"];
	["PhotographerCreateImageEntityRelationInput"]: GraphQLTypes["PhotographerCreateImageEntityRelationInput"];
	["PhotographerCreateContentGroupsEntityRelationInput"]: GraphQLTypes["PhotographerCreateContentGroupsEntityRelationInput"];
	["PhotographerContentGroupWithoutPhotographerCreateInput"]: GraphQLTypes["PhotographerContentGroupWithoutPhotographerCreateInput"];
	["PhotographerContentGroupCreateContentGroupEntityRelationInput"]: GraphQLTypes["PhotographerContentGroupCreateContentGroupEntityRelationInput"];
	["PhotographerCreatePhotographerLocationEntityRelationInput"]: GraphQLTypes["PhotographerCreatePhotographerLocationEntityRelationInput"];
	["PhotographerLocationUniqueWhere"]: GraphQLTypes["PhotographerLocationUniqueWhere"];
	["PhotographerLocationWithoutPhotographerCreateInput"]: GraphQLTypes["PhotographerLocationWithoutPhotographerCreateInput"];
	["LinkableCreatePhotographersPageEntityRelationInput"]: GraphQLTypes["LinkableCreatePhotographersPageEntityRelationInput"];
	["PhotographersPageWithoutLinkCreateInput"]: GraphQLTypes["PhotographersPageWithoutLinkCreateInput"];
	["PhotographersPageCreateSeoEntityRelationInput"]: GraphQLTypes["PhotographersPageCreateSeoEntityRelationInput"];
	["PhotographersPageCreateContentGroupsEntityRelationInput"]: GraphQLTypes["PhotographersPageCreateContentGroupsEntityRelationInput"];
	["PhotographersPageContentGroupWithoutPhotographersPageCreateInput"]: GraphQLTypes["PhotographersPageContentGroupWithoutPhotographersPageCreateInput"];
	["PhotographersPageContentGroupCreateContentGroupEntityRelationInput"]: GraphQLTypes["PhotographersPageContentGroupCreateContentGroupEntityRelationInput"];
	["LinkableCreateOurWorkPageEntityRelationInput"]: GraphQLTypes["LinkableCreateOurWorkPageEntityRelationInput"];
	["OurWorkPageWithoutLinkCreateInput"]: GraphQLTypes["OurWorkPageWithoutLinkCreateInput"];
	["OurWorkPageCreateContentGroupsEntityRelationInput"]: GraphQLTypes["OurWorkPageCreateContentGroupsEntityRelationInput"];
	["OurWorkPageContentGroupWithoutOurWorkPageCreateInput"]: GraphQLTypes["OurWorkPageContentGroupWithoutOurWorkPageCreateInput"];
	["OurWorkPageContentGroupCreateContentGroupEntityRelationInput"]: GraphQLTypes["OurWorkPageContentGroupCreateContentGroupEntityRelationInput"];
	["OurWorkPageCreateSeoEntityRelationInput"]: GraphQLTypes["OurWorkPageCreateSeoEntityRelationInput"];
	["LinkableCreateTabletopPageEntityRelationInput"]: GraphQLTypes["LinkableCreateTabletopPageEntityRelationInput"];
	["TabletopPageWithoutLinkCreateInput"]: GraphQLTypes["TabletopPageWithoutLinkCreateInput"];
	["TabletopPageCreateLogoEntityRelationInput"]: GraphQLTypes["TabletopPageCreateLogoEntityRelationInput"];
	["TabletopPageCreateSeoEntityRelationInput"]: GraphQLTypes["TabletopPageCreateSeoEntityRelationInput"];
	["TabletopPageCreateContentGroupsEntityRelationInput"]: GraphQLTypes["TabletopPageCreateContentGroupsEntityRelationInput"];
	["TabletopPageContentGroupWithoutTabletopPageCreateInput"]: GraphQLTypes["TabletopPageContentGroupWithoutTabletopPageCreateInput"];
	["TabletopPageContentGroupCreateContentGroupEntityRelationInput"]: GraphQLTypes["TabletopPageContentGroupCreateContentGroupEntityRelationInput"];
	["ContentReferenceCreateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"];
	["ContentReferenceCreateCardMediaEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateCardMediaEntityRelationInput"];
	["CardMediaUniqueWhere"]: GraphQLTypes["CardMediaUniqueWhere"];
	["CardMediaCreateInput"]: GraphQLTypes["CardMediaCreateInput"];
	["CardMediaCreateImageEntityRelationInput"]: GraphQLTypes["CardMediaCreateImageEntityRelationInput"];
	["ContentUpdateInput"]: GraphQLTypes["ContentUpdateInput"];
	["ContentUpdateBlocksEntityRelationInput"]: GraphQLTypes["ContentUpdateBlocksEntityRelationInput"];
	["ContentUpdateBlocksRelationInput"]: GraphQLTypes["ContentUpdateBlocksRelationInput"];
	["ContentBlockWithoutContentUpdateInput"]: GraphQLTypes["ContentBlockWithoutContentUpdateInput"];
	["ContentBlockUpdateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"];
	["ContentBlockUpdateReferencesRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"];
	["ContentReferenceWithoutBlockUpdateInput"]: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"];
	["ContentReferenceUpdateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: GraphQLTypes["LinkUpdateInput"];
	["LinkUpdateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"];
	["LinkableUpdateInput"]: GraphQLTypes["LinkableUpdateInput"];
	["LinkableUpdateHomePageEntityRelationInput"]: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"];
	["HomePageWithoutLinkUpdateInput"]: GraphQLTypes["HomePageWithoutLinkUpdateInput"];
	["HomePageUpdateLogoEntityRelationInput"]: GraphQLTypes["HomePageUpdateLogoEntityRelationInput"];
	["HomePageUpsertLogoRelationInput"]: GraphQLTypes["HomePageUpsertLogoRelationInput"];
	["HomePageUpdateSeoEntityRelationInput"]: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: GraphQLTypes["SeoUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"];
	["SeoUpsertOgImageRelationInput"]: GraphQLTypes["SeoUpsertOgImageRelationInput"];
	["HomePageUpsertSeoRelationInput"]: GraphQLTypes["HomePageUpsertSeoRelationInput"];
	["HomePageUpdateContentGroupsEntityRelationInput"]: GraphQLTypes["HomePageUpdateContentGroupsEntityRelationInput"];
	["HomePageUpdateContentGroupsRelationInput"]: GraphQLTypes["HomePageUpdateContentGroupsRelationInput"];
	["HomePageContentGroupWithoutHomePageUpdateInput"]: GraphQLTypes["HomePageContentGroupWithoutHomePageUpdateInput"];
	["HomePageContentGroupUpdateContentGroupEntityRelationInput"]: GraphQLTypes["HomePageContentGroupUpdateContentGroupEntityRelationInput"];
	["ContentGroupUpdateInput"]: GraphQLTypes["ContentGroupUpdateInput"];
	["ContentGroupUpdateGalleryEntityRelationInput"]: GraphQLTypes["ContentGroupUpdateGalleryEntityRelationInput"];
	["GalleryUpdateInput"]: GraphQLTypes["GalleryUpdateInput"];
	["GalleryUpdateItemsEntityRelationInput"]: GraphQLTypes["GalleryUpdateItemsEntityRelationInput"];
	["GalleryUpdateItemsRelationInput"]: GraphQLTypes["GalleryUpdateItemsRelationInput"];
	["GalleryItemWithoutListUpdateInput"]: GraphQLTypes["GalleryItemWithoutListUpdateInput"];
	["GalleryItemUpdateImageEntityRelationInput"]: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"];
	["GalleryItemUpsertImageRelationInput"]: GraphQLTypes["GalleryItemUpsertImageRelationInput"];
	["GalleryUpsertItemsRelationInput"]: GraphQLTypes["GalleryUpsertItemsRelationInput"];
	["ContentGroupUpsertGalleryRelationInput"]: GraphQLTypes["ContentGroupUpsertGalleryRelationInput"];
	["ContentGroupUpdateFilmsEntityRelationInput"]: GraphQLTypes["ContentGroupUpdateFilmsEntityRelationInput"];
	["ContentGroupUpdateFilmsRelationInput"]: GraphQLTypes["ContentGroupUpdateFilmsRelationInput"];
	["FilmItemWithoutContentGroupsUpdateInput"]: GraphQLTypes["FilmItemWithoutContentGroupsUpdateInput"];
	["FilmItemUpdateFilmEntityRelationInput"]: GraphQLTypes["FilmItemUpdateFilmEntityRelationInput"];
	["FilmUpdateInput"]: GraphQLTypes["FilmUpdateInput"];
	["FilmUpdatePosterImageEntityRelationInput"]: GraphQLTypes["FilmUpdatePosterImageEntityRelationInput"];
	["FilmUpsertPosterImageRelationInput"]: GraphQLTypes["FilmUpsertPosterImageRelationInput"];
	["FilmItemUpsertFilmRelationInput"]: GraphQLTypes["FilmItemUpsertFilmRelationInput"];
	["ContentGroupUpsertFilmsRelationInput"]: GraphQLTypes["ContentGroupUpsertFilmsRelationInput"];
	["HomePageContentGroupUpsertContentGroupRelationInput"]: GraphQLTypes["HomePageContentGroupUpsertContentGroupRelationInput"];
	["HomePageUpsertContentGroupsRelationInput"]: GraphQLTypes["HomePageUpsertContentGroupsRelationInput"];
	["HomePageUpdateBackgroundImageEntityRelationInput"]: GraphQLTypes["HomePageUpdateBackgroundImageEntityRelationInput"];
	["HomePageUpsertBackgroundImageRelationInput"]: GraphQLTypes["HomePageUpsertBackgroundImageRelationInput"];
	["LinkableUpsertHomePageRelationInput"]: GraphQLTypes["LinkableUpsertHomePageRelationInput"];
	["LinkableUpdateRedirectEntityRelationInput"]: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"];
	["RedirectWithoutLinkUpdateInput"]: GraphQLTypes["RedirectWithoutLinkUpdateInput"];
	["RedirectUpdateTargetEntityRelationInput"]: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"];
	["RedirectUpsertTargetRelationInput"]: GraphQLTypes["RedirectUpsertTargetRelationInput"];
	["LinkableUpsertRedirectRelationInput"]: GraphQLTypes["LinkableUpsertRedirectRelationInput"];
	["LinkableUpdateDirectorEntityRelationInput"]: GraphQLTypes["LinkableUpdateDirectorEntityRelationInput"];
	["DirectorWithoutLinkUpdateInput"]: GraphQLTypes["DirectorWithoutLinkUpdateInput"];
	["DirectorUpdateImageEntityRelationInput"]: GraphQLTypes["DirectorUpdateImageEntityRelationInput"];
	["DirectorUpsertImageRelationInput"]: GraphQLTypes["DirectorUpsertImageRelationInput"];
	["DirectorUpdateContentGroupsEntityRelationInput"]: GraphQLTypes["DirectorUpdateContentGroupsEntityRelationInput"];
	["DirectorUpdateContentGroupsRelationInput"]: GraphQLTypes["DirectorUpdateContentGroupsRelationInput"];
	["DirectorContentGroupWithoutDirectorUpdateInput"]: GraphQLTypes["DirectorContentGroupWithoutDirectorUpdateInput"];
	["DirectorContentGroupUpdateContentGroupEntityRelationInput"]: GraphQLTypes["DirectorContentGroupUpdateContentGroupEntityRelationInput"];
	["DirectorContentGroupUpsertContentGroupRelationInput"]: GraphQLTypes["DirectorContentGroupUpsertContentGroupRelationInput"];
	["DirectorUpsertContentGroupsRelationInput"]: GraphQLTypes["DirectorUpsertContentGroupsRelationInput"];
	["DirectorUpdateDirectorLocationEntityRelationInput"]: GraphQLTypes["DirectorUpdateDirectorLocationEntityRelationInput"];
	["DirectorLocationWithoutDirectorUpdateInput"]: GraphQLTypes["DirectorLocationWithoutDirectorUpdateInput"];
	["DirectorUpsertDirectorLocationRelationInput"]: GraphQLTypes["DirectorUpsertDirectorLocationRelationInput"];
	["LinkableUpsertDirectorRelationInput"]: GraphQLTypes["LinkableUpsertDirectorRelationInput"];
	["LinkableUpdateContactsPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateContactsPageEntityRelationInput"];
	["ContactsPageWithoutLinkUpdateInput"]: GraphQLTypes["ContactsPageWithoutLinkUpdateInput"];
	["ContactsPageUpdateSeoEntityRelationInput"]: GraphQLTypes["ContactsPageUpdateSeoEntityRelationInput"];
	["ContactsPageUpsertSeoRelationInput"]: GraphQLTypes["ContactsPageUpsertSeoRelationInput"];
	["LinkableUpsertContactsPageRelationInput"]: GraphQLTypes["LinkableUpsertContactsPageRelationInput"];
	["LinkableUpdateDirectorsPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateDirectorsPageEntityRelationInput"];
	["DirectorsPageWithoutLinkUpdateInput"]: GraphQLTypes["DirectorsPageWithoutLinkUpdateInput"];
	["DirectorsPageUpdateSeoEntityRelationInput"]: GraphQLTypes["DirectorsPageUpdateSeoEntityRelationInput"];
	["DirectorsPageUpsertSeoRelationInput"]: GraphQLTypes["DirectorsPageUpsertSeoRelationInput"];
	["LinkableUpsertDirectorsPageRelationInput"]: GraphQLTypes["LinkableUpsertDirectorsPageRelationInput"];
	["LinkableUpdatePhotographerEntityRelationInput"]: GraphQLTypes["LinkableUpdatePhotographerEntityRelationInput"];
	["PhotographerWithoutLinkUpdateInput"]: GraphQLTypes["PhotographerWithoutLinkUpdateInput"];
	["PhotographerUpdateImageEntityRelationInput"]: GraphQLTypes["PhotographerUpdateImageEntityRelationInput"];
	["PhotographerUpsertImageRelationInput"]: GraphQLTypes["PhotographerUpsertImageRelationInput"];
	["PhotographerUpdateContentGroupsEntityRelationInput"]: GraphQLTypes["PhotographerUpdateContentGroupsEntityRelationInput"];
	["PhotographerUpdateContentGroupsRelationInput"]: GraphQLTypes["PhotographerUpdateContentGroupsRelationInput"];
	["PhotographerContentGroupWithoutPhotographerUpdateInput"]: GraphQLTypes["PhotographerContentGroupWithoutPhotographerUpdateInput"];
	["PhotographerContentGroupUpdateContentGroupEntityRelationInput"]: GraphQLTypes["PhotographerContentGroupUpdateContentGroupEntityRelationInput"];
	["PhotographerContentGroupUpsertContentGroupRelationInput"]: GraphQLTypes["PhotographerContentGroupUpsertContentGroupRelationInput"];
	["PhotographerUpsertContentGroupsRelationInput"]: GraphQLTypes["PhotographerUpsertContentGroupsRelationInput"];
	["PhotographerUpdatePhotographerLocationEntityRelationInput"]: GraphQLTypes["PhotographerUpdatePhotographerLocationEntityRelationInput"];
	["PhotographerLocationWithoutPhotographerUpdateInput"]: GraphQLTypes["PhotographerLocationWithoutPhotographerUpdateInput"];
	["PhotographerUpsertPhotographerLocationRelationInput"]: GraphQLTypes["PhotographerUpsertPhotographerLocationRelationInput"];
	["LinkableUpsertPhotographerRelationInput"]: GraphQLTypes["LinkableUpsertPhotographerRelationInput"];
	["LinkableUpdatePhotographersPageEntityRelationInput"]: GraphQLTypes["LinkableUpdatePhotographersPageEntityRelationInput"];
	["PhotographersPageWithoutLinkUpdateInput"]: GraphQLTypes["PhotographersPageWithoutLinkUpdateInput"];
	["PhotographersPageUpdateSeoEntityRelationInput"]: GraphQLTypes["PhotographersPageUpdateSeoEntityRelationInput"];
	["PhotographersPageUpsertSeoRelationInput"]: GraphQLTypes["PhotographersPageUpsertSeoRelationInput"];
	["PhotographersPageUpdateContentGroupsEntityRelationInput"]: GraphQLTypes["PhotographersPageUpdateContentGroupsEntityRelationInput"];
	["PhotographersPageUpdateContentGroupsRelationInput"]: GraphQLTypes["PhotographersPageUpdateContentGroupsRelationInput"];
	["PhotographersPageContentGroupWithoutPhotographersPageUpdateInput"]: GraphQLTypes["PhotographersPageContentGroupWithoutPhotographersPageUpdateInput"];
	["PhotographersPageContentGroupUpdateContentGroupEntityRelationInput"]: GraphQLTypes["PhotographersPageContentGroupUpdateContentGroupEntityRelationInput"];
	["PhotographersPageContentGroupUpsertContentGroupRelationInput"]: GraphQLTypes["PhotographersPageContentGroupUpsertContentGroupRelationInput"];
	["PhotographersPageUpsertContentGroupsRelationInput"]: GraphQLTypes["PhotographersPageUpsertContentGroupsRelationInput"];
	["LinkableUpsertPhotographersPageRelationInput"]: GraphQLTypes["LinkableUpsertPhotographersPageRelationInput"];
	["LinkableUpdateOurWorkPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateOurWorkPageEntityRelationInput"];
	["OurWorkPageWithoutLinkUpdateInput"]: GraphQLTypes["OurWorkPageWithoutLinkUpdateInput"];
	["OurWorkPageUpdateContentGroupsEntityRelationInput"]: GraphQLTypes["OurWorkPageUpdateContentGroupsEntityRelationInput"];
	["OurWorkPageUpdateContentGroupsRelationInput"]: GraphQLTypes["OurWorkPageUpdateContentGroupsRelationInput"];
	["OurWorkPageContentGroupWithoutOurWorkPageUpdateInput"]: GraphQLTypes["OurWorkPageContentGroupWithoutOurWorkPageUpdateInput"];
	["OurWorkPageContentGroupUpdateContentGroupEntityRelationInput"]: GraphQLTypes["OurWorkPageContentGroupUpdateContentGroupEntityRelationInput"];
	["OurWorkPageContentGroupUpsertContentGroupRelationInput"]: GraphQLTypes["OurWorkPageContentGroupUpsertContentGroupRelationInput"];
	["OurWorkPageUpsertContentGroupsRelationInput"]: GraphQLTypes["OurWorkPageUpsertContentGroupsRelationInput"];
	["OurWorkPageUpdateSeoEntityRelationInput"]: GraphQLTypes["OurWorkPageUpdateSeoEntityRelationInput"];
	["OurWorkPageUpsertSeoRelationInput"]: GraphQLTypes["OurWorkPageUpsertSeoRelationInput"];
	["LinkableUpsertOurWorkPageRelationInput"]: GraphQLTypes["LinkableUpsertOurWorkPageRelationInput"];
	["LinkableUpdateTabletopPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateTabletopPageEntityRelationInput"];
	["TabletopPageWithoutLinkUpdateInput"]: GraphQLTypes["TabletopPageWithoutLinkUpdateInput"];
	["TabletopPageUpdateLogoEntityRelationInput"]: GraphQLTypes["TabletopPageUpdateLogoEntityRelationInput"];
	["TabletopPageUpsertLogoRelationInput"]: GraphQLTypes["TabletopPageUpsertLogoRelationInput"];
	["TabletopPageUpdateSeoEntityRelationInput"]: GraphQLTypes["TabletopPageUpdateSeoEntityRelationInput"];
	["TabletopPageUpsertSeoRelationInput"]: GraphQLTypes["TabletopPageUpsertSeoRelationInput"];
	["TabletopPageUpdateContentGroupsEntityRelationInput"]: GraphQLTypes["TabletopPageUpdateContentGroupsEntityRelationInput"];
	["TabletopPageUpdateContentGroupsRelationInput"]: GraphQLTypes["TabletopPageUpdateContentGroupsRelationInput"];
	["TabletopPageContentGroupWithoutTabletopPageUpdateInput"]: GraphQLTypes["TabletopPageContentGroupWithoutTabletopPageUpdateInput"];
	["TabletopPageContentGroupUpdateContentGroupEntityRelationInput"]: GraphQLTypes["TabletopPageContentGroupUpdateContentGroupEntityRelationInput"];
	["TabletopPageContentGroupUpsertContentGroupRelationInput"]: GraphQLTypes["TabletopPageContentGroupUpsertContentGroupRelationInput"];
	["TabletopPageUpsertContentGroupsRelationInput"]: GraphQLTypes["TabletopPageUpsertContentGroupsRelationInput"];
	["LinkableUpsertTabletopPageRelationInput"]: GraphQLTypes["LinkableUpsertTabletopPageRelationInput"];
	["LinkUpsertInternalLinkRelationInput"]: GraphQLTypes["LinkUpsertInternalLinkRelationInput"];
	["ContentReferenceUpsertLinkRelationInput"]: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"];
	["ContentReferenceUpdateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"];
	["ContentReferenceUpsertImageRelationInput"]: GraphQLTypes["ContentReferenceUpsertImageRelationInput"];
	["ContentReferenceUpdateCardMediaEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateCardMediaEntityRelationInput"];
	["CardMediaUpdateInput"]: GraphQLTypes["CardMediaUpdateInput"];
	["CardMediaUpdateImageEntityRelationInput"]: GraphQLTypes["CardMediaUpdateImageEntityRelationInput"];
	["CardMediaUpsertImageRelationInput"]: GraphQLTypes["CardMediaUpsertImageRelationInput"];
	["ContentReferenceUpsertCardMediaRelationInput"]: GraphQLTypes["ContentReferenceUpsertCardMediaRelationInput"];
	["ContentBlockUpsertReferencesRelationInput"]: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"];
	["ContentUpsertBlocksRelationInput"]: GraphQLTypes["ContentUpsertBlocksRelationInput"];
	["ContentBlockCreateInput"]: GraphQLTypes["ContentBlockCreateInput"];
	["ContentBlockCreateContentEntityRelationInput"]: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"];
	["ContentWithoutBlocksCreateInput"]: GraphQLTypes["ContentWithoutBlocksCreateInput"];
	["ContentBlockUpdateInput"]: GraphQLTypes["ContentBlockUpdateInput"];
	["ContentBlockUpdateContentEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"];
	["ContentWithoutBlocksUpdateInput"]: GraphQLTypes["ContentWithoutBlocksUpdateInput"];
	["ContentBlockUpsertContentRelationInput"]: GraphQLTypes["ContentBlockUpsertContentRelationInput"];
	["ContentReferenceCreateInput"]: GraphQLTypes["ContentReferenceCreateInput"];
	["ContentReferenceCreateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesCreateInput"]: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"];
	["ContentReferenceUpdateInput"]: GraphQLTypes["ContentReferenceUpdateInput"];
	["ContentReferenceUpdateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesUpdateInput"]: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"];
	["ContentReferenceUpsertBlockRelationInput"]: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"];
	["CardMediaConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["CardMediaEdge"][]
};
	["CardMediaEdge"]: {
		node:ModelTypes["CardMedia"]
};
	["FallbackSeo"]: {
		_meta?:ModelTypes["FallbackSeoMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	seo?:ModelTypes["Seo"]
};
	["FallbackSeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["FallbackSeoUniqueWhere"]: GraphQLTypes["FallbackSeoUniqueWhere"];
	["FallbackSeoWhere"]: GraphQLTypes["FallbackSeoWhere"];
	["FallbackSeoOrderBy"]: GraphQLTypes["FallbackSeoOrderBy"];
	["FallbackSeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FallbackSeoEdge"][]
};
	["FallbackSeoEdge"]: {
		node:ModelTypes["FallbackSeo"]
};
	["FallbackSeoCreateInput"]: GraphQLTypes["FallbackSeoCreateInput"];
	["FallbackSeoCreateSeoEntityRelationInput"]: GraphQLTypes["FallbackSeoCreateSeoEntityRelationInput"];
	["FallbackSeoUpdateInput"]: GraphQLTypes["FallbackSeoUpdateInput"];
	["FallbackSeoUpdateSeoEntityRelationInput"]: GraphQLTypes["FallbackSeoUpdateSeoEntityRelationInput"];
	["FallbackSeoUpsertSeoRelationInput"]: GraphQLTypes["FallbackSeoUpsertSeoRelationInput"];
	["Footer"]: {
		_meta?:ModelTypes["FooterMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	logo?:ModelTypes["Image"],
	socialLinks:ModelTypes["SocialLink"][],
	directorsText?:string,
	contactText?:string,
	directorsButton?:ModelTypes["Link"],
	contactButton?:ModelTypes["Link"],
	paginateSocialLinks:ModelTypes["SocialLinkConnection"]
};
	["FooterMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	socialLinks?:ModelTypes["FieldMeta"],
	directorsText?:ModelTypes["FieldMeta"],
	contactText?:ModelTypes["FieldMeta"],
	directorsButton?:ModelTypes["FieldMeta"],
	contactButton?:ModelTypes["FieldMeta"]
};
	["SocialLink"]: {
		_meta?:ModelTypes["SocialLinkMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["SocialLinkType"],
	order:number,
	link?:string,
	linkLabel?:string
};
	["SocialLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	linkLabel?:ModelTypes["FieldMeta"]
};
	["SocialLinkType"]: GraphQLTypes["SocialLinkType"];
	["SocialLinkWhere"]: GraphQLTypes["SocialLinkWhere"];
	["SocialLinkTypeCondition"]: GraphQLTypes["SocialLinkTypeCondition"];
	["SocialLinkOrderBy"]: GraphQLTypes["SocialLinkOrderBy"];
	["SocialLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialLinkEdge"][]
};
	["SocialLinkEdge"]: {
		node:ModelTypes["SocialLink"]
};
	["FooterUniqueWhere"]: GraphQLTypes["FooterUniqueWhere"];
	["FooterWhere"]: GraphQLTypes["FooterWhere"];
	["FooterOrderBy"]: GraphQLTypes["FooterOrderBy"];
	["FooterConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterEdge"][]
};
	["FooterEdge"]: {
		node:ModelTypes["Footer"]
};
	["FooterCreateInput"]: GraphQLTypes["FooterCreateInput"];
	["FooterCreateLogoEntityRelationInput"]: GraphQLTypes["FooterCreateLogoEntityRelationInput"];
	["FooterCreateSocialLinksEntityRelationInput"]: GraphQLTypes["FooterCreateSocialLinksEntityRelationInput"];
	["SocialLinkUniqueWhere"]: GraphQLTypes["SocialLinkUniqueWhere"];
	["SocialLinkCreateInput"]: GraphQLTypes["SocialLinkCreateInput"];
	["FooterCreateDirectorsButtonEntityRelationInput"]: GraphQLTypes["FooterCreateDirectorsButtonEntityRelationInput"];
	["FooterCreateContactButtonEntityRelationInput"]: GraphQLTypes["FooterCreateContactButtonEntityRelationInput"];
	["FooterUpdateInput"]: GraphQLTypes["FooterUpdateInput"];
	["FooterUpdateLogoEntityRelationInput"]: GraphQLTypes["FooterUpdateLogoEntityRelationInput"];
	["FooterUpsertLogoRelationInput"]: GraphQLTypes["FooterUpsertLogoRelationInput"];
	["FooterUpdateSocialLinksEntityRelationInput"]: GraphQLTypes["FooterUpdateSocialLinksEntityRelationInput"];
	["FooterUpdateSocialLinksRelationInput"]: GraphQLTypes["FooterUpdateSocialLinksRelationInput"];
	["SocialLinkUpdateInput"]: GraphQLTypes["SocialLinkUpdateInput"];
	["FooterUpsertSocialLinksRelationInput"]: GraphQLTypes["FooterUpsertSocialLinksRelationInput"];
	["FooterUpdateDirectorsButtonEntityRelationInput"]: GraphQLTypes["FooterUpdateDirectorsButtonEntityRelationInput"];
	["FooterUpsertDirectorsButtonRelationInput"]: GraphQLTypes["FooterUpsertDirectorsButtonRelationInput"];
	["FooterUpdateContactButtonEntityRelationInput"]: GraphQLTypes["FooterUpdateContactButtonEntityRelationInput"];
	["FooterUpsertContactButtonRelationInput"]: GraphQLTypes["FooterUpsertContactButtonRelationInput"];
	["GalleryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GalleryEdge"][]
};
	["GalleryEdge"]: {
		node:ModelTypes["Gallery"]
};
	["GalleryItemCreateInput"]: GraphQLTypes["GalleryItemCreateInput"];
	["GalleryItemCreateListEntityRelationInput"]: GraphQLTypes["GalleryItemCreateListEntityRelationInput"];
	["GalleryWithoutItemsCreateInput"]: GraphQLTypes["GalleryWithoutItemsCreateInput"];
	["GalleryItemUpdateInput"]: GraphQLTypes["GalleryItemUpdateInput"];
	["GalleryItemUpdateListEntityRelationInput"]: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"];
	["GalleryWithoutItemsUpdateInput"]: GraphQLTypes["GalleryWithoutItemsUpdateInput"];
	["GalleryItemUpsertListRelationInput"]: GraphQLTypes["GalleryItemUpsertListRelationInput"];
	["Header"]: {
		_meta?:ModelTypes["HeaderMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	logo?:ModelTypes["Image"],
	links:ModelTypes["HeaderLink"][],
	paginateLinks:ModelTypes["HeaderLinkConnection"]
};
	["HeaderMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	links?:ModelTypes["FieldMeta"]
};
	["HeaderLink"]: {
		_meta?:ModelTypes["HeaderLinkMeta"],
	id:ModelTypes["UUID"],
	order:number,
	link?:ModelTypes["Link"]
};
	["HeaderLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["HeaderLinkWhere"]: GraphQLTypes["HeaderLinkWhere"];
	["HeaderLinkOrderBy"]: GraphQLTypes["HeaderLinkOrderBy"];
	["HeaderLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderLinkEdge"][]
};
	["HeaderLinkEdge"]: {
		node:ModelTypes["HeaderLink"]
};
	["HeaderUniqueWhere"]: GraphQLTypes["HeaderUniqueWhere"];
	["HeaderWhere"]: GraphQLTypes["HeaderWhere"];
	["HeaderOrderBy"]: GraphQLTypes["HeaderOrderBy"];
	["HeaderConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderEdge"][]
};
	["HeaderEdge"]: {
		node:ModelTypes["Header"]
};
	["HeaderCreateInput"]: GraphQLTypes["HeaderCreateInput"];
	["HeaderCreateLogoEntityRelationInput"]: GraphQLTypes["HeaderCreateLogoEntityRelationInput"];
	["HeaderCreateLinksEntityRelationInput"]: GraphQLTypes["HeaderCreateLinksEntityRelationInput"];
	["HeaderLinkUniqueWhere"]: GraphQLTypes["HeaderLinkUniqueWhere"];
	["HeaderLinkCreateInput"]: GraphQLTypes["HeaderLinkCreateInput"];
	["HeaderLinkCreateLinkEntityRelationInput"]: GraphQLTypes["HeaderLinkCreateLinkEntityRelationInput"];
	["HeaderUpdateInput"]: GraphQLTypes["HeaderUpdateInput"];
	["HeaderUpdateLogoEntityRelationInput"]: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"];
	["HeaderUpsertLogoRelationInput"]: GraphQLTypes["HeaderUpsertLogoRelationInput"];
	["HeaderUpdateLinksEntityRelationInput"]: GraphQLTypes["HeaderUpdateLinksEntityRelationInput"];
	["HeaderUpdateLinksRelationInput"]: GraphQLTypes["HeaderUpdateLinksRelationInput"];
	["HeaderLinkUpdateInput"]: GraphQLTypes["HeaderLinkUpdateInput"];
	["HeaderLinkUpdateLinkEntityRelationInput"]: GraphQLTypes["HeaderLinkUpdateLinkEntityRelationInput"];
	["HeaderLinkUpsertLinkRelationInput"]: GraphQLTypes["HeaderLinkUpsertLinkRelationInput"];
	["HeaderUpsertLinksRelationInput"]: GraphQLTypes["HeaderUpsertLinksRelationInput"];
	["HomePageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HomePageEdge"][]
};
	["HomePageEdge"]: {
		node:ModelTypes["HomePage"]
};
	["HomePageCreateInput"]: GraphQLTypes["HomePageCreateInput"];
	["HomePageCreateLinkEntityRelationInput"]: GraphQLTypes["HomePageCreateLinkEntityRelationInput"];
	["LinkableWithoutHomePageCreateInput"]: GraphQLTypes["LinkableWithoutHomePageCreateInput"];
	["HomePageUpdateInput"]: GraphQLTypes["HomePageUpdateInput"];
	["HomePageUpdateLinkEntityRelationInput"]: GraphQLTypes["HomePageUpdateLinkEntityRelationInput"];
	["LinkableWithoutHomePageUpdateInput"]: GraphQLTypes["LinkableWithoutHomePageUpdateInput"];
	["HomePageUpsertLinkRelationInput"]: GraphQLTypes["HomePageUpsertLinkRelationInput"];
	["ImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageEdge"][]
};
	["ImageEdge"]: {
		node:ModelTypes["Image"]
};
	["LinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkEdge"][]
};
	["LinkEdge"]: {
		node:ModelTypes["Link"]
};
	["LinkableConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkableEdge"][]
};
	["LinkableEdge"]: {
		node:ModelTypes["Linkable"]
};
	["RedirectConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RedirectEdge"][]
};
	["RedirectEdge"]: {
		node:ModelTypes["Redirect"]
};
	["RedirectCreateInput"]: GraphQLTypes["RedirectCreateInput"];
	["RedirectCreateLinkEntityRelationInput"]: GraphQLTypes["RedirectCreateLinkEntityRelationInput"];
	["LinkableWithoutRedirectCreateInput"]: GraphQLTypes["LinkableWithoutRedirectCreateInput"];
	["RedirectUpdateInput"]: GraphQLTypes["RedirectUpdateInput"];
	["RedirectUpdateLinkEntityRelationInput"]: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"];
	["LinkableWithoutRedirectUpdateInput"]: GraphQLTypes["LinkableWithoutRedirectUpdateInput"];
	["RedirectUpsertLinkRelationInput"]: GraphQLTypes["RedirectUpsertLinkRelationInput"];
	["SeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoEdge"][]
};
	["SeoEdge"]: {
		node:ModelTypes["Seo"]
};
	["ContactLocationConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactLocationEdge"][]
};
	["ContactLocationEdge"]: {
		node:ModelTypes["ContactLocation"]
};
	["ContactLocationCreateInput"]: GraphQLTypes["ContactLocationCreateInput"];
	["ContactLocationCreateContactEntityRelationInput"]: GraphQLTypes["ContactLocationCreateContactEntityRelationInput"];
	["ContactWithoutContactLocationCreateInput"]: GraphQLTypes["ContactWithoutContactLocationCreateInput"];
	["ContactLocationUpdateInput"]: GraphQLTypes["ContactLocationUpdateInput"];
	["ContactLocationUpdateContactEntityRelationInput"]: GraphQLTypes["ContactLocationUpdateContactEntityRelationInput"];
	["ContactLocationUpdateContactRelationInput"]: GraphQLTypes["ContactLocationUpdateContactRelationInput"];
	["ContactWithoutContactLocationUpdateInput"]: GraphQLTypes["ContactWithoutContactLocationUpdateInput"];
	["ContactLocationUpsertContactRelationInput"]: GraphQLTypes["ContactLocationUpsertContactRelationInput"];
	["DirectorCreateInput"]: GraphQLTypes["DirectorCreateInput"];
	["DirectorCreateLinkEntityRelationInput"]: GraphQLTypes["DirectorCreateLinkEntityRelationInput"];
	["LinkableWithoutDirectorCreateInput"]: GraphQLTypes["LinkableWithoutDirectorCreateInput"];
	["DirectorUpdateInput"]: GraphQLTypes["DirectorUpdateInput"];
	["DirectorUpdateLinkEntityRelationInput"]: GraphQLTypes["DirectorUpdateLinkEntityRelationInput"];
	["LinkableWithoutDirectorUpdateInput"]: GraphQLTypes["LinkableWithoutDirectorUpdateInput"];
	["DirectorUpsertLinkRelationInput"]: GraphQLTypes["DirectorUpsertLinkRelationInput"];
	["FilmConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FilmEdge"][]
};
	["FilmEdge"]: {
		node:ModelTypes["Film"]
};
	["DirectorLocationConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DirectorLocationEdge"][]
};
	["DirectorLocationEdge"]: {
		node:ModelTypes["DirectorLocation"]
};
	["DirectorLocationCreateInput"]: GraphQLTypes["DirectorLocationCreateInput"];
	["DirectorLocationCreateDirectorEntityRelationInput"]: GraphQLTypes["DirectorLocationCreateDirectorEntityRelationInput"];
	["DirectorWithoutDirectorLocationCreateInput"]: GraphQLTypes["DirectorWithoutDirectorLocationCreateInput"];
	["DirectorLocationUpdateInput"]: GraphQLTypes["DirectorLocationUpdateInput"];
	["DirectorLocationUpdateDirectorEntityRelationInput"]: GraphQLTypes["DirectorLocationUpdateDirectorEntityRelationInput"];
	["DirectorLocationUpdateDirectorRelationInput"]: GraphQLTypes["DirectorLocationUpdateDirectorRelationInput"];
	["DirectorWithoutDirectorLocationUpdateInput"]: GraphQLTypes["DirectorWithoutDirectorLocationUpdateInput"];
	["DirectorLocationUpsertDirectorRelationInput"]: GraphQLTypes["DirectorLocationUpsertDirectorRelationInput"];
	["ContactsPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactsPageEdge"][]
};
	["ContactsPageEdge"]: {
		node:ModelTypes["ContactsPage"]
};
	["ContactsPageCreateInput"]: GraphQLTypes["ContactsPageCreateInput"];
	["ContactsPageCreateLinkEntityRelationInput"]: GraphQLTypes["ContactsPageCreateLinkEntityRelationInput"];
	["LinkableWithoutContactsPageCreateInput"]: GraphQLTypes["LinkableWithoutContactsPageCreateInput"];
	["ContactsPageUpdateInput"]: GraphQLTypes["ContactsPageUpdateInput"];
	["ContactsPageUpdateLinkEntityRelationInput"]: GraphQLTypes["ContactsPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutContactsPageUpdateInput"]: GraphQLTypes["LinkableWithoutContactsPageUpdateInput"];
	["ContactsPageUpsertLinkRelationInput"]: GraphQLTypes["ContactsPageUpsertLinkRelationInput"];
	["DirectorsPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DirectorsPageEdge"][]
};
	["DirectorsPageEdge"]: {
		node:ModelTypes["DirectorsPage"]
};
	["DirectorsPageCreateInput"]: GraphQLTypes["DirectorsPageCreateInput"];
	["DirectorsPageCreateLinkEntityRelationInput"]: GraphQLTypes["DirectorsPageCreateLinkEntityRelationInput"];
	["LinkableWithoutDirectorsPageCreateInput"]: GraphQLTypes["LinkableWithoutDirectorsPageCreateInput"];
	["DirectorsPageUpdateInput"]: GraphQLTypes["DirectorsPageUpdateInput"];
	["DirectorsPageUpdateLinkEntityRelationInput"]: GraphQLTypes["DirectorsPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutDirectorsPageUpdateInput"]: GraphQLTypes["LinkableWithoutDirectorsPageUpdateInput"];
	["DirectorsPageUpsertLinkRelationInput"]: GraphQLTypes["DirectorsPageUpsertLinkRelationInput"];
	["FilmItemCreateInput"]: GraphQLTypes["FilmItemCreateInput"];
	["FilmItemCreateContentGroupsEntityRelationInput"]: GraphQLTypes["FilmItemCreateContentGroupsEntityRelationInput"];
	["ContentGroupWithoutFilmsCreateInput"]: GraphQLTypes["ContentGroupWithoutFilmsCreateInput"];
	["FilmItemUpdateInput"]: GraphQLTypes["FilmItemUpdateInput"];
	["FilmItemUpdateContentGroupsEntityRelationInput"]: GraphQLTypes["FilmItemUpdateContentGroupsEntityRelationInput"];
	["ContentGroupWithoutFilmsUpdateInput"]: GraphQLTypes["ContentGroupWithoutFilmsUpdateInput"];
	["FilmItemUpsertContentGroupsRelationInput"]: GraphQLTypes["FilmItemUpsertContentGroupsRelationInput"];
	["DirectorContentGroupCreateInput"]: GraphQLTypes["DirectorContentGroupCreateInput"];
	["DirectorContentGroupCreateDirectorEntityRelationInput"]: GraphQLTypes["DirectorContentGroupCreateDirectorEntityRelationInput"];
	["DirectorWithoutContentGroupsCreateInput"]: GraphQLTypes["DirectorWithoutContentGroupsCreateInput"];
	["DirectorContentGroupUpdateInput"]: GraphQLTypes["DirectorContentGroupUpdateInput"];
	["DirectorContentGroupUpdateDirectorEntityRelationInput"]: GraphQLTypes["DirectorContentGroupUpdateDirectorEntityRelationInput"];
	["DirectorWithoutContentGroupsUpdateInput"]: GraphQLTypes["DirectorWithoutContentGroupsUpdateInput"];
	["DirectorContentGroupUpsertDirectorRelationInput"]: GraphQLTypes["DirectorContentGroupUpsertDirectorRelationInput"];
	["PhotographerCreateInput"]: GraphQLTypes["PhotographerCreateInput"];
	["PhotographerCreateLinkEntityRelationInput"]: GraphQLTypes["PhotographerCreateLinkEntityRelationInput"];
	["LinkableWithoutPhotographerCreateInput"]: GraphQLTypes["LinkableWithoutPhotographerCreateInput"];
	["PhotographerUpdateInput"]: GraphQLTypes["PhotographerUpdateInput"];
	["PhotographerUpdateLinkEntityRelationInput"]: GraphQLTypes["PhotographerUpdateLinkEntityRelationInput"];
	["LinkableWithoutPhotographerUpdateInput"]: GraphQLTypes["LinkableWithoutPhotographerUpdateInput"];
	["PhotographerUpsertLinkRelationInput"]: GraphQLTypes["PhotographerUpsertLinkRelationInput"];
	["PhotographerContentGroupCreateInput"]: GraphQLTypes["PhotographerContentGroupCreateInput"];
	["PhotographerContentGroupCreatePhotographerEntityRelationInput"]: GraphQLTypes["PhotographerContentGroupCreatePhotographerEntityRelationInput"];
	["PhotographerWithoutContentGroupsCreateInput"]: GraphQLTypes["PhotographerWithoutContentGroupsCreateInput"];
	["PhotographerContentGroupUpdateInput"]: GraphQLTypes["PhotographerContentGroupUpdateInput"];
	["PhotographerContentGroupUpdatePhotographerEntityRelationInput"]: GraphQLTypes["PhotographerContentGroupUpdatePhotographerEntityRelationInput"];
	["PhotographerWithoutContentGroupsUpdateInput"]: GraphQLTypes["PhotographerWithoutContentGroupsUpdateInput"];
	["PhotographerContentGroupUpsertPhotographerRelationInput"]: GraphQLTypes["PhotographerContentGroupUpsertPhotographerRelationInput"];
	["PhotographerLocationConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PhotographerLocationEdge"][]
};
	["PhotographerLocationEdge"]: {
		node:ModelTypes["PhotographerLocation"]
};
	["PhotographerLocationCreateInput"]: GraphQLTypes["PhotographerLocationCreateInput"];
	["PhotographerLocationCreatePhotographerEntityRelationInput"]: GraphQLTypes["PhotographerLocationCreatePhotographerEntityRelationInput"];
	["PhotographerWithoutPhotographerLocationCreateInput"]: GraphQLTypes["PhotographerWithoutPhotographerLocationCreateInput"];
	["PhotographerLocationUpdateInput"]: GraphQLTypes["PhotographerLocationUpdateInput"];
	["PhotographerLocationUpdatePhotographerEntityRelationInput"]: GraphQLTypes["PhotographerLocationUpdatePhotographerEntityRelationInput"];
	["PhotographerLocationUpdatePhotographerRelationInput"]: GraphQLTypes["PhotographerLocationUpdatePhotographerRelationInput"];
	["PhotographerWithoutPhotographerLocationUpdateInput"]: GraphQLTypes["PhotographerWithoutPhotographerLocationUpdateInput"];
	["PhotographerLocationUpsertPhotographerRelationInput"]: GraphQLTypes["PhotographerLocationUpsertPhotographerRelationInput"];
	["PhotographersPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PhotographersPageEdge"][]
};
	["PhotographersPageEdge"]: {
		node:ModelTypes["PhotographersPage"]
};
	["PhotographersPageCreateInput"]: GraphQLTypes["PhotographersPageCreateInput"];
	["PhotographersPageCreateLinkEntityRelationInput"]: GraphQLTypes["PhotographersPageCreateLinkEntityRelationInput"];
	["LinkableWithoutPhotographersPageCreateInput"]: GraphQLTypes["LinkableWithoutPhotographersPageCreateInput"];
	["PhotographersPageUpdateInput"]: GraphQLTypes["PhotographersPageUpdateInput"];
	["PhotographersPageUpdateLinkEntityRelationInput"]: GraphQLTypes["PhotographersPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutPhotographersPageUpdateInput"]: GraphQLTypes["LinkableWithoutPhotographersPageUpdateInput"];
	["PhotographersPageUpsertLinkRelationInput"]: GraphQLTypes["PhotographersPageUpsertLinkRelationInput"];
	["OurWorkPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["OurWorkPageEdge"][]
};
	["OurWorkPageEdge"]: {
		node:ModelTypes["OurWorkPage"]
};
	["OurWorkPageCreateInput"]: GraphQLTypes["OurWorkPageCreateInput"];
	["OurWorkPageCreateLinkEntityRelationInput"]: GraphQLTypes["OurWorkPageCreateLinkEntityRelationInput"];
	["LinkableWithoutOurWorkPageCreateInput"]: GraphQLTypes["LinkableWithoutOurWorkPageCreateInput"];
	["OurWorkPageUpdateInput"]: GraphQLTypes["OurWorkPageUpdateInput"];
	["OurWorkPageUpdateLinkEntityRelationInput"]: GraphQLTypes["OurWorkPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutOurWorkPageUpdateInput"]: GraphQLTypes["LinkableWithoutOurWorkPageUpdateInput"];
	["OurWorkPageUpsertLinkRelationInput"]: GraphQLTypes["OurWorkPageUpsertLinkRelationInput"];
	["OurWorkPageContentGroupCreateInput"]: GraphQLTypes["OurWorkPageContentGroupCreateInput"];
	["OurWorkPageContentGroupCreateOurWorkPageEntityRelationInput"]: GraphQLTypes["OurWorkPageContentGroupCreateOurWorkPageEntityRelationInput"];
	["OurWorkPageWithoutContentGroupsCreateInput"]: GraphQLTypes["OurWorkPageWithoutContentGroupsCreateInput"];
	["OurWorkPageContentGroupUpdateInput"]: GraphQLTypes["OurWorkPageContentGroupUpdateInput"];
	["OurWorkPageContentGroupUpdateOurWorkPageEntityRelationInput"]: GraphQLTypes["OurWorkPageContentGroupUpdateOurWorkPageEntityRelationInput"];
	["OurWorkPageWithoutContentGroupsUpdateInput"]: GraphQLTypes["OurWorkPageWithoutContentGroupsUpdateInput"];
	["OurWorkPageContentGroupUpsertOurWorkPageRelationInput"]: GraphQLTypes["OurWorkPageContentGroupUpsertOurWorkPageRelationInput"];
	["ContentGroupConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentGroupEdge"][]
};
	["ContentGroupEdge"]: {
		node:ModelTypes["ContentGroup"]
};
	["HomePageContentGroupCreateInput"]: GraphQLTypes["HomePageContentGroupCreateInput"];
	["HomePageContentGroupCreateHomePageEntityRelationInput"]: GraphQLTypes["HomePageContentGroupCreateHomePageEntityRelationInput"];
	["HomePageWithoutContentGroupsCreateInput"]: GraphQLTypes["HomePageWithoutContentGroupsCreateInput"];
	["HomePageContentGroupUpdateInput"]: GraphQLTypes["HomePageContentGroupUpdateInput"];
	["HomePageContentGroupUpdateHomePageEntityRelationInput"]: GraphQLTypes["HomePageContentGroupUpdateHomePageEntityRelationInput"];
	["HomePageWithoutContentGroupsUpdateInput"]: GraphQLTypes["HomePageWithoutContentGroupsUpdateInput"];
	["HomePageContentGroupUpsertHomePageRelationInput"]: GraphQLTypes["HomePageContentGroupUpsertHomePageRelationInput"];
	["TabletopPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TabletopPageEdge"][]
};
	["TabletopPageEdge"]: {
		node:ModelTypes["TabletopPage"]
};
	["TabletopPageCreateInput"]: GraphQLTypes["TabletopPageCreateInput"];
	["TabletopPageCreateLinkEntityRelationInput"]: GraphQLTypes["TabletopPageCreateLinkEntityRelationInput"];
	["LinkableWithoutTabletopPageCreateInput"]: GraphQLTypes["LinkableWithoutTabletopPageCreateInput"];
	["TabletopPageUpdateInput"]: GraphQLTypes["TabletopPageUpdateInput"];
	["TabletopPageUpdateLinkEntityRelationInput"]: GraphQLTypes["TabletopPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutTabletopPageUpdateInput"]: GraphQLTypes["LinkableWithoutTabletopPageUpdateInput"];
	["TabletopPageUpsertLinkRelationInput"]: GraphQLTypes["TabletopPageUpsertLinkRelationInput"];
	["TabletopPageContentGroupCreateInput"]: GraphQLTypes["TabletopPageContentGroupCreateInput"];
	["TabletopPageContentGroupCreateTabletopPageEntityRelationInput"]: GraphQLTypes["TabletopPageContentGroupCreateTabletopPageEntityRelationInput"];
	["TabletopPageWithoutContentGroupsCreateInput"]: GraphQLTypes["TabletopPageWithoutContentGroupsCreateInput"];
	["TabletopPageContentGroupUpdateInput"]: GraphQLTypes["TabletopPageContentGroupUpdateInput"];
	["TabletopPageContentGroupUpdateTabletopPageEntityRelationInput"]: GraphQLTypes["TabletopPageContentGroupUpdateTabletopPageEntityRelationInput"];
	["TabletopPageWithoutContentGroupsUpdateInput"]: GraphQLTypes["TabletopPageWithoutContentGroupsUpdateInput"];
	["TabletopPageContentGroupUpsertTabletopPageRelationInput"]: GraphQLTypes["TabletopPageContentGroupUpsertTabletopPageRelationInput"];
	["PhotographersPageContentGroupCreateInput"]: GraphQLTypes["PhotographersPageContentGroupCreateInput"];
	["PhotographersPageContentGroupCreatePhotographersPageEntityRelationInput"]: GraphQLTypes["PhotographersPageContentGroupCreatePhotographersPageEntityRelationInput"];
	["PhotographersPageWithoutContentGroupsCreateInput"]: GraphQLTypes["PhotographersPageWithoutContentGroupsCreateInput"];
	["PhotographersPageContentGroupUpdateInput"]: GraphQLTypes["PhotographersPageContentGroupUpdateInput"];
	["PhotographersPageContentGroupUpdatePhotographersPageEntityRelationInput"]: GraphQLTypes["PhotographersPageContentGroupUpdatePhotographersPageEntityRelationInput"];
	["PhotographersPageWithoutContentGroupsUpdateInput"]: GraphQLTypes["PhotographersPageWithoutContentGroupsUpdateInput"];
	["PhotographersPageContentGroupUpsertPhotographersPageRelationInput"]: GraphQLTypes["PhotographersPageContentGroupUpsertPhotographersPageRelationInput"];
	["QueryTransaction"]: {
		getContact?:ModelTypes["Contact"],
	listContact:ModelTypes["Contact"][],
	paginateContact:ModelTypes["ContactConnection"],
	validateCreateContact:ModelTypes["_ValidationResult"],
	validateUpdateContact:ModelTypes["_ValidationResult"],
	getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getCardMedia?:ModelTypes["CardMedia"],
	listCardMedia:ModelTypes["CardMedia"][],
	paginateCardMedia:ModelTypes["CardMediaConnection"],
	validateCreateCardMedia:ModelTypes["_ValidationResult"],
	validateUpdateCardMedia:ModelTypes["_ValidationResult"],
	getFallbackSeo?:ModelTypes["FallbackSeo"],
	listFallbackSeo:ModelTypes["FallbackSeo"][],
	paginateFallbackSeo:ModelTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo:ModelTypes["_ValidationResult"],
	validateUpdateFallbackSeo:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getSocialLink?:ModelTypes["SocialLink"],
	listSocialLink:ModelTypes["SocialLink"][],
	paginateSocialLink:ModelTypes["SocialLinkConnection"],
	validateCreateSocialLink:ModelTypes["_ValidationResult"],
	validateUpdateSocialLink:ModelTypes["_ValidationResult"],
	getGallery?:ModelTypes["Gallery"],
	listGallery:ModelTypes["Gallery"][],
	paginateGallery:ModelTypes["GalleryConnection"],
	validateCreateGallery:ModelTypes["_ValidationResult"],
	validateUpdateGallery:ModelTypes["_ValidationResult"],
	getGalleryItem?:ModelTypes["GalleryItem"],
	listGalleryItem:ModelTypes["GalleryItem"][],
	paginateGalleryItem:ModelTypes["GalleryItemConnection"],
	validateCreateGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateGalleryItem:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getHeaderLink?:ModelTypes["HeaderLink"],
	listHeaderLink:ModelTypes["HeaderLink"][],
	paginateHeaderLink:ModelTypes["HeaderLinkConnection"],
	validateCreateHeaderLink:ModelTypes["_ValidationResult"],
	validateUpdateHeaderLink:ModelTypes["_ValidationResult"],
	getHomePage?:ModelTypes["HomePage"],
	listHomePage:ModelTypes["HomePage"][],
	paginateHomePage:ModelTypes["HomePageConnection"],
	validateCreateHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHomePage:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getContactLocation?:ModelTypes["ContactLocation"],
	listContactLocation:ModelTypes["ContactLocation"][],
	paginateContactLocation:ModelTypes["ContactLocationConnection"],
	validateCreateContactLocation:ModelTypes["_ValidationResult"],
	validateUpdateContactLocation:ModelTypes["_ValidationResult"],
	getDirector?:ModelTypes["Director"],
	listDirector:ModelTypes["Director"][],
	paginateDirector:ModelTypes["DirectorConnection"],
	validateCreateDirector:ModelTypes["_ValidationResult"],
	validateUpdateDirector:ModelTypes["_ValidationResult"],
	getFilm?:ModelTypes["Film"],
	listFilm:ModelTypes["Film"][],
	paginateFilm:ModelTypes["FilmConnection"],
	validateCreateFilm:ModelTypes["_ValidationResult"],
	validateUpdateFilm:ModelTypes["_ValidationResult"],
	getDirectorLocation?:ModelTypes["DirectorLocation"],
	listDirectorLocation:ModelTypes["DirectorLocation"][],
	paginateDirectorLocation:ModelTypes["DirectorLocationConnection"],
	validateCreateDirectorLocation:ModelTypes["_ValidationResult"],
	validateUpdateDirectorLocation:ModelTypes["_ValidationResult"],
	getContactsPage?:ModelTypes["ContactsPage"],
	listContactsPage:ModelTypes["ContactsPage"][],
	paginateContactsPage:ModelTypes["ContactsPageConnection"],
	validateCreateContactsPage:ModelTypes["_ValidationResult"],
	validateUpdateContactsPage:ModelTypes["_ValidationResult"],
	getDirectorsPage?:ModelTypes["DirectorsPage"],
	listDirectorsPage:ModelTypes["DirectorsPage"][],
	paginateDirectorsPage:ModelTypes["DirectorsPageConnection"],
	validateCreateDirectorsPage:ModelTypes["_ValidationResult"],
	validateUpdateDirectorsPage:ModelTypes["_ValidationResult"],
	getFilmItem?:ModelTypes["FilmItem"],
	listFilmItem:ModelTypes["FilmItem"][],
	paginateFilmItem:ModelTypes["FilmItemConnection"],
	validateCreateFilmItem:ModelTypes["_ValidationResult"],
	validateUpdateFilmItem:ModelTypes["_ValidationResult"],
	getDirectorContentGroup?:ModelTypes["DirectorContentGroup"],
	listDirectorContentGroup:ModelTypes["DirectorContentGroup"][],
	paginateDirectorContentGroup:ModelTypes["DirectorContentGroupConnection"],
	validateCreateDirectorContentGroup:ModelTypes["_ValidationResult"],
	validateUpdateDirectorContentGroup:ModelTypes["_ValidationResult"],
	getPhotographer?:ModelTypes["Photographer"],
	listPhotographer:ModelTypes["Photographer"][],
	paginatePhotographer:ModelTypes["PhotographerConnection"],
	validateCreatePhotographer:ModelTypes["_ValidationResult"],
	validateUpdatePhotographer:ModelTypes["_ValidationResult"],
	getPhotographerContentGroup?:ModelTypes["PhotographerContentGroup"],
	listPhotographerContentGroup:ModelTypes["PhotographerContentGroup"][],
	paginatePhotographerContentGroup:ModelTypes["PhotographerContentGroupConnection"],
	validateCreatePhotographerContentGroup:ModelTypes["_ValidationResult"],
	validateUpdatePhotographerContentGroup:ModelTypes["_ValidationResult"],
	getPhotographerLocation?:ModelTypes["PhotographerLocation"],
	listPhotographerLocation:ModelTypes["PhotographerLocation"][],
	paginatePhotographerLocation:ModelTypes["PhotographerLocationConnection"],
	validateCreatePhotographerLocation:ModelTypes["_ValidationResult"],
	validateUpdatePhotographerLocation:ModelTypes["_ValidationResult"],
	getPhotographersPage?:ModelTypes["PhotographersPage"],
	listPhotographersPage:ModelTypes["PhotographersPage"][],
	paginatePhotographersPage:ModelTypes["PhotographersPageConnection"],
	validateCreatePhotographersPage:ModelTypes["_ValidationResult"],
	validateUpdatePhotographersPage:ModelTypes["_ValidationResult"],
	getOurWorkPage?:ModelTypes["OurWorkPage"],
	listOurWorkPage:ModelTypes["OurWorkPage"][],
	paginateOurWorkPage:ModelTypes["OurWorkPageConnection"],
	validateCreateOurWorkPage:ModelTypes["_ValidationResult"],
	validateUpdateOurWorkPage:ModelTypes["_ValidationResult"],
	getOurWorkPageContentGroup?:ModelTypes["OurWorkPageContentGroup"],
	listOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroup"][],
	paginateOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroupConnection"],
	validateCreateOurWorkPageContentGroup:ModelTypes["_ValidationResult"],
	validateUpdateOurWorkPageContentGroup:ModelTypes["_ValidationResult"],
	getContentGroup?:ModelTypes["ContentGroup"],
	listContentGroup:ModelTypes["ContentGroup"][],
	paginateContentGroup:ModelTypes["ContentGroupConnection"],
	validateCreateContentGroup:ModelTypes["_ValidationResult"],
	validateUpdateContentGroup:ModelTypes["_ValidationResult"],
	getHomePageContentGroup?:ModelTypes["HomePageContentGroup"],
	listHomePageContentGroup:ModelTypes["HomePageContentGroup"][],
	paginateHomePageContentGroup:ModelTypes["HomePageContentGroupConnection"],
	validateCreateHomePageContentGroup:ModelTypes["_ValidationResult"],
	validateUpdateHomePageContentGroup:ModelTypes["_ValidationResult"],
	getTabletopPage?:ModelTypes["TabletopPage"],
	listTabletopPage:ModelTypes["TabletopPage"][],
	paginateTabletopPage:ModelTypes["TabletopPageConnection"],
	validateCreateTabletopPage:ModelTypes["_ValidationResult"],
	validateUpdateTabletopPage:ModelTypes["_ValidationResult"],
	getTabletopPageContentGroup?:ModelTypes["TabletopPageContentGroup"],
	listTabletopPageContentGroup:ModelTypes["TabletopPageContentGroup"][],
	paginateTabletopPageContentGroup:ModelTypes["TabletopPageContentGroupConnection"],
	validateCreateTabletopPageContentGroup:ModelTypes["_ValidationResult"],
	validateUpdateTabletopPageContentGroup:ModelTypes["_ValidationResult"],
	getPhotographersPageContentGroup?:ModelTypes["PhotographersPageContentGroup"],
	listPhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroup"][],
	paginatePhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroupConnection"],
	validateCreatePhotographersPageContentGroup:ModelTypes["_ValidationResult"],
	validateUpdatePhotographersPageContentGroup:ModelTypes["_ValidationResult"]
};
	["Info"]: {
		description?:string
};
	["Mutation"]: {
		createContact:ModelTypes["ContactCreateResult"],
	deleteContact:ModelTypes["ContactDeleteResult"],
	updateContact:ModelTypes["ContactUpdateResult"],
	upsertContact:ModelTypes["ContactUpsertResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createCardMedia:ModelTypes["CardMediaCreateResult"],
	deleteCardMedia:ModelTypes["CardMediaDeleteResult"],
	updateCardMedia:ModelTypes["CardMediaUpdateResult"],
	upsertCardMedia:ModelTypes["CardMediaUpsertResult"],
	createFallbackSeo:ModelTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo:ModelTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo:ModelTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo:ModelTypes["FallbackSeoUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createSocialLink:ModelTypes["SocialLinkCreateResult"],
	deleteSocialLink:ModelTypes["SocialLinkDeleteResult"],
	updateSocialLink:ModelTypes["SocialLinkUpdateResult"],
	upsertSocialLink:ModelTypes["SocialLinkUpsertResult"],
	createGallery:ModelTypes["GalleryCreateResult"],
	deleteGallery:ModelTypes["GalleryDeleteResult"],
	updateGallery:ModelTypes["GalleryUpdateResult"],
	upsertGallery:ModelTypes["GalleryUpsertResult"],
	createGalleryItem:ModelTypes["GalleryItemCreateResult"],
	deleteGalleryItem:ModelTypes["GalleryItemDeleteResult"],
	updateGalleryItem:ModelTypes["GalleryItemUpdateResult"],
	upsertGalleryItem:ModelTypes["GalleryItemUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createHeaderLink:ModelTypes["HeaderLinkCreateResult"],
	deleteHeaderLink:ModelTypes["HeaderLinkDeleteResult"],
	updateHeaderLink:ModelTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink:ModelTypes["HeaderLinkUpsertResult"],
	createHomePage:ModelTypes["HomePageCreateResult"],
	deleteHomePage:ModelTypes["HomePageDeleteResult"],
	updateHomePage:ModelTypes["HomePageUpdateResult"],
	upsertHomePage:ModelTypes["HomePageUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createContactLocation:ModelTypes["ContactLocationCreateResult"],
	deleteContactLocation:ModelTypes["ContactLocationDeleteResult"],
	updateContactLocation:ModelTypes["ContactLocationUpdateResult"],
	upsertContactLocation:ModelTypes["ContactLocationUpsertResult"],
	createDirector:ModelTypes["DirectorCreateResult"],
	deleteDirector:ModelTypes["DirectorDeleteResult"],
	updateDirector:ModelTypes["DirectorUpdateResult"],
	upsertDirector:ModelTypes["DirectorUpsertResult"],
	createFilm:ModelTypes["FilmCreateResult"],
	deleteFilm:ModelTypes["FilmDeleteResult"],
	updateFilm:ModelTypes["FilmUpdateResult"],
	upsertFilm:ModelTypes["FilmUpsertResult"],
	createDirectorLocation:ModelTypes["DirectorLocationCreateResult"],
	deleteDirectorLocation:ModelTypes["DirectorLocationDeleteResult"],
	updateDirectorLocation:ModelTypes["DirectorLocationUpdateResult"],
	upsertDirectorLocation:ModelTypes["DirectorLocationUpsertResult"],
	createContactsPage:ModelTypes["ContactsPageCreateResult"],
	deleteContactsPage:ModelTypes["ContactsPageDeleteResult"],
	updateContactsPage:ModelTypes["ContactsPageUpdateResult"],
	upsertContactsPage:ModelTypes["ContactsPageUpsertResult"],
	createDirectorsPage:ModelTypes["DirectorsPageCreateResult"],
	deleteDirectorsPage:ModelTypes["DirectorsPageDeleteResult"],
	updateDirectorsPage:ModelTypes["DirectorsPageUpdateResult"],
	upsertDirectorsPage:ModelTypes["DirectorsPageUpsertResult"],
	createFilmItem:ModelTypes["FilmItemCreateResult"],
	deleteFilmItem:ModelTypes["FilmItemDeleteResult"],
	updateFilmItem:ModelTypes["FilmItemUpdateResult"],
	upsertFilmItem:ModelTypes["FilmItemUpsertResult"],
	createDirectorContentGroup:ModelTypes["DirectorContentGroupCreateResult"],
	deleteDirectorContentGroup:ModelTypes["DirectorContentGroupDeleteResult"],
	updateDirectorContentGroup:ModelTypes["DirectorContentGroupUpdateResult"],
	upsertDirectorContentGroup:ModelTypes["DirectorContentGroupUpsertResult"],
	createPhotographer:ModelTypes["PhotographerCreateResult"],
	deletePhotographer:ModelTypes["PhotographerDeleteResult"],
	updatePhotographer:ModelTypes["PhotographerUpdateResult"],
	upsertPhotographer:ModelTypes["PhotographerUpsertResult"],
	createPhotographerContentGroup:ModelTypes["PhotographerContentGroupCreateResult"],
	deletePhotographerContentGroup:ModelTypes["PhotographerContentGroupDeleteResult"],
	updatePhotographerContentGroup:ModelTypes["PhotographerContentGroupUpdateResult"],
	upsertPhotographerContentGroup:ModelTypes["PhotographerContentGroupUpsertResult"],
	createPhotographerLocation:ModelTypes["PhotographerLocationCreateResult"],
	deletePhotographerLocation:ModelTypes["PhotographerLocationDeleteResult"],
	updatePhotographerLocation:ModelTypes["PhotographerLocationUpdateResult"],
	upsertPhotographerLocation:ModelTypes["PhotographerLocationUpsertResult"],
	createPhotographersPage:ModelTypes["PhotographersPageCreateResult"],
	deletePhotographersPage:ModelTypes["PhotographersPageDeleteResult"],
	updatePhotographersPage:ModelTypes["PhotographersPageUpdateResult"],
	upsertPhotographersPage:ModelTypes["PhotographersPageUpsertResult"],
	createOurWorkPage:ModelTypes["OurWorkPageCreateResult"],
	deleteOurWorkPage:ModelTypes["OurWorkPageDeleteResult"],
	updateOurWorkPage:ModelTypes["OurWorkPageUpdateResult"],
	upsertOurWorkPage:ModelTypes["OurWorkPageUpsertResult"],
	createOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroupCreateResult"],
	deleteOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroupDeleteResult"],
	updateOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroupUpdateResult"],
	upsertOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroupUpsertResult"],
	createContentGroup:ModelTypes["ContentGroupCreateResult"],
	deleteContentGroup:ModelTypes["ContentGroupDeleteResult"],
	updateContentGroup:ModelTypes["ContentGroupUpdateResult"],
	upsertContentGroup:ModelTypes["ContentGroupUpsertResult"],
	createHomePageContentGroup:ModelTypes["HomePageContentGroupCreateResult"],
	deleteHomePageContentGroup:ModelTypes["HomePageContentGroupDeleteResult"],
	updateHomePageContentGroup:ModelTypes["HomePageContentGroupUpdateResult"],
	upsertHomePageContentGroup:ModelTypes["HomePageContentGroupUpsertResult"],
	createTabletopPage:ModelTypes["TabletopPageCreateResult"],
	deleteTabletopPage:ModelTypes["TabletopPageDeleteResult"],
	updateTabletopPage:ModelTypes["TabletopPageUpdateResult"],
	upsertTabletopPage:ModelTypes["TabletopPageUpsertResult"],
	createTabletopPageContentGroup:ModelTypes["TabletopPageContentGroupCreateResult"],
	deleteTabletopPageContentGroup:ModelTypes["TabletopPageContentGroupDeleteResult"],
	updateTabletopPageContentGroup:ModelTypes["TabletopPageContentGroupUpdateResult"],
	upsertTabletopPageContentGroup:ModelTypes["TabletopPageContentGroupUpsertResult"],
	createPhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroupCreateResult"],
	deletePhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroupDeleteResult"],
	updatePhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroupUpdateResult"],
	upsertPhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroupUpsertResult"],
	transaction:ModelTypes["MutationTransaction"],
	query:ModelTypes["Query"],
	generateUploadUrl:ModelTypes["S3SignedUpload"],
	generateReadUrl:ModelTypes["S3SignedRead"]
};
	["ContactCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Contact"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["ContactCreateResult"] | ModelTypes["ContactDeleteResult"] | ModelTypes["ContactUpdateResult"] | ModelTypes["ContactUpsertResult"] | ModelTypes["ContentCreateResult"] | ModelTypes["ContentDeleteResult"] | ModelTypes["ContentUpdateResult"] | ModelTypes["ContentUpsertResult"] | ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ContentReferenceCreateResult"] | ModelTypes["ContentReferenceDeleteResult"] | ModelTypes["ContentReferenceUpdateResult"] | ModelTypes["ContentReferenceUpsertResult"] | ModelTypes["CardMediaCreateResult"] | ModelTypes["CardMediaDeleteResult"] | ModelTypes["CardMediaUpdateResult"] | ModelTypes["CardMediaUpsertResult"] | ModelTypes["FallbackSeoCreateResult"] | ModelTypes["FallbackSeoDeleteResult"] | ModelTypes["FallbackSeoUpdateResult"] | ModelTypes["FallbackSeoUpsertResult"] | ModelTypes["FooterCreateResult"] | ModelTypes["FooterDeleteResult"] | ModelTypes["FooterUpdateResult"] | ModelTypes["FooterUpsertResult"] | ModelTypes["SocialLinkCreateResult"] | ModelTypes["SocialLinkDeleteResult"] | ModelTypes["SocialLinkUpdateResult"] | ModelTypes["SocialLinkUpsertResult"] | ModelTypes["GalleryCreateResult"] | ModelTypes["GalleryDeleteResult"] | ModelTypes["GalleryUpdateResult"] | ModelTypes["GalleryUpsertResult"] | ModelTypes["GalleryItemCreateResult"] | ModelTypes["GalleryItemDeleteResult"] | ModelTypes["GalleryItemUpdateResult"] | ModelTypes["GalleryItemUpsertResult"] | ModelTypes["HeaderCreateResult"] | ModelTypes["HeaderDeleteResult"] | ModelTypes["HeaderUpdateResult"] | ModelTypes["HeaderUpsertResult"] | ModelTypes["HeaderLinkCreateResult"] | ModelTypes["HeaderLinkDeleteResult"] | ModelTypes["HeaderLinkUpdateResult"] | ModelTypes["HeaderLinkUpsertResult"] | ModelTypes["HomePageCreateResult"] | ModelTypes["HomePageDeleteResult"] | ModelTypes["HomePageUpdateResult"] | ModelTypes["HomePageUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["RedirectCreateResult"] | ModelTypes["RedirectDeleteResult"] | ModelTypes["RedirectUpdateResult"] | ModelTypes["RedirectUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["ContactLocationCreateResult"] | ModelTypes["ContactLocationDeleteResult"] | ModelTypes["ContactLocationUpdateResult"] | ModelTypes["ContactLocationUpsertResult"] | ModelTypes["DirectorCreateResult"] | ModelTypes["DirectorDeleteResult"] | ModelTypes["DirectorUpdateResult"] | ModelTypes["DirectorUpsertResult"] | ModelTypes["FilmCreateResult"] | ModelTypes["FilmDeleteResult"] | ModelTypes["FilmUpdateResult"] | ModelTypes["FilmUpsertResult"] | ModelTypes["DirectorLocationCreateResult"] | ModelTypes["DirectorLocationDeleteResult"] | ModelTypes["DirectorLocationUpdateResult"] | ModelTypes["DirectorLocationUpsertResult"] | ModelTypes["ContactsPageCreateResult"] | ModelTypes["ContactsPageDeleteResult"] | ModelTypes["ContactsPageUpdateResult"] | ModelTypes["ContactsPageUpsertResult"] | ModelTypes["DirectorsPageCreateResult"] | ModelTypes["DirectorsPageDeleteResult"] | ModelTypes["DirectorsPageUpdateResult"] | ModelTypes["DirectorsPageUpsertResult"] | ModelTypes["FilmItemCreateResult"] | ModelTypes["FilmItemDeleteResult"] | ModelTypes["FilmItemUpdateResult"] | ModelTypes["FilmItemUpsertResult"] | ModelTypes["DirectorContentGroupCreateResult"] | ModelTypes["DirectorContentGroupDeleteResult"] | ModelTypes["DirectorContentGroupUpdateResult"] | ModelTypes["DirectorContentGroupUpsertResult"] | ModelTypes["PhotographerCreateResult"] | ModelTypes["PhotographerDeleteResult"] | ModelTypes["PhotographerUpdateResult"] | ModelTypes["PhotographerUpsertResult"] | ModelTypes["PhotographerContentGroupCreateResult"] | ModelTypes["PhotographerContentGroupDeleteResult"] | ModelTypes["PhotographerContentGroupUpdateResult"] | ModelTypes["PhotographerContentGroupUpsertResult"] | ModelTypes["PhotographerLocationCreateResult"] | ModelTypes["PhotographerLocationDeleteResult"] | ModelTypes["PhotographerLocationUpdateResult"] | ModelTypes["PhotographerLocationUpsertResult"] | ModelTypes["PhotographersPageCreateResult"] | ModelTypes["PhotographersPageDeleteResult"] | ModelTypes["PhotographersPageUpdateResult"] | ModelTypes["PhotographersPageUpsertResult"] | ModelTypes["OurWorkPageCreateResult"] | ModelTypes["OurWorkPageDeleteResult"] | ModelTypes["OurWorkPageUpdateResult"] | ModelTypes["OurWorkPageUpsertResult"] | ModelTypes["OurWorkPageContentGroupCreateResult"] | ModelTypes["OurWorkPageContentGroupDeleteResult"] | ModelTypes["OurWorkPageContentGroupUpdateResult"] | ModelTypes["OurWorkPageContentGroupUpsertResult"] | ModelTypes["ContentGroupCreateResult"] | ModelTypes["ContentGroupDeleteResult"] | ModelTypes["ContentGroupUpdateResult"] | ModelTypes["ContentGroupUpsertResult"] | ModelTypes["HomePageContentGroupCreateResult"] | ModelTypes["HomePageContentGroupDeleteResult"] | ModelTypes["HomePageContentGroupUpdateResult"] | ModelTypes["HomePageContentGroupUpsertResult"] | ModelTypes["TabletopPageCreateResult"] | ModelTypes["TabletopPageDeleteResult"] | ModelTypes["TabletopPageUpdateResult"] | ModelTypes["TabletopPageUpsertResult"] | ModelTypes["TabletopPageContentGroupCreateResult"] | ModelTypes["TabletopPageContentGroupDeleteResult"] | ModelTypes["TabletopPageContentGroupUpdateResult"] | ModelTypes["TabletopPageContentGroupUpsertResult"] | ModelTypes["PhotographersPageContentGroupCreateResult"] | ModelTypes["PhotographersPageContentGroupDeleteResult"] | ModelTypes["PhotographersPageContentGroupUpdateResult"] | ModelTypes["PhotographersPageContentGroupUpsertResult"];
	["_MutationError"]: {
		path:ModelTypes["_PathFragment"][],
	paths:ModelTypes["_PathFragment"][],
	type:ModelTypes["_MutationErrorType"],
	message?:string
};
	["_MutationErrorType"]: GraphQLTypes["_MutationErrorType"];
	["ContactDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Contact"]
};
	["ContactUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Contact"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Contact"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"]
};
	["ContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["CardMediaCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CardMedia"],
	validation:ModelTypes["_ValidationResult"]
};
	["CardMediaDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CardMedia"]
};
	["CardMediaUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CardMedia"],
	validation:ModelTypes["_ValidationResult"]
};
	["CardMediaUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CardMedia"],
	validation:ModelTypes["_ValidationResult"]
};
	["FallbackSeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FallbackSeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"]
};
	["FallbackSeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FallbackSeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"]
};
	["FooterUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"]
};
	["SocialLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"]
};
	["GalleryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"]
};
	["GalleryItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"]
};
	["HeaderUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"]
};
	["HeaderLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"]
};
	["HomePageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"]
};
	["ImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"]
};
	["LinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"]
};
	["SeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactLocationCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactLocation"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactLocationDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactLocation"]
};
	["ContactLocationUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactLocation"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactLocationUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactLocation"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Director"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Director"]
};
	["DirectorUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Director"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Director"],
	validation:ModelTypes["_ValidationResult"]
};
	["FilmCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Film"],
	validation:ModelTypes["_ValidationResult"]
};
	["FilmDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Film"]
};
	["FilmUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Film"],
	validation:ModelTypes["_ValidationResult"]
};
	["FilmUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Film"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorLocationCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorLocation"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorLocationDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorLocation"]
};
	["DirectorLocationUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorLocation"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorLocationUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorLocation"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactsPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactsPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactsPage"]
};
	["ContactsPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactsPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorsPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorsPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorsPage"]
};
	["DirectorsPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorsPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["FilmItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FilmItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["FilmItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FilmItem"]
};
	["FilmItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FilmItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["FilmItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FilmItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorContentGroupCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorContentGroupDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorContentGroup"]
};
	["DirectorContentGroupUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["DirectorContentGroupUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DirectorContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Photographer"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Photographer"]
};
	["PhotographerUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Photographer"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Photographer"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerContentGroupCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographerContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerContentGroupDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographerContentGroup"]
};
	["PhotographerContentGroupUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographerContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerContentGroupUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographerContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerLocationCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographerLocation"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerLocationDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographerLocation"]
};
	["PhotographerLocationUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographerLocation"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerLocationUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographerLocation"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographersPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographersPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographersPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographersPage"]
};
	["PhotographersPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographersPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographersPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographersPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["OurWorkPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OurWorkPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["OurWorkPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OurWorkPage"]
};
	["OurWorkPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OurWorkPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["OurWorkPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OurWorkPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["OurWorkPageContentGroupCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OurWorkPageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["OurWorkPageContentGroupDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OurWorkPageContentGroup"]
};
	["OurWorkPageContentGroupUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OurWorkPageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["OurWorkPageContentGroupUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OurWorkPageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentGroupCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentGroupDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentGroup"]
};
	["ContentGroupUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentGroupUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageContentGroupCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageContentGroupDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePageContentGroup"]
};
	["HomePageContentGroupUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageContentGroupUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["TabletopPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TabletopPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["TabletopPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TabletopPage"]
};
	["TabletopPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TabletopPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["TabletopPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TabletopPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["TabletopPageContentGroupCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TabletopPageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["TabletopPageContentGroupDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TabletopPageContentGroup"]
};
	["TabletopPageContentGroupUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TabletopPageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["TabletopPageContentGroupUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TabletopPageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographersPageContentGroupCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographersPageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographersPageContentGroupDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographersPageContentGroup"]
};
	["PhotographersPageContentGroupUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographersPageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographersPageContentGroupUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PhotographersPageContentGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	validation:ModelTypes["_ValidationResult"],
	createContact:ModelTypes["ContactCreateResult"],
	deleteContact:ModelTypes["ContactDeleteResult"],
	updateContact:ModelTypes["ContactUpdateResult"],
	upsertContact:ModelTypes["ContactUpsertResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createCardMedia:ModelTypes["CardMediaCreateResult"],
	deleteCardMedia:ModelTypes["CardMediaDeleteResult"],
	updateCardMedia:ModelTypes["CardMediaUpdateResult"],
	upsertCardMedia:ModelTypes["CardMediaUpsertResult"],
	createFallbackSeo:ModelTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo:ModelTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo:ModelTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo:ModelTypes["FallbackSeoUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createSocialLink:ModelTypes["SocialLinkCreateResult"],
	deleteSocialLink:ModelTypes["SocialLinkDeleteResult"],
	updateSocialLink:ModelTypes["SocialLinkUpdateResult"],
	upsertSocialLink:ModelTypes["SocialLinkUpsertResult"],
	createGallery:ModelTypes["GalleryCreateResult"],
	deleteGallery:ModelTypes["GalleryDeleteResult"],
	updateGallery:ModelTypes["GalleryUpdateResult"],
	upsertGallery:ModelTypes["GalleryUpsertResult"],
	createGalleryItem:ModelTypes["GalleryItemCreateResult"],
	deleteGalleryItem:ModelTypes["GalleryItemDeleteResult"],
	updateGalleryItem:ModelTypes["GalleryItemUpdateResult"],
	upsertGalleryItem:ModelTypes["GalleryItemUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createHeaderLink:ModelTypes["HeaderLinkCreateResult"],
	deleteHeaderLink:ModelTypes["HeaderLinkDeleteResult"],
	updateHeaderLink:ModelTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink:ModelTypes["HeaderLinkUpsertResult"],
	createHomePage:ModelTypes["HomePageCreateResult"],
	deleteHomePage:ModelTypes["HomePageDeleteResult"],
	updateHomePage:ModelTypes["HomePageUpdateResult"],
	upsertHomePage:ModelTypes["HomePageUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createContactLocation:ModelTypes["ContactLocationCreateResult"],
	deleteContactLocation:ModelTypes["ContactLocationDeleteResult"],
	updateContactLocation:ModelTypes["ContactLocationUpdateResult"],
	upsertContactLocation:ModelTypes["ContactLocationUpsertResult"],
	createDirector:ModelTypes["DirectorCreateResult"],
	deleteDirector:ModelTypes["DirectorDeleteResult"],
	updateDirector:ModelTypes["DirectorUpdateResult"],
	upsertDirector:ModelTypes["DirectorUpsertResult"],
	createFilm:ModelTypes["FilmCreateResult"],
	deleteFilm:ModelTypes["FilmDeleteResult"],
	updateFilm:ModelTypes["FilmUpdateResult"],
	upsertFilm:ModelTypes["FilmUpsertResult"],
	createDirectorLocation:ModelTypes["DirectorLocationCreateResult"],
	deleteDirectorLocation:ModelTypes["DirectorLocationDeleteResult"],
	updateDirectorLocation:ModelTypes["DirectorLocationUpdateResult"],
	upsertDirectorLocation:ModelTypes["DirectorLocationUpsertResult"],
	createContactsPage:ModelTypes["ContactsPageCreateResult"],
	deleteContactsPage:ModelTypes["ContactsPageDeleteResult"],
	updateContactsPage:ModelTypes["ContactsPageUpdateResult"],
	upsertContactsPage:ModelTypes["ContactsPageUpsertResult"],
	createDirectorsPage:ModelTypes["DirectorsPageCreateResult"],
	deleteDirectorsPage:ModelTypes["DirectorsPageDeleteResult"],
	updateDirectorsPage:ModelTypes["DirectorsPageUpdateResult"],
	upsertDirectorsPage:ModelTypes["DirectorsPageUpsertResult"],
	createFilmItem:ModelTypes["FilmItemCreateResult"],
	deleteFilmItem:ModelTypes["FilmItemDeleteResult"],
	updateFilmItem:ModelTypes["FilmItemUpdateResult"],
	upsertFilmItem:ModelTypes["FilmItemUpsertResult"],
	createDirectorContentGroup:ModelTypes["DirectorContentGroupCreateResult"],
	deleteDirectorContentGroup:ModelTypes["DirectorContentGroupDeleteResult"],
	updateDirectorContentGroup:ModelTypes["DirectorContentGroupUpdateResult"],
	upsertDirectorContentGroup:ModelTypes["DirectorContentGroupUpsertResult"],
	createPhotographer:ModelTypes["PhotographerCreateResult"],
	deletePhotographer:ModelTypes["PhotographerDeleteResult"],
	updatePhotographer:ModelTypes["PhotographerUpdateResult"],
	upsertPhotographer:ModelTypes["PhotographerUpsertResult"],
	createPhotographerContentGroup:ModelTypes["PhotographerContentGroupCreateResult"],
	deletePhotographerContentGroup:ModelTypes["PhotographerContentGroupDeleteResult"],
	updatePhotographerContentGroup:ModelTypes["PhotographerContentGroupUpdateResult"],
	upsertPhotographerContentGroup:ModelTypes["PhotographerContentGroupUpsertResult"],
	createPhotographerLocation:ModelTypes["PhotographerLocationCreateResult"],
	deletePhotographerLocation:ModelTypes["PhotographerLocationDeleteResult"],
	updatePhotographerLocation:ModelTypes["PhotographerLocationUpdateResult"],
	upsertPhotographerLocation:ModelTypes["PhotographerLocationUpsertResult"],
	createPhotographersPage:ModelTypes["PhotographersPageCreateResult"],
	deletePhotographersPage:ModelTypes["PhotographersPageDeleteResult"],
	updatePhotographersPage:ModelTypes["PhotographersPageUpdateResult"],
	upsertPhotographersPage:ModelTypes["PhotographersPageUpsertResult"],
	createOurWorkPage:ModelTypes["OurWorkPageCreateResult"],
	deleteOurWorkPage:ModelTypes["OurWorkPageDeleteResult"],
	updateOurWorkPage:ModelTypes["OurWorkPageUpdateResult"],
	upsertOurWorkPage:ModelTypes["OurWorkPageUpsertResult"],
	createOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroupCreateResult"],
	deleteOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroupDeleteResult"],
	updateOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroupUpdateResult"],
	upsertOurWorkPageContentGroup:ModelTypes["OurWorkPageContentGroupUpsertResult"],
	createContentGroup:ModelTypes["ContentGroupCreateResult"],
	deleteContentGroup:ModelTypes["ContentGroupDeleteResult"],
	updateContentGroup:ModelTypes["ContentGroupUpdateResult"],
	upsertContentGroup:ModelTypes["ContentGroupUpsertResult"],
	createHomePageContentGroup:ModelTypes["HomePageContentGroupCreateResult"],
	deleteHomePageContentGroup:ModelTypes["HomePageContentGroupDeleteResult"],
	updateHomePageContentGroup:ModelTypes["HomePageContentGroupUpdateResult"],
	upsertHomePageContentGroup:ModelTypes["HomePageContentGroupUpsertResult"],
	createTabletopPage:ModelTypes["TabletopPageCreateResult"],
	deleteTabletopPage:ModelTypes["TabletopPageDeleteResult"],
	updateTabletopPage:ModelTypes["TabletopPageUpdateResult"],
	upsertTabletopPage:ModelTypes["TabletopPageUpsertResult"],
	createTabletopPageContentGroup:ModelTypes["TabletopPageContentGroupCreateResult"],
	deleteTabletopPageContentGroup:ModelTypes["TabletopPageContentGroupDeleteResult"],
	updateTabletopPageContentGroup:ModelTypes["TabletopPageContentGroupUpdateResult"],
	upsertTabletopPageContentGroup:ModelTypes["TabletopPageContentGroupUpsertResult"],
	createPhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroupCreateResult"],
	deletePhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroupDeleteResult"],
	updatePhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroupUpdateResult"],
	upsertPhotographersPageContentGroup:ModelTypes["PhotographersPageContentGroupUpsertResult"],
	query?:ModelTypes["Query"]
};
	["MutationTransactionOptions"]: GraphQLTypes["MutationTransactionOptions"];
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
		enums:ModelTypes["_Enum"][],
	entities:ModelTypes["_Entity"][]
};
	["_Entity"]: {
		name:string,
	customPrimaryAllowed:boolean,
	fields:ModelTypes["_Field"][],
	unique:ModelTypes["_UniqueConstraint"][]
};
	["_UniqueConstraint"]: {
		fields:string[]
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Column"]: {
		name:string,
	type:string,
	enumName?:string,
	defaultValue?:ModelTypes["Json"],
	nullable:boolean,
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_OnDeleteBehaviour"]: GraphQLTypes["_OnDeleteBehaviour"];
	["_RelationSide"]: GraphQLTypes["_RelationSide"];
	["_OrderByDirection"]: GraphQLTypes["_OrderByDirection"];
	["_OrderBy"]: {
		path:string[],
	direction:ModelTypes["_OrderByDirection"]
};
	["_Relation"]: {
		name:string,
	type:string,
	side:ModelTypes["_RelationSide"],
	targetEntity:string,
	ownedBy?:string,
	inversedBy?:string,
	nullable?:boolean,
	onDelete?:ModelTypes["_OnDeleteBehaviour"],
	orphanRemoval?:boolean,
	orderBy?:ModelTypes["_OrderBy"][],
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_Rule"]: {
		message?:ModelTypes["_RuleMessage"],
	validator:number
};
	["_Validator"]: {
		operation:string,
	arguments:ModelTypes["_Argument"][]
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator:number
};
	["_PathArgument"]: {
		path:string[]
};
	["_LiteralArgument"]: {
		value?:ModelTypes["Json"]
};
	["_RuleMessage"]: {
		text?:string
};
	["_Enum"]: {
		name:string,
	values:string[]
};
	["S3SignedUpload"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string,
	publicUrl:string
};
	["S3Header"]: {
		key:string,
	value:string
};
	["S3SignedRead"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string
}
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	getContact?: GraphQLTypes["Contact"],
	listContact: Array<GraphQLTypes["Contact"]>,
	paginateContact: GraphQLTypes["ContactConnection"],
	validateCreateContact: GraphQLTypes["_ValidationResult"],
	validateUpdateContact: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getCardMedia?: GraphQLTypes["CardMedia"],
	listCardMedia: Array<GraphQLTypes["CardMedia"]>,
	paginateCardMedia: GraphQLTypes["CardMediaConnection"],
	validateCreateCardMedia: GraphQLTypes["_ValidationResult"],
	validateUpdateCardMedia: GraphQLTypes["_ValidationResult"],
	getFallbackSeo?: GraphQLTypes["FallbackSeo"],
	listFallbackSeo: Array<GraphQLTypes["FallbackSeo"]>,
	paginateFallbackSeo: GraphQLTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateFallbackSeo: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getSocialLink?: GraphQLTypes["SocialLink"],
	listSocialLink: Array<GraphQLTypes["SocialLink"]>,
	paginateSocialLink: GraphQLTypes["SocialLinkConnection"],
	validateCreateSocialLink: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLink: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"],
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"],
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHeaderLink?: GraphQLTypes["HeaderLink"],
	listHeaderLink: Array<GraphQLTypes["HeaderLink"]>,
	paginateHeaderLink: GraphQLTypes["HeaderLinkConnection"],
	validateCreateHeaderLink: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLink: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"],
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getContactLocation?: GraphQLTypes["ContactLocation"],
	listContactLocation: Array<GraphQLTypes["ContactLocation"]>,
	paginateContactLocation: GraphQLTypes["ContactLocationConnection"],
	validateCreateContactLocation: GraphQLTypes["_ValidationResult"],
	validateUpdateContactLocation: GraphQLTypes["_ValidationResult"],
	getDirector?: GraphQLTypes["Director"],
	listDirector: Array<GraphQLTypes["Director"]>,
	paginateDirector: GraphQLTypes["DirectorConnection"],
	validateCreateDirector: GraphQLTypes["_ValidationResult"],
	validateUpdateDirector: GraphQLTypes["_ValidationResult"],
	getFilm?: GraphQLTypes["Film"],
	listFilm: Array<GraphQLTypes["Film"]>,
	paginateFilm: GraphQLTypes["FilmConnection"],
	validateCreateFilm: GraphQLTypes["_ValidationResult"],
	validateUpdateFilm: GraphQLTypes["_ValidationResult"],
	getDirectorLocation?: GraphQLTypes["DirectorLocation"],
	listDirectorLocation: Array<GraphQLTypes["DirectorLocation"]>,
	paginateDirectorLocation: GraphQLTypes["DirectorLocationConnection"],
	validateCreateDirectorLocation: GraphQLTypes["_ValidationResult"],
	validateUpdateDirectorLocation: GraphQLTypes["_ValidationResult"],
	getContactsPage?: GraphQLTypes["ContactsPage"],
	listContactsPage: Array<GraphQLTypes["ContactsPage"]>,
	paginateContactsPage: GraphQLTypes["ContactsPageConnection"],
	validateCreateContactsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateContactsPage: GraphQLTypes["_ValidationResult"],
	getDirectorsPage?: GraphQLTypes["DirectorsPage"],
	listDirectorsPage: Array<GraphQLTypes["DirectorsPage"]>,
	paginateDirectorsPage: GraphQLTypes["DirectorsPageConnection"],
	validateCreateDirectorsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateDirectorsPage: GraphQLTypes["_ValidationResult"],
	getFilmItem?: GraphQLTypes["FilmItem"],
	listFilmItem: Array<GraphQLTypes["FilmItem"]>,
	paginateFilmItem: GraphQLTypes["FilmItemConnection"],
	validateCreateFilmItem: GraphQLTypes["_ValidationResult"],
	validateUpdateFilmItem: GraphQLTypes["_ValidationResult"],
	getDirectorContentGroup?: GraphQLTypes["DirectorContentGroup"],
	listDirectorContentGroup: Array<GraphQLTypes["DirectorContentGroup"]>,
	paginateDirectorContentGroup: GraphQLTypes["DirectorContentGroupConnection"],
	validateCreateDirectorContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateDirectorContentGroup: GraphQLTypes["_ValidationResult"],
	getPhotographer?: GraphQLTypes["Photographer"],
	listPhotographer: Array<GraphQLTypes["Photographer"]>,
	paginatePhotographer: GraphQLTypes["PhotographerConnection"],
	validateCreatePhotographer: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographer: GraphQLTypes["_ValidationResult"],
	getPhotographerContentGroup?: GraphQLTypes["PhotographerContentGroup"],
	listPhotographerContentGroup: Array<GraphQLTypes["PhotographerContentGroup"]>,
	paginatePhotographerContentGroup: GraphQLTypes["PhotographerContentGroupConnection"],
	validateCreatePhotographerContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographerContentGroup: GraphQLTypes["_ValidationResult"],
	getPhotographerLocation?: GraphQLTypes["PhotographerLocation"],
	listPhotographerLocation: Array<GraphQLTypes["PhotographerLocation"]>,
	paginatePhotographerLocation: GraphQLTypes["PhotographerLocationConnection"],
	validateCreatePhotographerLocation: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographerLocation: GraphQLTypes["_ValidationResult"],
	getPhotographersPage?: GraphQLTypes["PhotographersPage"],
	listPhotographersPage: Array<GraphQLTypes["PhotographersPage"]>,
	paginatePhotographersPage: GraphQLTypes["PhotographersPageConnection"],
	validateCreatePhotographersPage: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographersPage: GraphQLTypes["_ValidationResult"],
	getOurWorkPage?: GraphQLTypes["OurWorkPage"],
	listOurWorkPage: Array<GraphQLTypes["OurWorkPage"]>,
	paginateOurWorkPage: GraphQLTypes["OurWorkPageConnection"],
	validateCreateOurWorkPage: GraphQLTypes["_ValidationResult"],
	validateUpdateOurWorkPage: GraphQLTypes["_ValidationResult"],
	getOurWorkPageContentGroup?: GraphQLTypes["OurWorkPageContentGroup"],
	listOurWorkPageContentGroup: Array<GraphQLTypes["OurWorkPageContentGroup"]>,
	paginateOurWorkPageContentGroup: GraphQLTypes["OurWorkPageContentGroupConnection"],
	validateCreateOurWorkPageContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateOurWorkPageContentGroup: GraphQLTypes["_ValidationResult"],
	getContentGroup?: GraphQLTypes["ContentGroup"],
	listContentGroup: Array<GraphQLTypes["ContentGroup"]>,
	paginateContentGroup: GraphQLTypes["ContentGroupConnection"],
	validateCreateContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateContentGroup: GraphQLTypes["_ValidationResult"],
	getHomePageContentGroup?: GraphQLTypes["HomePageContentGroup"],
	listHomePageContentGroup: Array<GraphQLTypes["HomePageContentGroup"]>,
	paginateHomePageContentGroup: GraphQLTypes["HomePageContentGroupConnection"],
	validateCreateHomePageContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePageContentGroup: GraphQLTypes["_ValidationResult"],
	getTabletopPage?: GraphQLTypes["TabletopPage"],
	listTabletopPage: Array<GraphQLTypes["TabletopPage"]>,
	paginateTabletopPage: GraphQLTypes["TabletopPageConnection"],
	validateCreateTabletopPage: GraphQLTypes["_ValidationResult"],
	validateUpdateTabletopPage: GraphQLTypes["_ValidationResult"],
	getTabletopPageContentGroup?: GraphQLTypes["TabletopPageContentGroup"],
	listTabletopPageContentGroup: Array<GraphQLTypes["TabletopPageContentGroup"]>,
	paginateTabletopPageContentGroup: GraphQLTypes["TabletopPageContentGroupConnection"],
	validateCreateTabletopPageContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateTabletopPageContentGroup: GraphQLTypes["_ValidationResult"],
	getPhotographersPageContentGroup?: GraphQLTypes["PhotographersPageContentGroup"],
	listPhotographersPageContentGroup: Array<GraphQLTypes["PhotographersPageContentGroup"]>,
	paginatePhotographersPageContentGroup: GraphQLTypes["PhotographersPageContentGroupConnection"],
	validateCreatePhotographersPageContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographersPageContentGroup: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"],
	_info?: GraphQLTypes["Info"],
	schema?: GraphQLTypes["_Schema"],
	s3DummyQuery?: string
};
	["Contact"]: {
	__typename: "Contact",
	_meta?: GraphQLTypes["ContactMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	name?: string,
	position?: string,
	phone?: string,
	email?: string,
	image?: GraphQLTypes["Image"],
	contactLocation?: GraphQLTypes["ContactLocation"],
	wordpressId?: string
};
	["ContactMeta"]: {
	__typename: "ContactMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	position?: GraphQLTypes["FieldMeta"],
	phone?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	contactLocation?: GraphQLTypes["FieldMeta"],
	wordpressId?: GraphQLTypes["FieldMeta"]
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean,
	updatable?: boolean
};
	["UUID"]:string;
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	alt?: GraphQLTypes["FieldMeta"]
};
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	alt?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	not?: GraphQLTypes["ImageWhere"]
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]>,
	or?: Array<GraphQLTypes["UUIDCondition"]>,
	not?: GraphQLTypes["UUIDCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["UUID"],
	notEq?: GraphQLTypes["UUID"],
	in?: Array<GraphQLTypes["UUID"]>,
	notIn?: Array<GraphQLTypes["UUID"]>,
	lt?: GraphQLTypes["UUID"],
	lte?: GraphQLTypes["UUID"],
	gt?: GraphQLTypes["UUID"],
	gte?: GraphQLTypes["UUID"]
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]>,
	or?: Array<GraphQLTypes["StringCondition"]>,
	not?: GraphQLTypes["StringCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: string,
	notEq?: string,
	in?: Array<string>,
	notIn?: Array<string>,
	lt?: string,
	lte?: string,
	gt?: string,
	gte?: string,
	contains?: string,
	startsWith?: string,
	endsWith?: string,
	containsCI?: string,
	startsWithCI?: string,
	endsWithCI?: string
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]>,
	or?: Array<GraphQLTypes["IntCondition"]>,
	not?: GraphQLTypes["IntCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["ContactLocation"]: {
	__typename: "ContactLocation",
	_meta?: GraphQLTypes["ContactLocationMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	city?: string,
	state?: string,
	address?: string,
	email?: string,
	phone?: string,
	fax?: string,
	note?: string,
	contact: Array<GraphQLTypes["Contact"]>,
	contactByWordpressId?: GraphQLTypes["Contact"],
	contactByImage?: GraphQLTypes["Contact"],
	paginateContact: GraphQLTypes["ContactConnection"]
};
	["ContactLocationMeta"]: {
	__typename: "ContactLocationMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	city?: GraphQLTypes["FieldMeta"],
	state?: GraphQLTypes["FieldMeta"],
	address?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	phone?: GraphQLTypes["FieldMeta"],
	fax?: GraphQLTypes["FieldMeta"],
	note?: GraphQLTypes["FieldMeta"],
	contact?: GraphQLTypes["FieldMeta"]
};
	["ContactWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	name?: GraphQLTypes["StringCondition"],
	position?: GraphQLTypes["StringCondition"],
	phone?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	contactLocation?: GraphQLTypes["ContactLocationWhere"],
	wordpressId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ContactWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactWhere"] | undefined>,
	not?: GraphQLTypes["ContactWhere"]
};
	["ContactLocationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	city?: GraphQLTypes["StringCondition"],
	state?: GraphQLTypes["StringCondition"],
	address?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	phone?: GraphQLTypes["StringCondition"],
	fax?: GraphQLTypes["StringCondition"],
	note?: GraphQLTypes["StringCondition"],
	contact?: GraphQLTypes["ContactWhere"],
	and?: Array<GraphQLTypes["ContactLocationWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactLocationWhere"] | undefined>,
	not?: GraphQLTypes["ContactLocationWhere"]
};
	["ContactOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	position?: GraphQLTypes["OrderDirection"],
	phone?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	contactLocation?: GraphQLTypes["ContactLocationOrderBy"],
	wordpressId?: GraphQLTypes["OrderDirection"]
};
	["OrderDirection"]: OrderDirection;
	["ImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	alt?: GraphQLTypes["OrderDirection"]
};
	["ContactLocationOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	city?: GraphQLTypes["OrderDirection"],
	state?: GraphQLTypes["OrderDirection"],
	address?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	phone?: GraphQLTypes["OrderDirection"],
	fax?: GraphQLTypes["OrderDirection"],
	note?: GraphQLTypes["OrderDirection"]
};
	["ContactLocationContactByWordpressIdUniqueWhere"]: {
		wordpressId?: string
};
	["ContactLocationContactByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContactConnection"]: {
	__typename: "ContactConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["ContactEdge"]: {
	__typename: "ContactEdge",
	node: GraphQLTypes["Contact"]
};
	["ContactUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	wordpressId?: string,
	image?: GraphQLTypes["ImageUniqueWhere"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
	__typename:"_FieldPathFragment" | "_IndexPathFragment"
	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["ContactCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	position?: string,
	phone?: string,
	email?: string,
	image?: GraphQLTypes["ContactCreateImageEntityRelationInput"],
	contactLocation?: GraphQLTypes["ContactCreateContactLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["ContactCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	_dummy_field_?: boolean
};
	["ContactCreateContactLocationEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactLocationUniqueWhere"],
	create?: GraphQLTypes["ContactLocationWithoutContactCreateInput"]
};
	["ContactLocationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	contact?: GraphQLTypes["ContactUniqueWhere"]
};
	["ContactLocationWithoutContactCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	city?: string,
	state?: string,
	address?: string,
	email?: string,
	phone?: string,
	fax?: string,
	note?: string,
	_dummy_field_?: boolean
};
	["ContactUpdateInput"]: {
		order?: number,
	name?: string,
	position?: string,
	phone?: string,
	email?: string,
	image?: GraphQLTypes["ContactUpdateImageEntityRelationInput"],
	contactLocation?: GraphQLTypes["ContactUpdateContactLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["ContactUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ContactUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	_dummy_field_?: boolean
};
	["ContactUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContactUpdateContactLocationEntityRelationInput"]: {
		create?: GraphQLTypes["ContactLocationWithoutContactCreateInput"],
	update?: GraphQLTypes["ContactLocationWithoutContactUpdateInput"],
	upsert?: GraphQLTypes["ContactUpsertContactLocationRelationInput"],
	connect?: GraphQLTypes["ContactLocationUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactLocationWithoutContactUpdateInput"]: {
		order?: number,
	city?: string,
	state?: string,
	address?: string,
	email?: string,
	phone?: string,
	fax?: string,
	note?: string,
	_dummy_field_?: boolean
};
	["ContactUpsertContactLocationRelationInput"]: {
		update?: GraphQLTypes["ContactLocationWithoutContactUpdateInput"],
	create?: GraphQLTypes["ContactLocationWithoutContactCreateInput"]
};
	["Content"]: {
	__typename: "Content",
	_meta?: GraphQLTypes["ContentMeta"],
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByReferences?: GraphQLTypes["ContentBlock"],
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
	__typename: "ContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	blocks?: GraphQLTypes["FieldMeta"]
};
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"],
	references: Array<GraphQLTypes["ContentReference"]>,
	referencesByLink?: GraphQLTypes["ContentReference"],
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	json?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	references?: GraphQLTypes["FieldMeta"]
};
	["ContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	blocks?: GraphQLTypes["ContentBlockWhere"],
	and?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	not?: GraphQLTypes["ContentWhere"]
};
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	json?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	references?: GraphQLTypes["ContentReferenceWhere"],
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	not?: GraphQLTypes["ContentBlockWhere"]
};
	["ContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ContentReferenceTypeCondition"],
	text?: GraphQLTypes["StringCondition"],
	block?: GraphQLTypes["ContentBlockWhere"],
	link?: GraphQLTypes["LinkWhere"],
	image?: GraphQLTypes["ImageWhere"],
	cardMedia?: GraphQLTypes["CardMediaWhere"],
	and?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	not?: GraphQLTypes["ContentReferenceWhere"]
};
	["ContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	or?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	not?: GraphQLTypes["ContentReferenceTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentReferenceType"],
	notEq?: GraphQLTypes["ContentReferenceType"],
	in?: Array<GraphQLTypes["ContentReferenceType"]>,
	notIn?: Array<GraphQLTypes["ContentReferenceType"]>,
	lt?: GraphQLTypes["ContentReferenceType"],
	lte?: GraphQLTypes["ContentReferenceType"],
	gt?: GraphQLTypes["ContentReferenceType"],
	gte?: GraphQLTypes["ContentReferenceType"]
};
	["ContentReferenceType"]: ContentReferenceType;
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["LinkTypeCondition"],
	title?: GraphQLTypes["StringCondition"],
	externalLink?: GraphQLTypes["StringCondition"],
	internalLink?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	not?: GraphQLTypes["LinkWhere"]
};
	["LinkTypeCondition"]: {
		and?: Array<GraphQLTypes["LinkTypeCondition"]>,
	or?: Array<GraphQLTypes["LinkTypeCondition"]>,
	not?: GraphQLTypes["LinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["LinkType"],
	notEq?: GraphQLTypes["LinkType"],
	in?: Array<GraphQLTypes["LinkType"]>,
	notIn?: Array<GraphQLTypes["LinkType"]>,
	lt?: GraphQLTypes["LinkType"],
	lte?: GraphQLTypes["LinkType"],
	gt?: GraphQLTypes["LinkType"],
	gte?: GraphQLTypes["LinkType"]
};
	["LinkType"]: LinkType;
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	homePage?: GraphQLTypes["HomePageWhere"],
	redirect?: GraphQLTypes["RedirectWhere"],
	director?: GraphQLTypes["DirectorWhere"],
	contactsPage?: GraphQLTypes["ContactsPageWhere"],
	directorsPage?: GraphQLTypes["DirectorsPageWhere"],
	photographer?: GraphQLTypes["PhotographerWhere"],
	photographersPage?: GraphQLTypes["PhotographersPageWhere"],
	ourWorkPage?: GraphQLTypes["OurWorkPageWhere"],
	tabletopPage?: GraphQLTypes["TabletopPageWhere"],
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	not?: GraphQLTypes["LinkableWhere"]
};
	["HomePageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	tagline?: GraphQLTypes["StringCondition"],
	logo?: GraphQLTypes["ImageWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	directorsText?: GraphQLTypes["StringCondition"],
	contentGroups?: GraphQLTypes["HomePageContentGroupWhere"],
	backgroundImage?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["HomePageWhere"] | undefined>,
	or?: Array<GraphQLTypes["HomePageWhere"] | undefined>,
	not?: GraphQLTypes["HomePageWhere"]
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]>,
	or?: Array<GraphQLTypes["OneCondition"]>,
	not?: GraphQLTypes["OneCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["One"],
	notEq?: GraphQLTypes["One"],
	in?: Array<GraphQLTypes["One"]>,
	notIn?: Array<GraphQLTypes["One"]>,
	lt?: GraphQLTypes["One"],
	lte?: GraphQLTypes["One"],
	gt?: GraphQLTypes["One"],
	gte?: GraphQLTypes["One"]
};
	["One"]: One;
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	ogTitle?: GraphQLTypes["StringCondition"],
	ogDescription?: GraphQLTypes["StringCondition"],
	ogImage?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	not?: GraphQLTypes["SeoWhere"]
};
	["HomePageContentGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	homePage?: GraphQLTypes["HomePageWhere"],
	contentGroup?: GraphQLTypes["ContentGroupWhere"],
	and?: Array<GraphQLTypes["HomePageContentGroupWhere"] | undefined>,
	or?: Array<GraphQLTypes["HomePageContentGroupWhere"] | undefined>,
	not?: GraphQLTypes["HomePageContentGroupWhere"]
};
	["ContentGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	contentType?: GraphQLTypes["ContentGroupTypeCondition"],
	gallery?: GraphQLTypes["GalleryWhere"],
	films?: GraphQLTypes["FilmItemWhere"],
	and?: Array<GraphQLTypes["ContentGroupWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentGroupWhere"] | undefined>,
	not?: GraphQLTypes["ContentGroupWhere"]
};
	["ContentGroupTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentGroupTypeCondition"]>,
	or?: Array<GraphQLTypes["ContentGroupTypeCondition"]>,
	not?: GraphQLTypes["ContentGroupTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentGroupType"],
	notEq?: GraphQLTypes["ContentGroupType"],
	in?: Array<GraphQLTypes["ContentGroupType"]>,
	notIn?: Array<GraphQLTypes["ContentGroupType"]>,
	lt?: GraphQLTypes["ContentGroupType"],
	lte?: GraphQLTypes["ContentGroupType"],
	gt?: GraphQLTypes["ContentGroupType"],
	gte?: GraphQLTypes["ContentGroupType"]
};
	["ContentGroupType"]: ContentGroupType;
	["GalleryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["GalleryItemWhere"],
	and?: Array<GraphQLTypes["GalleryWhere"] | undefined>,
	or?: Array<GraphQLTypes["GalleryWhere"] | undefined>,
	not?: GraphQLTypes["GalleryWhere"]
};
	["GalleryItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["GalleryWhere"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["GalleryItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["GalleryItemWhere"] | undefined>,
	not?: GraphQLTypes["GalleryItemWhere"]
};
	["FilmItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	contentGroups?: GraphQLTypes["ContentGroupWhere"],
	film?: GraphQLTypes["FilmWhere"],
	and?: Array<GraphQLTypes["FilmItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["FilmItemWhere"] | undefined>,
	not?: GraphQLTypes["FilmItemWhere"]
};
	["FilmWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	author?: GraphQLTypes["StringCondition"],
	vimeoId?: GraphQLTypes["StringCondition"],
	posterImage?: GraphQLTypes["ImageWhere"],
	order?: GraphQLTypes["IntCondition"],
	wordpressId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["FilmWhere"] | undefined>,
	or?: Array<GraphQLTypes["FilmWhere"] | undefined>,
	not?: GraphQLTypes["FilmWhere"]
};
	["RedirectWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	targetUrl?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	target?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	or?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	not?: GraphQLTypes["RedirectWhere"]
};
	["DirectorWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	order?: GraphQLTypes["IntCondition"],
	contentGroups?: GraphQLTypes["DirectorContentGroupWhere"],
	directorLocation?: GraphQLTypes["DirectorLocationWhere"],
	wordpressId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["DirectorWhere"] | undefined>,
	or?: Array<GraphQLTypes["DirectorWhere"] | undefined>,
	not?: GraphQLTypes["DirectorWhere"]
};
	["DirectorContentGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	director?: GraphQLTypes["DirectorWhere"],
	contentGroup?: GraphQLTypes["ContentGroupWhere"],
	and?: Array<GraphQLTypes["DirectorContentGroupWhere"] | undefined>,
	or?: Array<GraphQLTypes["DirectorContentGroupWhere"] | undefined>,
	not?: GraphQLTypes["DirectorContentGroupWhere"]
};
	["DirectorLocationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	city?: GraphQLTypes["StringCondition"],
	director?: GraphQLTypes["DirectorWhere"],
	and?: Array<GraphQLTypes["DirectorLocationWhere"] | undefined>,
	or?: Array<GraphQLTypes["DirectorLocationWhere"] | undefined>,
	not?: GraphQLTypes["DirectorLocationWhere"]
};
	["ContactsPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ContactsPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactsPageWhere"] | undefined>,
	not?: GraphQLTypes["ContactsPageWhere"]
};
	["DirectorsPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["DirectorsPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["DirectorsPageWhere"] | undefined>,
	not?: GraphQLTypes["DirectorsPageWhere"]
};
	["PhotographerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	name?: GraphQLTypes["StringCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	contentGroups?: GraphQLTypes["PhotographerContentGroupWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	photographerLocation?: GraphQLTypes["PhotographerLocationWhere"],
	wordpressId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["PhotographerWhere"] | undefined>,
	or?: Array<GraphQLTypes["PhotographerWhere"] | undefined>,
	not?: GraphQLTypes["PhotographerWhere"]
};
	["PhotographerContentGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	photographer?: GraphQLTypes["PhotographerWhere"],
	contentGroup?: GraphQLTypes["ContentGroupWhere"],
	and?: Array<GraphQLTypes["PhotographerContentGroupWhere"] | undefined>,
	or?: Array<GraphQLTypes["PhotographerContentGroupWhere"] | undefined>,
	not?: GraphQLTypes["PhotographerContentGroupWhere"]
};
	["PhotographerLocationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	city?: GraphQLTypes["StringCondition"],
	photographer?: GraphQLTypes["PhotographerWhere"],
	and?: Array<GraphQLTypes["PhotographerLocationWhere"] | undefined>,
	or?: Array<GraphQLTypes["PhotographerLocationWhere"] | undefined>,
	not?: GraphQLTypes["PhotographerLocationWhere"]
};
	["PhotographersPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	contentGroups?: GraphQLTypes["PhotographersPageContentGroupWhere"],
	and?: Array<GraphQLTypes["PhotographersPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["PhotographersPageWhere"] | undefined>,
	not?: GraphQLTypes["PhotographersPageWhere"]
};
	["PhotographersPageContentGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	photographersPage?: GraphQLTypes["PhotographersPageWhere"],
	contentGroup?: GraphQLTypes["ContentGroupWhere"],
	and?: Array<GraphQLTypes["PhotographersPageContentGroupWhere"] | undefined>,
	or?: Array<GraphQLTypes["PhotographersPageContentGroupWhere"] | undefined>,
	not?: GraphQLTypes["PhotographersPageContentGroupWhere"]
};
	["OurWorkPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	contentGroups?: GraphQLTypes["OurWorkPageContentGroupWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["OurWorkPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["OurWorkPageWhere"] | undefined>,
	not?: GraphQLTypes["OurWorkPageWhere"]
};
	["OurWorkPageContentGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	ourWorkPage?: GraphQLTypes["OurWorkPageWhere"],
	contentGroup?: GraphQLTypes["ContentGroupWhere"],
	and?: Array<GraphQLTypes["OurWorkPageContentGroupWhere"] | undefined>,
	or?: Array<GraphQLTypes["OurWorkPageContentGroupWhere"] | undefined>,
	not?: GraphQLTypes["OurWorkPageContentGroupWhere"]
};
	["TabletopPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	teamTitle?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	logo?: GraphQLTypes["ImageWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	contentGroups?: GraphQLTypes["TabletopPageContentGroupWhere"],
	and?: Array<GraphQLTypes["TabletopPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["TabletopPageWhere"] | undefined>,
	not?: GraphQLTypes["TabletopPageWhere"]
};
	["TabletopPageContentGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	tabletopPage?: GraphQLTypes["TabletopPageWhere"],
	contentGroup?: GraphQLTypes["ContentGroupWhere"],
	and?: Array<GraphQLTypes["TabletopPageContentGroupWhere"] | undefined>,
	or?: Array<GraphQLTypes["TabletopPageContentGroupWhere"] | undefined>,
	not?: GraphQLTypes["TabletopPageContentGroupWhere"]
};
	["CardMediaWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	text?: GraphQLTypes["StringCondition"],
	imageNote?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["CardMediaWhere"] | undefined>,
	or?: Array<GraphQLTypes["CardMediaWhere"] | undefined>,
	not?: GraphQLTypes["CardMediaWhere"]
};
	["ContentReference"]: {
	__typename: "ContentReference",
	_meta?: GraphQLTypes["ContentReferenceMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	text?: string,
	block?: GraphQLTypes["ContentBlock"],
	link?: GraphQLTypes["Link"],
	image?: GraphQLTypes["Image"],
	cardMedia?: GraphQLTypes["CardMedia"]
};
	["ContentReferenceMeta"]: {
	__typename: "ContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	block?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	cardMedia?: GraphQLTypes["FieldMeta"]
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["Linkable"]
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	externalLink?: GraphQLTypes["FieldMeta"],
	internalLink?: GraphQLTypes["FieldMeta"]
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	homePage?: GraphQLTypes["HomePage"],
	redirect?: GraphQLTypes["Redirect"],
	director?: GraphQLTypes["Director"],
	contactsPage?: GraphQLTypes["ContactsPage"],
	directorsPage?: GraphQLTypes["DirectorsPage"],
	photographer?: GraphQLTypes["Photographer"],
	photographersPage?: GraphQLTypes["PhotographersPage"],
	ourWorkPage?: GraphQLTypes["OurWorkPage"],
	tabletopPage?: GraphQLTypes["TabletopPage"]
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	homePage?: GraphQLTypes["FieldMeta"],
	redirect?: GraphQLTypes["FieldMeta"],
	director?: GraphQLTypes["FieldMeta"],
	contactsPage?: GraphQLTypes["FieldMeta"],
	directorsPage?: GraphQLTypes["FieldMeta"],
	photographer?: GraphQLTypes["FieldMeta"],
	photographersPage?: GraphQLTypes["FieldMeta"],
	ourWorkPage?: GraphQLTypes["FieldMeta"],
	tabletopPage?: GraphQLTypes["FieldMeta"]
};
	["HomePage"]: {
	__typename: "HomePage",
	_meta?: GraphQLTypes["HomePageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	tagline?: string,
	logo?: GraphQLTypes["Image"],
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	directorsText?: string,
	contentGroups: Array<GraphQLTypes["HomePageContentGroup"]>,
	backgroundImage?: GraphQLTypes["Image"],
	contentGroupsByContentGroup?: GraphQLTypes["HomePageContentGroup"],
	paginateContentGroups: GraphQLTypes["HomePageContentGroupConnection"]
};
	["HomePageMeta"]: {
	__typename: "HomePageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	tagline?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	directorsText?: GraphQLTypes["FieldMeta"],
	contentGroups?: GraphQLTypes["FieldMeta"],
	backgroundImage?: GraphQLTypes["FieldMeta"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["Image"]
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	ogTitle?: GraphQLTypes["FieldMeta"],
	ogDescription?: GraphQLTypes["FieldMeta"],
	ogImage?: GraphQLTypes["FieldMeta"]
};
	["HomePageContentGroup"]: {
	__typename: "HomePageContentGroup",
	_meta?: GraphQLTypes["HomePageContentGroupMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	homePage?: GraphQLTypes["HomePage"],
	contentGroup?: GraphQLTypes["ContentGroup"]
};
	["HomePageContentGroupMeta"]: {
	__typename: "HomePageContentGroupMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	homePage?: GraphQLTypes["FieldMeta"],
	contentGroup?: GraphQLTypes["FieldMeta"]
};
	["ContentGroup"]: {
	__typename: "ContentGroup",
	_meta?: GraphQLTypes["ContentGroupMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	contentType?: GraphQLTypes["ContentGroupType"],
	gallery?: GraphQLTypes["Gallery"],
	films: Array<GraphQLTypes["FilmItem"]>,
	paginateFilms: GraphQLTypes["FilmItemConnection"]
};
	["ContentGroupMeta"]: {
	__typename: "ContentGroupMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	contentType?: GraphQLTypes["FieldMeta"],
	gallery?: GraphQLTypes["FieldMeta"],
	films?: GraphQLTypes["FieldMeta"]
};
	["Gallery"]: {
	__typename: "Gallery",
	_meta?: GraphQLTypes["GalleryMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["GalleryItem"]>,
	paginateItems: GraphQLTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
	__typename: "GalleryMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["GalleryItem"]: {
	__typename: "GalleryItem",
	_meta?: GraphQLTypes["GalleryItemMeta"],
	id: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["Gallery"],
	image?: GraphQLTypes["Image"]
};
	["GalleryItemMeta"]: {
	__typename: "GalleryItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["GalleryItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["GalleryOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["GalleryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["GalleryItemConnection"]: {
	__typename: "GalleryItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryItemEdge"]>
};
	["GalleryItemEdge"]: {
	__typename: "GalleryItemEdge",
	node: GraphQLTypes["GalleryItem"]
};
	["FilmItem"]: {
	__typename: "FilmItem",
	_meta?: GraphQLTypes["FilmItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	contentGroups?: GraphQLTypes["ContentGroup"],
	film?: GraphQLTypes["Film"]
};
	["FilmItemMeta"]: {
	__typename: "FilmItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	contentGroups?: GraphQLTypes["FieldMeta"],
	film?: GraphQLTypes["FieldMeta"]
};
	["Film"]: {
	__typename: "Film",
	_meta?: GraphQLTypes["FilmMeta"],
	id: GraphQLTypes["UUID"],
	name?: string,
	author?: string,
	vimeoId?: string,
	posterImage?: GraphQLTypes["Image"],
	order: number,
	wordpressId?: string
};
	["FilmMeta"]: {
	__typename: "FilmMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	author?: GraphQLTypes["FieldMeta"],
	vimeoId?: GraphQLTypes["FieldMeta"],
	posterImage?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	wordpressId?: GraphQLTypes["FieldMeta"]
};
	["FilmItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	contentGroups?: GraphQLTypes["ContentGroupOrderBy"],
	film?: GraphQLTypes["FilmOrderBy"]
};
	["ContentGroupOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	contentType?: GraphQLTypes["OrderDirection"],
	gallery?: GraphQLTypes["GalleryOrderBy"]
};
	["FilmOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	author?: GraphQLTypes["OrderDirection"],
	vimeoId?: GraphQLTypes["OrderDirection"],
	posterImage?: GraphQLTypes["ImageOrderBy"],
	order?: GraphQLTypes["OrderDirection"],
	wordpressId?: GraphQLTypes["OrderDirection"]
};
	["FilmItemConnection"]: {
	__typename: "FilmItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FilmItemEdge"]>
};
	["FilmItemEdge"]: {
	__typename: "FilmItemEdge",
	node: GraphQLTypes["FilmItem"]
};
	["HomePageContentGroupOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	homePage?: GraphQLTypes["HomePageOrderBy"],
	contentGroup?: GraphQLTypes["ContentGroupOrderBy"]
};
	["HomePageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	tagline?: GraphQLTypes["OrderDirection"],
	logo?: GraphQLTypes["ImageOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	directorsText?: GraphQLTypes["OrderDirection"],
	backgroundImage?: GraphQLTypes["ImageOrderBy"]
};
	["SeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	ogTitle?: GraphQLTypes["OrderDirection"],
	ogDescription?: GraphQLTypes["OrderDirection"],
	ogImage?: GraphQLTypes["ImageOrderBy"]
};
	["LinkableOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	homePage?: GraphQLTypes["HomePageOrderBy"],
	redirect?: GraphQLTypes["RedirectOrderBy"],
	director?: GraphQLTypes["DirectorOrderBy"],
	contactsPage?: GraphQLTypes["ContactsPageOrderBy"],
	directorsPage?: GraphQLTypes["DirectorsPageOrderBy"],
	photographer?: GraphQLTypes["PhotographerOrderBy"],
	photographersPage?: GraphQLTypes["PhotographersPageOrderBy"],
	ourWorkPage?: GraphQLTypes["OurWorkPageOrderBy"],
	tabletopPage?: GraphQLTypes["TabletopPageOrderBy"]
};
	["RedirectOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	targetUrl?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	target?: GraphQLTypes["LinkableOrderBy"]
};
	["DirectorOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	order?: GraphQLTypes["OrderDirection"],
	directorLocation?: GraphQLTypes["DirectorLocationOrderBy"],
	wordpressId?: GraphQLTypes["OrderDirection"]
};
	["DirectorLocationOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	city?: GraphQLTypes["OrderDirection"]
};
	["ContactsPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	leadParagraph?: GraphQLTypes["OrderDirection"]
};
	["DirectorsPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	leadParagraph?: GraphQLTypes["OrderDirection"]
};
	["PhotographerOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	photographerLocation?: GraphQLTypes["PhotographerLocationOrderBy"],
	wordpressId?: GraphQLTypes["OrderDirection"]
};
	["PhotographerLocationOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	city?: GraphQLTypes["OrderDirection"]
};
	["PhotographersPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"]
};
	["OurWorkPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["TabletopPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	teamTitle?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	logo?: GraphQLTypes["ImageOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["HomePageContentGroupsByContentGroupUniqueWhere"]: {
		contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["ContentGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	gallery?: GraphQLTypes["GalleryUniqueWhere"],
	films?: GraphQLTypes["FilmItemUniqueWhere"]
};
	["GalleryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["GalleryItemUniqueWhere"]
};
	["GalleryItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["FilmItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["HomePageContentGroupConnection"]: {
	__typename: "HomePageContentGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageContentGroupEdge"]>
};
	["HomePageContentGroupEdge"]: {
	__typename: "HomePageContentGroupEdge",
	node: GraphQLTypes["HomePageContentGroup"]
};
	["Redirect"]: {
	__typename: "Redirect",
	_meta?: GraphQLTypes["RedirectMeta"],
	id: GraphQLTypes["UUID"],
	targetUrl?: string,
	link?: GraphQLTypes["Linkable"],
	target?: GraphQLTypes["Linkable"]
};
	["RedirectMeta"]: {
	__typename: "RedirectMeta",
	id?: GraphQLTypes["FieldMeta"],
	targetUrl?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"]
};
	["Director"]: {
	__typename: "Director",
	_meta?: GraphQLTypes["DirectorMeta"],
	id: GraphQLTypes["UUID"],
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["Image"],
	link?: GraphQLTypes["Linkable"],
	order: number,
	contentGroups: Array<GraphQLTypes["DirectorContentGroup"]>,
	directorLocation?: GraphQLTypes["DirectorLocation"],
	wordpressId?: string,
	contentGroupsByContentGroup?: GraphQLTypes["DirectorContentGroup"],
	paginateContentGroups: GraphQLTypes["DirectorContentGroupConnection"]
};
	["DirectorMeta"]: {
	__typename: "DirectorMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	contentGroups?: GraphQLTypes["FieldMeta"],
	directorLocation?: GraphQLTypes["FieldMeta"],
	wordpressId?: GraphQLTypes["FieldMeta"]
};
	["DirectorContentGroup"]: {
	__typename: "DirectorContentGroup",
	_meta?: GraphQLTypes["DirectorContentGroupMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	director?: GraphQLTypes["Director"],
	contentGroup?: GraphQLTypes["ContentGroup"]
};
	["DirectorContentGroupMeta"]: {
	__typename: "DirectorContentGroupMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	director?: GraphQLTypes["FieldMeta"],
	contentGroup?: GraphQLTypes["FieldMeta"]
};
	["DirectorContentGroupOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	director?: GraphQLTypes["DirectorOrderBy"],
	contentGroup?: GraphQLTypes["ContentGroupOrderBy"]
};
	["DirectorLocation"]: {
	__typename: "DirectorLocation",
	_meta?: GraphQLTypes["DirectorLocationMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	city?: string,
	director: Array<GraphQLTypes["Director"]>,
	directorByWordpressId?: GraphQLTypes["Director"],
	directorByImage?: GraphQLTypes["Director"],
	directorByLink?: GraphQLTypes["Director"],
	directorByContentGroups?: GraphQLTypes["Director"],
	paginateDirector: GraphQLTypes["DirectorConnection"]
};
	["DirectorLocationMeta"]: {
	__typename: "DirectorLocationMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	city?: GraphQLTypes["FieldMeta"],
	director?: GraphQLTypes["FieldMeta"]
};
	["DirectorLocationDirectorByWordpressIdUniqueWhere"]: {
		wordpressId?: string
};
	["DirectorLocationDirectorByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["DirectorLocationDirectorByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["HomePageUniqueWhere"],
	redirect?: GraphQLTypes["RedirectUniqueWhere"],
	director?: GraphQLTypes["DirectorUniqueWhere"],
	contactsPage?: GraphQLTypes["ContactsPageUniqueWhere"],
	directorsPage?: GraphQLTypes["DirectorsPageUniqueWhere"],
	photographer?: GraphQLTypes["PhotographerUniqueWhere"],
	photographersPage?: GraphQLTypes["PhotographersPageUniqueWhere"],
	ourWorkPage?: GraphQLTypes["OurWorkPageUniqueWhere"],
	tabletopPage?: GraphQLTypes["TabletopPageUniqueWhere"]
};
	["HomePageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["ImageUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	contentGroups?: GraphQLTypes["HomePageContentGroupUniqueWhere"],
	backgroundImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["HomePageContentGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["RedirectUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["DirectorUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	wordpressId?: string,
	image?: GraphQLTypes["ImageUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	contentGroups?: GraphQLTypes["DirectorContentGroupUniqueWhere"]
};
	["DirectorContentGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["ContactsPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["DirectorsPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["PhotographerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	wordpressId?: string,
	image?: GraphQLTypes["ImageUniqueWhere"],
	contentGroups?: GraphQLTypes["PhotographerContentGroupUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["PhotographerContentGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["PhotographersPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	contentGroups?: GraphQLTypes["PhotographersPageContentGroupUniqueWhere"]
};
	["PhotographersPageContentGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["OurWorkPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	contentGroups?: GraphQLTypes["OurWorkPageContentGroupUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["OurWorkPageContentGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["TabletopPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	logo?: GraphQLTypes["ImageUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	contentGroups?: GraphQLTypes["TabletopPageContentGroupUniqueWhere"]
};
	["TabletopPageContentGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["DirectorLocationDirectorByContentGroupsUniqueWhere"]: {
		contentGroups?: GraphQLTypes["DirectorContentGroupUniqueWhere"]
};
	["DirectorConnection"]: {
	__typename: "DirectorConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DirectorEdge"]>
};
	["DirectorEdge"]: {
	__typename: "DirectorEdge",
	node: GraphQLTypes["Director"]
};
	["DirectorContentGroupsByContentGroupUniqueWhere"]: {
		contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["DirectorContentGroupConnection"]: {
	__typename: "DirectorContentGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DirectorContentGroupEdge"]>
};
	["DirectorContentGroupEdge"]: {
	__typename: "DirectorContentGroupEdge",
	node: GraphQLTypes["DirectorContentGroup"]
};
	["ContactsPage"]: {
	__typename: "ContactsPage",
	_meta?: GraphQLTypes["ContactsPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	leadParagraph?: string
};
	["ContactsPageMeta"]: {
	__typename: "ContactsPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"]
};
	["DirectorsPage"]: {
	__typename: "DirectorsPage",
	_meta?: GraphQLTypes["DirectorsPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	leadParagraph?: string
};
	["DirectorsPageMeta"]: {
	__typename: "DirectorsPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"]
};
	["Photographer"]: {
	__typename: "Photographer",
	_meta?: GraphQLTypes["PhotographerMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["Image"],
	contentGroups: Array<GraphQLTypes["PhotographerContentGroup"]>,
	link?: GraphQLTypes["Linkable"],
	photographerLocation?: GraphQLTypes["PhotographerLocation"],
	wordpressId?: string,
	contentGroupsByContentGroup?: GraphQLTypes["PhotographerContentGroup"],
	paginateContentGroups: GraphQLTypes["PhotographerContentGroupConnection"]
};
	["PhotographerMeta"]: {
	__typename: "PhotographerMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	contentGroups?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	photographerLocation?: GraphQLTypes["FieldMeta"],
	wordpressId?: GraphQLTypes["FieldMeta"]
};
	["PhotographerContentGroup"]: {
	__typename: "PhotographerContentGroup",
	_meta?: GraphQLTypes["PhotographerContentGroupMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	photographer?: GraphQLTypes["Photographer"],
	contentGroup?: GraphQLTypes["ContentGroup"]
};
	["PhotographerContentGroupMeta"]: {
	__typename: "PhotographerContentGroupMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	photographer?: GraphQLTypes["FieldMeta"],
	contentGroup?: GraphQLTypes["FieldMeta"]
};
	["PhotographerContentGroupOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	photographer?: GraphQLTypes["PhotographerOrderBy"],
	contentGroup?: GraphQLTypes["ContentGroupOrderBy"]
};
	["PhotographerLocation"]: {
	__typename: "PhotographerLocation",
	_meta?: GraphQLTypes["PhotographerLocationMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	city?: string,
	photographer: Array<GraphQLTypes["Photographer"]>,
	photographerByWordpressId?: GraphQLTypes["Photographer"],
	photographerByImage?: GraphQLTypes["Photographer"],
	photographerByContentGroups?: GraphQLTypes["Photographer"],
	photographerByLink?: GraphQLTypes["Photographer"],
	paginatePhotographer: GraphQLTypes["PhotographerConnection"]
};
	["PhotographerLocationMeta"]: {
	__typename: "PhotographerLocationMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	city?: GraphQLTypes["FieldMeta"],
	photographer?: GraphQLTypes["FieldMeta"]
};
	["PhotographerLocationPhotographerByWordpressIdUniqueWhere"]: {
		wordpressId?: string
};
	["PhotographerLocationPhotographerByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["PhotographerLocationPhotographerByContentGroupsUniqueWhere"]: {
		contentGroups?: GraphQLTypes["PhotographerContentGroupUniqueWhere"]
};
	["PhotographerLocationPhotographerByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["PhotographerConnection"]: {
	__typename: "PhotographerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PhotographerEdge"]>
};
	["PhotographerEdge"]: {
	__typename: "PhotographerEdge",
	node: GraphQLTypes["Photographer"]
};
	["PhotographerContentGroupsByContentGroupUniqueWhere"]: {
		contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["PhotographerContentGroupConnection"]: {
	__typename: "PhotographerContentGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PhotographerContentGroupEdge"]>
};
	["PhotographerContentGroupEdge"]: {
	__typename: "PhotographerContentGroupEdge",
	node: GraphQLTypes["PhotographerContentGroup"]
};
	["PhotographersPage"]: {
	__typename: "PhotographersPage",
	_meta?: GraphQLTypes["PhotographersPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	contentGroups: Array<GraphQLTypes["PhotographersPageContentGroup"]>,
	contentGroupsByContentGroup?: GraphQLTypes["PhotographersPageContentGroup"],
	paginateContentGroups: GraphQLTypes["PhotographersPageContentGroupConnection"]
};
	["PhotographersPageMeta"]: {
	__typename: "PhotographersPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	contentGroups?: GraphQLTypes["FieldMeta"]
};
	["PhotographersPageContentGroup"]: {
	__typename: "PhotographersPageContentGroup",
	_meta?: GraphQLTypes["PhotographersPageContentGroupMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	photographersPage?: GraphQLTypes["PhotographersPage"],
	contentGroup?: GraphQLTypes["ContentGroup"]
};
	["PhotographersPageContentGroupMeta"]: {
	__typename: "PhotographersPageContentGroupMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	photographersPage?: GraphQLTypes["FieldMeta"],
	contentGroup?: GraphQLTypes["FieldMeta"]
};
	["PhotographersPageContentGroupOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	photographersPage?: GraphQLTypes["PhotographersPageOrderBy"],
	contentGroup?: GraphQLTypes["ContentGroupOrderBy"]
};
	["PhotographersPageContentGroupsByContentGroupUniqueWhere"]: {
		contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["PhotographersPageContentGroupConnection"]: {
	__typename: "PhotographersPageContentGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PhotographersPageContentGroupEdge"]>
};
	["PhotographersPageContentGroupEdge"]: {
	__typename: "PhotographersPageContentGroupEdge",
	node: GraphQLTypes["PhotographersPageContentGroup"]
};
	["OurWorkPage"]: {
	__typename: "OurWorkPage",
	_meta?: GraphQLTypes["OurWorkPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	link?: GraphQLTypes["Linkable"],
	contentGroups: Array<GraphQLTypes["OurWorkPageContentGroup"]>,
	seo?: GraphQLTypes["Seo"],
	contentGroupsByContentGroup?: GraphQLTypes["OurWorkPageContentGroup"],
	paginateContentGroups: GraphQLTypes["OurWorkPageContentGroupConnection"]
};
	["OurWorkPageMeta"]: {
	__typename: "OurWorkPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	contentGroups?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["OurWorkPageContentGroup"]: {
	__typename: "OurWorkPageContentGroup",
	_meta?: GraphQLTypes["OurWorkPageContentGroupMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	ourWorkPage?: GraphQLTypes["OurWorkPage"],
	contentGroup?: GraphQLTypes["ContentGroup"]
};
	["OurWorkPageContentGroupMeta"]: {
	__typename: "OurWorkPageContentGroupMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	ourWorkPage?: GraphQLTypes["FieldMeta"],
	contentGroup?: GraphQLTypes["FieldMeta"]
};
	["OurWorkPageContentGroupOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	ourWorkPage?: GraphQLTypes["OurWorkPageOrderBy"],
	contentGroup?: GraphQLTypes["ContentGroupOrderBy"]
};
	["OurWorkPageContentGroupsByContentGroupUniqueWhere"]: {
		contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["OurWorkPageContentGroupConnection"]: {
	__typename: "OurWorkPageContentGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OurWorkPageContentGroupEdge"]>
};
	["OurWorkPageContentGroupEdge"]: {
	__typename: "OurWorkPageContentGroupEdge",
	node: GraphQLTypes["OurWorkPageContentGroup"]
};
	["TabletopPage"]: {
	__typename: "TabletopPage",
	_meta?: GraphQLTypes["TabletopPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	teamTitle?: string,
	link?: GraphQLTypes["Linkable"],
	logo?: GraphQLTypes["Image"],
	seo?: GraphQLTypes["Seo"],
	contentGroups: Array<GraphQLTypes["TabletopPageContentGroup"]>,
	contentGroupsByContentGroup?: GraphQLTypes["TabletopPageContentGroup"],
	paginateContentGroups: GraphQLTypes["TabletopPageContentGroupConnection"]
};
	["TabletopPageMeta"]: {
	__typename: "TabletopPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	teamTitle?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	contentGroups?: GraphQLTypes["FieldMeta"]
};
	["TabletopPageContentGroup"]: {
	__typename: "TabletopPageContentGroup",
	_meta?: GraphQLTypes["TabletopPageContentGroupMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	tabletopPage?: GraphQLTypes["TabletopPage"],
	contentGroup?: GraphQLTypes["ContentGroup"]
};
	["TabletopPageContentGroupMeta"]: {
	__typename: "TabletopPageContentGroupMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	tabletopPage?: GraphQLTypes["FieldMeta"],
	contentGroup?: GraphQLTypes["FieldMeta"]
};
	["TabletopPageContentGroupOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	tabletopPage?: GraphQLTypes["TabletopPageOrderBy"],
	contentGroup?: GraphQLTypes["ContentGroupOrderBy"]
};
	["TabletopPageContentGroupsByContentGroupUniqueWhere"]: {
		contentGroup?: GraphQLTypes["ContentGroupUniqueWhere"]
};
	["TabletopPageContentGroupConnection"]: {
	__typename: "TabletopPageContentGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TabletopPageContentGroupEdge"]>
};
	["TabletopPageContentGroupEdge"]: {
	__typename: "TabletopPageContentGroupEdge",
	node: GraphQLTypes["TabletopPageContentGroup"]
};
	["CardMedia"]: {
	__typename: "CardMedia",
	_meta?: GraphQLTypes["CardMediaMeta"],
	id: GraphQLTypes["UUID"],
	text?: string,
	imageNote?: string,
	image?: GraphQLTypes["Image"]
};
	["CardMediaMeta"]: {
	__typename: "CardMediaMeta",
	id?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	imageNote?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["ContentReferenceOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	block?: GraphQLTypes["ContentBlockOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	cardMedia?: GraphQLTypes["CardMediaOrderBy"]
};
	["ContentBlockOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	json?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"]
};
	["ContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["LinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	externalLink?: GraphQLTypes["OrderDirection"],
	internalLink?: GraphQLTypes["LinkableOrderBy"]
};
	["CardMediaOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	imageNote?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContentReferenceConnection"]: {
	__typename: "ContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
	__typename: "ContentReferenceEdge",
	node: GraphQLTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["ContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"]
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentConnection"]: {
	__typename: "ContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
	__typename: "ContentEdge",
	node: GraphQLTypes["Content"]
};
	["ContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: Array<GraphQLTypes["ContentCreateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	alias?: string
};
	["ContentBlockWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	alias?: string
};
	["ContentReferenceWithoutBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	text?: string,
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	cardMedia?: GraphQLTypes["ContentReferenceCreateCardMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableCreateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableCreateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableCreateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableCreatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableCreatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableCreateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableCreateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateHomePageEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageUniqueWhere"],
	create?: GraphQLTypes["HomePageWithoutLinkCreateInput"]
};
	["HomePageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	tagline?: string,
	logo?: GraphQLTypes["HomePageCreateLogoEntityRelationInput"],
	seo?: GraphQLTypes["HomePageCreateSeoEntityRelationInput"],
	directorsText?: string,
	contentGroups?: Array<GraphQLTypes["HomePageCreateContentGroupsEntityRelationInput"]>,
	backgroundImage?: GraphQLTypes["HomePageCreateBackgroundImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HomePageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HomePageCreateContentGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageContentGroupUniqueWhere"],
	create?: GraphQLTypes["HomePageContentGroupWithoutHomePageCreateInput"],
	alias?: string
};
	["HomePageContentGroupWithoutHomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentGroup?: GraphQLTypes["HomePageContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageContentGroupCreateContentGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["ContentGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	contentType?: GraphQLTypes["ContentGroupType"],
	gallery?: GraphQLTypes["ContentGroupCreateGalleryEntityRelationInput"],
	films?: Array<GraphQLTypes["ContentGroupCreateFilmsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentGroupCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"],
	create?: GraphQLTypes["GalleryCreateInput"]
};
	["GalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["GalleryCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GalleryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryItemUniqueWhere"],
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"],
	alias?: string
};
	["GalleryItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentGroupCreateFilmsEntityRelationInput"]: {
		connect?: GraphQLTypes["FilmItemUniqueWhere"],
	create?: GraphQLTypes["FilmItemWithoutContentGroupsCreateInput"],
	alias?: string
};
	["FilmItemWithoutContentGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	film?: GraphQLTypes["FilmItemCreateFilmEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilmItemCreateFilmEntityRelationInput"]: {
		connect?: GraphQLTypes["FilmUniqueWhere"],
	create?: GraphQLTypes["FilmCreateInput"]
};
	["FilmUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	wordpressId?: string,
	posterImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["FilmCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	author?: string,
	vimeoId?: string,
	posterImage?: GraphQLTypes["FilmCreatePosterImageEntityRelationInput"],
	order?: number,
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["FilmCreatePosterImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HomePageCreateBackgroundImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["LinkableCreateRedirectEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["RedirectWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	targetUrl?: string,
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableCreateDirectorEntityRelationInput"]: {
		connect?: GraphQLTypes["DirectorUniqueWhere"],
	create?: GraphQLTypes["DirectorWithoutLinkCreateInput"]
};
	["DirectorWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["DirectorCreateImageEntityRelationInput"],
	order?: number,
	contentGroups?: Array<GraphQLTypes["DirectorCreateContentGroupsEntityRelationInput"]>,
	directorLocation?: GraphQLTypes["DirectorCreateDirectorLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["DirectorCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["DirectorCreateContentGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["DirectorContentGroupUniqueWhere"],
	create?: GraphQLTypes["DirectorContentGroupWithoutDirectorCreateInput"],
	alias?: string
};
	["DirectorContentGroupWithoutDirectorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentGroup?: GraphQLTypes["DirectorContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DirectorContentGroupCreateContentGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["DirectorCreateDirectorLocationEntityRelationInput"]: {
		connect?: GraphQLTypes["DirectorLocationUniqueWhere"],
	create?: GraphQLTypes["DirectorLocationWithoutDirectorCreateInput"]
};
	["DirectorLocationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	director?: GraphQLTypes["DirectorUniqueWhere"]
};
	["DirectorLocationWithoutDirectorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	city?: string,
	_dummy_field_?: boolean
};
	["LinkableCreateContactsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactsPageUniqueWhere"],
	create?: GraphQLTypes["ContactsPageWithoutLinkCreateInput"]
};
	["ContactsPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["ContactsPageCreateSeoEntityRelationInput"],
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["ContactsPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableCreateDirectorsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["DirectorsPageUniqueWhere"],
	create?: GraphQLTypes["DirectorsPageWithoutLinkCreateInput"]
};
	["DirectorsPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["DirectorsPageCreateSeoEntityRelationInput"],
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["DirectorsPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableCreatePhotographerEntityRelationInput"]: {
		connect?: GraphQLTypes["PhotographerUniqueWhere"],
	create?: GraphQLTypes["PhotographerWithoutLinkCreateInput"]
};
	["PhotographerWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["PhotographerCreateImageEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["PhotographerCreateContentGroupsEntityRelationInput"]>,
	photographerLocation?: GraphQLTypes["PhotographerCreatePhotographerLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["PhotographerCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["PhotographerCreateContentGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["PhotographerContentGroupUniqueWhere"],
	create?: GraphQLTypes["PhotographerContentGroupWithoutPhotographerCreateInput"],
	alias?: string
};
	["PhotographerContentGroupWithoutPhotographerCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentGroup?: GraphQLTypes["PhotographerContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographerContentGroupCreateContentGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["PhotographerCreatePhotographerLocationEntityRelationInput"]: {
		connect?: GraphQLTypes["PhotographerLocationUniqueWhere"],
	create?: GraphQLTypes["PhotographerLocationWithoutPhotographerCreateInput"]
};
	["PhotographerLocationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	photographer?: GraphQLTypes["PhotographerUniqueWhere"]
};
	["PhotographerLocationWithoutPhotographerCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	city?: string,
	_dummy_field_?: boolean
};
	["LinkableCreatePhotographersPageEntityRelationInput"]: {
		connect?: GraphQLTypes["PhotographersPageUniqueWhere"],
	create?: GraphQLTypes["PhotographersPageWithoutLinkCreateInput"]
};
	["PhotographersPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	seo?: GraphQLTypes["PhotographersPageCreateSeoEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["PhotographersPageCreateContentGroupsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PhotographersPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["PhotographersPageCreateContentGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["PhotographersPageContentGroupUniqueWhere"],
	create?: GraphQLTypes["PhotographersPageContentGroupWithoutPhotographersPageCreateInput"],
	alias?: string
};
	["PhotographersPageContentGroupWithoutPhotographersPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentGroup?: GraphQLTypes["PhotographersPageContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographersPageContentGroupCreateContentGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["LinkableCreateOurWorkPageEntityRelationInput"]: {
		connect?: GraphQLTypes["OurWorkPageUniqueWhere"],
	create?: GraphQLTypes["OurWorkPageWithoutLinkCreateInput"]
};
	["OurWorkPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	contentGroups?: Array<GraphQLTypes["OurWorkPageCreateContentGroupsEntityRelationInput"]>,
	seo?: GraphQLTypes["OurWorkPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageCreateContentGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["OurWorkPageContentGroupUniqueWhere"],
	create?: GraphQLTypes["OurWorkPageContentGroupWithoutOurWorkPageCreateInput"],
	alias?: string
};
	["OurWorkPageContentGroupWithoutOurWorkPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentGroup?: GraphQLTypes["OurWorkPageContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageContentGroupCreateContentGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["OurWorkPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableCreateTabletopPageEntityRelationInput"]: {
		connect?: GraphQLTypes["TabletopPageUniqueWhere"],
	create?: GraphQLTypes["TabletopPageWithoutLinkCreateInput"]
};
	["TabletopPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	teamTitle?: string,
	logo?: GraphQLTypes["TabletopPageCreateLogoEntityRelationInput"],
	seo?: GraphQLTypes["TabletopPageCreateSeoEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["TabletopPageCreateContentGroupsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TabletopPageCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["TabletopPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["TabletopPageCreateContentGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["TabletopPageContentGroupUniqueWhere"],
	create?: GraphQLTypes["TabletopPageContentGroupWithoutTabletopPageCreateInput"],
	alias?: string
};
	["TabletopPageContentGroupWithoutTabletopPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentGroup?: GraphQLTypes["TabletopPageContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TabletopPageContentGroupCreateContentGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateCardMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["CardMediaUniqueWhere"],
	create?: GraphQLTypes["CardMediaCreateInput"]
};
	["CardMediaUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"]
};
	["CardMediaCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	imageNote?: string,
	image?: GraphQLTypes["CardMediaCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CardMediaCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentUpdateInput"]: {
		blocks?: Array<GraphQLTypes["ContentUpdateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateBlocksRelationInput"],
	upsert?: GraphQLTypes["ContentUpsertBlocksRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: GraphQLTypes["ContentBlockUniqueWhere"],
	alias?: string
};
	["ContentUpdateBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	data?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
		order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	update?: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["ContentBlockUpdateReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	data?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	text?: string,
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	cardMedia?: GraphQLTypes["ContentReferenceUpdateCardMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["LinkUpsertInternalLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableUpdateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableUpdateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableUpdateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableUpdatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableUpdatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableUpdateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableUpdateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageWithoutLinkCreateInput"],
	update?: GraphQLTypes["HomePageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertHomePageRelationInput"],
	connect?: GraphQLTypes["HomePageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	tagline?: string,
	logo?: GraphQLTypes["HomePageUpdateLogoEntityRelationInput"],
	seo?: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"],
	directorsText?: string,
	contentGroups?: Array<GraphQLTypes["HomePageUpdateContentGroupsEntityRelationInput"]>,
	backgroundImage?: GraphQLTypes["HomePageUpdateBackgroundImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HomePageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpsertOgImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HomePageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["HomePageUpdateContentGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageContentGroupWithoutHomePageCreateInput"],
	update?: GraphQLTypes["HomePageUpdateContentGroupsRelationInput"],
	upsert?: GraphQLTypes["HomePageUpsertContentGroupsRelationInput"],
	connect?: GraphQLTypes["HomePageContentGroupUniqueWhere"],
	disconnect?: GraphQLTypes["HomePageContentGroupUniqueWhere"],
	delete?: GraphQLTypes["HomePageContentGroupUniqueWhere"],
	alias?: string
};
	["HomePageUpdateContentGroupsRelationInput"]: {
		by?: GraphQLTypes["HomePageContentGroupUniqueWhere"],
	data?: GraphQLTypes["HomePageContentGroupWithoutHomePageUpdateInput"]
};
	["HomePageContentGroupWithoutHomePageUpdateInput"]: {
		order?: number,
	contentGroup?: GraphQLTypes["HomePageContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageContentGroupUpdateContentGroupEntityRelationInput"]: {
		create?: GraphQLTypes["ContentGroupCreateInput"],
	update?: GraphQLTypes["ContentGroupUpdateInput"],
	upsert?: GraphQLTypes["HomePageContentGroupUpsertContentGroupRelationInput"],
	connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentGroupUpdateInput"]: {
		title?: string,
	contentType?: GraphQLTypes["ContentGroupType"],
	gallery?: GraphQLTypes["ContentGroupUpdateGalleryEntityRelationInput"],
	films?: Array<GraphQLTypes["ContentGroupUpdateFilmsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentGroupUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryCreateInput"],
	update?: GraphQLTypes["GalleryUpdateInput"],
	upsert?: GraphQLTypes["ContentGroupUpsertGalleryRelationInput"],
	connect?: GraphQLTypes["GalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryUpdateInput"]: {
		items?: Array<GraphQLTypes["GalleryUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GalleryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryItemWithoutListCreateInput"],
	update?: GraphQLTypes["GalleryUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["GalleryUpsertItemsRelationInput"],
	connect?: GraphQLTypes["GalleryItemUniqueWhere"],
	disconnect?: GraphQLTypes["GalleryItemUniqueWhere"],
	delete?: GraphQLTypes["GalleryItemUniqueWhere"],
	alias?: string
};
	["GalleryUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["GalleryItemUniqueWhere"],
	data?: GraphQLTypes["GalleryItemWithoutListUpdateInput"]
};
	["GalleryItemWithoutListUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["GalleryItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["GalleryUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["GalleryItemUniqueWhere"],
	update?: GraphQLTypes["GalleryItemWithoutListUpdateInput"],
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"]
};
	["ContentGroupUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["GalleryUpdateInput"],
	create?: GraphQLTypes["GalleryCreateInput"]
};
	["ContentGroupUpdateFilmsEntityRelationInput"]: {
		create?: GraphQLTypes["FilmItemWithoutContentGroupsCreateInput"],
	update?: GraphQLTypes["ContentGroupUpdateFilmsRelationInput"],
	upsert?: GraphQLTypes["ContentGroupUpsertFilmsRelationInput"],
	connect?: GraphQLTypes["FilmItemUniqueWhere"],
	disconnect?: GraphQLTypes["FilmItemUniqueWhere"],
	delete?: GraphQLTypes["FilmItemUniqueWhere"],
	alias?: string
};
	["ContentGroupUpdateFilmsRelationInput"]: {
		by?: GraphQLTypes["FilmItemUniqueWhere"],
	data?: GraphQLTypes["FilmItemWithoutContentGroupsUpdateInput"]
};
	["FilmItemWithoutContentGroupsUpdateInput"]: {
		order?: number,
	film?: GraphQLTypes["FilmItemUpdateFilmEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilmItemUpdateFilmEntityRelationInput"]: {
		create?: GraphQLTypes["FilmCreateInput"],
	update?: GraphQLTypes["FilmUpdateInput"],
	upsert?: GraphQLTypes["FilmItemUpsertFilmRelationInput"],
	connect?: GraphQLTypes["FilmUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FilmUpdateInput"]: {
		name?: string,
	author?: string,
	vimeoId?: string,
	posterImage?: GraphQLTypes["FilmUpdatePosterImageEntityRelationInput"],
	order?: number,
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["FilmUpdatePosterImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["FilmUpsertPosterImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FilmUpsertPosterImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FilmItemUpsertFilmRelationInput"]: {
		update?: GraphQLTypes["FilmUpdateInput"],
	create?: GraphQLTypes["FilmCreateInput"]
};
	["ContentGroupUpsertFilmsRelationInput"]: {
		by?: GraphQLTypes["FilmItemUniqueWhere"],
	update?: GraphQLTypes["FilmItemWithoutContentGroupsUpdateInput"],
	create?: GraphQLTypes["FilmItemWithoutContentGroupsCreateInput"]
};
	["HomePageContentGroupUpsertContentGroupRelationInput"]: {
		update?: GraphQLTypes["ContentGroupUpdateInput"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["HomePageUpsertContentGroupsRelationInput"]: {
		by?: GraphQLTypes["HomePageContentGroupUniqueWhere"],
	update?: GraphQLTypes["HomePageContentGroupWithoutHomePageUpdateInput"],
	create?: GraphQLTypes["HomePageContentGroupWithoutHomePageCreateInput"]
};
	["HomePageUpdateBackgroundImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertBackgroundImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageUpsertBackgroundImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["LinkableUpsertHomePageRelationInput"]: {
		update?: GraphQLTypes["HomePageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["HomePageWithoutLinkCreateInput"]
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutLinkCreateInput"],
	update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertRedirectRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RedirectWithoutLinkUpdateInput"]: {
		targetUrl?: string,
	target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RedirectUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableUpsertRedirectRelationInput"]: {
		update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["LinkableUpdateDirectorEntityRelationInput"]: {
		create?: GraphQLTypes["DirectorWithoutLinkCreateInput"],
	update?: GraphQLTypes["DirectorWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertDirectorRelationInput"],
	connect?: GraphQLTypes["DirectorUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["DirectorWithoutLinkUpdateInput"]: {
		name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["DirectorUpdateImageEntityRelationInput"],
	order?: number,
	contentGroups?: Array<GraphQLTypes["DirectorUpdateContentGroupsEntityRelationInput"]>,
	directorLocation?: GraphQLTypes["DirectorUpdateDirectorLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["DirectorUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["DirectorUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["DirectorUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["DirectorUpdateContentGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["DirectorContentGroupWithoutDirectorCreateInput"],
	update?: GraphQLTypes["DirectorUpdateContentGroupsRelationInput"],
	upsert?: GraphQLTypes["DirectorUpsertContentGroupsRelationInput"],
	connect?: GraphQLTypes["DirectorContentGroupUniqueWhere"],
	disconnect?: GraphQLTypes["DirectorContentGroupUniqueWhere"],
	delete?: GraphQLTypes["DirectorContentGroupUniqueWhere"],
	alias?: string
};
	["DirectorUpdateContentGroupsRelationInput"]: {
		by?: GraphQLTypes["DirectorContentGroupUniqueWhere"],
	data?: GraphQLTypes["DirectorContentGroupWithoutDirectorUpdateInput"]
};
	["DirectorContentGroupWithoutDirectorUpdateInput"]: {
		order?: number,
	contentGroup?: GraphQLTypes["DirectorContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DirectorContentGroupUpdateContentGroupEntityRelationInput"]: {
		create?: GraphQLTypes["ContentGroupCreateInput"],
	update?: GraphQLTypes["ContentGroupUpdateInput"],
	upsert?: GraphQLTypes["DirectorContentGroupUpsertContentGroupRelationInput"],
	connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["DirectorContentGroupUpsertContentGroupRelationInput"]: {
		update?: GraphQLTypes["ContentGroupUpdateInput"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["DirectorUpsertContentGroupsRelationInput"]: {
		by?: GraphQLTypes["DirectorContentGroupUniqueWhere"],
	update?: GraphQLTypes["DirectorContentGroupWithoutDirectorUpdateInput"],
	create?: GraphQLTypes["DirectorContentGroupWithoutDirectorCreateInput"]
};
	["DirectorUpdateDirectorLocationEntityRelationInput"]: {
		create?: GraphQLTypes["DirectorLocationWithoutDirectorCreateInput"],
	update?: GraphQLTypes["DirectorLocationWithoutDirectorUpdateInput"],
	upsert?: GraphQLTypes["DirectorUpsertDirectorLocationRelationInput"],
	connect?: GraphQLTypes["DirectorLocationUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["DirectorLocationWithoutDirectorUpdateInput"]: {
		order?: number,
	city?: string,
	_dummy_field_?: boolean
};
	["DirectorUpsertDirectorLocationRelationInput"]: {
		update?: GraphQLTypes["DirectorLocationWithoutDirectorUpdateInput"],
	create?: GraphQLTypes["DirectorLocationWithoutDirectorCreateInput"]
};
	["LinkableUpsertDirectorRelationInput"]: {
		update?: GraphQLTypes["DirectorWithoutLinkUpdateInput"],
	create?: GraphQLTypes["DirectorWithoutLinkCreateInput"]
};
	["LinkableUpdateContactsPageEntityRelationInput"]: {
		create?: GraphQLTypes["ContactsPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["ContactsPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertContactsPageRelationInput"],
	connect?: GraphQLTypes["ContactsPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactsPageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["ContactsPageUpdateSeoEntityRelationInput"],
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["ContactsPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ContactsPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactsPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertContactsPageRelationInput"]: {
		update?: GraphQLTypes["ContactsPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["ContactsPageWithoutLinkCreateInput"]
};
	["LinkableUpdateDirectorsPageEntityRelationInput"]: {
		create?: GraphQLTypes["DirectorsPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["DirectorsPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertDirectorsPageRelationInput"],
	connect?: GraphQLTypes["DirectorsPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["DirectorsPageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["DirectorsPageUpdateSeoEntityRelationInput"],
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["DirectorsPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["DirectorsPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["DirectorsPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertDirectorsPageRelationInput"]: {
		update?: GraphQLTypes["DirectorsPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["DirectorsPageWithoutLinkCreateInput"]
};
	["LinkableUpdatePhotographerEntityRelationInput"]: {
		create?: GraphQLTypes["PhotographerWithoutLinkCreateInput"],
	update?: GraphQLTypes["PhotographerWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertPhotographerRelationInput"],
	connect?: GraphQLTypes["PhotographerUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PhotographerWithoutLinkUpdateInput"]: {
		order?: number,
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["PhotographerUpdateImageEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["PhotographerUpdateContentGroupsEntityRelationInput"]>,
	photographerLocation?: GraphQLTypes["PhotographerUpdatePhotographerLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["PhotographerUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["PhotographerUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PhotographerUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["PhotographerUpdateContentGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["PhotographerContentGroupWithoutPhotographerCreateInput"],
	update?: GraphQLTypes["PhotographerUpdateContentGroupsRelationInput"],
	upsert?: GraphQLTypes["PhotographerUpsertContentGroupsRelationInput"],
	connect?: GraphQLTypes["PhotographerContentGroupUniqueWhere"],
	disconnect?: GraphQLTypes["PhotographerContentGroupUniqueWhere"],
	delete?: GraphQLTypes["PhotographerContentGroupUniqueWhere"],
	alias?: string
};
	["PhotographerUpdateContentGroupsRelationInput"]: {
		by?: GraphQLTypes["PhotographerContentGroupUniqueWhere"],
	data?: GraphQLTypes["PhotographerContentGroupWithoutPhotographerUpdateInput"]
};
	["PhotographerContentGroupWithoutPhotographerUpdateInput"]: {
		order?: number,
	contentGroup?: GraphQLTypes["PhotographerContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographerContentGroupUpdateContentGroupEntityRelationInput"]: {
		create?: GraphQLTypes["ContentGroupCreateInput"],
	update?: GraphQLTypes["ContentGroupUpdateInput"],
	upsert?: GraphQLTypes["PhotographerContentGroupUpsertContentGroupRelationInput"],
	connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PhotographerContentGroupUpsertContentGroupRelationInput"]: {
		update?: GraphQLTypes["ContentGroupUpdateInput"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["PhotographerUpsertContentGroupsRelationInput"]: {
		by?: GraphQLTypes["PhotographerContentGroupUniqueWhere"],
	update?: GraphQLTypes["PhotographerContentGroupWithoutPhotographerUpdateInput"],
	create?: GraphQLTypes["PhotographerContentGroupWithoutPhotographerCreateInput"]
};
	["PhotographerUpdatePhotographerLocationEntityRelationInput"]: {
		create?: GraphQLTypes["PhotographerLocationWithoutPhotographerCreateInput"],
	update?: GraphQLTypes["PhotographerLocationWithoutPhotographerUpdateInput"],
	upsert?: GraphQLTypes["PhotographerUpsertPhotographerLocationRelationInput"],
	connect?: GraphQLTypes["PhotographerLocationUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PhotographerLocationWithoutPhotographerUpdateInput"]: {
		order?: number,
	city?: string,
	_dummy_field_?: boolean
};
	["PhotographerUpsertPhotographerLocationRelationInput"]: {
		update?: GraphQLTypes["PhotographerLocationWithoutPhotographerUpdateInput"],
	create?: GraphQLTypes["PhotographerLocationWithoutPhotographerCreateInput"]
};
	["LinkableUpsertPhotographerRelationInput"]: {
		update?: GraphQLTypes["PhotographerWithoutLinkUpdateInput"],
	create?: GraphQLTypes["PhotographerWithoutLinkCreateInput"]
};
	["LinkableUpdatePhotographersPageEntityRelationInput"]: {
		create?: GraphQLTypes["PhotographersPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["PhotographersPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertPhotographersPageRelationInput"],
	connect?: GraphQLTypes["PhotographersPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PhotographersPageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	seo?: GraphQLTypes["PhotographersPageUpdateSeoEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["PhotographersPageUpdateContentGroupsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PhotographersPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["PhotographersPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PhotographersPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["PhotographersPageUpdateContentGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["PhotographersPageContentGroupWithoutPhotographersPageCreateInput"],
	update?: GraphQLTypes["PhotographersPageUpdateContentGroupsRelationInput"],
	upsert?: GraphQLTypes["PhotographersPageUpsertContentGroupsRelationInput"],
	connect?: GraphQLTypes["PhotographersPageContentGroupUniqueWhere"],
	disconnect?: GraphQLTypes["PhotographersPageContentGroupUniqueWhere"],
	delete?: GraphQLTypes["PhotographersPageContentGroupUniqueWhere"],
	alias?: string
};
	["PhotographersPageUpdateContentGroupsRelationInput"]: {
		by?: GraphQLTypes["PhotographersPageContentGroupUniqueWhere"],
	data?: GraphQLTypes["PhotographersPageContentGroupWithoutPhotographersPageUpdateInput"]
};
	["PhotographersPageContentGroupWithoutPhotographersPageUpdateInput"]: {
		order?: number,
	contentGroup?: GraphQLTypes["PhotographersPageContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographersPageContentGroupUpdateContentGroupEntityRelationInput"]: {
		create?: GraphQLTypes["ContentGroupCreateInput"],
	update?: GraphQLTypes["ContentGroupUpdateInput"],
	upsert?: GraphQLTypes["PhotographersPageContentGroupUpsertContentGroupRelationInput"],
	connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PhotographersPageContentGroupUpsertContentGroupRelationInput"]: {
		update?: GraphQLTypes["ContentGroupUpdateInput"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["PhotographersPageUpsertContentGroupsRelationInput"]: {
		by?: GraphQLTypes["PhotographersPageContentGroupUniqueWhere"],
	update?: GraphQLTypes["PhotographersPageContentGroupWithoutPhotographersPageUpdateInput"],
	create?: GraphQLTypes["PhotographersPageContentGroupWithoutPhotographersPageCreateInput"]
};
	["LinkableUpsertPhotographersPageRelationInput"]: {
		update?: GraphQLTypes["PhotographersPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["PhotographersPageWithoutLinkCreateInput"]
};
	["LinkableUpdateOurWorkPageEntityRelationInput"]: {
		create?: GraphQLTypes["OurWorkPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["OurWorkPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertOurWorkPageRelationInput"],
	connect?: GraphQLTypes["OurWorkPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["OurWorkPageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	contentGroups?: Array<GraphQLTypes["OurWorkPageUpdateContentGroupsEntityRelationInput"]>,
	seo?: GraphQLTypes["OurWorkPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageUpdateContentGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["OurWorkPageContentGroupWithoutOurWorkPageCreateInput"],
	update?: GraphQLTypes["OurWorkPageUpdateContentGroupsRelationInput"],
	upsert?: GraphQLTypes["OurWorkPageUpsertContentGroupsRelationInput"],
	connect?: GraphQLTypes["OurWorkPageContentGroupUniqueWhere"],
	disconnect?: GraphQLTypes["OurWorkPageContentGroupUniqueWhere"],
	delete?: GraphQLTypes["OurWorkPageContentGroupUniqueWhere"],
	alias?: string
};
	["OurWorkPageUpdateContentGroupsRelationInput"]: {
		by?: GraphQLTypes["OurWorkPageContentGroupUniqueWhere"],
	data?: GraphQLTypes["OurWorkPageContentGroupWithoutOurWorkPageUpdateInput"]
};
	["OurWorkPageContentGroupWithoutOurWorkPageUpdateInput"]: {
		order?: number,
	contentGroup?: GraphQLTypes["OurWorkPageContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageContentGroupUpdateContentGroupEntityRelationInput"]: {
		create?: GraphQLTypes["ContentGroupCreateInput"],
	update?: GraphQLTypes["ContentGroupUpdateInput"],
	upsert?: GraphQLTypes["OurWorkPageContentGroupUpsertContentGroupRelationInput"],
	connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["OurWorkPageContentGroupUpsertContentGroupRelationInput"]: {
		update?: GraphQLTypes["ContentGroupUpdateInput"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["OurWorkPageUpsertContentGroupsRelationInput"]: {
		by?: GraphQLTypes["OurWorkPageContentGroupUniqueWhere"],
	update?: GraphQLTypes["OurWorkPageContentGroupWithoutOurWorkPageUpdateInput"],
	create?: GraphQLTypes["OurWorkPageContentGroupWithoutOurWorkPageCreateInput"]
};
	["OurWorkPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["OurWorkPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["OurWorkPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertOurWorkPageRelationInput"]: {
		update?: GraphQLTypes["OurWorkPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["OurWorkPageWithoutLinkCreateInput"]
};
	["LinkableUpdateTabletopPageEntityRelationInput"]: {
		create?: GraphQLTypes["TabletopPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["TabletopPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertTabletopPageRelationInput"],
	connect?: GraphQLTypes["TabletopPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TabletopPageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	teamTitle?: string,
	logo?: GraphQLTypes["TabletopPageUpdateLogoEntityRelationInput"],
	seo?: GraphQLTypes["TabletopPageUpdateSeoEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["TabletopPageUpdateContentGroupsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TabletopPageUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["TabletopPageUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TabletopPageUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["TabletopPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["TabletopPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TabletopPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["TabletopPageUpdateContentGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["TabletopPageContentGroupWithoutTabletopPageCreateInput"],
	update?: GraphQLTypes["TabletopPageUpdateContentGroupsRelationInput"],
	upsert?: GraphQLTypes["TabletopPageUpsertContentGroupsRelationInput"],
	connect?: GraphQLTypes["TabletopPageContentGroupUniqueWhere"],
	disconnect?: GraphQLTypes["TabletopPageContentGroupUniqueWhere"],
	delete?: GraphQLTypes["TabletopPageContentGroupUniqueWhere"],
	alias?: string
};
	["TabletopPageUpdateContentGroupsRelationInput"]: {
		by?: GraphQLTypes["TabletopPageContentGroupUniqueWhere"],
	data?: GraphQLTypes["TabletopPageContentGroupWithoutTabletopPageUpdateInput"]
};
	["TabletopPageContentGroupWithoutTabletopPageUpdateInput"]: {
		order?: number,
	contentGroup?: GraphQLTypes["TabletopPageContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TabletopPageContentGroupUpdateContentGroupEntityRelationInput"]: {
		create?: GraphQLTypes["ContentGroupCreateInput"],
	update?: GraphQLTypes["ContentGroupUpdateInput"],
	upsert?: GraphQLTypes["TabletopPageContentGroupUpsertContentGroupRelationInput"],
	connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TabletopPageContentGroupUpsertContentGroupRelationInput"]: {
		update?: GraphQLTypes["ContentGroupUpdateInput"],
	create?: GraphQLTypes["ContentGroupCreateInput"]
};
	["TabletopPageUpsertContentGroupsRelationInput"]: {
		by?: GraphQLTypes["TabletopPageContentGroupUniqueWhere"],
	update?: GraphQLTypes["TabletopPageContentGroupWithoutTabletopPageUpdateInput"],
	create?: GraphQLTypes["TabletopPageContentGroupWithoutTabletopPageCreateInput"]
};
	["LinkableUpsertTabletopPageRelationInput"]: {
		update?: GraphQLTypes["TabletopPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["TabletopPageWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["ContentReferenceUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateCardMediaEntityRelationInput"]: {
		create?: GraphQLTypes["CardMediaCreateInput"],
	update?: GraphQLTypes["CardMediaUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertCardMediaRelationInput"],
	connect?: GraphQLTypes["CardMediaUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["CardMediaUpdateInput"]: {
		text?: string,
	imageNote?: string,
	image?: GraphQLTypes["CardMediaUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CardMediaUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["CardMediaUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["CardMediaUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertCardMediaRelationInput"]: {
		update?: GraphQLTypes["CardMediaUpdateInput"],
	create?: GraphQLTypes["CardMediaCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	update?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	update?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentWithoutBlocksCreateInput"],
	update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	delete?: boolean
};
	["ContentWithoutBlocksUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ContentBlockUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	text?: string,
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	cardMedia?: GraphQLTypes["ContentReferenceCreateCardMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentBlockWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	text?: string,
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	cardMedia?: GraphQLTypes["ContentReferenceUpdateCardMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"],
	update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: boolean
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertBlockRelationInput"]: {
		update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["CardMediaConnection"]: {
	__typename: "CardMediaConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CardMediaEdge"]>
};
	["CardMediaEdge"]: {
	__typename: "CardMediaEdge",
	node: GraphQLTypes["CardMedia"]
};
	["FallbackSeo"]: {
	__typename: "FallbackSeo",
	_meta?: GraphQLTypes["FallbackSeoMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	seo?: GraphQLTypes["Seo"]
};
	["FallbackSeoMeta"]: {
	__typename: "FallbackSeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["FallbackSeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["FallbackSeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["FallbackSeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["FallbackSeoWhere"] | undefined>,
	not?: GraphQLTypes["FallbackSeoWhere"]
};
	["FallbackSeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["FallbackSeoConnection"]: {
	__typename: "FallbackSeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FallbackSeoEdge"]>
};
	["FallbackSeoEdge"]: {
	__typename: "FallbackSeoEdge",
	node: GraphQLTypes["FallbackSeo"]
};
	["FallbackSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["FallbackSeoCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FallbackSeoCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["FallbackSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["FallbackSeoUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FallbackSeoUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["FallbackSeoUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FallbackSeoUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["Footer"]: {
	__typename: "Footer",
	_meta?: GraphQLTypes["FooterMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	logo?: GraphQLTypes["Image"],
	socialLinks: Array<GraphQLTypes["SocialLink"]>,
	directorsText?: string,
	contactText?: string,
	directorsButton?: GraphQLTypes["Link"],
	contactButton?: GraphQLTypes["Link"],
	paginateSocialLinks: GraphQLTypes["SocialLinkConnection"]
};
	["FooterMeta"]: {
	__typename: "FooterMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	socialLinks?: GraphQLTypes["FieldMeta"],
	directorsText?: GraphQLTypes["FieldMeta"],
	contactText?: GraphQLTypes["FieldMeta"],
	directorsButton?: GraphQLTypes["FieldMeta"],
	contactButton?: GraphQLTypes["FieldMeta"]
};
	["SocialLink"]: {
	__typename: "SocialLink",
	_meta?: GraphQLTypes["SocialLinkMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["SocialLinkType"],
	order: number,
	link?: string,
	linkLabel?: string
};
	["SocialLinkMeta"]: {
	__typename: "SocialLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	linkLabel?: GraphQLTypes["FieldMeta"]
};
	["SocialLinkType"]: SocialLinkType;
	["SocialLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["SocialLinkTypeCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["StringCondition"],
	linkLabel?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["SocialLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialLinkWhere"] | undefined>,
	not?: GraphQLTypes["SocialLinkWhere"]
};
	["SocialLinkTypeCondition"]: {
		and?: Array<GraphQLTypes["SocialLinkTypeCondition"]>,
	or?: Array<GraphQLTypes["SocialLinkTypeCondition"]>,
	not?: GraphQLTypes["SocialLinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["SocialLinkType"],
	notEq?: GraphQLTypes["SocialLinkType"],
	in?: Array<GraphQLTypes["SocialLinkType"]>,
	notIn?: Array<GraphQLTypes["SocialLinkType"]>,
	lt?: GraphQLTypes["SocialLinkType"],
	lte?: GraphQLTypes["SocialLinkType"],
	gt?: GraphQLTypes["SocialLinkType"],
	gte?: GraphQLTypes["SocialLinkType"]
};
	["SocialLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["OrderDirection"],
	linkLabel?: GraphQLTypes["OrderDirection"]
};
	["SocialLinkConnection"]: {
	__typename: "SocialLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialLinkEdge"]>
};
	["SocialLinkEdge"]: {
	__typename: "SocialLinkEdge",
	node: GraphQLTypes["SocialLink"]
};
	["FooterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["ImageUniqueWhere"],
	directorsButton?: GraphQLTypes["LinkUniqueWhere"],
	contactButton?: GraphQLTypes["LinkUniqueWhere"]
};
	["FooterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	logo?: GraphQLTypes["ImageWhere"],
	socialLinks?: GraphQLTypes["SocialLinkWhere"],
	directorsText?: GraphQLTypes["StringCondition"],
	contactText?: GraphQLTypes["StringCondition"],
	directorsButton?: GraphQLTypes["LinkWhere"],
	contactButton?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	not?: GraphQLTypes["FooterWhere"]
};
	["FooterOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	logo?: GraphQLTypes["ImageOrderBy"],
	directorsText?: GraphQLTypes["OrderDirection"],
	contactText?: GraphQLTypes["OrderDirection"],
	directorsButton?: GraphQLTypes["LinkOrderBy"],
	contactButton?: GraphQLTypes["LinkOrderBy"]
};
	["FooterConnection"]: {
	__typename: "FooterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterEdge"]>
};
	["FooterEdge"]: {
	__typename: "FooterEdge",
	node: GraphQLTypes["Footer"]
};
	["FooterCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["FooterCreateLogoEntityRelationInput"],
	socialLinks?: Array<GraphQLTypes["FooterCreateSocialLinksEntityRelationInput"]>,
	directorsText?: string,
	contactText?: string,
	directorsButton?: GraphQLTypes["FooterCreateDirectorsButtonEntityRelationInput"],
	contactButton?: GraphQLTypes["FooterCreateContactButtonEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterCreateSocialLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkUniqueWhere"],
	create?: GraphQLTypes["SocialLinkCreateInput"],
	alias?: string
};
	["SocialLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SocialLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["SocialLinkType"],
	order?: number,
	link?: string,
	linkLabel?: string,
	_dummy_field_?: boolean
};
	["FooterCreateDirectorsButtonEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterCreateContactButtonEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["FooterUpdateLogoEntityRelationInput"],
	socialLinks?: Array<GraphQLTypes["FooterUpdateSocialLinksEntityRelationInput"]>,
	directorsText?: string,
	contactText?: string,
	directorsButton?: GraphQLTypes["FooterUpdateDirectorsButtonEntityRelationInput"],
	contactButton?: GraphQLTypes["FooterUpdateContactButtonEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterUpdateSocialLinksEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkCreateInput"],
	update?: GraphQLTypes["FooterUpdateSocialLinksRelationInput"],
	upsert?: GraphQLTypes["FooterUpsertSocialLinksRelationInput"],
	connect?: GraphQLTypes["SocialLinkUniqueWhere"],
	disconnect?: GraphQLTypes["SocialLinkUniqueWhere"],
	delete?: GraphQLTypes["SocialLinkUniqueWhere"],
	alias?: string
};
	["FooterUpdateSocialLinksRelationInput"]: {
		by?: GraphQLTypes["SocialLinkUniqueWhere"],
	data?: GraphQLTypes["SocialLinkUpdateInput"]
};
	["SocialLinkUpdateInput"]: {
		type?: GraphQLTypes["SocialLinkType"],
	order?: number,
	link?: string,
	linkLabel?: string,
	_dummy_field_?: boolean
};
	["FooterUpsertSocialLinksRelationInput"]: {
		by?: GraphQLTypes["SocialLinkUniqueWhere"],
	update?: GraphQLTypes["SocialLinkUpdateInput"],
	create?: GraphQLTypes["SocialLinkCreateInput"]
};
	["FooterUpdateDirectorsButtonEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertDirectorsButtonRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertDirectorsButtonRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterUpdateContactButtonEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertContactButtonRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertContactButtonRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["GalleryConnection"]: {
	__typename: "GalleryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryEdge"]>
};
	["GalleryEdge"]: {
	__typename: "GalleryEdge",
	node: GraphQLTypes["Gallery"]
};
	["GalleryItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["GalleryItemCreateListEntityRelationInput"],
	image?: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"],
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"]
};
	["GalleryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"],
	image?: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryWithoutItemsCreateInput"],
	update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["GalleryItemUpsertListRelationInput"],
	connect?: GraphQLTypes["GalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["GalleryItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"],
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"]
};
	["Header"]: {
	__typename: "Header",
	_meta?: GraphQLTypes["HeaderMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	logo?: GraphQLTypes["Image"],
	links: Array<GraphQLTypes["HeaderLink"]>,
	paginateLinks: GraphQLTypes["HeaderLinkConnection"]
};
	["HeaderMeta"]: {
	__typename: "HeaderMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	links?: GraphQLTypes["FieldMeta"]
};
	["HeaderLink"]: {
	__typename: "HeaderLink",
	_meta?: GraphQLTypes["HeaderLinkMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	link?: GraphQLTypes["Link"]
};
	["HeaderLinkMeta"]: {
	__typename: "HeaderLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["HeaderLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["HeaderLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderLinkWhere"] | undefined>,
	not?: GraphQLTypes["HeaderLinkWhere"]
};
	["HeaderLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["HeaderLinkConnection"]: {
	__typename: "HeaderLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderLinkEdge"]>
};
	["HeaderLinkEdge"]: {
	__typename: "HeaderLinkEdge",
	node: GraphQLTypes["HeaderLink"]
};
	["HeaderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["ImageUniqueWhere"]
};
	["HeaderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	logo?: GraphQLTypes["ImageWhere"],
	links?: GraphQLTypes["HeaderLinkWhere"],
	and?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	not?: GraphQLTypes["HeaderWhere"]
};
	["HeaderOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	logo?: GraphQLTypes["ImageOrderBy"]
};
	["HeaderConnection"]: {
	__typename: "HeaderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderEdge"]>
};
	["HeaderEdge"]: {
	__typename: "HeaderEdge",
	node: GraphQLTypes["Header"]
};
	["HeaderCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["HeaderCreateLogoEntityRelationInput"],
	links?: Array<GraphQLTypes["HeaderCreateLinksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HeaderCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLinkUniqueWhere"],
	create?: GraphQLTypes["HeaderLinkCreateInput"],
	alias?: string
};
	["HeaderLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["HeaderLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["HeaderLinkCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLinkCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["HeaderUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"],
	links?: Array<GraphQLTypes["HeaderUpdateLinksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HeaderUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["HeaderUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLinkCreateInput"],
	update?: GraphQLTypes["HeaderUpdateLinksRelationInput"],
	upsert?: GraphQLTypes["HeaderUpsertLinksRelationInput"],
	connect?: GraphQLTypes["HeaderLinkUniqueWhere"],
	disconnect?: GraphQLTypes["HeaderLinkUniqueWhere"],
	delete?: GraphQLTypes["HeaderLinkUniqueWhere"],
	alias?: string
};
	["HeaderUpdateLinksRelationInput"]: {
		by?: GraphQLTypes["HeaderLinkUniqueWhere"],
	data?: GraphQLTypes["HeaderLinkUpdateInput"]
};
	["HeaderLinkUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["HeaderLinkUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLinkUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["HeaderLinkUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderLinkUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["HeaderUpsertLinksRelationInput"]: {
		by?: GraphQLTypes["HeaderLinkUniqueWhere"],
	update?: GraphQLTypes["HeaderLinkUpdateInput"],
	create?: GraphQLTypes["HeaderLinkCreateInput"]
};
	["HomePageConnection"]: {
	__typename: "HomePageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageEdge"]>
};
	["HomePageEdge"]: {
	__typename: "HomePageEdge",
	node: GraphQLTypes["HomePage"]
};
	["HomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	tagline?: string,
	logo?: GraphQLTypes["HomePageCreateLogoEntityRelationInput"],
	seo?: GraphQLTypes["HomePageCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["HomePageCreateLinkEntityRelationInput"],
	directorsText?: string,
	contentGroups?: Array<GraphQLTypes["HomePageCreateContentGroupsEntityRelationInput"]>,
	backgroundImage?: GraphQLTypes["HomePageCreateBackgroundImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"]
};
	["LinkableWithoutHomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableCreateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableCreateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableCreateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableCreatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableCreatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableCreateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableCreateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	tagline?: string,
	logo?: GraphQLTypes["HomePageUpdateLogoEntityRelationInput"],
	seo?: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["HomePageUpdateLinkEntityRelationInput"],
	directorsText?: string,
	contentGroups?: Array<GraphQLTypes["HomePageUpdateContentGroupsEntityRelationInput"]>,
	backgroundImage?: GraphQLTypes["HomePageUpdateBackgroundImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutHomePageUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutHomePageUpdateInput"]: {
		url?: string,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableUpdateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableUpdateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableUpdateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableUpdatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableUpdatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableUpdateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableUpdateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutHomePageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["RedirectConnection"]: {
	__typename: "RedirectConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RedirectEdge"]>
};
	["RedirectEdge"]: {
	__typename: "RedirectEdge",
	node: GraphQLTypes["Redirect"]
};
	["RedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	targetUrl?: string,
	link?: GraphQLTypes["RedirectCreateLinkEntityRelationInput"],
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["LinkableWithoutRedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	director?: GraphQLTypes["LinkableCreateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableCreateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableCreateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableCreatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableCreatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableCreateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableCreateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateInput"]: {
		targetUrl?: string,
	link?: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"],
	target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"],
	update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutRedirectUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	director?: GraphQLTypes["LinkableUpdateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableUpdateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableUpdateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableUpdatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableUpdatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableUpdateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableUpdateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["ContactLocationConnection"]: {
	__typename: "ContactLocationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactLocationEdge"]>
};
	["ContactLocationEdge"]: {
	__typename: "ContactLocationEdge",
	node: GraphQLTypes["ContactLocation"]
};
	["ContactLocationCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	city?: string,
	state?: string,
	address?: string,
	email?: string,
	phone?: string,
	fax?: string,
	note?: string,
	contact?: Array<GraphQLTypes["ContactLocationCreateContactEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContactLocationCreateContactEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactUniqueWhere"],
	create?: GraphQLTypes["ContactWithoutContactLocationCreateInput"],
	alias?: string
};
	["ContactWithoutContactLocationCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	position?: string,
	phone?: string,
	email?: string,
	image?: GraphQLTypes["ContactCreateImageEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["ContactLocationUpdateInput"]: {
		order?: number,
	city?: string,
	state?: string,
	address?: string,
	email?: string,
	phone?: string,
	fax?: string,
	note?: string,
	contact?: Array<GraphQLTypes["ContactLocationUpdateContactEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContactLocationUpdateContactEntityRelationInput"]: {
		create?: GraphQLTypes["ContactWithoutContactLocationCreateInput"],
	update?: GraphQLTypes["ContactLocationUpdateContactRelationInput"],
	upsert?: GraphQLTypes["ContactLocationUpsertContactRelationInput"],
	connect?: GraphQLTypes["ContactUniqueWhere"],
	disconnect?: GraphQLTypes["ContactUniqueWhere"],
	delete?: GraphQLTypes["ContactUniqueWhere"],
	alias?: string
};
	["ContactLocationUpdateContactRelationInput"]: {
		by?: GraphQLTypes["ContactUniqueWhere"],
	data?: GraphQLTypes["ContactWithoutContactLocationUpdateInput"]
};
	["ContactWithoutContactLocationUpdateInput"]: {
		order?: number,
	name?: string,
	position?: string,
	phone?: string,
	email?: string,
	image?: GraphQLTypes["ContactUpdateImageEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["ContactLocationUpsertContactRelationInput"]: {
		by?: GraphQLTypes["ContactUniqueWhere"],
	update?: GraphQLTypes["ContactWithoutContactLocationUpdateInput"],
	create?: GraphQLTypes["ContactWithoutContactLocationCreateInput"]
};
	["DirectorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["DirectorCreateImageEntityRelationInput"],
	link?: GraphQLTypes["DirectorCreateLinkEntityRelationInput"],
	order?: number,
	contentGroups?: Array<GraphQLTypes["DirectorCreateContentGroupsEntityRelationInput"]>,
	directorLocation?: GraphQLTypes["DirectorCreateDirectorLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["DirectorCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutDirectorCreateInput"]
};
	["LinkableWithoutDirectorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableCreateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableCreateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableCreatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableCreatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableCreateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableCreateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DirectorUpdateInput"]: {
		name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["DirectorUpdateImageEntityRelationInput"],
	link?: GraphQLTypes["DirectorUpdateLinkEntityRelationInput"],
	order?: number,
	contentGroups?: Array<GraphQLTypes["DirectorUpdateContentGroupsEntityRelationInput"]>,
	directorLocation?: GraphQLTypes["DirectorUpdateDirectorLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["DirectorUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutDirectorCreateInput"],
	update?: GraphQLTypes["LinkableWithoutDirectorUpdateInput"],
	upsert?: GraphQLTypes["DirectorUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutDirectorUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableUpdateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableUpdateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableUpdatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableUpdatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableUpdateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableUpdateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DirectorUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutDirectorUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutDirectorCreateInput"]
};
	["FilmConnection"]: {
	__typename: "FilmConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FilmEdge"]>
};
	["FilmEdge"]: {
	__typename: "FilmEdge",
	node: GraphQLTypes["Film"]
};
	["DirectorLocationConnection"]: {
	__typename: "DirectorLocationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DirectorLocationEdge"]>
};
	["DirectorLocationEdge"]: {
	__typename: "DirectorLocationEdge",
	node: GraphQLTypes["DirectorLocation"]
};
	["DirectorLocationCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	city?: string,
	director?: Array<GraphQLTypes["DirectorLocationCreateDirectorEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["DirectorLocationCreateDirectorEntityRelationInput"]: {
		connect?: GraphQLTypes["DirectorUniqueWhere"],
	create?: GraphQLTypes["DirectorWithoutDirectorLocationCreateInput"],
	alias?: string
};
	["DirectorWithoutDirectorLocationCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["DirectorCreateImageEntityRelationInput"],
	link?: GraphQLTypes["DirectorCreateLinkEntityRelationInput"],
	order?: number,
	contentGroups?: Array<GraphQLTypes["DirectorCreateContentGroupsEntityRelationInput"]>,
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["DirectorLocationUpdateInput"]: {
		order?: number,
	city?: string,
	director?: Array<GraphQLTypes["DirectorLocationUpdateDirectorEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["DirectorLocationUpdateDirectorEntityRelationInput"]: {
		create?: GraphQLTypes["DirectorWithoutDirectorLocationCreateInput"],
	update?: GraphQLTypes["DirectorLocationUpdateDirectorRelationInput"],
	upsert?: GraphQLTypes["DirectorLocationUpsertDirectorRelationInput"],
	connect?: GraphQLTypes["DirectorUniqueWhere"],
	disconnect?: GraphQLTypes["DirectorUniqueWhere"],
	delete?: GraphQLTypes["DirectorUniqueWhere"],
	alias?: string
};
	["DirectorLocationUpdateDirectorRelationInput"]: {
		by?: GraphQLTypes["DirectorUniqueWhere"],
	data?: GraphQLTypes["DirectorWithoutDirectorLocationUpdateInput"]
};
	["DirectorWithoutDirectorLocationUpdateInput"]: {
		name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["DirectorUpdateImageEntityRelationInput"],
	link?: GraphQLTypes["DirectorUpdateLinkEntityRelationInput"],
	order?: number,
	contentGroups?: Array<GraphQLTypes["DirectorUpdateContentGroupsEntityRelationInput"]>,
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["DirectorLocationUpsertDirectorRelationInput"]: {
		by?: GraphQLTypes["DirectorUniqueWhere"],
	update?: GraphQLTypes["DirectorWithoutDirectorLocationUpdateInput"],
	create?: GraphQLTypes["DirectorWithoutDirectorLocationCreateInput"]
};
	["ContactsPageConnection"]: {
	__typename: "ContactsPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactsPageEdge"]>
};
	["ContactsPageEdge"]: {
	__typename: "ContactsPageEdge",
	node: GraphQLTypes["ContactsPage"]
};
	["ContactsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["ContactsPageCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["ContactsPageCreateLinkEntityRelationInput"],
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["ContactsPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutContactsPageCreateInput"]
};
	["LinkableWithoutContactsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableCreateDirectorEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableCreateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableCreatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableCreatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableCreateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableCreateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactsPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["ContactsPageUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["ContactsPageUpdateLinkEntityRelationInput"],
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["ContactsPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutContactsPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutContactsPageUpdateInput"],
	upsert?: GraphQLTypes["ContactsPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutContactsPageUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableUpdateDirectorEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableUpdateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableUpdatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableUpdatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableUpdateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableUpdateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactsPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutContactsPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutContactsPageCreateInput"]
};
	["DirectorsPageConnection"]: {
	__typename: "DirectorsPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DirectorsPageEdge"]>
};
	["DirectorsPageEdge"]: {
	__typename: "DirectorsPageEdge",
	node: GraphQLTypes["DirectorsPage"]
};
	["DirectorsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["DirectorsPageCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["DirectorsPageCreateLinkEntityRelationInput"],
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["DirectorsPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutDirectorsPageCreateInput"]
};
	["LinkableWithoutDirectorsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableCreateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableCreateContactsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableCreatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableCreatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableCreateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableCreateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DirectorsPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["DirectorsPageUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["DirectorsPageUpdateLinkEntityRelationInput"],
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["DirectorsPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutDirectorsPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutDirectorsPageUpdateInput"],
	upsert?: GraphQLTypes["DirectorsPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutDirectorsPageUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableUpdateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableUpdateContactsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableUpdatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableUpdatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableUpdateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableUpdateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DirectorsPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutDirectorsPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutDirectorsPageCreateInput"]
};
	["FilmItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentGroups?: GraphQLTypes["FilmItemCreateContentGroupsEntityRelationInput"],
	film?: GraphQLTypes["FilmItemCreateFilmEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilmItemCreateContentGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	create?: GraphQLTypes["ContentGroupWithoutFilmsCreateInput"]
};
	["ContentGroupWithoutFilmsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	contentType?: GraphQLTypes["ContentGroupType"],
	gallery?: GraphQLTypes["ContentGroupCreateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilmItemUpdateInput"]: {
		order?: number,
	contentGroups?: GraphQLTypes["FilmItemUpdateContentGroupsEntityRelationInput"],
	film?: GraphQLTypes["FilmItemUpdateFilmEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilmItemUpdateContentGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["ContentGroupWithoutFilmsCreateInput"],
	update?: GraphQLTypes["ContentGroupWithoutFilmsUpdateInput"],
	upsert?: GraphQLTypes["FilmItemUpsertContentGroupsRelationInput"],
	connect?: GraphQLTypes["ContentGroupUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentGroupWithoutFilmsUpdateInput"]: {
		title?: string,
	contentType?: GraphQLTypes["ContentGroupType"],
	gallery?: GraphQLTypes["ContentGroupUpdateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilmItemUpsertContentGroupsRelationInput"]: {
		update?: GraphQLTypes["ContentGroupWithoutFilmsUpdateInput"],
	create?: GraphQLTypes["ContentGroupWithoutFilmsCreateInput"]
};
	["DirectorContentGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	director?: GraphQLTypes["DirectorContentGroupCreateDirectorEntityRelationInput"],
	contentGroup?: GraphQLTypes["DirectorContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DirectorContentGroupCreateDirectorEntityRelationInput"]: {
		connect?: GraphQLTypes["DirectorUniqueWhere"],
	create?: GraphQLTypes["DirectorWithoutContentGroupsCreateInput"]
};
	["DirectorWithoutContentGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["DirectorCreateImageEntityRelationInput"],
	link?: GraphQLTypes["DirectorCreateLinkEntityRelationInput"],
	order?: number,
	directorLocation?: GraphQLTypes["DirectorCreateDirectorLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["DirectorContentGroupUpdateInput"]: {
		order?: number,
	director?: GraphQLTypes["DirectorContentGroupUpdateDirectorEntityRelationInput"],
	contentGroup?: GraphQLTypes["DirectorContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DirectorContentGroupUpdateDirectorEntityRelationInput"]: {
		create?: GraphQLTypes["DirectorWithoutContentGroupsCreateInput"],
	update?: GraphQLTypes["DirectorWithoutContentGroupsUpdateInput"],
	upsert?: GraphQLTypes["DirectorContentGroupUpsertDirectorRelationInput"],
	connect?: GraphQLTypes["DirectorUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["DirectorWithoutContentGroupsUpdateInput"]: {
		name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["DirectorUpdateImageEntityRelationInput"],
	link?: GraphQLTypes["DirectorUpdateLinkEntityRelationInput"],
	order?: number,
	directorLocation?: GraphQLTypes["DirectorUpdateDirectorLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["DirectorContentGroupUpsertDirectorRelationInput"]: {
		update?: GraphQLTypes["DirectorWithoutContentGroupsUpdateInput"],
	create?: GraphQLTypes["DirectorWithoutContentGroupsCreateInput"]
};
	["PhotographerCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["PhotographerCreateImageEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["PhotographerCreateContentGroupsEntityRelationInput"]>,
	link?: GraphQLTypes["PhotographerCreateLinkEntityRelationInput"],
	photographerLocation?: GraphQLTypes["PhotographerCreatePhotographerLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["PhotographerCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutPhotographerCreateInput"]
};
	["LinkableWithoutPhotographerCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableCreateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableCreateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableCreateDirectorsPageEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableCreatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableCreateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableCreateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographerUpdateInput"]: {
		order?: number,
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["PhotographerUpdateImageEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["PhotographerUpdateContentGroupsEntityRelationInput"]>,
	link?: GraphQLTypes["PhotographerUpdateLinkEntityRelationInput"],
	photographerLocation?: GraphQLTypes["PhotographerUpdatePhotographerLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["PhotographerUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutPhotographerCreateInput"],
	update?: GraphQLTypes["LinkableWithoutPhotographerUpdateInput"],
	upsert?: GraphQLTypes["PhotographerUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutPhotographerUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableUpdateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableUpdateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableUpdateDirectorsPageEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableUpdatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableUpdateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableUpdateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographerUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutPhotographerUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutPhotographerCreateInput"]
};
	["PhotographerContentGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	photographer?: GraphQLTypes["PhotographerContentGroupCreatePhotographerEntityRelationInput"],
	contentGroup?: GraphQLTypes["PhotographerContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographerContentGroupCreatePhotographerEntityRelationInput"]: {
		connect?: GraphQLTypes["PhotographerUniqueWhere"],
	create?: GraphQLTypes["PhotographerWithoutContentGroupsCreateInput"]
};
	["PhotographerWithoutContentGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["PhotographerCreateImageEntityRelationInput"],
	link?: GraphQLTypes["PhotographerCreateLinkEntityRelationInput"],
	photographerLocation?: GraphQLTypes["PhotographerCreatePhotographerLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["PhotographerContentGroupUpdateInput"]: {
		order?: number,
	photographer?: GraphQLTypes["PhotographerContentGroupUpdatePhotographerEntityRelationInput"],
	contentGroup?: GraphQLTypes["PhotographerContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographerContentGroupUpdatePhotographerEntityRelationInput"]: {
		create?: GraphQLTypes["PhotographerWithoutContentGroupsCreateInput"],
	update?: GraphQLTypes["PhotographerWithoutContentGroupsUpdateInput"],
	upsert?: GraphQLTypes["PhotographerContentGroupUpsertPhotographerRelationInput"],
	connect?: GraphQLTypes["PhotographerUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PhotographerWithoutContentGroupsUpdateInput"]: {
		order?: number,
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["PhotographerUpdateImageEntityRelationInput"],
	link?: GraphQLTypes["PhotographerUpdateLinkEntityRelationInput"],
	photographerLocation?: GraphQLTypes["PhotographerUpdatePhotographerLocationEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["PhotographerContentGroupUpsertPhotographerRelationInput"]: {
		update?: GraphQLTypes["PhotographerWithoutContentGroupsUpdateInput"],
	create?: GraphQLTypes["PhotographerWithoutContentGroupsCreateInput"]
};
	["PhotographerLocationConnection"]: {
	__typename: "PhotographerLocationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PhotographerLocationEdge"]>
};
	["PhotographerLocationEdge"]: {
	__typename: "PhotographerLocationEdge",
	node: GraphQLTypes["PhotographerLocation"]
};
	["PhotographerLocationCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	city?: string,
	photographer?: Array<GraphQLTypes["PhotographerLocationCreatePhotographerEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PhotographerLocationCreatePhotographerEntityRelationInput"]: {
		connect?: GraphQLTypes["PhotographerUniqueWhere"],
	create?: GraphQLTypes["PhotographerWithoutPhotographerLocationCreateInput"],
	alias?: string
};
	["PhotographerWithoutPhotographerLocationCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["PhotographerCreateImageEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["PhotographerCreateContentGroupsEntityRelationInput"]>,
	link?: GraphQLTypes["PhotographerCreateLinkEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["PhotographerLocationUpdateInput"]: {
		order?: number,
	city?: string,
	photographer?: Array<GraphQLTypes["PhotographerLocationUpdatePhotographerEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PhotographerLocationUpdatePhotographerEntityRelationInput"]: {
		create?: GraphQLTypes["PhotographerWithoutPhotographerLocationCreateInput"],
	update?: GraphQLTypes["PhotographerLocationUpdatePhotographerRelationInput"],
	upsert?: GraphQLTypes["PhotographerLocationUpsertPhotographerRelationInput"],
	connect?: GraphQLTypes["PhotographerUniqueWhere"],
	disconnect?: GraphQLTypes["PhotographerUniqueWhere"],
	delete?: GraphQLTypes["PhotographerUniqueWhere"],
	alias?: string
};
	["PhotographerLocationUpdatePhotographerRelationInput"]: {
		by?: GraphQLTypes["PhotographerUniqueWhere"],
	data?: GraphQLTypes["PhotographerWithoutPhotographerLocationUpdateInput"]
};
	["PhotographerWithoutPhotographerLocationUpdateInput"]: {
		order?: number,
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["PhotographerUpdateImageEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["PhotographerUpdateContentGroupsEntityRelationInput"]>,
	link?: GraphQLTypes["PhotographerUpdateLinkEntityRelationInput"],
	wordpressId?: string,
	_dummy_field_?: boolean
};
	["PhotographerLocationUpsertPhotographerRelationInput"]: {
		by?: GraphQLTypes["PhotographerUniqueWhere"],
	update?: GraphQLTypes["PhotographerWithoutPhotographerLocationUpdateInput"],
	create?: GraphQLTypes["PhotographerWithoutPhotographerLocationCreateInput"]
};
	["PhotographersPageConnection"]: {
	__typename: "PhotographersPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PhotographersPageEdge"]>
};
	["PhotographersPageEdge"]: {
	__typename: "PhotographersPageEdge",
	node: GraphQLTypes["PhotographersPage"]
};
	["PhotographersPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	seo?: GraphQLTypes["PhotographersPageCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["PhotographersPageCreateLinkEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["PhotographersPageCreateContentGroupsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PhotographersPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutPhotographersPageCreateInput"]
};
	["LinkableWithoutPhotographersPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableCreateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableCreateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableCreateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableCreatePhotographerEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableCreateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableCreateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographersPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	seo?: GraphQLTypes["PhotographersPageUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["PhotographersPageUpdateLinkEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["PhotographersPageUpdateContentGroupsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PhotographersPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutPhotographersPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutPhotographersPageUpdateInput"],
	upsert?: GraphQLTypes["PhotographersPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutPhotographersPageUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableUpdateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableUpdateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableUpdateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableUpdatePhotographerEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableUpdateOurWorkPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableUpdateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographersPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutPhotographersPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutPhotographersPageCreateInput"]
};
	["OurWorkPageConnection"]: {
	__typename: "OurWorkPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OurWorkPageEdge"]>
};
	["OurWorkPageEdge"]: {
	__typename: "OurWorkPageEdge",
	node: GraphQLTypes["OurWorkPage"]
};
	["OurWorkPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	link?: GraphQLTypes["OurWorkPageCreateLinkEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["OurWorkPageCreateContentGroupsEntityRelationInput"]>,
	seo?: GraphQLTypes["OurWorkPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutOurWorkPageCreateInput"]
};
	["LinkableWithoutOurWorkPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableCreateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableCreateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableCreateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableCreatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableCreatePhotographersPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableCreateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	link?: GraphQLTypes["OurWorkPageUpdateLinkEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["OurWorkPageUpdateContentGroupsEntityRelationInput"]>,
	seo?: GraphQLTypes["OurWorkPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutOurWorkPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutOurWorkPageUpdateInput"],
	upsert?: GraphQLTypes["OurWorkPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutOurWorkPageUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableUpdateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableUpdateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableUpdateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableUpdatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableUpdatePhotographersPageEntityRelationInput"],
	tabletopPage?: GraphQLTypes["LinkableUpdateTabletopPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutOurWorkPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutOurWorkPageCreateInput"]
};
	["OurWorkPageContentGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	ourWorkPage?: GraphQLTypes["OurWorkPageContentGroupCreateOurWorkPageEntityRelationInput"],
	contentGroup?: GraphQLTypes["OurWorkPageContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageContentGroupCreateOurWorkPageEntityRelationInput"]: {
		connect?: GraphQLTypes["OurWorkPageUniqueWhere"],
	create?: GraphQLTypes["OurWorkPageWithoutContentGroupsCreateInput"]
};
	["OurWorkPageWithoutContentGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	link?: GraphQLTypes["OurWorkPageCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["OurWorkPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageContentGroupUpdateInput"]: {
		order?: number,
	ourWorkPage?: GraphQLTypes["OurWorkPageContentGroupUpdateOurWorkPageEntityRelationInput"],
	contentGroup?: GraphQLTypes["OurWorkPageContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageContentGroupUpdateOurWorkPageEntityRelationInput"]: {
		create?: GraphQLTypes["OurWorkPageWithoutContentGroupsCreateInput"],
	update?: GraphQLTypes["OurWorkPageWithoutContentGroupsUpdateInput"],
	upsert?: GraphQLTypes["OurWorkPageContentGroupUpsertOurWorkPageRelationInput"],
	connect?: GraphQLTypes["OurWorkPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["OurWorkPageWithoutContentGroupsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	link?: GraphQLTypes["OurWorkPageUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["OurWorkPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OurWorkPageContentGroupUpsertOurWorkPageRelationInput"]: {
		update?: GraphQLTypes["OurWorkPageWithoutContentGroupsUpdateInput"],
	create?: GraphQLTypes["OurWorkPageWithoutContentGroupsCreateInput"]
};
	["ContentGroupConnection"]: {
	__typename: "ContentGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentGroupEdge"]>
};
	["ContentGroupEdge"]: {
	__typename: "ContentGroupEdge",
	node: GraphQLTypes["ContentGroup"]
};
	["HomePageContentGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	homePage?: GraphQLTypes["HomePageContentGroupCreateHomePageEntityRelationInput"],
	contentGroup?: GraphQLTypes["HomePageContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageContentGroupCreateHomePageEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageUniqueWhere"],
	create?: GraphQLTypes["HomePageWithoutContentGroupsCreateInput"]
};
	["HomePageWithoutContentGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	tagline?: string,
	logo?: GraphQLTypes["HomePageCreateLogoEntityRelationInput"],
	seo?: GraphQLTypes["HomePageCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["HomePageCreateLinkEntityRelationInput"],
	directorsText?: string,
	backgroundImage?: GraphQLTypes["HomePageCreateBackgroundImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageContentGroupUpdateInput"]: {
		order?: number,
	homePage?: GraphQLTypes["HomePageContentGroupUpdateHomePageEntityRelationInput"],
	contentGroup?: GraphQLTypes["HomePageContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageContentGroupUpdateHomePageEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageWithoutContentGroupsCreateInput"],
	update?: GraphQLTypes["HomePageWithoutContentGroupsUpdateInput"],
	upsert?: GraphQLTypes["HomePageContentGroupUpsertHomePageRelationInput"],
	connect?: GraphQLTypes["HomePageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageWithoutContentGroupsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	tagline?: string,
	logo?: GraphQLTypes["HomePageUpdateLogoEntityRelationInput"],
	seo?: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["HomePageUpdateLinkEntityRelationInput"],
	directorsText?: string,
	backgroundImage?: GraphQLTypes["HomePageUpdateBackgroundImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageContentGroupUpsertHomePageRelationInput"]: {
		update?: GraphQLTypes["HomePageWithoutContentGroupsUpdateInput"],
	create?: GraphQLTypes["HomePageWithoutContentGroupsCreateInput"]
};
	["TabletopPageConnection"]: {
	__typename: "TabletopPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TabletopPageEdge"]>
};
	["TabletopPageEdge"]: {
	__typename: "TabletopPageEdge",
	node: GraphQLTypes["TabletopPage"]
};
	["TabletopPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	teamTitle?: string,
	link?: GraphQLTypes["TabletopPageCreateLinkEntityRelationInput"],
	logo?: GraphQLTypes["TabletopPageCreateLogoEntityRelationInput"],
	seo?: GraphQLTypes["TabletopPageCreateSeoEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["TabletopPageCreateContentGroupsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TabletopPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutTabletopPageCreateInput"]
};
	["LinkableWithoutTabletopPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableCreateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableCreateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableCreateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableCreatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableCreatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableCreateOurWorkPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TabletopPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	teamTitle?: string,
	link?: GraphQLTypes["TabletopPageUpdateLinkEntityRelationInput"],
	logo?: GraphQLTypes["TabletopPageUpdateLogoEntityRelationInput"],
	seo?: GraphQLTypes["TabletopPageUpdateSeoEntityRelationInput"],
	contentGroups?: Array<GraphQLTypes["TabletopPageUpdateContentGroupsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TabletopPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutTabletopPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutTabletopPageUpdateInput"],
	upsert?: GraphQLTypes["TabletopPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutTabletopPageUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	director?: GraphQLTypes["LinkableUpdateDirectorEntityRelationInput"],
	contactsPage?: GraphQLTypes["LinkableUpdateContactsPageEntityRelationInput"],
	directorsPage?: GraphQLTypes["LinkableUpdateDirectorsPageEntityRelationInput"],
	photographer?: GraphQLTypes["LinkableUpdatePhotographerEntityRelationInput"],
	photographersPage?: GraphQLTypes["LinkableUpdatePhotographersPageEntityRelationInput"],
	ourWorkPage?: GraphQLTypes["LinkableUpdateOurWorkPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TabletopPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutTabletopPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutTabletopPageCreateInput"]
};
	["TabletopPageContentGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	tabletopPage?: GraphQLTypes["TabletopPageContentGroupCreateTabletopPageEntityRelationInput"],
	contentGroup?: GraphQLTypes["TabletopPageContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TabletopPageContentGroupCreateTabletopPageEntityRelationInput"]: {
		connect?: GraphQLTypes["TabletopPageUniqueWhere"],
	create?: GraphQLTypes["TabletopPageWithoutContentGroupsCreateInput"]
};
	["TabletopPageWithoutContentGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	teamTitle?: string,
	link?: GraphQLTypes["TabletopPageCreateLinkEntityRelationInput"],
	logo?: GraphQLTypes["TabletopPageCreateLogoEntityRelationInput"],
	seo?: GraphQLTypes["TabletopPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TabletopPageContentGroupUpdateInput"]: {
		order?: number,
	tabletopPage?: GraphQLTypes["TabletopPageContentGroupUpdateTabletopPageEntityRelationInput"],
	contentGroup?: GraphQLTypes["TabletopPageContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TabletopPageContentGroupUpdateTabletopPageEntityRelationInput"]: {
		create?: GraphQLTypes["TabletopPageWithoutContentGroupsCreateInput"],
	update?: GraphQLTypes["TabletopPageWithoutContentGroupsUpdateInput"],
	upsert?: GraphQLTypes["TabletopPageContentGroupUpsertTabletopPageRelationInput"],
	connect?: GraphQLTypes["TabletopPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TabletopPageWithoutContentGroupsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	teamTitle?: string,
	link?: GraphQLTypes["TabletopPageUpdateLinkEntityRelationInput"],
	logo?: GraphQLTypes["TabletopPageUpdateLogoEntityRelationInput"],
	seo?: GraphQLTypes["TabletopPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TabletopPageContentGroupUpsertTabletopPageRelationInput"]: {
		update?: GraphQLTypes["TabletopPageWithoutContentGroupsUpdateInput"],
	create?: GraphQLTypes["TabletopPageWithoutContentGroupsCreateInput"]
};
	["PhotographersPageContentGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	photographersPage?: GraphQLTypes["PhotographersPageContentGroupCreatePhotographersPageEntityRelationInput"],
	contentGroup?: GraphQLTypes["PhotographersPageContentGroupCreateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographersPageContentGroupCreatePhotographersPageEntityRelationInput"]: {
		connect?: GraphQLTypes["PhotographersPageUniqueWhere"],
	create?: GraphQLTypes["PhotographersPageWithoutContentGroupsCreateInput"]
};
	["PhotographersPageWithoutContentGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	seo?: GraphQLTypes["PhotographersPageCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["PhotographersPageCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographersPageContentGroupUpdateInput"]: {
		order?: number,
	photographersPage?: GraphQLTypes["PhotographersPageContentGroupUpdatePhotographersPageEntityRelationInput"],
	contentGroup?: GraphQLTypes["PhotographersPageContentGroupUpdateContentGroupEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographersPageContentGroupUpdatePhotographersPageEntityRelationInput"]: {
		create?: GraphQLTypes["PhotographersPageWithoutContentGroupsCreateInput"],
	update?: GraphQLTypes["PhotographersPageWithoutContentGroupsUpdateInput"],
	upsert?: GraphQLTypes["PhotographersPageContentGroupUpsertPhotographersPageRelationInput"],
	connect?: GraphQLTypes["PhotographersPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PhotographersPageWithoutContentGroupsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	leadParagraph?: string,
	seo?: GraphQLTypes["PhotographersPageUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["PhotographersPageUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographersPageContentGroupUpsertPhotographersPageRelationInput"]: {
		update?: GraphQLTypes["PhotographersPageWithoutContentGroupsUpdateInput"],
	create?: GraphQLTypes["PhotographersPageWithoutContentGroupsCreateInput"]
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	getContact?: GraphQLTypes["Contact"],
	listContact: Array<GraphQLTypes["Contact"]>,
	paginateContact: GraphQLTypes["ContactConnection"],
	validateCreateContact: GraphQLTypes["_ValidationResult"],
	validateUpdateContact: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getCardMedia?: GraphQLTypes["CardMedia"],
	listCardMedia: Array<GraphQLTypes["CardMedia"]>,
	paginateCardMedia: GraphQLTypes["CardMediaConnection"],
	validateCreateCardMedia: GraphQLTypes["_ValidationResult"],
	validateUpdateCardMedia: GraphQLTypes["_ValidationResult"],
	getFallbackSeo?: GraphQLTypes["FallbackSeo"],
	listFallbackSeo: Array<GraphQLTypes["FallbackSeo"]>,
	paginateFallbackSeo: GraphQLTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateFallbackSeo: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getSocialLink?: GraphQLTypes["SocialLink"],
	listSocialLink: Array<GraphQLTypes["SocialLink"]>,
	paginateSocialLink: GraphQLTypes["SocialLinkConnection"],
	validateCreateSocialLink: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLink: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"],
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"],
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHeaderLink?: GraphQLTypes["HeaderLink"],
	listHeaderLink: Array<GraphQLTypes["HeaderLink"]>,
	paginateHeaderLink: GraphQLTypes["HeaderLinkConnection"],
	validateCreateHeaderLink: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLink: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"],
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getContactLocation?: GraphQLTypes["ContactLocation"],
	listContactLocation: Array<GraphQLTypes["ContactLocation"]>,
	paginateContactLocation: GraphQLTypes["ContactLocationConnection"],
	validateCreateContactLocation: GraphQLTypes["_ValidationResult"],
	validateUpdateContactLocation: GraphQLTypes["_ValidationResult"],
	getDirector?: GraphQLTypes["Director"],
	listDirector: Array<GraphQLTypes["Director"]>,
	paginateDirector: GraphQLTypes["DirectorConnection"],
	validateCreateDirector: GraphQLTypes["_ValidationResult"],
	validateUpdateDirector: GraphQLTypes["_ValidationResult"],
	getFilm?: GraphQLTypes["Film"],
	listFilm: Array<GraphQLTypes["Film"]>,
	paginateFilm: GraphQLTypes["FilmConnection"],
	validateCreateFilm: GraphQLTypes["_ValidationResult"],
	validateUpdateFilm: GraphQLTypes["_ValidationResult"],
	getDirectorLocation?: GraphQLTypes["DirectorLocation"],
	listDirectorLocation: Array<GraphQLTypes["DirectorLocation"]>,
	paginateDirectorLocation: GraphQLTypes["DirectorLocationConnection"],
	validateCreateDirectorLocation: GraphQLTypes["_ValidationResult"],
	validateUpdateDirectorLocation: GraphQLTypes["_ValidationResult"],
	getContactsPage?: GraphQLTypes["ContactsPage"],
	listContactsPage: Array<GraphQLTypes["ContactsPage"]>,
	paginateContactsPage: GraphQLTypes["ContactsPageConnection"],
	validateCreateContactsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateContactsPage: GraphQLTypes["_ValidationResult"],
	getDirectorsPage?: GraphQLTypes["DirectorsPage"],
	listDirectorsPage: Array<GraphQLTypes["DirectorsPage"]>,
	paginateDirectorsPage: GraphQLTypes["DirectorsPageConnection"],
	validateCreateDirectorsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateDirectorsPage: GraphQLTypes["_ValidationResult"],
	getFilmItem?: GraphQLTypes["FilmItem"],
	listFilmItem: Array<GraphQLTypes["FilmItem"]>,
	paginateFilmItem: GraphQLTypes["FilmItemConnection"],
	validateCreateFilmItem: GraphQLTypes["_ValidationResult"],
	validateUpdateFilmItem: GraphQLTypes["_ValidationResult"],
	getDirectorContentGroup?: GraphQLTypes["DirectorContentGroup"],
	listDirectorContentGroup: Array<GraphQLTypes["DirectorContentGroup"]>,
	paginateDirectorContentGroup: GraphQLTypes["DirectorContentGroupConnection"],
	validateCreateDirectorContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateDirectorContentGroup: GraphQLTypes["_ValidationResult"],
	getPhotographer?: GraphQLTypes["Photographer"],
	listPhotographer: Array<GraphQLTypes["Photographer"]>,
	paginatePhotographer: GraphQLTypes["PhotographerConnection"],
	validateCreatePhotographer: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographer: GraphQLTypes["_ValidationResult"],
	getPhotographerContentGroup?: GraphQLTypes["PhotographerContentGroup"],
	listPhotographerContentGroup: Array<GraphQLTypes["PhotographerContentGroup"]>,
	paginatePhotographerContentGroup: GraphQLTypes["PhotographerContentGroupConnection"],
	validateCreatePhotographerContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographerContentGroup: GraphQLTypes["_ValidationResult"],
	getPhotographerLocation?: GraphQLTypes["PhotographerLocation"],
	listPhotographerLocation: Array<GraphQLTypes["PhotographerLocation"]>,
	paginatePhotographerLocation: GraphQLTypes["PhotographerLocationConnection"],
	validateCreatePhotographerLocation: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographerLocation: GraphQLTypes["_ValidationResult"],
	getPhotographersPage?: GraphQLTypes["PhotographersPage"],
	listPhotographersPage: Array<GraphQLTypes["PhotographersPage"]>,
	paginatePhotographersPage: GraphQLTypes["PhotographersPageConnection"],
	validateCreatePhotographersPage: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographersPage: GraphQLTypes["_ValidationResult"],
	getOurWorkPage?: GraphQLTypes["OurWorkPage"],
	listOurWorkPage: Array<GraphQLTypes["OurWorkPage"]>,
	paginateOurWorkPage: GraphQLTypes["OurWorkPageConnection"],
	validateCreateOurWorkPage: GraphQLTypes["_ValidationResult"],
	validateUpdateOurWorkPage: GraphQLTypes["_ValidationResult"],
	getOurWorkPageContentGroup?: GraphQLTypes["OurWorkPageContentGroup"],
	listOurWorkPageContentGroup: Array<GraphQLTypes["OurWorkPageContentGroup"]>,
	paginateOurWorkPageContentGroup: GraphQLTypes["OurWorkPageContentGroupConnection"],
	validateCreateOurWorkPageContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateOurWorkPageContentGroup: GraphQLTypes["_ValidationResult"],
	getContentGroup?: GraphQLTypes["ContentGroup"],
	listContentGroup: Array<GraphQLTypes["ContentGroup"]>,
	paginateContentGroup: GraphQLTypes["ContentGroupConnection"],
	validateCreateContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateContentGroup: GraphQLTypes["_ValidationResult"],
	getHomePageContentGroup?: GraphQLTypes["HomePageContentGroup"],
	listHomePageContentGroup: Array<GraphQLTypes["HomePageContentGroup"]>,
	paginateHomePageContentGroup: GraphQLTypes["HomePageContentGroupConnection"],
	validateCreateHomePageContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePageContentGroup: GraphQLTypes["_ValidationResult"],
	getTabletopPage?: GraphQLTypes["TabletopPage"],
	listTabletopPage: Array<GraphQLTypes["TabletopPage"]>,
	paginateTabletopPage: GraphQLTypes["TabletopPageConnection"],
	validateCreateTabletopPage: GraphQLTypes["_ValidationResult"],
	validateUpdateTabletopPage: GraphQLTypes["_ValidationResult"],
	getTabletopPageContentGroup?: GraphQLTypes["TabletopPageContentGroup"],
	listTabletopPageContentGroup: Array<GraphQLTypes["TabletopPageContentGroup"]>,
	paginateTabletopPageContentGroup: GraphQLTypes["TabletopPageContentGroupConnection"],
	validateCreateTabletopPageContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateTabletopPageContentGroup: GraphQLTypes["_ValidationResult"],
	getPhotographersPageContentGroup?: GraphQLTypes["PhotographersPageContentGroup"],
	listPhotographersPageContentGroup: Array<GraphQLTypes["PhotographersPageContentGroup"]>,
	paginatePhotographersPageContentGroup: GraphQLTypes["PhotographersPageContentGroupConnection"],
	validateCreatePhotographersPageContentGroup: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographersPageContentGroup: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string
};
	["Mutation"]: {
	__typename: "Mutation",
	createContact: GraphQLTypes["ContactCreateResult"],
	deleteContact: GraphQLTypes["ContactDeleteResult"],
	updateContact: GraphQLTypes["ContactUpdateResult"],
	upsertContact: GraphQLTypes["ContactUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createCardMedia: GraphQLTypes["CardMediaCreateResult"],
	deleteCardMedia: GraphQLTypes["CardMediaDeleteResult"],
	updateCardMedia: GraphQLTypes["CardMediaUpdateResult"],
	upsertCardMedia: GraphQLTypes["CardMediaUpsertResult"],
	createFallbackSeo: GraphQLTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo: GraphQLTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo: GraphQLTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo: GraphQLTypes["FallbackSeoUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createSocialLink: GraphQLTypes["SocialLinkCreateResult"],
	deleteSocialLink: GraphQLTypes["SocialLinkDeleteResult"],
	updateSocialLink: GraphQLTypes["SocialLinkUpdateResult"],
	upsertSocialLink: GraphQLTypes["SocialLinkUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHeaderLink: GraphQLTypes["HeaderLinkCreateResult"],
	deleteHeaderLink: GraphQLTypes["HeaderLinkDeleteResult"],
	updateHeaderLink: GraphQLTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink: GraphQLTypes["HeaderLinkUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createContactLocation: GraphQLTypes["ContactLocationCreateResult"],
	deleteContactLocation: GraphQLTypes["ContactLocationDeleteResult"],
	updateContactLocation: GraphQLTypes["ContactLocationUpdateResult"],
	upsertContactLocation: GraphQLTypes["ContactLocationUpsertResult"],
	createDirector: GraphQLTypes["DirectorCreateResult"],
	deleteDirector: GraphQLTypes["DirectorDeleteResult"],
	updateDirector: GraphQLTypes["DirectorUpdateResult"],
	upsertDirector: GraphQLTypes["DirectorUpsertResult"],
	createFilm: GraphQLTypes["FilmCreateResult"],
	deleteFilm: GraphQLTypes["FilmDeleteResult"],
	updateFilm: GraphQLTypes["FilmUpdateResult"],
	upsertFilm: GraphQLTypes["FilmUpsertResult"],
	createDirectorLocation: GraphQLTypes["DirectorLocationCreateResult"],
	deleteDirectorLocation: GraphQLTypes["DirectorLocationDeleteResult"],
	updateDirectorLocation: GraphQLTypes["DirectorLocationUpdateResult"],
	upsertDirectorLocation: GraphQLTypes["DirectorLocationUpsertResult"],
	createContactsPage: GraphQLTypes["ContactsPageCreateResult"],
	deleteContactsPage: GraphQLTypes["ContactsPageDeleteResult"],
	updateContactsPage: GraphQLTypes["ContactsPageUpdateResult"],
	upsertContactsPage: GraphQLTypes["ContactsPageUpsertResult"],
	createDirectorsPage: GraphQLTypes["DirectorsPageCreateResult"],
	deleteDirectorsPage: GraphQLTypes["DirectorsPageDeleteResult"],
	updateDirectorsPage: GraphQLTypes["DirectorsPageUpdateResult"],
	upsertDirectorsPage: GraphQLTypes["DirectorsPageUpsertResult"],
	createFilmItem: GraphQLTypes["FilmItemCreateResult"],
	deleteFilmItem: GraphQLTypes["FilmItemDeleteResult"],
	updateFilmItem: GraphQLTypes["FilmItemUpdateResult"],
	upsertFilmItem: GraphQLTypes["FilmItemUpsertResult"],
	createDirectorContentGroup: GraphQLTypes["DirectorContentGroupCreateResult"],
	deleteDirectorContentGroup: GraphQLTypes["DirectorContentGroupDeleteResult"],
	updateDirectorContentGroup: GraphQLTypes["DirectorContentGroupUpdateResult"],
	upsertDirectorContentGroup: GraphQLTypes["DirectorContentGroupUpsertResult"],
	createPhotographer: GraphQLTypes["PhotographerCreateResult"],
	deletePhotographer: GraphQLTypes["PhotographerDeleteResult"],
	updatePhotographer: GraphQLTypes["PhotographerUpdateResult"],
	upsertPhotographer: GraphQLTypes["PhotographerUpsertResult"],
	createPhotographerContentGroup: GraphQLTypes["PhotographerContentGroupCreateResult"],
	deletePhotographerContentGroup: GraphQLTypes["PhotographerContentGroupDeleteResult"],
	updatePhotographerContentGroup: GraphQLTypes["PhotographerContentGroupUpdateResult"],
	upsertPhotographerContentGroup: GraphQLTypes["PhotographerContentGroupUpsertResult"],
	createPhotographerLocation: GraphQLTypes["PhotographerLocationCreateResult"],
	deletePhotographerLocation: GraphQLTypes["PhotographerLocationDeleteResult"],
	updatePhotographerLocation: GraphQLTypes["PhotographerLocationUpdateResult"],
	upsertPhotographerLocation: GraphQLTypes["PhotographerLocationUpsertResult"],
	createPhotographersPage: GraphQLTypes["PhotographersPageCreateResult"],
	deletePhotographersPage: GraphQLTypes["PhotographersPageDeleteResult"],
	updatePhotographersPage: GraphQLTypes["PhotographersPageUpdateResult"],
	upsertPhotographersPage: GraphQLTypes["PhotographersPageUpsertResult"],
	createOurWorkPage: GraphQLTypes["OurWorkPageCreateResult"],
	deleteOurWorkPage: GraphQLTypes["OurWorkPageDeleteResult"],
	updateOurWorkPage: GraphQLTypes["OurWorkPageUpdateResult"],
	upsertOurWorkPage: GraphQLTypes["OurWorkPageUpsertResult"],
	createOurWorkPageContentGroup: GraphQLTypes["OurWorkPageContentGroupCreateResult"],
	deleteOurWorkPageContentGroup: GraphQLTypes["OurWorkPageContentGroupDeleteResult"],
	updateOurWorkPageContentGroup: GraphQLTypes["OurWorkPageContentGroupUpdateResult"],
	upsertOurWorkPageContentGroup: GraphQLTypes["OurWorkPageContentGroupUpsertResult"],
	createContentGroup: GraphQLTypes["ContentGroupCreateResult"],
	deleteContentGroup: GraphQLTypes["ContentGroupDeleteResult"],
	updateContentGroup: GraphQLTypes["ContentGroupUpdateResult"],
	upsertContentGroup: GraphQLTypes["ContentGroupUpsertResult"],
	createHomePageContentGroup: GraphQLTypes["HomePageContentGroupCreateResult"],
	deleteHomePageContentGroup: GraphQLTypes["HomePageContentGroupDeleteResult"],
	updateHomePageContentGroup: GraphQLTypes["HomePageContentGroupUpdateResult"],
	upsertHomePageContentGroup: GraphQLTypes["HomePageContentGroupUpsertResult"],
	createTabletopPage: GraphQLTypes["TabletopPageCreateResult"],
	deleteTabletopPage: GraphQLTypes["TabletopPageDeleteResult"],
	updateTabletopPage: GraphQLTypes["TabletopPageUpdateResult"],
	upsertTabletopPage: GraphQLTypes["TabletopPageUpsertResult"],
	createTabletopPageContentGroup: GraphQLTypes["TabletopPageContentGroupCreateResult"],
	deleteTabletopPageContentGroup: GraphQLTypes["TabletopPageContentGroupDeleteResult"],
	updateTabletopPageContentGroup: GraphQLTypes["TabletopPageContentGroupUpdateResult"],
	upsertTabletopPageContentGroup: GraphQLTypes["TabletopPageContentGroupUpsertResult"],
	createPhotographersPageContentGroup: GraphQLTypes["PhotographersPageContentGroupCreateResult"],
	deletePhotographersPageContentGroup: GraphQLTypes["PhotographersPageContentGroupDeleteResult"],
	updatePhotographersPageContentGroup: GraphQLTypes["PhotographersPageContentGroupUpdateResult"],
	upsertPhotographersPageContentGroup: GraphQLTypes["PhotographersPageContentGroupUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"]
};
	["ContactCreateResult"]: {
	__typename: "ContactCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Contact"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"ContactCreateResult" | "ContactDeleteResult" | "ContactUpdateResult" | "ContactUpsertResult" | "ContentCreateResult" | "ContentDeleteResult" | "ContentUpdateResult" | "ContentUpsertResult" | "ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ContentReferenceCreateResult" | "ContentReferenceDeleteResult" | "ContentReferenceUpdateResult" | "ContentReferenceUpsertResult" | "CardMediaCreateResult" | "CardMediaDeleteResult" | "CardMediaUpdateResult" | "CardMediaUpsertResult" | "FallbackSeoCreateResult" | "FallbackSeoDeleteResult" | "FallbackSeoUpdateResult" | "FallbackSeoUpsertResult" | "FooterCreateResult" | "FooterDeleteResult" | "FooterUpdateResult" | "FooterUpsertResult" | "SocialLinkCreateResult" | "SocialLinkDeleteResult" | "SocialLinkUpdateResult" | "SocialLinkUpsertResult" | "GalleryCreateResult" | "GalleryDeleteResult" | "GalleryUpdateResult" | "GalleryUpsertResult" | "GalleryItemCreateResult" | "GalleryItemDeleteResult" | "GalleryItemUpdateResult" | "GalleryItemUpsertResult" | "HeaderCreateResult" | "HeaderDeleteResult" | "HeaderUpdateResult" | "HeaderUpsertResult" | "HeaderLinkCreateResult" | "HeaderLinkDeleteResult" | "HeaderLinkUpdateResult" | "HeaderLinkUpsertResult" | "HomePageCreateResult" | "HomePageDeleteResult" | "HomePageUpdateResult" | "HomePageUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "RedirectCreateResult" | "RedirectDeleteResult" | "RedirectUpdateResult" | "RedirectUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "ContactLocationCreateResult" | "ContactLocationDeleteResult" | "ContactLocationUpdateResult" | "ContactLocationUpsertResult" | "DirectorCreateResult" | "DirectorDeleteResult" | "DirectorUpdateResult" | "DirectorUpsertResult" | "FilmCreateResult" | "FilmDeleteResult" | "FilmUpdateResult" | "FilmUpsertResult" | "DirectorLocationCreateResult" | "DirectorLocationDeleteResult" | "DirectorLocationUpdateResult" | "DirectorLocationUpsertResult" | "ContactsPageCreateResult" | "ContactsPageDeleteResult" | "ContactsPageUpdateResult" | "ContactsPageUpsertResult" | "DirectorsPageCreateResult" | "DirectorsPageDeleteResult" | "DirectorsPageUpdateResult" | "DirectorsPageUpsertResult" | "FilmItemCreateResult" | "FilmItemDeleteResult" | "FilmItemUpdateResult" | "FilmItemUpsertResult" | "DirectorContentGroupCreateResult" | "DirectorContentGroupDeleteResult" | "DirectorContentGroupUpdateResult" | "DirectorContentGroupUpsertResult" | "PhotographerCreateResult" | "PhotographerDeleteResult" | "PhotographerUpdateResult" | "PhotographerUpsertResult" | "PhotographerContentGroupCreateResult" | "PhotographerContentGroupDeleteResult" | "PhotographerContentGroupUpdateResult" | "PhotographerContentGroupUpsertResult" | "PhotographerLocationCreateResult" | "PhotographerLocationDeleteResult" | "PhotographerLocationUpdateResult" | "PhotographerLocationUpsertResult" | "PhotographersPageCreateResult" | "PhotographersPageDeleteResult" | "PhotographersPageUpdateResult" | "PhotographersPageUpsertResult" | "OurWorkPageCreateResult" | "OurWorkPageDeleteResult" | "OurWorkPageUpdateResult" | "OurWorkPageUpsertResult" | "OurWorkPageContentGroupCreateResult" | "OurWorkPageContentGroupDeleteResult" | "OurWorkPageContentGroupUpdateResult" | "OurWorkPageContentGroupUpsertResult" | "ContentGroupCreateResult" | "ContentGroupDeleteResult" | "ContentGroupUpdateResult" | "ContentGroupUpsertResult" | "HomePageContentGroupCreateResult" | "HomePageContentGroupDeleteResult" | "HomePageContentGroupUpdateResult" | "HomePageContentGroupUpsertResult" | "TabletopPageCreateResult" | "TabletopPageDeleteResult" | "TabletopPageUpdateResult" | "TabletopPageUpsertResult" | "TabletopPageContentGroupCreateResult" | "TabletopPageContentGroupDeleteResult" | "TabletopPageContentGroupUpdateResult" | "TabletopPageContentGroupUpsertResult" | "PhotographersPageContentGroupCreateResult" | "PhotographersPageContentGroupDeleteResult" | "PhotographersPageContentGroupUpdateResult" | "PhotographersPageContentGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on ContactCreateResult']: '__union' & GraphQLTypes["ContactCreateResult"];
	['...on ContactDeleteResult']: '__union' & GraphQLTypes["ContactDeleteResult"];
	['...on ContactUpdateResult']: '__union' & GraphQLTypes["ContactUpdateResult"];
	['...on ContactUpsertResult']: '__union' & GraphQLTypes["ContactUpsertResult"];
	['...on ContentCreateResult']: '__union' & GraphQLTypes["ContentCreateResult"];
	['...on ContentDeleteResult']: '__union' & GraphQLTypes["ContentDeleteResult"];
	['...on ContentUpdateResult']: '__union' & GraphQLTypes["ContentUpdateResult"];
	['...on ContentUpsertResult']: '__union' & GraphQLTypes["ContentUpsertResult"];
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ContentReferenceCreateResult']: '__union' & GraphQLTypes["ContentReferenceCreateResult"];
	['...on ContentReferenceDeleteResult']: '__union' & GraphQLTypes["ContentReferenceDeleteResult"];
	['...on ContentReferenceUpdateResult']: '__union' & GraphQLTypes["ContentReferenceUpdateResult"];
	['...on ContentReferenceUpsertResult']: '__union' & GraphQLTypes["ContentReferenceUpsertResult"];
	['...on CardMediaCreateResult']: '__union' & GraphQLTypes["CardMediaCreateResult"];
	['...on CardMediaDeleteResult']: '__union' & GraphQLTypes["CardMediaDeleteResult"];
	['...on CardMediaUpdateResult']: '__union' & GraphQLTypes["CardMediaUpdateResult"];
	['...on CardMediaUpsertResult']: '__union' & GraphQLTypes["CardMediaUpsertResult"];
	['...on FallbackSeoCreateResult']: '__union' & GraphQLTypes["FallbackSeoCreateResult"];
	['...on FallbackSeoDeleteResult']: '__union' & GraphQLTypes["FallbackSeoDeleteResult"];
	['...on FallbackSeoUpdateResult']: '__union' & GraphQLTypes["FallbackSeoUpdateResult"];
	['...on FallbackSeoUpsertResult']: '__union' & GraphQLTypes["FallbackSeoUpsertResult"];
	['...on FooterCreateResult']: '__union' & GraphQLTypes["FooterCreateResult"];
	['...on FooterDeleteResult']: '__union' & GraphQLTypes["FooterDeleteResult"];
	['...on FooterUpdateResult']: '__union' & GraphQLTypes["FooterUpdateResult"];
	['...on FooterUpsertResult']: '__union' & GraphQLTypes["FooterUpsertResult"];
	['...on SocialLinkCreateResult']: '__union' & GraphQLTypes["SocialLinkCreateResult"];
	['...on SocialLinkDeleteResult']: '__union' & GraphQLTypes["SocialLinkDeleteResult"];
	['...on SocialLinkUpdateResult']: '__union' & GraphQLTypes["SocialLinkUpdateResult"];
	['...on SocialLinkUpsertResult']: '__union' & GraphQLTypes["SocialLinkUpsertResult"];
	['...on GalleryCreateResult']: '__union' & GraphQLTypes["GalleryCreateResult"];
	['...on GalleryDeleteResult']: '__union' & GraphQLTypes["GalleryDeleteResult"];
	['...on GalleryUpdateResult']: '__union' & GraphQLTypes["GalleryUpdateResult"];
	['...on GalleryUpsertResult']: '__union' & GraphQLTypes["GalleryUpsertResult"];
	['...on GalleryItemCreateResult']: '__union' & GraphQLTypes["GalleryItemCreateResult"];
	['...on GalleryItemDeleteResult']: '__union' & GraphQLTypes["GalleryItemDeleteResult"];
	['...on GalleryItemUpdateResult']: '__union' & GraphQLTypes["GalleryItemUpdateResult"];
	['...on GalleryItemUpsertResult']: '__union' & GraphQLTypes["GalleryItemUpsertResult"];
	['...on HeaderCreateResult']: '__union' & GraphQLTypes["HeaderCreateResult"];
	['...on HeaderDeleteResult']: '__union' & GraphQLTypes["HeaderDeleteResult"];
	['...on HeaderUpdateResult']: '__union' & GraphQLTypes["HeaderUpdateResult"];
	['...on HeaderUpsertResult']: '__union' & GraphQLTypes["HeaderUpsertResult"];
	['...on HeaderLinkCreateResult']: '__union' & GraphQLTypes["HeaderLinkCreateResult"];
	['...on HeaderLinkDeleteResult']: '__union' & GraphQLTypes["HeaderLinkDeleteResult"];
	['...on HeaderLinkUpdateResult']: '__union' & GraphQLTypes["HeaderLinkUpdateResult"];
	['...on HeaderLinkUpsertResult']: '__union' & GraphQLTypes["HeaderLinkUpsertResult"];
	['...on HomePageCreateResult']: '__union' & GraphQLTypes["HomePageCreateResult"];
	['...on HomePageDeleteResult']: '__union' & GraphQLTypes["HomePageDeleteResult"];
	['...on HomePageUpdateResult']: '__union' & GraphQLTypes["HomePageUpdateResult"];
	['...on HomePageUpsertResult']: '__union' & GraphQLTypes["HomePageUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on RedirectCreateResult']: '__union' & GraphQLTypes["RedirectCreateResult"];
	['...on RedirectDeleteResult']: '__union' & GraphQLTypes["RedirectDeleteResult"];
	['...on RedirectUpdateResult']: '__union' & GraphQLTypes["RedirectUpdateResult"];
	['...on RedirectUpsertResult']: '__union' & GraphQLTypes["RedirectUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on ContactLocationCreateResult']: '__union' & GraphQLTypes["ContactLocationCreateResult"];
	['...on ContactLocationDeleteResult']: '__union' & GraphQLTypes["ContactLocationDeleteResult"];
	['...on ContactLocationUpdateResult']: '__union' & GraphQLTypes["ContactLocationUpdateResult"];
	['...on ContactLocationUpsertResult']: '__union' & GraphQLTypes["ContactLocationUpsertResult"];
	['...on DirectorCreateResult']: '__union' & GraphQLTypes["DirectorCreateResult"];
	['...on DirectorDeleteResult']: '__union' & GraphQLTypes["DirectorDeleteResult"];
	['...on DirectorUpdateResult']: '__union' & GraphQLTypes["DirectorUpdateResult"];
	['...on DirectorUpsertResult']: '__union' & GraphQLTypes["DirectorUpsertResult"];
	['...on FilmCreateResult']: '__union' & GraphQLTypes["FilmCreateResult"];
	['...on FilmDeleteResult']: '__union' & GraphQLTypes["FilmDeleteResult"];
	['...on FilmUpdateResult']: '__union' & GraphQLTypes["FilmUpdateResult"];
	['...on FilmUpsertResult']: '__union' & GraphQLTypes["FilmUpsertResult"];
	['...on DirectorLocationCreateResult']: '__union' & GraphQLTypes["DirectorLocationCreateResult"];
	['...on DirectorLocationDeleteResult']: '__union' & GraphQLTypes["DirectorLocationDeleteResult"];
	['...on DirectorLocationUpdateResult']: '__union' & GraphQLTypes["DirectorLocationUpdateResult"];
	['...on DirectorLocationUpsertResult']: '__union' & GraphQLTypes["DirectorLocationUpsertResult"];
	['...on ContactsPageCreateResult']: '__union' & GraphQLTypes["ContactsPageCreateResult"];
	['...on ContactsPageDeleteResult']: '__union' & GraphQLTypes["ContactsPageDeleteResult"];
	['...on ContactsPageUpdateResult']: '__union' & GraphQLTypes["ContactsPageUpdateResult"];
	['...on ContactsPageUpsertResult']: '__union' & GraphQLTypes["ContactsPageUpsertResult"];
	['...on DirectorsPageCreateResult']: '__union' & GraphQLTypes["DirectorsPageCreateResult"];
	['...on DirectorsPageDeleteResult']: '__union' & GraphQLTypes["DirectorsPageDeleteResult"];
	['...on DirectorsPageUpdateResult']: '__union' & GraphQLTypes["DirectorsPageUpdateResult"];
	['...on DirectorsPageUpsertResult']: '__union' & GraphQLTypes["DirectorsPageUpsertResult"];
	['...on FilmItemCreateResult']: '__union' & GraphQLTypes["FilmItemCreateResult"];
	['...on FilmItemDeleteResult']: '__union' & GraphQLTypes["FilmItemDeleteResult"];
	['...on FilmItemUpdateResult']: '__union' & GraphQLTypes["FilmItemUpdateResult"];
	['...on FilmItemUpsertResult']: '__union' & GraphQLTypes["FilmItemUpsertResult"];
	['...on DirectorContentGroupCreateResult']: '__union' & GraphQLTypes["DirectorContentGroupCreateResult"];
	['...on DirectorContentGroupDeleteResult']: '__union' & GraphQLTypes["DirectorContentGroupDeleteResult"];
	['...on DirectorContentGroupUpdateResult']: '__union' & GraphQLTypes["DirectorContentGroupUpdateResult"];
	['...on DirectorContentGroupUpsertResult']: '__union' & GraphQLTypes["DirectorContentGroupUpsertResult"];
	['...on PhotographerCreateResult']: '__union' & GraphQLTypes["PhotographerCreateResult"];
	['...on PhotographerDeleteResult']: '__union' & GraphQLTypes["PhotographerDeleteResult"];
	['...on PhotographerUpdateResult']: '__union' & GraphQLTypes["PhotographerUpdateResult"];
	['...on PhotographerUpsertResult']: '__union' & GraphQLTypes["PhotographerUpsertResult"];
	['...on PhotographerContentGroupCreateResult']: '__union' & GraphQLTypes["PhotographerContentGroupCreateResult"];
	['...on PhotographerContentGroupDeleteResult']: '__union' & GraphQLTypes["PhotographerContentGroupDeleteResult"];
	['...on PhotographerContentGroupUpdateResult']: '__union' & GraphQLTypes["PhotographerContentGroupUpdateResult"];
	['...on PhotographerContentGroupUpsertResult']: '__union' & GraphQLTypes["PhotographerContentGroupUpsertResult"];
	['...on PhotographerLocationCreateResult']: '__union' & GraphQLTypes["PhotographerLocationCreateResult"];
	['...on PhotographerLocationDeleteResult']: '__union' & GraphQLTypes["PhotographerLocationDeleteResult"];
	['...on PhotographerLocationUpdateResult']: '__union' & GraphQLTypes["PhotographerLocationUpdateResult"];
	['...on PhotographerLocationUpsertResult']: '__union' & GraphQLTypes["PhotographerLocationUpsertResult"];
	['...on PhotographersPageCreateResult']: '__union' & GraphQLTypes["PhotographersPageCreateResult"];
	['...on PhotographersPageDeleteResult']: '__union' & GraphQLTypes["PhotographersPageDeleteResult"];
	['...on PhotographersPageUpdateResult']: '__union' & GraphQLTypes["PhotographersPageUpdateResult"];
	['...on PhotographersPageUpsertResult']: '__union' & GraphQLTypes["PhotographersPageUpsertResult"];
	['...on OurWorkPageCreateResult']: '__union' & GraphQLTypes["OurWorkPageCreateResult"];
	['...on OurWorkPageDeleteResult']: '__union' & GraphQLTypes["OurWorkPageDeleteResult"];
	['...on OurWorkPageUpdateResult']: '__union' & GraphQLTypes["OurWorkPageUpdateResult"];
	['...on OurWorkPageUpsertResult']: '__union' & GraphQLTypes["OurWorkPageUpsertResult"];
	['...on OurWorkPageContentGroupCreateResult']: '__union' & GraphQLTypes["OurWorkPageContentGroupCreateResult"];
	['...on OurWorkPageContentGroupDeleteResult']: '__union' & GraphQLTypes["OurWorkPageContentGroupDeleteResult"];
	['...on OurWorkPageContentGroupUpdateResult']: '__union' & GraphQLTypes["OurWorkPageContentGroupUpdateResult"];
	['...on OurWorkPageContentGroupUpsertResult']: '__union' & GraphQLTypes["OurWorkPageContentGroupUpsertResult"];
	['...on ContentGroupCreateResult']: '__union' & GraphQLTypes["ContentGroupCreateResult"];
	['...on ContentGroupDeleteResult']: '__union' & GraphQLTypes["ContentGroupDeleteResult"];
	['...on ContentGroupUpdateResult']: '__union' & GraphQLTypes["ContentGroupUpdateResult"];
	['...on ContentGroupUpsertResult']: '__union' & GraphQLTypes["ContentGroupUpsertResult"];
	['...on HomePageContentGroupCreateResult']: '__union' & GraphQLTypes["HomePageContentGroupCreateResult"];
	['...on HomePageContentGroupDeleteResult']: '__union' & GraphQLTypes["HomePageContentGroupDeleteResult"];
	['...on HomePageContentGroupUpdateResult']: '__union' & GraphQLTypes["HomePageContentGroupUpdateResult"];
	['...on HomePageContentGroupUpsertResult']: '__union' & GraphQLTypes["HomePageContentGroupUpsertResult"];
	['...on TabletopPageCreateResult']: '__union' & GraphQLTypes["TabletopPageCreateResult"];
	['...on TabletopPageDeleteResult']: '__union' & GraphQLTypes["TabletopPageDeleteResult"];
	['...on TabletopPageUpdateResult']: '__union' & GraphQLTypes["TabletopPageUpdateResult"];
	['...on TabletopPageUpsertResult']: '__union' & GraphQLTypes["TabletopPageUpsertResult"];
	['...on TabletopPageContentGroupCreateResult']: '__union' & GraphQLTypes["TabletopPageContentGroupCreateResult"];
	['...on TabletopPageContentGroupDeleteResult']: '__union' & GraphQLTypes["TabletopPageContentGroupDeleteResult"];
	['...on TabletopPageContentGroupUpdateResult']: '__union' & GraphQLTypes["TabletopPageContentGroupUpdateResult"];
	['...on TabletopPageContentGroupUpsertResult']: '__union' & GraphQLTypes["TabletopPageContentGroupUpsertResult"];
	['...on PhotographersPageContentGroupCreateResult']: '__union' & GraphQLTypes["PhotographersPageContentGroupCreateResult"];
	['...on PhotographersPageContentGroupDeleteResult']: '__union' & GraphQLTypes["PhotographersPageContentGroupDeleteResult"];
	['...on PhotographersPageContentGroupUpdateResult']: '__union' & GraphQLTypes["PhotographersPageContentGroupUpdateResult"];
	['...on PhotographersPageContentGroupUpsertResult']: '__union' & GraphQLTypes["PhotographersPageContentGroupUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<GraphQLTypes["_PathFragment"]>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string
};
	["_MutationErrorType"]: _MutationErrorType;
	["ContactDeleteResult"]: {
	__typename: "ContactDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Contact"]
};
	["ContactUpdateResult"]: {
	__typename: "ContactUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Contact"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactUpsertResult"]: {
	__typename: "ContactUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Contact"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
	__typename: "ContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
	__typename: "ContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"]
};
	["ContentUpdateResult"]: {
	__typename: "ContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
	__typename: "ContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
	__typename: "ContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
	__typename: "ContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
	__typename: "ContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
	__typename: "ContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardMediaCreateResult"]: {
	__typename: "CardMediaCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardMedia"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardMediaDeleteResult"]: {
	__typename: "CardMediaDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardMedia"]
};
	["CardMediaUpdateResult"]: {
	__typename: "CardMediaUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardMedia"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardMediaUpsertResult"]: {
	__typename: "CardMediaUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardMedia"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FallbackSeoCreateResult"]: {
	__typename: "FallbackSeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FallbackSeoDeleteResult"]: {
	__typename: "FallbackSeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"]
};
	["FallbackSeoUpdateResult"]: {
	__typename: "FallbackSeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FallbackSeoUpsertResult"]: {
	__typename: "FallbackSeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
	__typename: "FooterCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
	__typename: "FooterDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"]
};
	["FooterUpdateResult"]: {
	__typename: "FooterUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
	__typename: "FooterUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkCreateResult"]: {
	__typename: "SocialLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkDeleteResult"]: {
	__typename: "SocialLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"]
};
	["SocialLinkUpdateResult"]: {
	__typename: "SocialLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkUpsertResult"]: {
	__typename: "SocialLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
	__typename: "GalleryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
	__typename: "GalleryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"]
};
	["GalleryUpdateResult"]: {
	__typename: "GalleryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
	__typename: "GalleryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
	__typename: "GalleryItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
	__typename: "GalleryItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"]
};
	["GalleryItemUpdateResult"]: {
	__typename: "GalleryItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
	__typename: "GalleryItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
	__typename: "HeaderCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
	__typename: "HeaderDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"]
};
	["HeaderUpdateResult"]: {
	__typename: "HeaderUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
	__typename: "HeaderUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLinkCreateResult"]: {
	__typename: "HeaderLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLinkDeleteResult"]: {
	__typename: "HeaderLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"]
};
	["HeaderLinkUpdateResult"]: {
	__typename: "HeaderLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLinkUpsertResult"]: {
	__typename: "HeaderLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
	__typename: "HomePageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
	__typename: "HomePageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"]
};
	["HomePageUpdateResult"]: {
	__typename: "HomePageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
	__typename: "HomePageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"]
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"]
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
	__typename: "RedirectCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
	__typename: "RedirectDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
	__typename: "RedirectUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
	__typename: "RedirectUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"]
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactLocationCreateResult"]: {
	__typename: "ContactLocationCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactLocation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactLocationDeleteResult"]: {
	__typename: "ContactLocationDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactLocation"]
};
	["ContactLocationUpdateResult"]: {
	__typename: "ContactLocationUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactLocation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactLocationUpsertResult"]: {
	__typename: "ContactLocationUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactLocation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorCreateResult"]: {
	__typename: "DirectorCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Director"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorDeleteResult"]: {
	__typename: "DirectorDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Director"]
};
	["DirectorUpdateResult"]: {
	__typename: "DirectorUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Director"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorUpsertResult"]: {
	__typename: "DirectorUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Director"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilmCreateResult"]: {
	__typename: "FilmCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Film"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilmDeleteResult"]: {
	__typename: "FilmDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Film"]
};
	["FilmUpdateResult"]: {
	__typename: "FilmUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Film"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilmUpsertResult"]: {
	__typename: "FilmUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Film"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorLocationCreateResult"]: {
	__typename: "DirectorLocationCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorLocation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorLocationDeleteResult"]: {
	__typename: "DirectorLocationDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorLocation"]
};
	["DirectorLocationUpdateResult"]: {
	__typename: "DirectorLocationUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorLocation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorLocationUpsertResult"]: {
	__typename: "DirectorLocationUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorLocation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactsPageCreateResult"]: {
	__typename: "ContactsPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactsPageDeleteResult"]: {
	__typename: "ContactsPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactsPage"]
};
	["ContactsPageUpdateResult"]: {
	__typename: "ContactsPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactsPageUpsertResult"]: {
	__typename: "ContactsPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorsPageCreateResult"]: {
	__typename: "DirectorsPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorsPageDeleteResult"]: {
	__typename: "DirectorsPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorsPage"]
};
	["DirectorsPageUpdateResult"]: {
	__typename: "DirectorsPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorsPageUpsertResult"]: {
	__typename: "DirectorsPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilmItemCreateResult"]: {
	__typename: "FilmItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilmItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilmItemDeleteResult"]: {
	__typename: "FilmItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilmItem"]
};
	["FilmItemUpdateResult"]: {
	__typename: "FilmItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilmItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilmItemUpsertResult"]: {
	__typename: "FilmItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilmItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorContentGroupCreateResult"]: {
	__typename: "DirectorContentGroupCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorContentGroupDeleteResult"]: {
	__typename: "DirectorContentGroupDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorContentGroup"]
};
	["DirectorContentGroupUpdateResult"]: {
	__typename: "DirectorContentGroupUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DirectorContentGroupUpsertResult"]: {
	__typename: "DirectorContentGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DirectorContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerCreateResult"]: {
	__typename: "PhotographerCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Photographer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerDeleteResult"]: {
	__typename: "PhotographerDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Photographer"]
};
	["PhotographerUpdateResult"]: {
	__typename: "PhotographerUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Photographer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerUpsertResult"]: {
	__typename: "PhotographerUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Photographer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerContentGroupCreateResult"]: {
	__typename: "PhotographerContentGroupCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographerContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerContentGroupDeleteResult"]: {
	__typename: "PhotographerContentGroupDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographerContentGroup"]
};
	["PhotographerContentGroupUpdateResult"]: {
	__typename: "PhotographerContentGroupUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographerContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerContentGroupUpsertResult"]: {
	__typename: "PhotographerContentGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographerContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerLocationCreateResult"]: {
	__typename: "PhotographerLocationCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographerLocation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerLocationDeleteResult"]: {
	__typename: "PhotographerLocationDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographerLocation"]
};
	["PhotographerLocationUpdateResult"]: {
	__typename: "PhotographerLocationUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographerLocation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerLocationUpsertResult"]: {
	__typename: "PhotographerLocationUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographerLocation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographersPageCreateResult"]: {
	__typename: "PhotographersPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographersPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographersPageDeleteResult"]: {
	__typename: "PhotographersPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographersPage"]
};
	["PhotographersPageUpdateResult"]: {
	__typename: "PhotographersPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographersPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographersPageUpsertResult"]: {
	__typename: "PhotographersPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographersPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["OurWorkPageCreateResult"]: {
	__typename: "OurWorkPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OurWorkPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["OurWorkPageDeleteResult"]: {
	__typename: "OurWorkPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OurWorkPage"]
};
	["OurWorkPageUpdateResult"]: {
	__typename: "OurWorkPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OurWorkPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["OurWorkPageUpsertResult"]: {
	__typename: "OurWorkPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OurWorkPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["OurWorkPageContentGroupCreateResult"]: {
	__typename: "OurWorkPageContentGroupCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OurWorkPageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["OurWorkPageContentGroupDeleteResult"]: {
	__typename: "OurWorkPageContentGroupDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OurWorkPageContentGroup"]
};
	["OurWorkPageContentGroupUpdateResult"]: {
	__typename: "OurWorkPageContentGroupUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OurWorkPageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["OurWorkPageContentGroupUpsertResult"]: {
	__typename: "OurWorkPageContentGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OurWorkPageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentGroupCreateResult"]: {
	__typename: "ContentGroupCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentGroupDeleteResult"]: {
	__typename: "ContentGroupDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentGroup"]
};
	["ContentGroupUpdateResult"]: {
	__typename: "ContentGroupUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentGroupUpsertResult"]: {
	__typename: "ContentGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageContentGroupCreateResult"]: {
	__typename: "HomePageContentGroupCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageContentGroupDeleteResult"]: {
	__typename: "HomePageContentGroupDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageContentGroup"]
};
	["HomePageContentGroupUpdateResult"]: {
	__typename: "HomePageContentGroupUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageContentGroupUpsertResult"]: {
	__typename: "HomePageContentGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TabletopPageCreateResult"]: {
	__typename: "TabletopPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TabletopPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TabletopPageDeleteResult"]: {
	__typename: "TabletopPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TabletopPage"]
};
	["TabletopPageUpdateResult"]: {
	__typename: "TabletopPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TabletopPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TabletopPageUpsertResult"]: {
	__typename: "TabletopPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TabletopPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TabletopPageContentGroupCreateResult"]: {
	__typename: "TabletopPageContentGroupCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TabletopPageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TabletopPageContentGroupDeleteResult"]: {
	__typename: "TabletopPageContentGroupDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TabletopPageContentGroup"]
};
	["TabletopPageContentGroupUpdateResult"]: {
	__typename: "TabletopPageContentGroupUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TabletopPageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TabletopPageContentGroupUpsertResult"]: {
	__typename: "TabletopPageContentGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TabletopPageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographersPageContentGroupCreateResult"]: {
	__typename: "PhotographersPageContentGroupCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographersPageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographersPageContentGroupDeleteResult"]: {
	__typename: "PhotographersPageContentGroupDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographersPageContentGroup"]
};
	["PhotographersPageContentGroupUpdateResult"]: {
	__typename: "PhotographersPageContentGroupUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographersPageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographersPageContentGroupUpsertResult"]: {
	__typename: "PhotographersPageContentGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PhotographersPageContentGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	createContact: GraphQLTypes["ContactCreateResult"],
	deleteContact: GraphQLTypes["ContactDeleteResult"],
	updateContact: GraphQLTypes["ContactUpdateResult"],
	upsertContact: GraphQLTypes["ContactUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createCardMedia: GraphQLTypes["CardMediaCreateResult"],
	deleteCardMedia: GraphQLTypes["CardMediaDeleteResult"],
	updateCardMedia: GraphQLTypes["CardMediaUpdateResult"],
	upsertCardMedia: GraphQLTypes["CardMediaUpsertResult"],
	createFallbackSeo: GraphQLTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo: GraphQLTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo: GraphQLTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo: GraphQLTypes["FallbackSeoUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createSocialLink: GraphQLTypes["SocialLinkCreateResult"],
	deleteSocialLink: GraphQLTypes["SocialLinkDeleteResult"],
	updateSocialLink: GraphQLTypes["SocialLinkUpdateResult"],
	upsertSocialLink: GraphQLTypes["SocialLinkUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHeaderLink: GraphQLTypes["HeaderLinkCreateResult"],
	deleteHeaderLink: GraphQLTypes["HeaderLinkDeleteResult"],
	updateHeaderLink: GraphQLTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink: GraphQLTypes["HeaderLinkUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createContactLocation: GraphQLTypes["ContactLocationCreateResult"],
	deleteContactLocation: GraphQLTypes["ContactLocationDeleteResult"],
	updateContactLocation: GraphQLTypes["ContactLocationUpdateResult"],
	upsertContactLocation: GraphQLTypes["ContactLocationUpsertResult"],
	createDirector: GraphQLTypes["DirectorCreateResult"],
	deleteDirector: GraphQLTypes["DirectorDeleteResult"],
	updateDirector: GraphQLTypes["DirectorUpdateResult"],
	upsertDirector: GraphQLTypes["DirectorUpsertResult"],
	createFilm: GraphQLTypes["FilmCreateResult"],
	deleteFilm: GraphQLTypes["FilmDeleteResult"],
	updateFilm: GraphQLTypes["FilmUpdateResult"],
	upsertFilm: GraphQLTypes["FilmUpsertResult"],
	createDirectorLocation: GraphQLTypes["DirectorLocationCreateResult"],
	deleteDirectorLocation: GraphQLTypes["DirectorLocationDeleteResult"],
	updateDirectorLocation: GraphQLTypes["DirectorLocationUpdateResult"],
	upsertDirectorLocation: GraphQLTypes["DirectorLocationUpsertResult"],
	createContactsPage: GraphQLTypes["ContactsPageCreateResult"],
	deleteContactsPage: GraphQLTypes["ContactsPageDeleteResult"],
	updateContactsPage: GraphQLTypes["ContactsPageUpdateResult"],
	upsertContactsPage: GraphQLTypes["ContactsPageUpsertResult"],
	createDirectorsPage: GraphQLTypes["DirectorsPageCreateResult"],
	deleteDirectorsPage: GraphQLTypes["DirectorsPageDeleteResult"],
	updateDirectorsPage: GraphQLTypes["DirectorsPageUpdateResult"],
	upsertDirectorsPage: GraphQLTypes["DirectorsPageUpsertResult"],
	createFilmItem: GraphQLTypes["FilmItemCreateResult"],
	deleteFilmItem: GraphQLTypes["FilmItemDeleteResult"],
	updateFilmItem: GraphQLTypes["FilmItemUpdateResult"],
	upsertFilmItem: GraphQLTypes["FilmItemUpsertResult"],
	createDirectorContentGroup: GraphQLTypes["DirectorContentGroupCreateResult"],
	deleteDirectorContentGroup: GraphQLTypes["DirectorContentGroupDeleteResult"],
	updateDirectorContentGroup: GraphQLTypes["DirectorContentGroupUpdateResult"],
	upsertDirectorContentGroup: GraphQLTypes["DirectorContentGroupUpsertResult"],
	createPhotographer: GraphQLTypes["PhotographerCreateResult"],
	deletePhotographer: GraphQLTypes["PhotographerDeleteResult"],
	updatePhotographer: GraphQLTypes["PhotographerUpdateResult"],
	upsertPhotographer: GraphQLTypes["PhotographerUpsertResult"],
	createPhotographerContentGroup: GraphQLTypes["PhotographerContentGroupCreateResult"],
	deletePhotographerContentGroup: GraphQLTypes["PhotographerContentGroupDeleteResult"],
	updatePhotographerContentGroup: GraphQLTypes["PhotographerContentGroupUpdateResult"],
	upsertPhotographerContentGroup: GraphQLTypes["PhotographerContentGroupUpsertResult"],
	createPhotographerLocation: GraphQLTypes["PhotographerLocationCreateResult"],
	deletePhotographerLocation: GraphQLTypes["PhotographerLocationDeleteResult"],
	updatePhotographerLocation: GraphQLTypes["PhotographerLocationUpdateResult"],
	upsertPhotographerLocation: GraphQLTypes["PhotographerLocationUpsertResult"],
	createPhotographersPage: GraphQLTypes["PhotographersPageCreateResult"],
	deletePhotographersPage: GraphQLTypes["PhotographersPageDeleteResult"],
	updatePhotographersPage: GraphQLTypes["PhotographersPageUpdateResult"],
	upsertPhotographersPage: GraphQLTypes["PhotographersPageUpsertResult"],
	createOurWorkPage: GraphQLTypes["OurWorkPageCreateResult"],
	deleteOurWorkPage: GraphQLTypes["OurWorkPageDeleteResult"],
	updateOurWorkPage: GraphQLTypes["OurWorkPageUpdateResult"],
	upsertOurWorkPage: GraphQLTypes["OurWorkPageUpsertResult"],
	createOurWorkPageContentGroup: GraphQLTypes["OurWorkPageContentGroupCreateResult"],
	deleteOurWorkPageContentGroup: GraphQLTypes["OurWorkPageContentGroupDeleteResult"],
	updateOurWorkPageContentGroup: GraphQLTypes["OurWorkPageContentGroupUpdateResult"],
	upsertOurWorkPageContentGroup: GraphQLTypes["OurWorkPageContentGroupUpsertResult"],
	createContentGroup: GraphQLTypes["ContentGroupCreateResult"],
	deleteContentGroup: GraphQLTypes["ContentGroupDeleteResult"],
	updateContentGroup: GraphQLTypes["ContentGroupUpdateResult"],
	upsertContentGroup: GraphQLTypes["ContentGroupUpsertResult"],
	createHomePageContentGroup: GraphQLTypes["HomePageContentGroupCreateResult"],
	deleteHomePageContentGroup: GraphQLTypes["HomePageContentGroupDeleteResult"],
	updateHomePageContentGroup: GraphQLTypes["HomePageContentGroupUpdateResult"],
	upsertHomePageContentGroup: GraphQLTypes["HomePageContentGroupUpsertResult"],
	createTabletopPage: GraphQLTypes["TabletopPageCreateResult"],
	deleteTabletopPage: GraphQLTypes["TabletopPageDeleteResult"],
	updateTabletopPage: GraphQLTypes["TabletopPageUpdateResult"],
	upsertTabletopPage: GraphQLTypes["TabletopPageUpsertResult"],
	createTabletopPageContentGroup: GraphQLTypes["TabletopPageContentGroupCreateResult"],
	deleteTabletopPageContentGroup: GraphQLTypes["TabletopPageContentGroupDeleteResult"],
	updateTabletopPageContentGroup: GraphQLTypes["TabletopPageContentGroupUpdateResult"],
	upsertTabletopPageContentGroup: GraphQLTypes["TabletopPageContentGroupUpsertResult"],
	createPhotographersPageContentGroup: GraphQLTypes["PhotographersPageContentGroupCreateResult"],
	deletePhotographersPageContentGroup: GraphQLTypes["PhotographersPageContentGroupDeleteResult"],
	updatePhotographersPageContentGroup: GraphQLTypes["PhotographersPageContentGroupUpdateResult"],
	upsertPhotographersPageContentGroup: GraphQLTypes["PhotographersPageContentGroupUpsertResult"],
	query?: GraphQLTypes["Query"]
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean
};
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string,
	defaultValue?: GraphQLTypes["Json"],
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_RelationSide"]: _RelationSide;
	["_OrderByDirection"]: _OrderByDirection;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string,
	inversedBy?: string,
	nullable?: boolean,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"],
	orphanRemoval?: boolean,
	orderBy?: Array<GraphQLTypes["_OrderBy"]>,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"],
	validator: number
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"]
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string
}
    }
export const enum OrderDirection {
	asc = "asc",
	desc = "desc"
}
export const enum ContentReferenceType {
	image = "image",
	cardMedia = "cardMedia"
}
export const enum LinkType {
	internal = "internal",
	external = "external"
}
export const enum One {
	One = "One"
}
export const enum ContentGroupType {
	films = "films",
	gallery = "gallery"
}
export const enum SocialLinkType {
	facebook = "facebook",
	vimeo = "vimeo",
	instagram = "instagram"
}
export const enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}
export const enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export const enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export const enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export class GraphQLError extends Error {
    constructor(public response: GraphQLResponse) {
      super("");
      console.error(response);
    }
    override toString() {
      return "GraphQL Response Error";
    }
  }


export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<
  UnwrapPromise<ReturnType<T>>
>;
export type ZeusHook<
  T extends (
    ...args: any[]
  ) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>
> = ZeusState<ReturnType<T>[N]>;

type WithTypeNameValue<T> = T & {
  __typename?: true;
};
type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
type IsArray<T, U> = T extends Array<infer R> ? InputType<R, U>[] : InputType<T, U>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;

type IsInterfaced<SRC extends DeepAnify<DST>, DST> = FlattenArray<SRC> extends ZEUS_INTERFACES | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P]>
          : {}
        : never;
    }[keyof DST] &
      {
        [P in keyof Omit<
          Pick<
            SRC,
            {
              [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
            }[keyof DST]
          >,
          '__typename'
        >]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
      }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
    };

export type MapType<SRC, DST> = SRC extends DeepAnify<DST> ? IsInterfaced<SRC, DST> : never;
export type InputType<SRC, DST> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P]>;
    } &
      MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>>
  : MapType<SRC, IsPayLoad<DST>>;
type Func<P extends any[], R> = (...args: P) => R;
type AnyFunc = Func<any, any>;
export type ArgsType<F extends AnyFunc> = F extends Func<infer P, any> ? P : never;
export type OperationOptions = {
  variables?: Record<string, any>;
  operationName?: string;
};
export type OperationToGraphQL<V, T> = <Z extends V>(o: Z | V, options?: OperationOptions) => Promise<InputType<T, Z>>;
export type SubscriptionToGraphQL<V, T> = <Z extends V>(
  o: Z | V,
  options?: OperationOptions,
) => {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z>; errors?:string[] }) => void) => void;
  open: () => void;
};
export type SelectionFunction<V> = <T>(t: T | V) => T;
export type fetchOptions = ArgsType<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (
  ...args: infer R
) => WebSocket
  ? R
  : never;
export type chainOptions =
  | [fetchOptions[0], fetchOptions[1] & {websocket?: websocketOptions}]
  | [fetchOptions[0]];
export type FetchFunction = (
  query: string,
  variables?: Record<string, any>,
) => Promise<any>;
export type SubscriptionFunction = (query: string) => void;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;



export const ZeusSelect = <T>() => ((t: any) => t) as SelectionFunction<T>;

export const ScalarResolver = (scalar: string, value: any) => {
  switch (scalar) {
    case 'String':
      return  `${JSON.stringify(value)}`;
    case 'Int':
      return `${value}`;
    case 'Float':
      return `${value}`;
    case 'Boolean':
      return `${value}`;
    case 'ID':
      return `"${value}"`;
    case 'enum':
      return `${value}`;
    case 'scalar':
      return `${value}`;
    default:
      return false;
  }
};


export const TypesPropsResolver = ({
    value,
    type,
    name,
    key,
    blockArrays
}: {
    value: any;
    type: string;
    name: string;
    key?: string;
    blockArrays?: boolean;
}): string => {
    if (value === null) {
        return `null`;
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error(`Cannot resolve ${type} ${name}${key ? ` ${key}` : ''}`)
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === 'string' && value.startsWith(`ZEUS_VAR$`)) {
        const isRequired = resolvedValue.required ? '!' : '';
        let t = `${typeResolved}`;
        if (isArray) {
          if (isRequired) {
              t = `${t}!`;
          }
          t = `[${t}]`;
          if(isArrayRequired){
            t = `${t}!`;
          }
        }else{
          if (isRequired) {
                t = `${t}!`;
          }
        }
        return `\$${value.split(`ZEUS_VAR$`)[1]}__ZEUS_VAR__${t}`;
    }
    if (isArray && !blockArrays) {
        return `[${value
        .map((v: any) => TypesPropsResolver({ value: v, type, name, key, blockArrays: true }))
        .join(',')}]`;
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === 'object') {
        const argsKeys = Object.keys(resolvedType);
        return `{${argsKeys
            .filter((ak) => value[ak] !== undefined)
            .map(
            (ak) => `${ak}:${TypesPropsResolver({ value: value[ak], type: typeResolved, name: ak })}`
            )}}`;
        }
        return ScalarResolver(AllTypesProps[typeResolved], value) as string;
    }
    return reslovedScalar;
};


const isArrayFunction = (
  parent: string[],
  a: any[]
) => {
  const [values, r] = a;
  const [mainKey, key, ...keys] = parent;
  const keyValues = Object.keys(values).filter((k) => typeof values[k] !== 'undefined');

  if (!keys.length) {
      return keyValues.length > 0
        ? `(${keyValues
            .map(
              (v) =>
                `${v}:${TypesPropsResolver({
                  value: values[v],
                  type: mainKey,
                  name: key,
                  key: v
                })}`
            )
            .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
        : traverseToSeekArrays(parent, r);
    }

  const [typeResolverKey] = keys.splice(keys.length - 1, 1);
  let valueToResolve = ReturnTypes[mainKey][key];
  for (const k of keys) {
    valueToResolve = ReturnTypes[valueToResolve][k];
  }

  const argumentString =
    keyValues.length > 0
      ? `(${keyValues
          .map(
            (v) =>
              `${v}:${TypesPropsResolver({
                value: values[v],
                type: valueToResolve,
                name: typeResolverKey,
                key: v
              })}`
          )
          .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
      : traverseToSeekArrays(parent, r);
  return argumentString;
};


const resolveKV = (k: string, v: boolean | string | { [x: string]: boolean | string }) =>
  typeof v === 'boolean' ? k : typeof v === 'object' ? `${k}{${objectToTree(v)}}` : `${k}${v}`;


const objectToTree = (o: { [x: string]: boolean | string }): string =>
  `{${Object.keys(o).map((k) => `${resolveKV(k, o[k])}`).join(' ')}}`;


const traverseToSeekArrays = (parent: string[], a?: any): string => {
  if (!a) return '';
  if (Object.keys(a).length === 0) {
    return '';
  }
  let b: Record<string, any> = {};
  if (Array.isArray(a)) {
    return isArrayFunction([...parent], a);
  } else {
    if (typeof a === 'object') {
      Object.keys(a)
        .filter((k) => typeof a[k] !== 'undefined')
        .forEach((k) => {
        if (k === '__alias') {
          Object.keys(a[k]).forEach((aliasKey) => {
            const aliasOperations = a[k][aliasKey];
            const aliasOperationName = Object.keys(aliasOperations)[0];
            const aliasOperation = aliasOperations[aliasOperationName];
            b[
              `${aliasOperationName}__alias__${aliasKey}: ${aliasOperationName}`
            ] = traverseToSeekArrays([...parent, aliasOperationName], aliasOperation);
          });
        } else {
          b[k] = traverseToSeekArrays([...parent, k], a[k]);
        }
      });
    } else {
      return '';
    }
  }
  return objectToTree(b);
};  


const buildQuery = (type: string, a?: Record<any, any>) => 
  traverseToSeekArrays([type], a);


const inspectVariables = (query: string) => {
  const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
  let result;
  const AllVariables: string[] = [];
  while ((result = regex.exec(query))) {
    if (AllVariables.includes(result[0])) {
      continue;
    }
    AllVariables.push(result[0]);
  }
  if (!AllVariables.length) {
    return query;
  }
  let filteredQuery = query;
  AllVariables.forEach((variable) => {
    while (filteredQuery.includes(variable)) {
      filteredQuery = filteredQuery.replace(variable, variable.split('__ZEUS_VAR__')[0]);
    }
  });
  return `(${AllVariables.map((a) => a.split('__ZEUS_VAR__'))
    .map(([variableName, variableType]) => `${variableName}:${variableType}`)
    .join(', ')})${filteredQuery}`;
};


export const queryConstruct = (t: 'query' | 'mutation' | 'subscription', tName: string, operationName?: string) => (o: Record<any, any>) =>
  `${t.toLowerCase()}${operationName ? ' ' + operationName : ''}${inspectVariables(buildQuery(tName, o))}`;
  

const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription', tName: string) => (
  o: Record<any, any>,
  options?: OperationOptions,
) => fn(queryConstruct(t, tName, options?.operationName)(o), options?.variables).then((r:any) => { 
  seekForAliases(r)
  return r
});

export const fullChainConstructor = <F extends FetchFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullChainConstruct(fn)(operation, key)(o as any, options)) as OperationToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const fullSubscriptionConstruct = (fn: SubscriptionFunction) => (
  t: 'query' | 'mutation' | 'subscription',
  tName: string,
) => (o: Record<any, any>, options?: OperationOptions) =>
  fn(queryConstruct(t, tName, options?.operationName)(o));

export const fullSubscriptionConstructor = <F extends SubscriptionFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullSubscriptionConstruct(fn)(operation, key)(o as any, options)) as SubscriptionToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const seekForAliases = (response: any) => {
  const traverseAlias = (value: any) => {
    if (Array.isArray(value)) {
      value.forEach(seekForAliases);
    } else {
      if (typeof value === 'object') {
        seekForAliases(value);
      }
    }
  };
  if (typeof response === 'object' && response) {
    const keys = Object.keys(response);
    if (keys.length < 1) {
      return;
    }
    keys.forEach((k) => {
      const value = response[k];
      if (k.indexOf('__alias__') !== -1) {
        const [operation, alias] = k.split('__alias__');
        response[alias] = {
          [operation]: value,
        };
        delete response[k];
      }
      traverseAlias(value);
    });
  }
};


export const $ = (t: TemplateStringsArray): any => `ZEUS_VAR$${t.join('')}`;


export const resolverFor = <
  X,
  T extends keyof ValueTypes,
  Z extends keyof ValueTypes[T],
>(
  type: T,
  field: Z,
  fn: (
    args: Required<ValueTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any,source?: any) => any;


const handleFetchResponse = (
  response: Parameters<Extract<Parameters<ReturnType<typeof fetch>['then']>[0], Function>>[0]
): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response.text().then(text => {
        try { reject(JSON.parse(text)); }
        catch (err) { reject(text); }
      }).catch(reject);
    });
  }
  return response.json();
};

export const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, any> = {}) => {
    let fetchFunction = fetch;
    let queryString = query;
    let fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      queryString = encodeURIComponent(query);
      return fetchFunction(`${options[0]}?query=${queryString}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetchFunction(`${options[0]}`, {
      body: JSON.stringify({ query: queryString, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      ...fetchOptions
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };
  

export const apiSubscription = (options: chainOptions) => (
    query: string,
  ) => {
    try {
      const queryString = options[0] + '?query=' + encodeURIComponent(query);
      const wsString = queryString.replace('http', 'ws');
      const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
      const webSocketOptions = options[1]?.websocket || [host];
      const ws = new WebSocket(...webSocketOptions);
      return {
        ws,
        on: (e: (args: any) => void) => {
          ws.onmessage = (event:any) => {
            if(event.data){
              const parsed = JSON.parse(event.data)
              const data = parsed.data
              if (data) {
                seekForAliases(data);
              }
              return e(data);
            }
          };
        },
        off: (e: (args: any) => void) => {
          ws.onclose = e;
        },
        error: (e: (args: any) => void) => {
          ws.onerror = e;
        },
        open: (e: () => void) => {
          ws.onopen = e;
        },
      };
    } catch {
      throw new Error('No websockets implemented');
    }
  };


export const Thunder = (fn: FetchFunction, subscriptionFn: SubscriptionFunction) => ({
  query: fullChainConstructor(fn,'query', 'Query'),
mutation: fullChainConstructor(fn,'mutation', 'Mutation')
});

export const Chain = (...options: chainOptions) => ({
  query: fullChainConstructor(apiFetch(options),'query', 'Query'),
mutation: fullChainConstructor(apiFetch(options),'mutation', 'Mutation')
});
export const Zeus = {
  query: (o:ValueTypes["Query"], operationName?: string) => queryConstruct('query', 'Query', operationName)(o),
mutation: (o:ValueTypes["Mutation"], operationName?: string) => queryConstruct('mutation', 'Mutation', operationName)(o)
};
export const Selectors = {
  query: ZeusSelect<ValueTypes["Query"]>(),
mutation: ZeusSelect<ValueTypes["Mutation"]>()
};
  
export type FragmentResult<K extends keyof ModelTypes, Q extends (...args: any) => any> = MapType<
	ModelTypes[K],
	ReturnType<Q>
>